/* eslint-disable */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-cron-editor-buefy"] = factory(require("vue"));
	else
		root["vue-cron-editor-buefy"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "1c25");
/******/ })
/************************************************************************/
/******/ ({

/***/ "083f":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "0c47":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("c91c");
var enumBugKeys = __webpack_require__("b17e");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "0d9f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("b8ba");
var anObject = __webpack_require__("157c");
var fails = __webpack_require__("72df");
var flags = __webpack_require__("abfd");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "0e93":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "0ed3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "0fdd":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionDescriptor = void 0;
var stringUtilities_1 = __webpack_require__(1);
var cronParser_1 = __webpack_require__(2);
var ExpressionDescriptor = (function () {
    function ExpressionDescriptor(expression, options) {
        this.expression = expression;
        this.options = options;
        this.expressionParts = new Array(5);
        if (ExpressionDescriptor.locales[options.locale]) {
            this.i18n = ExpressionDescriptor.locales[options.locale];
        }
        else {
            console.warn("Locale '" + options.locale + "' could not be found; falling back to 'en'.");
            this.i18n = ExpressionDescriptor.locales["en"];
        }
        if (options.use24HourTimeFormat === undefined) {
            options.use24HourTimeFormat = this.i18n.use24HourTimeFormatByDefault();
        }
    }
    ExpressionDescriptor.toString = function (expression, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.throwExceptionOnParseError, throwExceptionOnParseError = _c === void 0 ? true : _c, _d = _b.verbose, verbose = _d === void 0 ? false : _d, _e = _b.dayOfWeekStartIndexZero, dayOfWeekStartIndexZero = _e === void 0 ? true : _e, use24HourTimeFormat = _b.use24HourTimeFormat, _f = _b.locale, locale = _f === void 0 ? "en" : _f;
        var options = {
            throwExceptionOnParseError: throwExceptionOnParseError,
            verbose: verbose,
            dayOfWeekStartIndexZero: dayOfWeekStartIndexZero,
            use24HourTimeFormat: use24HourTimeFormat,
            locale: locale,
        };
        var descripter = new ExpressionDescriptor(expression, options);
        return descripter.getFullDescription();
    };
    ExpressionDescriptor.initialize = function (localesLoader) {
        ExpressionDescriptor.specialCharacters = ["/", "-", ",", "*"];
        localesLoader.load(ExpressionDescriptor.locales);
    };
    ExpressionDescriptor.prototype.getFullDescription = function () {
        var description = "";
        try {
            var parser = new cronParser_1.CronParser(this.expression, this.options.dayOfWeekStartIndexZero);
            this.expressionParts = parser.parse();
            var timeSegment = this.getTimeOfDayDescription();
            var dayOfMonthDesc = this.getDayOfMonthDescription();
            var monthDesc = this.getMonthDescription();
            var dayOfWeekDesc = this.getDayOfWeekDescription();
            var yearDesc = this.getYearDescription();
            description += timeSegment + dayOfMonthDesc + dayOfWeekDesc + monthDesc + yearDesc;
            description = this.transformVerbosity(description, this.options.verbose);
            description = description.charAt(0).toLocaleUpperCase() + description.substr(1);
        }
        catch (ex) {
            if (!this.options.throwExceptionOnParseError) {
                description = this.i18n.anErrorOccuredWhenGeneratingTheExpressionD();
            }
            else {
                throw "" + ex;
            }
        }
        return description;
    };
    ExpressionDescriptor.prototype.getTimeOfDayDescription = function () {
        var secondsExpression = this.expressionParts[0];
        var minuteExpression = this.expressionParts[1];
        var hourExpression = this.expressionParts[2];
        var description = "";
        if (!stringUtilities_1.StringUtilities.containsAny(minuteExpression, ExpressionDescriptor.specialCharacters) &&
            !stringUtilities_1.StringUtilities.containsAny(hourExpression, ExpressionDescriptor.specialCharacters) &&
            !stringUtilities_1.StringUtilities.containsAny(secondsExpression, ExpressionDescriptor.specialCharacters)) {
            description += this.i18n.atSpace() + this.formatTime(hourExpression, minuteExpression, secondsExpression);
        }
        else if (!secondsExpression &&
            minuteExpression.indexOf("-") > -1 &&
            !(minuteExpression.indexOf(",") > -1) &&
            !(minuteExpression.indexOf("/") > -1) &&
            !stringUtilities_1.StringUtilities.containsAny(hourExpression, ExpressionDescriptor.specialCharacters)) {
            var minuteParts = minuteExpression.split("-");
            description += stringUtilities_1.StringUtilities.format(this.i18n.everyMinuteBetweenX0AndX1(), this.formatTime(hourExpression, minuteParts[0], ""), this.formatTime(hourExpression, minuteParts[1], ""));
        }
        else if (!secondsExpression &&
            hourExpression.indexOf(",") > -1 &&
            hourExpression.indexOf("-") == -1 &&
            hourExpression.indexOf("/") == -1 &&
            !stringUtilities_1.StringUtilities.containsAny(minuteExpression, ExpressionDescriptor.specialCharacters)) {
            var hourParts = hourExpression.split(",");
            description += this.i18n.at();
            for (var i = 0; i < hourParts.length; i++) {
                description += " ";
                description += this.formatTime(hourParts[i], minuteExpression, "");
                if (i < hourParts.length - 2) {
                    description += ",";
                }
                if (i == hourParts.length - 2) {
                    description += this.i18n.spaceAnd();
                }
            }
        }
        else {
            var secondsDescription = this.getSecondsDescription();
            var minutesDescription = this.getMinutesDescription();
            var hoursDescription = this.getHoursDescription();
            description += secondsDescription;
            if (description.length > 0 && minutesDescription.length > 0) {
                description += ", ";
            }
            description += minutesDescription;
            if (minutesDescription === hoursDescription) {
                return description;
            }
            if (description.length > 0 && hoursDescription.length > 0) {
                description += ", ";
            }
            description += hoursDescription;
        }
        return description;
    };
    ExpressionDescriptor.prototype.getSecondsDescription = function () {
        var _this = this;
        var description = this.getSegmentDescription(this.expressionParts[0], this.i18n.everySecond(), function (s) {
            return s;
        }, function (s) {
            return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Seconds(), s);
        }, function (s) {
            return _this.i18n.secondsX0ThroughX1PastTheMinute();
        }, function (s) {
            return s == "0"
                ? ""
                : parseInt(s) < 20
                    ? _this.i18n.atX0SecondsPastTheMinute()
                    : _this.i18n.atX0SecondsPastTheMinuteGt20() || _this.i18n.atX0SecondsPastTheMinute();
        });
        return description;
    };
    ExpressionDescriptor.prototype.getMinutesDescription = function () {
        var _this = this;
        var secondsExpression = this.expressionParts[0];
        var hourExpression = this.expressionParts[2];
        var description = this.getSegmentDescription(this.expressionParts[1], this.i18n.everyMinute(), function (s) {
            return s;
        }, function (s) {
            return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Minutes(), s);
        }, function (s) {
            return _this.i18n.minutesX0ThroughX1PastTheHour();
        }, function (s) {
            try {
                return s == "0" && hourExpression.indexOf("/") == -1 && secondsExpression == ""
                    ? _this.i18n.everyHour()
                    : parseInt(s) < 20
                        ? _this.i18n.atX0MinutesPastTheHour()
                        : _this.i18n.atX0MinutesPastTheHourGt20() || _this.i18n.atX0MinutesPastTheHour();
            }
            catch (e) {
                return _this.i18n.atX0MinutesPastTheHour();
            }
        });
        return description;
    };
    ExpressionDescriptor.prototype.getHoursDescription = function () {
        var _this = this;
        var expression = this.expressionParts[2];
        var description = this.getSegmentDescription(expression, this.i18n.everyHour(), function (s) {
            return _this.formatTime(s, "0", "");
        }, function (s) {
            return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Hours(), s);
        }, function (s) {
            return _this.i18n.betweenX0AndX1();
        }, function (s) {
            return _this.i18n.atX0();
        });
        return description;
    };
    ExpressionDescriptor.prototype.getDayOfWeekDescription = function () {
        var _this = this;
        var daysOfWeekNames = this.i18n.daysOfTheWeek();
        var description = null;
        if (this.expressionParts[5] == "*") {
            description = "";
        }
        else {
            description = this.getSegmentDescription(this.expressionParts[5], this.i18n.commaEveryDay(), function (s) {
                var exp = s;
                if (s.indexOf("#") > -1) {
                    exp = s.substr(0, s.indexOf("#"));
                }
                else if (s.indexOf("L") > -1) {
                    exp = exp.replace("L", "");
                }
                return daysOfWeekNames[parseInt(exp)];
            }, function (s) {
                if (parseInt(s) == 1) {
                    return "";
                }
                else {
                    return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0DaysOfTheWeek(), s);
                }
            }, function (s) {
                return _this.i18n.commaX0ThroughX1();
            }, function (s) {
                var format = null;
                if (s.indexOf("#") > -1) {
                    var dayOfWeekOfMonthNumber = s.substring(s.indexOf("#") + 1);
                    var dayOfWeekOfMonthDescription = null;
                    switch (dayOfWeekOfMonthNumber) {
                        case "1":
                            dayOfWeekOfMonthDescription = _this.i18n.first();
                            break;
                        case "2":
                            dayOfWeekOfMonthDescription = _this.i18n.second();
                            break;
                        case "3":
                            dayOfWeekOfMonthDescription = _this.i18n.third();
                            break;
                        case "4":
                            dayOfWeekOfMonthDescription = _this.i18n.fourth();
                            break;
                        case "5":
                            dayOfWeekOfMonthDescription = _this.i18n.fifth();
                            break;
                    }
                    format = _this.i18n.commaOnThe() + dayOfWeekOfMonthDescription + _this.i18n.spaceX0OfTheMonth();
                }
                else if (s.indexOf("L") > -1) {
                    format = _this.i18n.commaOnTheLastX0OfTheMonth();
                }
                else {
                    var domSpecified = _this.expressionParts[3] != "*";
                    format = domSpecified ? _this.i18n.commaAndOnX0() : _this.i18n.commaOnlyOnX0();
                }
                return format;
            });
        }
        return description;
    };
    ExpressionDescriptor.prototype.getMonthDescription = function () {
        var _this = this;
        var monthNames = this.i18n.monthsOfTheYear();
        var description = this.getSegmentDescription(this.expressionParts[4], "", function (s) {
            return monthNames[parseInt(s) - 1];
        }, function (s) {
            if (parseInt(s) == 1) {
                return "";
            }
            else {
                return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0Months(), s);
            }
        }, function (s) {
            return _this.i18n.commaMonthX0ThroughMonthX1() || _this.i18n.commaX0ThroughX1();
        }, function (s) {
            return _this.i18n.commaOnlyInMonthX0 ? _this.i18n.commaOnlyInMonthX0() : _this.i18n.commaOnlyInX0();
        });
        return description;
    };
    ExpressionDescriptor.prototype.getDayOfMonthDescription = function () {
        var _this = this;
        var description = null;
        var expression = this.expressionParts[3];
        switch (expression) {
            case "L":
                description = this.i18n.commaOnTheLastDayOfTheMonth();
                break;
            case "WL":
            case "LW":
                description = this.i18n.commaOnTheLastWeekdayOfTheMonth();
                break;
            default:
                var weekDayNumberMatches = expression.match(/(\d{1,2}W)|(W\d{1,2})/);
                if (weekDayNumberMatches) {
                    var dayNumber = parseInt(weekDayNumberMatches[0].replace("W", ""));
                    var dayString = dayNumber == 1
                        ? this.i18n.firstWeekday()
                        : stringUtilities_1.StringUtilities.format(this.i18n.weekdayNearestDayX0(), dayNumber.toString());
                    description = stringUtilities_1.StringUtilities.format(this.i18n.commaOnTheX0OfTheMonth(), dayString);
                    break;
                }
                else {
                    var lastDayOffSetMatches = expression.match(/L-(\d{1,2})/);
                    if (lastDayOffSetMatches) {
                        var offSetDays = lastDayOffSetMatches[1];
                        description = stringUtilities_1.StringUtilities.format(this.i18n.commaDaysBeforeTheLastDayOfTheMonth(), offSetDays);
                        break;
                    }
                    else if (expression == "*" && this.expressionParts[5] != "*") {
                        return "";
                    }
                    else {
                        description = this.getSegmentDescription(expression, this.i18n.commaEveryDay(), function (s) {
                            return s == "L"
                                ? _this.i18n.lastDay()
                                : _this.i18n.dayX0
                                    ? stringUtilities_1.StringUtilities.format(_this.i18n.dayX0(), s)
                                    : s;
                        }, function (s) {
                            return s == "1" ? _this.i18n.commaEveryDay() : _this.i18n.commaEveryX0Days();
                        }, function (s) {
                            return _this.i18n.commaBetweenDayX0AndX1OfTheMonth();
                        }, function (s) {
                            return _this.i18n.commaOnDayX0OfTheMonth();
                        });
                    }
                    break;
                }
        }
        return description;
    };
    ExpressionDescriptor.prototype.getYearDescription = function () {
        var _this = this;
        var description = this.getSegmentDescription(this.expressionParts[6], "", function (s) {
            return /^\d+$/.test(s) ? new Date(parseInt(s), 1).getFullYear().toString() : s;
        }, function (s) {
            return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0Years(), s);
        }, function (s) {
            return _this.i18n.commaYearX0ThroughYearX1() || _this.i18n.commaX0ThroughX1();
        }, function (s) {
            return _this.i18n.commaOnlyInYearX0 ? _this.i18n.commaOnlyInYearX0() : _this.i18n.commaOnlyInX0();
        });
        return description;
    };
    ExpressionDescriptor.prototype.getSegmentDescription = function (expression, allDescription, getSingleItemDescription, getIncrementDescriptionFormat, getRangeDescriptionFormat, getDescriptionFormat) {
        var description = null;
        var doesExpressionContainIncrement = expression.indexOf("/") > -1;
        var doesExpressionContainRange = expression.indexOf("-") > -1;
        var doesExpressionContainMultipleValues = expression.indexOf(",") > -1;
        if (!expression) {
            description = "";
        }
        else if (expression === "*") {
            description = allDescription;
        }
        else if (!doesExpressionContainIncrement && !doesExpressionContainRange && !doesExpressionContainMultipleValues) {
            description = stringUtilities_1.StringUtilities.format(getDescriptionFormat(expression), getSingleItemDescription(expression));
        }
        else if (doesExpressionContainMultipleValues) {
            var segments = expression.split(",");
            var descriptionContent = "";
            for (var i = 0; i < segments.length; i++) {
                if (i > 0 && segments.length > 2) {
                    descriptionContent += ",";
                    if (i < segments.length - 1) {
                        descriptionContent += " ";
                    }
                }
                if (i > 0 && segments.length > 1 && (i == segments.length - 1 || segments.length == 2)) {
                    descriptionContent += this.i18n.spaceAnd() + " ";
                }
                if (segments[i].indexOf("/") > -1 || segments[i].indexOf("-") > -1) {
                    var isSegmentRangeWithoutIncrement = segments[i].indexOf("-") > -1 && segments[i].indexOf("/") == -1;
                    var currentDescriptionContent = this.getSegmentDescription(segments[i], allDescription, getSingleItemDescription, getIncrementDescriptionFormat, isSegmentRangeWithoutIncrement ? this.i18n.commaX0ThroughX1 : getRangeDescriptionFormat, getDescriptionFormat);
                    if (isSegmentRangeWithoutIncrement) {
                        currentDescriptionContent = currentDescriptionContent.replace(", ", "");
                    }
                    descriptionContent += currentDescriptionContent;
                }
                else if (!doesExpressionContainIncrement) {
                    descriptionContent += getSingleItemDescription(segments[i]);
                }
                else {
                    descriptionContent += this.getSegmentDescription(segments[i], allDescription, getSingleItemDescription, getIncrementDescriptionFormat, getRangeDescriptionFormat, getDescriptionFormat);
                }
            }
            if (!doesExpressionContainIncrement) {
                description = stringUtilities_1.StringUtilities.format(getDescriptionFormat(expression), descriptionContent);
            }
            else {
                description = descriptionContent;
            }
        }
        else if (doesExpressionContainIncrement) {
            var segments = expression.split("/");
            description = stringUtilities_1.StringUtilities.format(getIncrementDescriptionFormat(segments[1]), segments[1]);
            if (segments[0].indexOf("-") > -1) {
                var rangeSegmentDescription = this.generateRangeSegmentDescription(segments[0], getRangeDescriptionFormat, getSingleItemDescription);
                if (rangeSegmentDescription.indexOf(", ") != 0) {
                    description += ", ";
                }
                description += rangeSegmentDescription;
            }
            else if (segments[0].indexOf("*") == -1) {
                var rangeItemDescription = stringUtilities_1.StringUtilities.format(getDescriptionFormat(segments[0]), getSingleItemDescription(segments[0]));
                rangeItemDescription = rangeItemDescription.replace(", ", "");
                description += stringUtilities_1.StringUtilities.format(this.i18n.commaStartingX0(), rangeItemDescription);
            }
        }
        else if (doesExpressionContainRange) {
            description = this.generateRangeSegmentDescription(expression, getRangeDescriptionFormat, getSingleItemDescription);
        }
        return description;
    };
    ExpressionDescriptor.prototype.generateRangeSegmentDescription = function (rangeExpression, getRangeDescriptionFormat, getSingleItemDescription) {
        var description = "";
        var rangeSegments = rangeExpression.split("-");
        var rangeSegment1Description = getSingleItemDescription(rangeSegments[0]);
        var rangeSegment2Description = getSingleItemDescription(rangeSegments[1]);
        rangeSegment2Description = rangeSegment2Description.replace(":00", ":59");
        var rangeDescriptionFormat = getRangeDescriptionFormat(rangeExpression);
        description += stringUtilities_1.StringUtilities.format(rangeDescriptionFormat, rangeSegment1Description, rangeSegment2Description);
        return description;
    };
    ExpressionDescriptor.prototype.formatTime = function (hourExpression, minuteExpression, secondExpression) {
        var hour = parseInt(hourExpression);
        var period = "";
        var setPeriodBeforeTime = false;
        if (!this.options.use24HourTimeFormat) {
            setPeriodBeforeTime = this.i18n.setPeriodBeforeTime && this.i18n.setPeriodBeforeTime();
            period = setPeriodBeforeTime ? this.getPeriod(hour) + " " : " " + this.getPeriod(hour);
            if (hour > 12) {
                hour -= 12;
            }
            if (hour === 0) {
                hour = 12;
            }
        }
        var minute = minuteExpression;
        var second = "";
        if (secondExpression) {
            second = ":" + ("00" + secondExpression).substring(secondExpression.length);
        }
        return "" + (setPeriodBeforeTime ? period : "") + ("00" + hour.toString()).substring(hour.toString().length) + ":" + ("00" + minute.toString()).substring(minute.toString().length) + second + (!setPeriodBeforeTime ? period : "");
    };
    ExpressionDescriptor.prototype.transformVerbosity = function (description, useVerboseFormat) {
        if (!useVerboseFormat) {
            description = description.replace(new RegExp(", " + this.i18n.everyMinute(), "g"), "");
            description = description.replace(new RegExp(", " + this.i18n.everyHour(), "g"), "");
            description = description.replace(new RegExp(this.i18n.commaEveryDay(), "g"), "");
            description = description.replace(/\, ?$/, "");
        }
        return description;
    };
    ExpressionDescriptor.prototype.getPeriod = function (hour) {
        return hour >= 12 ? (this.i18n.pm && this.i18n.pm()) || "PM" : (this.i18n.am && this.i18n.am()) || "AM";
    };
    ExpressionDescriptor.locales = {};
    return ExpressionDescriptor;
}());
exports.ExpressionDescriptor = ExpressionDescriptor;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtilities = void 0;
var StringUtilities = (function () {
    function StringUtilities() {
    }
    StringUtilities.format = function (template) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        return template.replace(/%s/g, function () {
            return values.shift();
        });
    };
    StringUtilities.containsAny = function (text, searchStrings) {
        return searchStrings.some(function (c) {
            return text.indexOf(c) > -1;
        });
    };
    return StringUtilities;
}());
exports.StringUtilities = StringUtilities;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CronParser = void 0;
var rangeValidator_1 = __webpack_require__(3);
var CronParser = (function () {
    function CronParser(expression, dayOfWeekStartIndexZero) {
        if (dayOfWeekStartIndexZero === void 0) { dayOfWeekStartIndexZero = true; }
        this.expression = expression;
        this.dayOfWeekStartIndexZero = dayOfWeekStartIndexZero;
    }
    CronParser.prototype.parse = function () {
        var parsed = this.extractParts(this.expression);
        this.normalize(parsed);
        this.validate(parsed);
        return parsed;
    };
    CronParser.prototype.extractParts = function (expression) {
        if (!this.expression) {
            throw new Error("Expression is empty");
        }
        var parsed = expression.trim().split(/[ ]+/);
        if (parsed.length < 5) {
            throw new Error("Expression has only " + parsed.length + " part" + (parsed.length == 1 ? "" : "s") + ". At least 5 parts are required.");
        }
        else if (parsed.length == 5) {
            parsed.unshift("");
            parsed.push("");
        }
        else if (parsed.length == 6) {
            var isYearWithNoSecondsPart = /\d{4}$/.test(parsed[5]) || parsed[4] == "?" || parsed[2] == "?";
            if (isYearWithNoSecondsPart) {
                parsed.unshift("");
            }
            else {
                parsed.push("");
            }
        }
        else if (parsed.length > 7) {
            throw new Error("Expression has " + parsed.length + " parts; too many!");
        }
        return parsed;
    };
    CronParser.prototype.normalize = function (expressionParts) {
        var _this = this;
        expressionParts[3] = expressionParts[3].replace("?", "*");
        expressionParts[5] = expressionParts[5].replace("?", "*");
        expressionParts[2] = expressionParts[2].replace("?", "*");
        if (expressionParts[0].indexOf("0/") == 0) {
            expressionParts[0] = expressionParts[0].replace("0/", "*/");
        }
        if (expressionParts[1].indexOf("0/") == 0) {
            expressionParts[1] = expressionParts[1].replace("0/", "*/");
        }
        if (expressionParts[2].indexOf("0/") == 0) {
            expressionParts[2] = expressionParts[2].replace("0/", "*/");
        }
        if (expressionParts[3].indexOf("1/") == 0) {
            expressionParts[3] = expressionParts[3].replace("1/", "*/");
        }
        if (expressionParts[4].indexOf("1/") == 0) {
            expressionParts[4] = expressionParts[4].replace("1/", "*/");
        }
        if (expressionParts[6].indexOf("1/") == 0) {
            expressionParts[6] = expressionParts[6].replace("1/", "*/");
        }
        expressionParts[5] = expressionParts[5].replace(/(^\d)|([^#/\s]\d)/g, function (t) {
            var dowDigits = t.replace(/\D/, "");
            var dowDigitsAdjusted = dowDigits;
            if (_this.dayOfWeekStartIndexZero) {
                if (dowDigits == "7") {
                    dowDigitsAdjusted = "0";
                }
            }
            else {
                dowDigitsAdjusted = (parseInt(dowDigits) - 1).toString();
            }
            return t.replace(dowDigits, dowDigitsAdjusted);
        });
        if (expressionParts[5] == "L") {
            expressionParts[5] = "6";
        }
        if (expressionParts[3] == "?") {
            expressionParts[3] = "*";
        }
        if (expressionParts[3].indexOf("W") > -1 &&
            (expressionParts[3].indexOf(",") > -1 || expressionParts[3].indexOf("-") > -1)) {
            throw new Error("The 'W' character can be specified only when the day-of-month is a single day, not a range or list of days.");
        }
        var days = {
            SUN: 0,
            MON: 1,
            TUE: 2,
            WED: 3,
            THU: 4,
            FRI: 5,
            SAT: 6,
        };
        for (var day in days) {
            expressionParts[5] = expressionParts[5].replace(new RegExp(day, "gi"), days[day].toString());
        }
        var months = {
            JAN: 1,
            FEB: 2,
            MAR: 3,
            APR: 4,
            MAY: 5,
            JUN: 6,
            JUL: 7,
            AUG: 8,
            SEP: 9,
            OCT: 10,
            NOV: 11,
            DEC: 12,
        };
        for (var month in months) {
            expressionParts[4] = expressionParts[4].replace(new RegExp(month, "gi"), months[month].toString());
        }
        if (expressionParts[0] == "0") {
            expressionParts[0] = "";
        }
        if (!/\*|\-|\,|\//.test(expressionParts[2]) &&
            (/\*|\//.test(expressionParts[1]) || /\*|\//.test(expressionParts[0]))) {
            expressionParts[2] += "-" + expressionParts[2];
        }
        for (var i = 0; i < expressionParts.length; i++) {
            if (expressionParts[i].indexOf(",") != -1) {
                expressionParts[i] =
                    expressionParts[i]
                        .split(",")
                        .filter(function (str) { return str !== ""; })
                        .join(",") || "*";
            }
            if (expressionParts[i] == "*/1") {
                expressionParts[i] = "*";
            }
            if (expressionParts[i].indexOf("/") > -1 && !/^\*|\-|\,/.test(expressionParts[i])) {
                var stepRangeThrough = null;
                switch (i) {
                    case 4:
                        stepRangeThrough = "12";
                        break;
                    case 5:
                        stepRangeThrough = "6";
                        break;
                    case 6:
                        stepRangeThrough = "9999";
                        break;
                    default:
                        stepRangeThrough = null;
                        break;
                }
                if (stepRangeThrough != null) {
                    var parts = expressionParts[i].split("/");
                    expressionParts[i] = parts[0] + "-" + stepRangeThrough + "/" + parts[1];
                }
            }
        }
    };
    CronParser.prototype.validate = function (parsed) {
        this.assertNoInvalidCharacters("DOW", parsed[5]);
        this.assertNoInvalidCharacters("DOM", parsed[3]);
        this.validateRange(parsed);
    };
    CronParser.prototype.validateRange = function (parsed) {
        rangeValidator_1.default.secondRange(parsed[0]);
        rangeValidator_1.default.minuteRange(parsed[1]);
        rangeValidator_1.default.hourRange(parsed[2]);
        rangeValidator_1.default.dayOfMonthRange(parsed[3]);
        rangeValidator_1.default.monthRange(parsed[4]);
        rangeValidator_1.default.dayOfWeekRange(parsed[5]);
    };
    CronParser.prototype.assertNoInvalidCharacters = function (partDescription, expression) {
        var invalidChars = expression.match(/[A-KM-VX-Z]+/gi);
        if (invalidChars && invalidChars.length) {
            throw new Error(partDescription + " part contains invalid values: '" + invalidChars.toString() + "'");
        }
    };
    return CronParser;
}());
exports.CronParser = CronParser;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function assert(value, message) {
    if (!value) {
        throw new Error(message);
    }
}
var RangeValidator = (function () {
    function RangeValidator() {
    }
    RangeValidator.secondRange = function (parse) {
        var parsed = parse.split(',');
        for (var i = 0; i < parsed.length; i++) {
            if (!isNaN(parseInt(parsed[i], 10))) {
                var second = parseInt(parsed[i], 10);
                assert(second >= 0 && second <= 59, 'seconds part must be >= 0 and <= 59');
            }
        }
    };
    RangeValidator.minuteRange = function (parse) {
        var parsed = parse.split(',');
        for (var i = 0; i < parsed.length; i++) {
            if (!isNaN(parseInt(parsed[i], 10))) {
                var minute = parseInt(parsed[i], 10);
                assert(minute >= 0 && minute <= 59, 'minutes part must be >= 0 and <= 59');
            }
        }
    };
    RangeValidator.hourRange = function (parse) {
        var parsed = parse.split(',');
        for (var i = 0; i < parsed.length; i++) {
            if (!isNaN(parseInt(parsed[i], 10))) {
                var hour = parseInt(parsed[i], 10);
                assert(hour >= 0 && hour <= 23, 'hours part must be >= 0 and <= 23');
            }
        }
    };
    RangeValidator.dayOfMonthRange = function (parse) {
        var parsed = parse.split(',');
        for (var i = 0; i < parsed.length; i++) {
            if (!isNaN(parseInt(parsed[i], 10))) {
                var dayOfMonth = parseInt(parsed[i], 10);
                assert(dayOfMonth >= 1 && dayOfMonth <= 31, 'DOM part must be >= 1 and <= 31');
            }
        }
    };
    RangeValidator.monthRange = function (parse) {
        var parsed = parse.split(',');
        for (var i = 0; i < parsed.length; i++) {
            if (!isNaN(parseInt(parsed[i], 10))) {
                var month = parseInt(parsed[i], 10);
                assert(month >= 1 && month <= 12, 'month part must be >= 1 and <= 12');
            }
        }
    };
    RangeValidator.dayOfWeekRange = function (parse) {
        var parsed = parse.split(',');
        for (var i = 0; i < parsed.length; i++) {
            if (!isNaN(parseInt(parsed[i], 10))) {
                var dayOfWeek = parseInt(parsed[i], 10);
                assert(dayOfWeek >= 0 && dayOfWeek <= 6, 'DOW part must be >= 0 and <= 6');
            }
        }
    };
    return RangeValidator;
}());
exports.default = RangeValidator;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.en = void 0;
var en = (function () {
    function en() {
    }
    en.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    en.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    en.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    en.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    en.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    en.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "An error occured when generating the expression description.  Check the cron expression syntax.";
    };
    en.prototype.everyMinute = function () {
        return "every minute";
    };
    en.prototype.everyHour = function () {
        return "every hour";
    };
    en.prototype.atSpace = function () {
        return "At ";
    };
    en.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Every minute between %s and %s";
    };
    en.prototype.at = function () {
        return "At";
    };
    en.prototype.spaceAnd = function () {
        return " and";
    };
    en.prototype.everySecond = function () {
        return "every second";
    };
    en.prototype.everyX0Seconds = function () {
        return "every %s seconds";
    };
    en.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "seconds %s through %s past the minute";
    };
    en.prototype.atX0SecondsPastTheMinute = function () {
        return "at %s seconds past the minute";
    };
    en.prototype.everyX0Minutes = function () {
        return "every %s minutes";
    };
    en.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minutes %s through %s past the hour";
    };
    en.prototype.atX0MinutesPastTheHour = function () {
        return "at %s minutes past the hour";
    };
    en.prototype.everyX0Hours = function () {
        return "every %s hours";
    };
    en.prototype.betweenX0AndX1 = function () {
        return "between %s and %s";
    };
    en.prototype.atX0 = function () {
        return "at %s";
    };
    en.prototype.commaEveryDay = function () {
        return ", every day";
    };
    en.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", every %s days of the week";
    };
    en.prototype.commaX0ThroughX1 = function () {
        return ", %s through %s";
    };
    en.prototype.first = function () {
        return "first";
    };
    en.prototype.second = function () {
        return "second";
    };
    en.prototype.third = function () {
        return "third";
    };
    en.prototype.fourth = function () {
        return "fourth";
    };
    en.prototype.fifth = function () {
        return "fifth";
    };
    en.prototype.commaOnThe = function () {
        return ", on the ";
    };
    en.prototype.spaceX0OfTheMonth = function () {
        return " %s of the month";
    };
    en.prototype.lastDay = function () {
        return "the last day";
    };
    en.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", on the last %s of the month";
    };
    en.prototype.commaOnlyOnX0 = function () {
        return ", only on %s";
    };
    en.prototype.commaAndOnX0 = function () {
        return ", and on %s";
    };
    en.prototype.commaEveryX0Months = function () {
        return ", every %s months";
    };
    en.prototype.commaOnlyInX0 = function () {
        return ", only in %s";
    };
    en.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", on the last day of the month";
    };
    en.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", on the last weekday of the month";
    };
    en.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s days before the last day of the month";
    };
    en.prototype.firstWeekday = function () {
        return "first weekday";
    };
    en.prototype.weekdayNearestDayX0 = function () {
        return "weekday nearest day %s";
    };
    en.prototype.commaOnTheX0OfTheMonth = function () {
        return ", on the %s of the month";
    };
    en.prototype.commaEveryX0Days = function () {
        return ", every %s days";
    };
    en.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", between day %s and %s of the month";
    };
    en.prototype.commaOnDayX0OfTheMonth = function () {
        return ", on day %s of the month";
    };
    en.prototype.commaEveryHour = function () {
        return ", every hour";
    };
    en.prototype.commaEveryX0Years = function () {
        return ", every %s years";
    };
    en.prototype.commaStartingX0 = function () {
        return ", starting %s";
    };
    en.prototype.daysOfTheWeek = function () {
        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    };
    en.prototype.monthsOfTheYear = function () {
        return [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
    };
    return en;
}());
exports.en = en;


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.toString = void 0;
var expressionDescriptor_1 = __webpack_require__(0);
var allLocalesLoader_1 = __webpack_require__(8);
expressionDescriptor_1.ExpressionDescriptor.initialize(new allLocalesLoader_1.allLocalesLoader());
exports.default = expressionDescriptor_1.ExpressionDescriptor;
var toString = expressionDescriptor_1.ExpressionDescriptor.toString;
exports.toString = toString;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.allLocalesLoader = void 0;
var allLocales = __webpack_require__(9);
var allLocalesLoader = (function () {
    function allLocalesLoader() {
    }
    allLocalesLoader.prototype.load = function (availableLocales) {
        for (var property in allLocales) {
            if (allLocales.hasOwnProperty(property)) {
                availableLocales[property] = new allLocales[property]();
            }
        }
    };
    return allLocalesLoader;
}());
exports.allLocalesLoader = allLocalesLoader;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var en_1 = __webpack_require__(4);
Object.defineProperty(exports, "en", { enumerable: true, get: function () { return en_1.en; } });
var da_1 = __webpack_require__(10);
Object.defineProperty(exports, "da", { enumerable: true, get: function () { return da_1.da; } });
var de_1 = __webpack_require__(11);
Object.defineProperty(exports, "de", { enumerable: true, get: function () { return de_1.de; } });
var es_1 = __webpack_require__(12);
Object.defineProperty(exports, "es", { enumerable: true, get: function () { return es_1.es; } });
var fr_1 = __webpack_require__(13);
Object.defineProperty(exports, "fr", { enumerable: true, get: function () { return fr_1.fr; } });
var it_1 = __webpack_require__(14);
Object.defineProperty(exports, "it", { enumerable: true, get: function () { return it_1.it; } });
var ko_1 = __webpack_require__(15);
Object.defineProperty(exports, "ko", { enumerable: true, get: function () { return ko_1.ko; } });
var nl_1 = __webpack_require__(16);
Object.defineProperty(exports, "nl", { enumerable: true, get: function () { return nl_1.nl; } });
var nb_1 = __webpack_require__(17);
Object.defineProperty(exports, "nb", { enumerable: true, get: function () { return nb_1.nb; } });
var sv_1 = __webpack_require__(18);
Object.defineProperty(exports, "sv", { enumerable: true, get: function () { return sv_1.sv; } });
var pl_1 = __webpack_require__(19);
Object.defineProperty(exports, "pl", { enumerable: true, get: function () { return pl_1.pl; } });
var pt_BR_1 = __webpack_require__(20);
Object.defineProperty(exports, "pt_BR", { enumerable: true, get: function () { return pt_BR_1.pt_BR; } });
var ro_1 = __webpack_require__(21);
Object.defineProperty(exports, "ro", { enumerable: true, get: function () { return ro_1.ro; } });
var ru_1 = __webpack_require__(22);
Object.defineProperty(exports, "ru", { enumerable: true, get: function () { return ru_1.ru; } });
var tr_1 = __webpack_require__(23);
Object.defineProperty(exports, "tr", { enumerable: true, get: function () { return tr_1.tr; } });
var uk_1 = __webpack_require__(24);
Object.defineProperty(exports, "uk", { enumerable: true, get: function () { return uk_1.uk; } });
var zh_CN_1 = __webpack_require__(25);
Object.defineProperty(exports, "zh_CN", { enumerable: true, get: function () { return zh_CN_1.zh_CN; } });
var zh_TW_1 = __webpack_require__(26);
Object.defineProperty(exports, "zh_TW", { enumerable: true, get: function () { return zh_TW_1.zh_TW; } });
var ja_1 = __webpack_require__(27);
Object.defineProperty(exports, "ja", { enumerable: true, get: function () { return ja_1.ja; } });
var he_1 = __webpack_require__(28);
Object.defineProperty(exports, "he", { enumerable: true, get: function () { return he_1.he; } });
var cs_1 = __webpack_require__(29);
Object.defineProperty(exports, "cs", { enumerable: true, get: function () { return cs_1.cs; } });
var sk_1 = __webpack_require__(30);
Object.defineProperty(exports, "sk", { enumerable: true, get: function () { return sk_1.sk; } });
var fi_1 = __webpack_require__(31);
Object.defineProperty(exports, "fi", { enumerable: true, get: function () { return fi_1.fi; } });
var sl_1 = __webpack_require__(32);
Object.defineProperty(exports, "sl", { enumerable: true, get: function () { return sl_1.sl; } });
var sw_1 = __webpack_require__(33);
Object.defineProperty(exports, "sw", { enumerable: true, get: function () { return sw_1.sw; } });
var fa_1 = __webpack_require__(34);
Object.defineProperty(exports, "fa", { enumerable: true, get: function () { return fa_1.fa; } });
var ca_1 = __webpack_require__(35);
Object.defineProperty(exports, "ca", { enumerable: true, get: function () { return ca_1.ca; } });


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.da = void 0;
var da = (function () {
    function da() {
    }
    da.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    da.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Der opstod en fejl ved generering af udtryksbeskrivelsen. Tjek cron-ekspressionssyntaxen.";
    };
    da.prototype.at = function () {
        return "kl";
    };
    da.prototype.atSpace = function () {
        return "kl ";
    };
    da.prototype.atX0 = function () {
        return "kl %s";
    };
    da.prototype.atX0MinutesPastTheHour = function () {
        return "%s minutter efter timeskift";
    };
    da.prototype.atX0SecondsPastTheMinute = function () {
        return "%s sekunder efter minutskift";
    };
    da.prototype.betweenX0AndX1 = function () {
        return "mellem %s og %s";
    };
    da.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", mellem dag %s og %s i måneden";
    };
    da.prototype.commaEveryDay = function () {
        return ", hver dag";
    };
    da.prototype.commaEveryX0Days = function () {
        return ", hver %s. dag";
    };
    da.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", hver %s. ugedag";
    };
    da.prototype.commaEveryX0Months = function () {
        return ", hver %s. måned";
    };
    da.prototype.commaEveryX0Years = function () {
        return ", hvert %s. år";
    };
    da.prototype.commaOnDayX0OfTheMonth = function () {
        return ", på dag %s i måneden";
    };
    da.prototype.commaOnlyInX0 = function () {
        return ", kun i %s";
    };
    da.prototype.commaOnlyOnX0 = function () {
        return ", kun på %s";
    };
    da.prototype.commaAndOnX0 = function () {
        return ", og på %s";
    };
    da.prototype.commaOnThe = function () {
        return ", på den ";
    };
    da.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", på den sidste dag i måneden";
    };
    da.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", på den sidste hverdag i måneden";
    };
    da.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dage før den sidste dag i måneden";
    };
    da.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", på den sidste %s i måneden";
    };
    da.prototype.commaOnTheX0OfTheMonth = function () {
        return ", på den %s i måneden";
    };
    da.prototype.commaX0ThroughX1 = function () {
        return ", %s til og med %s";
    };
    da.prototype.everyHour = function () {
        return "hver time";
    };
    da.prototype.everyMinute = function () {
        return "hvert minut";
    };
    da.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "hvert minut mellem %s og %s";
    };
    da.prototype.everySecond = function () {
        return "hvert sekund";
    };
    da.prototype.everyX0Hours = function () {
        return "hver %s. time";
    };
    da.prototype.everyX0Minutes = function () {
        return "hvert %s. minut";
    };
    da.prototype.everyX0Seconds = function () {
        return "hvert %s. sekund";
    };
    da.prototype.fifth = function () {
        return "femte";
    };
    da.prototype.first = function () {
        return "første";
    };
    da.prototype.firstWeekday = function () {
        return "første hverdag";
    };
    da.prototype.fourth = function () {
        return "fjerde";
    };
    da.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minutterne fra %s til og med %s hver time";
    };
    da.prototype.second = function () {
        return "anden";
    };
    da.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekunderne fra %s til og med %s hvert minut";
    };
    da.prototype.spaceAnd = function () {
        return " og";
    };
    da.prototype.spaceX0OfTheMonth = function () {
        return " %s i måneden";
    };
    da.prototype.lastDay = function () {
        return "sidste dag";
    };
    da.prototype.third = function () {
        return "tredje";
    };
    da.prototype.weekdayNearestDayX0 = function () {
        return "hverdag nærmest dag %s";
    };
    da.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    da.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    da.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    da.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    da.prototype.commaStartingX0 = function () {
        return ", startende %s";
    };
    da.prototype.daysOfTheWeek = function () {
        return ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
    };
    da.prototype.monthsOfTheYear = function () {
        return [
            "januar",
            "februar",
            "marts",
            "april",
            "maj",
            "juni",
            "juli",
            "august",
            "september",
            "oktober",
            "november",
            "december",
        ];
    };
    return da;
}());
exports.da = da;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.de = void 0;
var de = (function () {
    function de() {
    }
    de.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    de.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    de.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    de.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    de.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    de.prototype.everyMinute = function () {
        return "jede Minute";
    };
    de.prototype.everyHour = function () {
        return "jede Stunde";
    };
    de.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Beim Generieren der Ausdrucksbeschreibung ist ein Fehler aufgetreten. Überprüfen Sie die Syntax des Cron-Ausdrucks.";
    };
    de.prototype.atSpace = function () {
        return "Um ";
    };
    de.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Jede Minute zwischen %s und %s";
    };
    de.prototype.at = function () {
        return "Um";
    };
    de.prototype.spaceAnd = function () {
        return " und";
    };
    de.prototype.everySecond = function () {
        return "Jede Sekunde";
    };
    de.prototype.everyX0Seconds = function () {
        return "alle %s Sekunden";
    };
    de.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "Sekunden %s bis %s";
    };
    de.prototype.atX0SecondsPastTheMinute = function () {
        return "bei Sekunde %s";
    };
    de.prototype.everyX0Minutes = function () {
        return "alle %s Minuten";
    };
    de.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "Minuten %s bis %s";
    };
    de.prototype.atX0MinutesPastTheHour = function () {
        return "bei Minute %s";
    };
    de.prototype.everyX0Hours = function () {
        return "alle %s Stunden";
    };
    de.prototype.betweenX0AndX1 = function () {
        return "zwischen %s und %s";
    };
    de.prototype.atX0 = function () {
        return "um %s";
    };
    de.prototype.commaEveryDay = function () {
        return ", jeden Tag";
    };
    de.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", alle %s Tage der Woche";
    };
    de.prototype.commaX0ThroughX1 = function () {
        return ", %s bis %s";
    };
    de.prototype.first = function () {
        return "ersten";
    };
    de.prototype.second = function () {
        return "zweiten";
    };
    de.prototype.third = function () {
        return "dritten";
    };
    de.prototype.fourth = function () {
        return "vierten";
    };
    de.prototype.fifth = function () {
        return "fünften";
    };
    de.prototype.commaOnThe = function () {
        return ", am ";
    };
    de.prototype.spaceX0OfTheMonth = function () {
        return " %s des Monats";
    };
    de.prototype.lastDay = function () {
        return "der letzte Tag";
    };
    de.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", am letzten %s des Monats";
    };
    de.prototype.commaOnlyOnX0 = function () {
        return ", nur jeden %s";
    };
    de.prototype.commaAndOnX0 = function () {
        return ", und jeden %s";
    };
    de.prototype.commaEveryX0Months = function () {
        return ", alle %s Monate";
    };
    de.prototype.commaOnlyInX0 = function () {
        return ", nur im %s";
    };
    de.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", am letzten Tag des Monats";
    };
    de.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", am letzten Werktag des Monats";
    };
    de.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s tage vor dem letzten Tag des Monats";
    };
    de.prototype.firstWeekday = function () {
        return "ersten Werktag";
    };
    de.prototype.weekdayNearestDayX0 = function () {
        return "Werktag am nächsten zum %s Tag";
    };
    de.prototype.commaOnTheX0OfTheMonth = function () {
        return ", am %s des Monats";
    };
    de.prototype.commaEveryX0Days = function () {
        return ", alle %s Tage";
    };
    de.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", zwischen Tag %s und %s des Monats";
    };
    de.prototype.commaOnDayX0OfTheMonth = function () {
        return ", an Tag %s des Monats";
    };
    de.prototype.commaEveryX0Years = function () {
        return ", alle %s Jahre";
    };
    de.prototype.commaStartingX0 = function () {
        return ", beginnend %s";
    };
    de.prototype.daysOfTheWeek = function () {
        return ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    };
    de.prototype.monthsOfTheYear = function () {
        return [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember",
        ];
    };
    return de;
}());
exports.de = de;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.es = void 0;
var es = (function () {
    function es() {
    }
    es.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    es.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    es.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    es.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    es.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    es.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Ocurrió un error mientras se generaba la descripción de la expresión. Revise la sintaxis de la expresión de cron.";
    };
    es.prototype.at = function () {
        return "A las";
    };
    es.prototype.atSpace = function () {
        return "A las ";
    };
    es.prototype.atX0 = function () {
        return "a las %s";
    };
    es.prototype.atX0MinutesPastTheHour = function () {
        return "a los %s minutos de la hora";
    };
    es.prototype.atX0SecondsPastTheMinute = function () {
        return "a los %s segundos del minuto";
    };
    es.prototype.betweenX0AndX1 = function () {
        return "entre las %s y las %s";
    };
    es.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", entre los días %s y %s del mes";
    };
    es.prototype.commaEveryDay = function () {
        return ", cada día";
    };
    es.prototype.commaEveryX0Days = function () {
        return ", cada %s días";
    };
    es.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", cada %s días de la semana";
    };
    es.prototype.commaEveryX0Months = function () {
        return ", cada %s meses";
    };
    es.prototype.commaOnDayX0OfTheMonth = function () {
        return ", el día %s del mes";
    };
    es.prototype.commaOnlyInX0 = function () {
        return ", sólo en %s";
    };
    es.prototype.commaOnlyOnX0 = function () {
        return ", sólo el %s";
    };
    es.prototype.commaAndOnX0 = function () {
        return ", y el %s";
    };
    es.prototype.commaOnThe = function () {
        return ", en el ";
    };
    es.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", en el último día del mes";
    };
    es.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", en el último día de la semana del mes";
    };
    es.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s días antes del último día del mes";
    };
    es.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", en el último %s del mes";
    };
    es.prototype.commaOnTheX0OfTheMonth = function () {
        return ", en el %s del mes";
    };
    es.prototype.commaX0ThroughX1 = function () {
        return ", de %s a %s";
    };
    es.prototype.everyHour = function () {
        return "cada hora";
    };
    es.prototype.everyMinute = function () {
        return "cada minuto";
    };
    es.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "cada minuto entre las %s y las %s";
    };
    es.prototype.everySecond = function () {
        return "cada segundo";
    };
    es.prototype.everyX0Hours = function () {
        return "cada %s horas";
    };
    es.prototype.everyX0Minutes = function () {
        return "cada %s minutos";
    };
    es.prototype.everyX0Seconds = function () {
        return "cada %s segundos";
    };
    es.prototype.fifth = function () {
        return "quinto";
    };
    es.prototype.first = function () {
        return "primero";
    };
    es.prototype.firstWeekday = function () {
        return "primer día de la semana";
    };
    es.prototype.fourth = function () {
        return "cuarto";
    };
    es.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "del minuto %s al %s pasada la hora";
    };
    es.prototype.second = function () {
        return "segundo";
    };
    es.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "En los segundos %s al %s de cada minuto";
    };
    es.prototype.spaceAnd = function () {
        return " y";
    };
    es.prototype.spaceX0OfTheMonth = function () {
        return " %s del mes";
    };
    es.prototype.lastDay = function () {
        return "el último día";
    };
    es.prototype.third = function () {
        return "tercer";
    };
    es.prototype.weekdayNearestDayX0 = function () {
        return "día de la semana más próximo al %s";
    };
    es.prototype.commaEveryX0Years = function () {
        return ", cada %s años";
    };
    es.prototype.commaStartingX0 = function () {
        return ", comenzando %s";
    };
    es.prototype.daysOfTheWeek = function () {
        return ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
    };
    es.prototype.monthsOfTheYear = function () {
        return [
            "enero",
            "febrero",
            "marzo",
            "abril",
            "mayo",
            "junio",
            "julio",
            "agosto",
            "septiembre",
            "octubre",
            "noviembre",
            "diciembre",
        ];
    };
    return es;
}());
exports.es = es;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.fr = void 0;
var fr = (function () {
    function fr() {
    }
    fr.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    fr.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    fr.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    fr.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    fr.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    fr.prototype.everyMinute = function () {
        return "toutes les minutes";
    };
    fr.prototype.everyHour = function () {
        return "toutes les heures";
    };
    fr.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Une erreur est survenue en générant la description de l'expression cron. Vérifiez sa syntaxe.";
    };
    fr.prototype.atSpace = function () {
        return "À ";
    };
    fr.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Toutes les minutes entre %s et %s";
    };
    fr.prototype.at = function () {
        return "À";
    };
    fr.prototype.spaceAnd = function () {
        return " et";
    };
    fr.prototype.everySecond = function () {
        return "toutes les secondes";
    };
    fr.prototype.everyX0Seconds = function () {
        return "toutes les %s secondes";
    };
    fr.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "les secondes entre %s et %s après la minute";
    };
    fr.prototype.atX0SecondsPastTheMinute = function () {
        return "%s secondes après la minute";
    };
    fr.prototype.everyX0Minutes = function () {
        return "toutes les %s minutes";
    };
    fr.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "les minutes entre %s et %s après l'heure";
    };
    fr.prototype.atX0MinutesPastTheHour = function () {
        return "%s minutes après l'heure";
    };
    fr.prototype.everyX0Hours = function () {
        return "toutes les %s heures";
    };
    fr.prototype.betweenX0AndX1 = function () {
        return "de %s à %s";
    };
    fr.prototype.atX0 = function () {
        return "à %s";
    };
    fr.prototype.commaEveryDay = function () {
        return ", tous les jours";
    };
    fr.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", every %s days of the week";
    };
    fr.prototype.commaX0ThroughX1 = function () {
        return ", de %s à %s";
    };
    fr.prototype.first = function () {
        return "premier";
    };
    fr.prototype.second = function () {
        return "second";
    };
    fr.prototype.third = function () {
        return "troisième";
    };
    fr.prototype.fourth = function () {
        return "quatrième";
    };
    fr.prototype.fifth = function () {
        return "cinquième";
    };
    fr.prototype.commaOnThe = function () {
        return ", le ";
    };
    fr.prototype.spaceX0OfTheMonth = function () {
        return " %s du mois";
    };
    fr.prototype.lastDay = function () {
        return "le dernier jour";
    };
    fr.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", le dernier %s du mois";
    };
    fr.prototype.commaOnlyOnX0 = function () {
        return ", uniquement le %s";
    };
    fr.prototype.commaAndOnX0 = function () {
        return ", et %s";
    };
    fr.prototype.commaEveryX0Months = function () {
        return ", tous les %s mois";
    };
    fr.prototype.commaOnlyInX0 = function () {
        return ", uniquement en %s";
    };
    fr.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", le dernier jour du mois";
    };
    fr.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", le dernier jour ouvrable du mois";
    };
    fr.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s jours avant le dernier jour du mois";
    };
    fr.prototype.firstWeekday = function () {
        return "premier jour ouvrable";
    };
    fr.prototype.weekdayNearestDayX0 = function () {
        return "jour ouvrable le plus proche du %s";
    };
    fr.prototype.commaOnTheX0OfTheMonth = function () {
        return ", le %s du mois";
    };
    fr.prototype.commaEveryX0Days = function () {
        return ", tous les %s jours";
    };
    fr.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", du %s au %s du mois";
    };
    fr.prototype.commaOnDayX0OfTheMonth = function () {
        return ", le %s du mois";
    };
    fr.prototype.commaEveryX0Years = function () {
        return ", tous les %s ans";
    };
    fr.prototype.commaDaysX0ThroughX1 = function () {
        return ", du %s au %s";
    };
    fr.prototype.commaStartingX0 = function () {
        return ", départ %s";
    };
    fr.prototype.daysOfTheWeek = function () {
        return ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
    };
    fr.prototype.monthsOfTheYear = function () {
        return [
            "janvier",
            "février",
            "mars",
            "avril",
            "mai",
            "juin",
            "juillet",
            "août",
            "septembre",
            "octobre",
            "novembre",
            "décembre",
        ];
    };
    return fr;
}());
exports.fr = fr;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.it = void 0;
var it = (function () {
    function it() {
    }
    it.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    it.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    it.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    it.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    it.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    it.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "È verificato un errore durante la generazione la descrizione espressione. Controllare la sintassi delle espressioni cron.";
    };
    it.prototype.at = function () {
        return "Alle";
    };
    it.prototype.atSpace = function () {
        return "Alle ";
    };
    it.prototype.atX0 = function () {
        return "alle %s";
    };
    it.prototype.atX0MinutesPastTheHour = function () {
        return "al %s minuto passata l'ora";
    };
    it.prototype.atX0SecondsPastTheMinute = function () {
        return "al %s secondo passato il minuto";
    };
    it.prototype.betweenX0AndX1 = function () {
        return "tra le %s e le %s";
    };
    it.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", tra il giorno %s e %s del mese";
    };
    it.prototype.commaEveryDay = function () {
        return ", ogni giorno";
    };
    it.prototype.commaEveryX0Days = function () {
        return ", ogni %s giorni";
    };
    it.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", ogni %s giorni della settimana";
    };
    it.prototype.commaEveryX0Months = function () {
        return ", ogni %s mesi";
    };
    it.prototype.commaEveryX0Years = function () {
        return ", ogni %s anni";
    };
    it.prototype.commaOnDayX0OfTheMonth = function () {
        return ", il giorno %s del mese";
    };
    it.prototype.commaOnlyInX0 = function () {
        return ", solo in %s";
    };
    it.prototype.commaOnlyOnX0 = function () {
        return ", solo il %s";
    };
    it.prototype.commaAndOnX0 = function () {
        return ", e il %s";
    };
    it.prototype.commaOnThe = function () {
        return ", il ";
    };
    it.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", l'ultimo giorno del mese";
    };
    it.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", nell'ultima settimana del mese";
    };
    it.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s giorni prima dell'ultimo giorno del mese";
    };
    it.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", l'ultimo %s del mese";
    };
    it.prototype.commaOnTheX0OfTheMonth = function () {
        return ", il %s del mese";
    };
    it.prototype.commaX0ThroughX1 = function () {
        return ", %s al %s";
    };
    it.prototype.everyHour = function () {
        return "ogni ora";
    };
    it.prototype.everyMinute = function () {
        return "ogni minuto";
    };
    it.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Ogni minuto tra le %s e le %s";
    };
    it.prototype.everySecond = function () {
        return "ogni secondo";
    };
    it.prototype.everyX0Hours = function () {
        return "ogni %s ore";
    };
    it.prototype.everyX0Minutes = function () {
        return "ogni %s minuti";
    };
    it.prototype.everyX0Seconds = function () {
        return "ogni %s secondi";
    };
    it.prototype.fifth = function () {
        return "quinto";
    };
    it.prototype.first = function () {
        return "primo";
    };
    it.prototype.firstWeekday = function () {
        return "primo giorno della settimana";
    };
    it.prototype.fourth = function () {
        return "quarto";
    };
    it.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minuti %s al %s dopo l'ora";
    };
    it.prototype.second = function () {
        return "secondo";
    };
    it.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "secondi %s al %s oltre il minuto";
    };
    it.prototype.spaceAnd = function () {
        return " e";
    };
    it.prototype.spaceX0OfTheMonth = function () {
        return " %s del mese";
    };
    it.prototype.lastDay = function () {
        return "l'ultimo giorno";
    };
    it.prototype.third = function () {
        return "terzo";
    };
    it.prototype.weekdayNearestDayX0 = function () {
        return "giorno della settimana più vicino al %s";
    };
    it.prototype.commaStartingX0 = function () {
        return ", a partire %s";
    };
    it.prototype.daysOfTheWeek = function () {
        return ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
    };
    it.prototype.monthsOfTheYear = function () {
        return [
            "gennaio",
            "febbraio",
            "marzo",
            "aprile",
            "maggio",
            "giugno",
            "luglio",
            "agosto",
            "settembre",
            "ottobre",
            "novembre",
            "dicembre",
        ];
    };
    return it;
}());
exports.it = it;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ko = void 0;
var ko = (function () {
    function ko() {
    }
    ko.prototype.setPeriodBeforeTime = function () {
        return true;
    };
    ko.prototype.pm = function () {
        return "오후";
    };
    ko.prototype.am = function () {
        return "오전";
    };
    ko.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    ko.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    ko.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    ko.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    ko.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    ko.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "표현식 설명을 생성하는 중 오류가 발생했습니다. cron 표현식 구문을 확인하십시오.";
    };
    ko.prototype.everyMinute = function () {
        return "1분마다";
    };
    ko.prototype.everyHour = function () {
        return "1시간마다";
    };
    ko.prototype.atSpace = function () {
        return "에서 ";
    };
    ko.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "%s 및 %s 사이에 매 분";
    };
    ko.prototype.at = function () {
        return "에서";
    };
    ko.prototype.spaceAnd = function () {
        return " 및";
    };
    ko.prototype.everySecond = function () {
        return "1초마다";
    };
    ko.prototype.everyX0Seconds = function () {
        return "%s초마다";
    };
    ko.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "정분 후 %s초에서 %s초까지";
    };
    ko.prototype.atX0SecondsPastTheMinute = function () {
        return "정분 후 %s초에서";
    };
    ko.prototype.everyX0Minutes = function () {
        return "%s분마다";
    };
    ko.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "정시 후 %s분에서 %s까지";
    };
    ko.prototype.atX0MinutesPastTheHour = function () {
        return "정시 후 %s분에서";
    };
    ko.prototype.everyX0Hours = function () {
        return "%s시간마다";
    };
    ko.prototype.betweenX0AndX1 = function () {
        return "%s에서 %s 사이";
    };
    ko.prototype.atX0 = function () {
        return "%s에서";
    };
    ko.prototype.commaEveryDay = function () {
        return ", 매일";
    };
    ko.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", 주 중 %s일마다";
    };
    ko.prototype.commaX0ThroughX1 = function () {
        return ", %s에서 %s가지";
    };
    ko.prototype.first = function () {
        return "첫 번째";
    };
    ko.prototype.second = function () {
        return "두 번째";
    };
    ko.prototype.third = function () {
        return "세 번째";
    };
    ko.prototype.fourth = function () {
        return "네 번째";
    };
    ko.prototype.fifth = function () {
        return "다섯 번째";
    };
    ko.prototype.commaOnThe = function () {
        return ", 해당 ";
    };
    ko.prototype.spaceX0OfTheMonth = function () {
        return " 해당 월의 %s";
    };
    ko.prototype.lastDay = function () {
        return "마지막 날";
    };
    ko.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", 해당 월의 마지막 %s";
    };
    ko.prototype.commaOnlyOnX0 = function () {
        return ", %s에만";
    };
    ko.prototype.commaAndOnX0 = function () {
        return ", 및 %s에";
    };
    ko.prototype.commaEveryX0Months = function () {
        return ", %s개월마다";
    };
    ko.prototype.commaOnlyInX0 = function () {
        return ", %s에서만";
    };
    ko.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", 해당 월의 마지막 날에";
    };
    ko.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", 해당 월의 마지막 평일에";
    };
    ko.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", 해당 월의 마지막 날 %s일 전";
    };
    ko.prototype.firstWeekday = function () {
        return "첫 번째 평일";
    };
    ko.prototype.weekdayNearestDayX0 = function () {
        return "평일 가장 가까운 날 %s";
    };
    ko.prototype.commaOnTheX0OfTheMonth = function () {
        return ", 해당 월의 %s에";
    };
    ko.prototype.commaEveryX0Days = function () {
        return ", %s일마다";
    };
    ko.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", 해당 월의 %s일 및 %s일 사이";
    };
    ko.prototype.commaOnDayX0OfTheMonth = function () {
        return ", 해당 월의 %s일에";
    };
    ko.prototype.commaEveryMinute = function () {
        return ", 1분마다";
    };
    ko.prototype.commaEveryHour = function () {
        return ", 1시간마다";
    };
    ko.prototype.commaEveryX0Years = function () {
        return ", %s년마다";
    };
    ko.prototype.commaStartingX0 = function () {
        return ", %s부터";
    };
    ko.prototype.daysOfTheWeek = function () {
        return ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
    };
    ko.prototype.monthsOfTheYear = function () {
        return ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"];
    };
    return ko;
}());
exports.ko = ko;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.nl = void 0;
var nl = (function () {
    function nl() {
    }
    nl.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    nl.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    nl.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    nl.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    nl.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    nl.prototype.everyMinute = function () {
        return "elke minuut";
    };
    nl.prototype.everyHour = function () {
        return "elk uur";
    };
    nl.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Er is een fout opgetreden bij het vertalen van de gegevens. Controleer de gegevens.";
    };
    nl.prototype.atSpace = function () {
        return "Op ";
    };
    nl.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Elke minuut tussen %s en %s";
    };
    nl.prototype.at = function () {
        return "Op";
    };
    nl.prototype.spaceAnd = function () {
        return " en";
    };
    nl.prototype.everySecond = function () {
        return "elke seconde";
    };
    nl.prototype.everyX0Seconds = function () {
        return "elke %s seconden";
    };
    nl.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "seconden %s t/m %s na de minuut";
    };
    nl.prototype.atX0SecondsPastTheMinute = function () {
        return "op %s seconden na de minuut";
    };
    nl.prototype.everyX0Minutes = function () {
        return "elke %s minuten";
    };
    nl.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minuut %s t/m %s na het uur";
    };
    nl.prototype.atX0MinutesPastTheHour = function () {
        return "op %s minuten na het uur";
    };
    nl.prototype.everyX0Hours = function () {
        return "elke %s uur";
    };
    nl.prototype.betweenX0AndX1 = function () {
        return "tussen %s en %s";
    };
    nl.prototype.atX0 = function () {
        return "op %s";
    };
    nl.prototype.commaEveryDay = function () {
        return ", elke dag";
    };
    nl.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", elke %s dagen van de week";
    };
    nl.prototype.commaX0ThroughX1 = function () {
        return ", %s t/m %s";
    };
    nl.prototype.first = function () {
        return "eerste";
    };
    nl.prototype.second = function () {
        return "tweede";
    };
    nl.prototype.third = function () {
        return "derde";
    };
    nl.prototype.fourth = function () {
        return "vierde";
    };
    nl.prototype.fifth = function () {
        return "vijfde";
    };
    nl.prototype.commaOnThe = function () {
        return ", op de ";
    };
    nl.prototype.spaceX0OfTheMonth = function () {
        return " %s van de maand";
    };
    nl.prototype.lastDay = function () {
        return "de laatste dag";
    };
    nl.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", op de laatste %s van de maand";
    };
    nl.prototype.commaOnlyOnX0 = function () {
        return ", alleen op %s";
    };
    nl.prototype.commaAndOnX0 = function () {
        return ", en op %s";
    };
    nl.prototype.commaEveryX0Months = function () {
        return ", elke %s maanden";
    };
    nl.prototype.commaOnlyInX0 = function () {
        return ", alleen in %s";
    };
    nl.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", op de laatste dag van de maand";
    };
    nl.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", op de laatste werkdag van de maand";
    };
    nl.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dagen vóór de laatste dag van de maand";
    };
    nl.prototype.firstWeekday = function () {
        return "eerste werkdag";
    };
    nl.prototype.weekdayNearestDayX0 = function () {
        return "werkdag dichtst bij dag %s";
    };
    nl.prototype.commaOnTheX0OfTheMonth = function () {
        return ", op de %s van de maand";
    };
    nl.prototype.commaEveryX0Days = function () {
        return ", elke %s dagen";
    };
    nl.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", tussen dag %s en %s van de maand";
    };
    nl.prototype.commaOnDayX0OfTheMonth = function () {
        return ", op dag %s van de maand";
    };
    nl.prototype.commaEveryX0Years = function () {
        return ", elke %s jaren";
    };
    nl.prototype.commaStartingX0 = function () {
        return ", beginnend %s";
    };
    nl.prototype.daysOfTheWeek = function () {
        return ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
    };
    nl.prototype.monthsOfTheYear = function () {
        return [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            "december",
        ];
    };
    return nl;
}());
exports.nl = nl;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.nb = void 0;
var nb = (function () {
    function nb() {
    }
    nb.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    nb.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    nb.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    nb.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    nb.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    nb.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "En feil inntraff ved generering av uttrykksbeskrivelse. Sjekk cron syntaks.";
    };
    nb.prototype.at = function () {
        return "Kl.";
    };
    nb.prototype.atSpace = function () {
        return "Kl.";
    };
    nb.prototype.atX0 = function () {
        return "på %s";
    };
    nb.prototype.atX0MinutesPastTheHour = function () {
        return "på %s minutter etter timen";
    };
    nb.prototype.atX0SecondsPastTheMinute = function () {
        return "på %s sekunder etter minuttet";
    };
    nb.prototype.betweenX0AndX1 = function () {
        return "mellom %s og %s";
    };
    nb.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", mellom dag %s og %s av måneden";
    };
    nb.prototype.commaEveryDay = function () {
        return ", hver dag";
    };
    nb.prototype.commaEveryX0Days = function () {
        return ", hver %s dag";
    };
    nb.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", hver %s ukedag";
    };
    nb.prototype.commaEveryX0Months = function () {
        return ", hver %s måned";
    };
    nb.prototype.commaEveryX0Years = function () {
        return ", hvert %s år";
    };
    nb.prototype.commaOnDayX0OfTheMonth = function () {
        return ", på dag %s av måneden";
    };
    nb.prototype.commaOnlyInX0 = function () {
        return ", bare i %s";
    };
    nb.prototype.commaOnlyOnX0 = function () {
        return ", på %s";
    };
    nb.prototype.commaAndOnX0 = function () {
        return ", og på %s";
    };
    nb.prototype.commaOnThe = function () {
        return ", på ";
    };
    nb.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", på den siste dagen i måneden";
    };
    nb.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", den siste ukedagen i måneden";
    };
    nb.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dager før den siste dagen i måneden";
    };
    nb.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", på den siste %s av måneden";
    };
    nb.prototype.commaOnTheX0OfTheMonth = function () {
        return ", på den %s av måneden";
    };
    nb.prototype.commaX0ThroughX1 = function () {
        return ", %s til og med %s";
    };
    nb.prototype.everyHour = function () {
        return "hver time";
    };
    nb.prototype.everyMinute = function () {
        return "hvert minutt";
    };
    nb.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Hvert minutt mellom %s og %s";
    };
    nb.prototype.everySecond = function () {
        return "hvert sekund";
    };
    nb.prototype.everyX0Hours = function () {
        return "hver %s time";
    };
    nb.prototype.everyX0Minutes = function () {
        return "hvert %s minutt";
    };
    nb.prototype.everyX0Seconds = function () {
        return "hvert %s sekund";
    };
    nb.prototype.fifth = function () {
        return "femte";
    };
    nb.prototype.first = function () {
        return "første";
    };
    nb.prototype.firstWeekday = function () {
        return "første ukedag";
    };
    nb.prototype.fourth = function () {
        return "fjerde";
    };
    nb.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minuttene fra %s til og med %s etter timen";
    };
    nb.prototype.second = function () {
        return "sekund";
    };
    nb.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekundene fra %s til og med %s etter minuttet";
    };
    nb.prototype.spaceAnd = function () {
        return " og";
    };
    nb.prototype.spaceX0OfTheMonth = function () {
        return " %s i måneden";
    };
    nb.prototype.lastDay = function () {
        return "den siste dagen";
    };
    nb.prototype.third = function () {
        return "tredje";
    };
    nb.prototype.weekdayNearestDayX0 = function () {
        return "ukedag nærmest dag %s";
    };
    nb.prototype.commaStartingX0 = function () {
        return ", starter %s";
    };
    nb.prototype.daysOfTheWeek = function () {
        return ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
    };
    nb.prototype.monthsOfTheYear = function () {
        return [
            "januar",
            "februar",
            "mars",
            "april",
            "mai",
            "juni",
            "juli",
            "august",
            "september",
            "oktober",
            "november",
            "desember",
        ];
    };
    return nb;
}());
exports.nb = nb;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.sv = void 0;
var sv = (function () {
    function sv() {
    }
    sv.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    sv.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    sv.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    sv.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    sv.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    sv.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Ett fel inträffade vid generering av uttryckets beskrivning. Kontrollera cron-uttryckets syntax.";
    };
    sv.prototype.everyMinute = function () {
        return "varje minut";
    };
    sv.prototype.everyHour = function () {
        return "varje timme";
    };
    sv.prototype.atSpace = function () {
        return "Kl ";
    };
    sv.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Varje minut mellan %s och %s";
    };
    sv.prototype.at = function () {
        return "Kl";
    };
    sv.prototype.spaceAnd = function () {
        return " och";
    };
    sv.prototype.everySecond = function () {
        return "varje sekund";
    };
    sv.prototype.everyX0Seconds = function () {
        return "varje %s sekund";
    };
    sv.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekunderna från %s till och med %s efter minuten";
    };
    sv.prototype.atX0SecondsPastTheMinute = function () {
        return "på %s sekunder efter minuten";
    };
    sv.prototype.everyX0Minutes = function () {
        return "var %s minut";
    };
    sv.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minuterna från %s till och med %s efter timmen";
    };
    sv.prototype.atX0MinutesPastTheHour = function () {
        return "på %s minuten efter timmen";
    };
    sv.prototype.everyX0Hours = function () {
        return "var %s timme";
    };
    sv.prototype.betweenX0AndX1 = function () {
        return "mellan %s och %s";
    };
    sv.prototype.atX0 = function () {
        return "kl %s";
    };
    sv.prototype.commaEveryDay = function () {
        return ", varje dag";
    };
    sv.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", var %s dag i veckan";
    };
    sv.prototype.commaX0ThroughX1 = function () {
        return ", %s till %s";
    };
    sv.prototype.first = function () {
        return "första";
    };
    sv.prototype.second = function () {
        return "andra";
    };
    sv.prototype.third = function () {
        return "tredje";
    };
    sv.prototype.fourth = function () {
        return "fjärde";
    };
    sv.prototype.fifth = function () {
        return "femte";
    };
    sv.prototype.commaOnThe = function () {
        return ", den ";
    };
    sv.prototype.spaceX0OfTheMonth = function () {
        return " %sen av månaden";
    };
    sv.prototype.lastDay = function () {
        return "den sista dagen";
    };
    sv.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", på sista %s av månaden";
    };
    sv.prototype.commaOnlyOnX0 = function () {
        return ", varje %s";
    };
    sv.prototype.commaAndOnX0 = function () {
        return ", och på %s";
    };
    sv.prototype.commaEveryX0Months = function () {
        return ", var %s månad";
    };
    sv.prototype.commaOnlyInX0 = function () {
        return ", bara på %s";
    };
    sv.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", på sista dagen av månaden";
    };
    sv.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", på sista veckodag av månaden";
    };
    sv.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dagar före den sista dagen i månaden";
    };
    sv.prototype.firstWeekday = function () {
        return "första veckodag";
    };
    sv.prototype.weekdayNearestDayX0 = function () {
        return "veckodagen närmast dag %s";
    };
    sv.prototype.commaOnTheX0OfTheMonth = function () {
        return ", på den %s av månaden";
    };
    sv.prototype.commaEveryX0Days = function () {
        return ", var %s dag";
    };
    sv.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", mellan dag %s och %s av månaden";
    };
    sv.prototype.commaOnDayX0OfTheMonth = function () {
        return ", på dag %s av månaden";
    };
    sv.prototype.commaEveryX0Years = function () {
        return ", var %s år";
    };
    sv.prototype.commaStartingX0 = function () {
        return ", startar %s";
    };
    sv.prototype.daysOfTheWeek = function () {
        return ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"];
    };
    sv.prototype.monthsOfTheYear = function () {
        return [
            "januari",
            "februari",
            "mars",
            "april",
            "maj",
            "juni",
            "juli",
            "augusti",
            "september",
            "oktober",
            "november",
            "december",
        ];
    };
    return sv;
}());
exports.sv = sv;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.pl = void 0;
var pl = (function () {
    function pl() {
    }
    pl.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    pl.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    pl.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    pl.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    pl.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    pl.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Wystąpił błąd podczas generowania opisu wyrażenia cron. Sprawdź składnię wyrażenia cron.";
    };
    pl.prototype.at = function () {
        return "O";
    };
    pl.prototype.atSpace = function () {
        return "O ";
    };
    pl.prototype.atX0 = function () {
        return "o %s";
    };
    pl.prototype.atX0MinutesPastTheHour = function () {
        return "w %s minucie";
    };
    pl.prototype.atX0SecondsPastTheMinute = function () {
        return "w %s sekundzie";
    };
    pl.prototype.betweenX0AndX1 = function () {
        return "od %s do %s";
    };
    pl.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", od %s-ego do %s-ego dnia miesiąca";
    };
    pl.prototype.commaEveryDay = function () {
        return ", co dzień";
    };
    pl.prototype.commaEveryX0Days = function () {
        return ", co %s dni";
    };
    pl.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", co %s dni tygodnia";
    };
    pl.prototype.commaEveryX0Months = function () {
        return ", co %s miesięcy";
    };
    pl.prototype.commaEveryX0Years = function () {
        return ", co %s lat";
    };
    pl.prototype.commaOnDayX0OfTheMonth = function () {
        return ", %s-ego dnia miesiąca";
    };
    pl.prototype.commaOnlyInX0 = function () {
        return ", tylko %s";
    };
    pl.prototype.commaOnlyOnX0 = function () {
        return ", tylko %s";
    };
    pl.prototype.commaAndOnX0 = function () {
        return ", i %s";
    };
    pl.prototype.commaOnThe = function () {
        return ", ";
    };
    pl.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", ostatni dzień miesiąca";
    };
    pl.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", ostatni dzień roboczy miesiąca";
    };
    pl.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dni przed ostatnim dniem miesiąca";
    };
    pl.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", ostatni %s miesiąca";
    };
    pl.prototype.commaOnTheX0OfTheMonth = function () {
        return ", %s miesiąca";
    };
    pl.prototype.commaX0ThroughX1 = function () {
        return ", od %s do %s";
    };
    pl.prototype.everyHour = function () {
        return "co godzinę";
    };
    pl.prototype.everyMinute = function () {
        return "co minutę";
    };
    pl.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Co minutę od %s do %s";
    };
    pl.prototype.everySecond = function () {
        return "co sekundę";
    };
    pl.prototype.everyX0Hours = function () {
        return "co %s godzin";
    };
    pl.prototype.everyX0Minutes = function () {
        return "co %s minut";
    };
    pl.prototype.everyX0Seconds = function () {
        return "co %s sekund";
    };
    pl.prototype.fifth = function () {
        return "piąty";
    };
    pl.prototype.first = function () {
        return "pierwszy";
    };
    pl.prototype.firstWeekday = function () {
        return "pierwszy dzień roboczy";
    };
    pl.prototype.fourth = function () {
        return "czwarty";
    };
    pl.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minuty od %s do %s";
    };
    pl.prototype.second = function () {
        return "drugi";
    };
    pl.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekundy od %s do %s";
    };
    pl.prototype.spaceAnd = function () {
        return " i";
    };
    pl.prototype.spaceX0OfTheMonth = function () {
        return " %s miesiąca";
    };
    pl.prototype.lastDay = function () {
        return "ostatni dzień";
    };
    pl.prototype.third = function () {
        return "trzeci";
    };
    pl.prototype.weekdayNearestDayX0 = function () {
        return "dzień roboczy najbliższy %s-ego dnia";
    };
    pl.prototype.commaStartingX0 = function () {
        return ", startowy %s";
    };
    pl.prototype.daysOfTheWeek = function () {
        return ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"];
    };
    pl.prototype.monthsOfTheYear = function () {
        return [
            "styczeń",
            "luty",
            "marzec",
            "kwiecień",
            "maj",
            "czerwiec",
            "lipiec",
            "sierpień",
            "wrzesień",
            "październik",
            "listopad",
            "grudzień",
        ];
    };
    return pl;
}());
exports.pl = pl;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.pt_BR = void 0;
var pt_BR = (function () {
    function pt_BR() {
    }
    pt_BR.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    pt_BR.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    pt_BR.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    pt_BR.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    pt_BR.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    pt_BR.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Ocorreu um erro ao gerar a descrição da expressão Cron.";
    };
    pt_BR.prototype.at = function () {
        return "às";
    };
    pt_BR.prototype.atSpace = function () {
        return "às ";
    };
    pt_BR.prototype.atX0 = function () {
        return "Às %s";
    };
    pt_BR.prototype.atX0MinutesPastTheHour = function () {
        return "aos %s minutos da hora";
    };
    pt_BR.prototype.atX0SecondsPastTheMinute = function () {
        return "aos %s segundos do minuto";
    };
    pt_BR.prototype.betweenX0AndX1 = function () {
        return "entre %s e %s";
    };
    pt_BR.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", entre os dias %s e %s do mês";
    };
    pt_BR.prototype.commaEveryDay = function () {
        return ", a cada dia";
    };
    pt_BR.prototype.commaEveryX0Days = function () {
        return ", a cada %s dias";
    };
    pt_BR.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", a cada %s dias de semana";
    };
    pt_BR.prototype.commaEveryX0Months = function () {
        return ", a cada %s meses";
    };
    pt_BR.prototype.commaOnDayX0OfTheMonth = function () {
        return ", no dia %s do mês";
    };
    pt_BR.prototype.commaOnlyInX0 = function () {
        return ", somente em %s";
    };
    pt_BR.prototype.commaOnlyOnX0 = function () {
        return ", somente de %s";
    };
    pt_BR.prototype.commaAndOnX0 = function () {
        return ", e de %s";
    };
    pt_BR.prototype.commaOnThe = function () {
        return ", na ";
    };
    pt_BR.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", no último dia do mês";
    };
    pt_BR.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", no último dia da semana do mês";
    };
    pt_BR.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dias antes do último dia do mês";
    };
    pt_BR.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", na última %s do mês";
    };
    pt_BR.prototype.commaOnTheX0OfTheMonth = function () {
        return ", no %s do mês";
    };
    pt_BR.prototype.commaX0ThroughX1 = function () {
        return ", de %s a %s";
    };
    pt_BR.prototype.everyHour = function () {
        return "a cada hora";
    };
    pt_BR.prototype.everyMinute = function () {
        return "a cada minuto";
    };
    pt_BR.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "a cada minuto entre %s e %s";
    };
    pt_BR.prototype.everySecond = function () {
        return "a cada segundo";
    };
    pt_BR.prototype.everyX0Hours = function () {
        return "a cada %s horas";
    };
    pt_BR.prototype.everyX0Minutes = function () {
        return "a cada %s minutos";
    };
    pt_BR.prototype.everyX0Seconds = function () {
        return "a cada %s segundos";
    };
    pt_BR.prototype.fifth = function () {
        return "quinta";
    };
    pt_BR.prototype.first = function () {
        return "primeira";
    };
    pt_BR.prototype.firstWeekday = function () {
        return "primeiro dia da semana";
    };
    pt_BR.prototype.fourth = function () {
        return "quarta";
    };
    pt_BR.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "do minuto %s até %s de cada hora";
    };
    pt_BR.prototype.second = function () {
        return "segunda";
    };
    pt_BR.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "No segundo %s até %s de cada minuto";
    };
    pt_BR.prototype.spaceAnd = function () {
        return " e";
    };
    pt_BR.prototype.spaceX0OfTheMonth = function () {
        return " %s do mês";
    };
    pt_BR.prototype.lastDay = function () {
        return "o último dia";
    };
    pt_BR.prototype.third = function () {
        return "terceira";
    };
    pt_BR.prototype.weekdayNearestDayX0 = function () {
        return "dia da semana mais próximo do dia %s";
    };
    pt_BR.prototype.commaEveryX0Years = function () {
        return ", a cada %s anos";
    };
    pt_BR.prototype.commaStartingX0 = function () {
        return ", iniciando %s";
    };
    pt_BR.prototype.daysOfTheWeek = function () {
        return ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
    };
    pt_BR.prototype.monthsOfTheYear = function () {
        return [
            "janeiro",
            "fevereiro",
            "março",
            "abril",
            "maio",
            "junho",
            "julho",
            "agosto",
            "setembro",
            "outubro",
            "novembro",
            "dezembro",
        ];
    };
    return pt_BR;
}());
exports.pt_BR = pt_BR;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ro = void 0;
var ro = (function () {
    function ro() {
    }
    ro.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    ro.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Eroare la generarea descrierii. Verificați sintaxa.";
    };
    ro.prototype.at = function () {
        return "La";
    };
    ro.prototype.atSpace = function () {
        return "La ";
    };
    ro.prototype.atX0 = function () {
        return "la %s";
    };
    ro.prototype.atX0MinutesPastTheHour = function () {
        return "la și %s minute";
    };
    ro.prototype.atX0SecondsPastTheMinute = function () {
        return "la și %s secunde";
    };
    ro.prototype.betweenX0AndX1 = function () {
        return "între %s și %s";
    };
    ro.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", între zilele %s și %s ale lunii";
    };
    ro.prototype.commaEveryDay = function () {
        return ", în fiecare zi";
    };
    ro.prototype.commaEveryX0Days = function () {
        return ", la fiecare %s zile";
    };
    ro.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", la fiecare a %s-a zi a săptămânii";
    };
    ro.prototype.commaEveryX0Months = function () {
        return ", la fiecare %s luni";
    };
    ro.prototype.commaEveryX0Years = function () {
        return ", o dată la %s ani";
    };
    ro.prototype.commaOnDayX0OfTheMonth = function () {
        return ", în ziua %s a lunii";
    };
    ro.prototype.commaOnlyInX0 = function () {
        return ", doar în %s";
    };
    ro.prototype.commaOnlyOnX0 = function () {
        return ", doar %s";
    };
    ro.prototype.commaAndOnX0 = function () {
        return ", și %s";
    };
    ro.prototype.commaOnThe = function () {
        return ", în ";
    };
    ro.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", în ultima zi a lunii";
    };
    ro.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", în ultima zi lucrătoare a lunii";
    };
    ro.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s zile înainte de ultima zi a lunii";
    };
    ro.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", în ultima %s a lunii";
    };
    ro.prototype.commaOnTheX0OfTheMonth = function () {
        return ", în %s a lunii";
    };
    ro.prototype.commaX0ThroughX1 = function () {
        return ", de %s până %s";
    };
    ro.prototype.everyHour = function () {
        return "în fiecare oră";
    };
    ro.prototype.everyMinute = function () {
        return "în fiecare minut";
    };
    ro.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "În fiecare minut între %s și %s";
    };
    ro.prototype.everySecond = function () {
        return "în fiecare secundă";
    };
    ro.prototype.everyX0Hours = function () {
        return "la fiecare %s ore";
    };
    ro.prototype.everyX0Minutes = function () {
        return "la fiecare %s minute";
    };
    ro.prototype.everyX0Seconds = function () {
        return "la fiecare %s secunde";
    };
    ro.prototype.fifth = function () {
        return "a cincea";
    };
    ro.prototype.first = function () {
        return "prima";
    };
    ro.prototype.firstWeekday = function () {
        return "prima zi a săptămânii";
    };
    ro.prototype.fourth = function () {
        return "a patra";
    };
    ro.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "între minutele %s și %s";
    };
    ro.prototype.second = function () {
        return "a doua";
    };
    ro.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "între secunda %s și secunda %s";
    };
    ro.prototype.spaceAnd = function () {
        return " și";
    };
    ro.prototype.spaceX0OfTheMonth = function () {
        return " %s a lunii";
    };
    ro.prototype.lastDay = function () {
        return "ultima zi";
    };
    ro.prototype.third = function () {
        return "a treia";
    };
    ro.prototype.weekdayNearestDayX0 = function () {
        return "cea mai apropiată zi a săptămânii de ziua %s";
    };
    ro.prototype.commaMonthX0ThroughMonthX1 = function () {
        return ", din %s până în %s";
    };
    ro.prototype.commaYearX0ThroughYearX1 = function () {
        return ", din %s până în %s";
    };
    ro.prototype.atX0MinutesPastTheHourGt20 = function () {
        return "la și %s de minute";
    };
    ro.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return "la și %s de secunde";
    };
    ro.prototype.commaStartingX0 = function () {
        return ", pornire %s";
    };
    ro.prototype.daysOfTheWeek = function () {
        return ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];
    };
    ro.prototype.monthsOfTheYear = function () {
        return [
            "ianuarie",
            "februarie",
            "martie",
            "aprilie",
            "mai",
            "iunie",
            "iulie",
            "august",
            "septembrie",
            "octombrie",
            "noiembrie",
            "decembrie",
        ];
    };
    return ro;
}());
exports.ro = ro;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ru = void 0;
var ru = (function () {
    function ru() {
    }
    ru.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    ru.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    ru.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    ru.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    ru.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    ru.prototype.everyMinute = function () {
        return "каждую минуту";
    };
    ru.prototype.everyHour = function () {
        return "каждый час";
    };
    ru.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Произошла ошибка во время генерации описания выражения. Проверьте синтаксис крон-выражения.";
    };
    ru.prototype.atSpace = function () {
        return "В ";
    };
    ru.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Каждую минуту с %s по %s";
    };
    ru.prototype.at = function () {
        return "В";
    };
    ru.prototype.spaceAnd = function () {
        return " и";
    };
    ru.prototype.everySecond = function () {
        return "каждую секунду";
    };
    ru.prototype.everyX0Seconds = function () {
        return "каждые %s секунд";
    };
    ru.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "секунды с %s по %s";
    };
    ru.prototype.atX0SecondsPastTheMinute = function () {
        return "в %s секунд";
    };
    ru.prototype.everyX0Minutes = function () {
        return "каждые %s минут";
    };
    ru.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "минуты с %s по %s";
    };
    ru.prototype.atX0MinutesPastTheHour = function () {
        return "в %s минут";
    };
    ru.prototype.everyX0Hours = function () {
        return "каждые %s часов";
    };
    ru.prototype.betweenX0AndX1 = function () {
        return "с %s по %s";
    };
    ru.prototype.atX0 = function () {
        return "в %s";
    };
    ru.prototype.commaEveryDay = function () {
        return ", каждый день";
    };
    ru.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", каждые %s дней недели";
    };
    ru.prototype.commaX0ThroughX1 = function () {
        return ", %s по %s";
    };
    ru.prototype.first = function () {
        return "первый";
    };
    ru.prototype.second = function () {
        return "второй";
    };
    ru.prototype.third = function () {
        return "третий";
    };
    ru.prototype.fourth = function () {
        return "четвертый";
    };
    ru.prototype.fifth = function () {
        return "пятый";
    };
    ru.prototype.commaOnThe = function () {
        return ", в ";
    };
    ru.prototype.spaceX0OfTheMonth = function () {
        return " %s месяца";
    };
    ru.prototype.lastDay = function () {
        return "последний день";
    };
    ru.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", в последний %s месяца";
    };
    ru.prototype.commaOnlyOnX0 = function () {
        return ", только в %s";
    };
    ru.prototype.commaAndOnX0 = function () {
        return ", и в %s";
    };
    ru.prototype.commaEveryX0Months = function () {
        return ", каждые %s месяцев";
    };
    ru.prototype.commaOnlyInX0 = function () {
        return ", только в %s";
    };
    ru.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", в последний день месяца";
    };
    ru.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", в последний будний день месяца";
    };
    ru.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s дней до последнего дня месяца";
    };
    ru.prototype.firstWeekday = function () {
        return "первый будний день";
    };
    ru.prototype.weekdayNearestDayX0 = function () {
        return "ближайший будний день к %s";
    };
    ru.prototype.commaOnTheX0OfTheMonth = function () {
        return ", в %s месяца";
    };
    ru.prototype.commaEveryX0Days = function () {
        return ", каждые %s дней";
    };
    ru.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", с %s по %s число месяца";
    };
    ru.prototype.commaOnDayX0OfTheMonth = function () {
        return ", в %s число месяца";
    };
    ru.prototype.commaEveryX0Years = function () {
        return ", каждые %s лет";
    };
    ru.prototype.commaStartingX0 = function () {
        return ", начало %s";
    };
    ru.prototype.daysOfTheWeek = function () {
        return ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"];
    };
    ru.prototype.monthsOfTheYear = function () {
        return [
            "январь",
            "февраль",
            "март",
            "апрель",
            "май",
            "июнь",
            "июль",
            "август",
            "сентябрь",
            "октябрь",
            "ноябрь",
            "декабрь",
        ];
    };
    return ru;
}());
exports.ru = ru;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.tr = void 0;
var tr = (function () {
    function tr() {
    }
    tr.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    tr.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    tr.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    tr.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    tr.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    tr.prototype.everyMinute = function () {
        return "her dakika";
    };
    tr.prototype.everyHour = function () {
        return "her saat";
    };
    tr.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "İfade açıklamasını oluştururken bir hata oluştu. Cron ifadesini gözden geçirin.";
    };
    tr.prototype.atSpace = function () {
        return "Saat ";
    };
    tr.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Saat %s ve %s arasındaki her dakika";
    };
    tr.prototype.at = function () {
        return "Saat";
    };
    tr.prototype.spaceAnd = function () {
        return " ve";
    };
    tr.prototype.everySecond = function () {
        return "her saniye";
    };
    tr.prototype.everyX0Seconds = function () {
        return "her %s saniyede bir";
    };
    tr.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "dakikaların %s. ve %s. saniyeleri arası";
    };
    tr.prototype.atX0SecondsPastTheMinute = function () {
        return "dakikaların %s. saniyesinde";
    };
    tr.prototype.everyX0Minutes = function () {
        return "her %s dakikada bir";
    };
    tr.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "saatlerin %s. ve %s. dakikaları arası";
    };
    tr.prototype.atX0MinutesPastTheHour = function () {
        return "saatlerin %s. dakikasında";
    };
    tr.prototype.everyX0Hours = function () {
        return "her %s saatte";
    };
    tr.prototype.betweenX0AndX1 = function () {
        return "%s ile %s arasında";
    };
    tr.prototype.atX0 = function () {
        return "saat %s";
    };
    tr.prototype.commaEveryDay = function () {
        return ", her gün";
    };
    tr.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", ayın her %s günü";
    };
    tr.prototype.commaX0ThroughX1 = function () {
        return ", %s ile %s arasında";
    };
    tr.prototype.first = function () {
        return "ilk";
    };
    tr.prototype.second = function () {
        return "ikinci";
    };
    tr.prototype.third = function () {
        return "üçüncü";
    };
    tr.prototype.fourth = function () {
        return "dördüncü";
    };
    tr.prototype.fifth = function () {
        return "beşinci";
    };
    tr.prototype.commaOnThe = function () {
        return ", ayın ";
    };
    tr.prototype.spaceX0OfTheMonth = function () {
        return " %s günü";
    };
    tr.prototype.lastDay = function () {
        return "son gün";
    };
    tr.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", ayın son %s günü";
    };
    tr.prototype.commaOnlyOnX0 = function () {
        return ", sadece %s günü";
    };
    tr.prototype.commaAndOnX0 = function () {
        return ", ve %s";
    };
    tr.prototype.commaEveryX0Months = function () {
        return ", %s ayda bir";
    };
    tr.prototype.commaOnlyInX0 = function () {
        return ", sadece %s için";
    };
    tr.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", ayın son günü";
    };
    tr.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", ayın son iş günü";
    };
    tr.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s ayın son gününden önceki günler";
    };
    tr.prototype.firstWeekday = function () {
        return "ilk iş günü";
    };
    tr.prototype.weekdayNearestDayX0 = function () {
        return "%s. günü sonrasındaki ilk iş günü";
    };
    tr.prototype.commaOnTheX0OfTheMonth = function () {
        return ", ayın %s";
    };
    tr.prototype.commaEveryX0Days = function () {
        return ", %s günde bir";
    };
    tr.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", ayın %s. ve %s. günleri arası";
    };
    tr.prototype.commaOnDayX0OfTheMonth = function () {
        return ", ayın %s. günü";
    };
    tr.prototype.commaEveryX0Years = function () {
        return ", %s yılda bir";
    };
    tr.prototype.commaStartingX0 = function () {
        return ", başlangıç %s";
    };
    tr.prototype.daysOfTheWeek = function () {
        return ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
    };
    tr.prototype.monthsOfTheYear = function () {
        return [
            "Ocak",
            "Şubat",
            "Mart",
            "Nisan",
            "Mayıs",
            "Haziran",
            "Temmuz",
            "Ağustos",
            "Eylül",
            "Ekim",
            "Kasım",
            "Aralık",
        ];
    };
    return tr;
}());
exports.tr = tr;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.uk = void 0;
var uk = (function () {
    function uk() {
    }
    uk.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    uk.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    uk.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    uk.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    uk.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    uk.prototype.everyMinute = function () {
        return "щохвилини";
    };
    uk.prototype.everyHour = function () {
        return "щогодини";
    };
    uk.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "ВІдбулася помилка підчас генерації опису. Перевірта правильність написання cron виразу.";
    };
    uk.prototype.atSpace = function () {
        return "О ";
    };
    uk.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Щохвилини між %s та %s";
    };
    uk.prototype.at = function () {
        return "О";
    };
    uk.prototype.spaceAnd = function () {
        return " та";
    };
    uk.prototype.everySecond = function () {
        return "Щосекунди";
    };
    uk.prototype.everyX0Seconds = function () {
        return "кожні %s секунд";
    };
    uk.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "з %s по %s секунду";
    };
    uk.prototype.atX0SecondsPastTheMinute = function () {
        return "о %s секунді";
    };
    uk.prototype.everyX0Minutes = function () {
        return "кожні %s хвилин";
    };
    uk.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "з %s по %s хвилину";
    };
    uk.prototype.atX0MinutesPastTheHour = function () {
        return "о %s хвилині";
    };
    uk.prototype.everyX0Hours = function () {
        return "кожні %s годин";
    };
    uk.prototype.betweenX0AndX1 = function () {
        return "між %s та %s";
    };
    uk.prototype.atX0 = function () {
        return "о %s";
    };
    uk.prototype.commaEveryDay = function () {
        return ", щоденно";
    };
    uk.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", кожен %s день тижня";
    };
    uk.prototype.commaX0ThroughX1 = function () {
        return ", %s по %s";
    };
    uk.prototype.first = function () {
        return "перший";
    };
    uk.prototype.second = function () {
        return "другий";
    };
    uk.prototype.third = function () {
        return "третій";
    };
    uk.prototype.fourth = function () {
        return "четвертий";
    };
    uk.prototype.fifth = function () {
        return "п'ятий";
    };
    uk.prototype.commaOnThe = function () {
        return ", в ";
    };
    uk.prototype.spaceX0OfTheMonth = function () {
        return " %s місяця";
    };
    uk.prototype.lastDay = function () {
        return "останній день";
    };
    uk.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", в останній %s місяця";
    };
    uk.prototype.commaOnlyOnX0 = function () {
        return ", тільки в %s";
    };
    uk.prototype.commaAndOnX0 = function () {
        return ", і в %s";
    };
    uk.prototype.commaEveryX0Months = function () {
        return ", кожен %s місяць";
    };
    uk.prototype.commaOnlyInX0 = function () {
        return ", тільки в %s";
    };
    uk.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", в останній день місяця";
    };
    uk.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", в останній будень місяця";
    };
    uk.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s днів до останнього дня місяця";
    };
    uk.prototype.firstWeekday = function () {
        return "перший будень";
    };
    uk.prototype.weekdayNearestDayX0 = function () {
        return "будень найближчий до %s дня";
    };
    uk.prototype.commaOnTheX0OfTheMonth = function () {
        return ", в %s місяця";
    };
    uk.prototype.commaEveryX0Days = function () {
        return ", кожен %s день";
    };
    uk.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", між %s та %s днями місяця";
    };
    uk.prototype.commaOnDayX0OfTheMonth = function () {
        return ", на %s день місяця";
    };
    uk.prototype.commaEveryX0Years = function () {
        return ", кожні %s роки";
    };
    uk.prototype.commaStartingX0 = function () {
        return ", початок %s";
    };
    uk.prototype.daysOfTheWeek = function () {
        return ["неділя", "понеділок", "вівторок", "середа", "четвер", "п'ятниця", "субота"];
    };
    uk.prototype.monthsOfTheYear = function () {
        return [
            "січень",
            "лютий",
            "березень",
            "квітень",
            "травень",
            "червень",
            "липень",
            "серпень",
            "вересень",
            "жовтень",
            "листопад",
            "грудень",
        ];
    };
    return uk;
}());
exports.uk = uk;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.zh_CN = void 0;
var zh_CN = (function () {
    function zh_CN() {
    }
    zh_CN.prototype.setPeriodBeforeTime = function () {
        return true;
    };
    zh_CN.prototype.pm = function () {
        return "下午";
    };
    zh_CN.prototype.am = function () {
        return "上午";
    };
    zh_CN.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    zh_CN.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    zh_CN.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    zh_CN.prototype.commaYearX0ThroughYearX1 = function () {
        return ", 从%s年至%s年";
    };
    zh_CN.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    zh_CN.prototype.everyMinute = function () {
        return "每分钟";
    };
    zh_CN.prototype.everyHour = function () {
        return "每小时";
    };
    zh_CN.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "生成表达式描述时发生了错误，请检查cron表达式语法。";
    };
    zh_CN.prototype.atSpace = function () {
        return "在";
    };
    zh_CN.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "在 %s 至 %s 之间的每分钟";
    };
    zh_CN.prototype.at = function () {
        return "在";
    };
    zh_CN.prototype.spaceAnd = function () {
        return " 和";
    };
    zh_CN.prototype.everySecond = function () {
        return "每秒";
    };
    zh_CN.prototype.everyX0Seconds = function () {
        return "每隔 %s 秒";
    };
    zh_CN.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "在每分钟的第 %s 到 %s 秒";
    };
    zh_CN.prototype.atX0SecondsPastTheMinute = function () {
        return "在每分钟的第 %s 秒";
    };
    zh_CN.prototype.everyX0Minutes = function () {
        return "每隔 %s 分钟";
    };
    zh_CN.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "在每小时的第 %s 到 %s 分钟";
    };
    zh_CN.prototype.atX0MinutesPastTheHour = function () {
        return "在每小时的第 %s 分钟";
    };
    zh_CN.prototype.everyX0Hours = function () {
        return "每隔 %s 小时";
    };
    zh_CN.prototype.betweenX0AndX1 = function () {
        return "在 %s 和 %s 之间";
    };
    zh_CN.prototype.atX0 = function () {
        return "在%s";
    };
    zh_CN.prototype.commaEveryDay = function () {
        return ", 每天";
    };
    zh_CN.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", 每周的每 %s 天";
    };
    zh_CN.prototype.commaX0ThroughX1 = function () {
        return ", %s至%s";
    };
    zh_CN.prototype.first = function () {
        return "第一个";
    };
    zh_CN.prototype.second = function () {
        return "第二个";
    };
    zh_CN.prototype.third = function () {
        return "第三个";
    };
    zh_CN.prototype.fourth = function () {
        return "第四个";
    };
    zh_CN.prototype.fifth = function () {
        return "第五个";
    };
    zh_CN.prototype.commaOnThe = function () {
        return ", 限每月的";
    };
    zh_CN.prototype.spaceX0OfTheMonth = function () {
        return "%s";
    };
    zh_CN.prototype.lastDay = function () {
        return "本月最后一天";
    };
    zh_CN.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", 限每月的最后一个%s";
    };
    zh_CN.prototype.commaOnlyOnX0 = function () {
        return ", 仅%s";
    };
    zh_CN.prototype.commaAndOnX0 = function () {
        return ", 并且为%s";
    };
    zh_CN.prototype.commaEveryX0Months = function () {
        return ", 每隔 %s 个月";
    };
    zh_CN.prototype.commaOnlyInX0 = function () {
        return ", 仅限%s";
    };
    zh_CN.prototype.commaOnlyInMonthX0 = function () {
        return ", 仅于%s份";
    };
    zh_CN.prototype.commaOnlyInYearX0 = function () {
        return ", 仅于 %s 年";
    };
    zh_CN.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", 限每月的最后一天";
    };
    zh_CN.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", 限每月的最后一个工作日";
    };
    zh_CN.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", 限每月最后%s天";
    };
    zh_CN.prototype.firstWeekday = function () {
        return "第一个工作日";
    };
    zh_CN.prototype.weekdayNearestDayX0 = function () {
        return "最接近 %s 号的工作日";
    };
    zh_CN.prototype.commaOnTheX0OfTheMonth = function () {
        return ", 限每月的%s";
    };
    zh_CN.prototype.commaEveryX0Days = function () {
        return ", 每隔 %s 天";
    };
    zh_CN.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", 限每月的 %s 至 %s 之间";
    };
    zh_CN.prototype.commaOnDayX0OfTheMonth = function () {
        return ", 限每月%s";
    };
    zh_CN.prototype.commaEveryX0Years = function () {
        return ", 每隔 %s 年";
    };
    zh_CN.prototype.commaStartingX0 = function () {
        return ", %s开始";
    };
    zh_CN.prototype.dayX0 = function () {
        return " %s 号";
    };
    zh_CN.prototype.daysOfTheWeek = function () {
        return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    };
    zh_CN.prototype.monthsOfTheYear = function () {
        return ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
    };
    return zh_CN;
}());
exports.zh_CN = zh_CN;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.zh_TW = void 0;
var zh_TW = (function () {
    function zh_TW() {
    }
    zh_TW.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    zh_TW.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    zh_TW.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    zh_TW.prototype.commaYearX0ThroughYearX1 = function () {
        return ", 从%s年至%s年";
    };
    zh_TW.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    zh_TW.prototype.everyMinute = function () {
        return "每分鐘";
    };
    zh_TW.prototype.everyHour = function () {
        return "每小時";
    };
    zh_TW.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "產生正規表達式描述時發生了錯誤，請檢查 cron 表達式語法。";
    };
    zh_TW.prototype.atSpace = function () {
        return "在 ";
    };
    zh_TW.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "在 %s 和 %s 之間的每分鐘";
    };
    zh_TW.prototype.at = function () {
        return "在";
    };
    zh_TW.prototype.spaceAnd = function () {
        return " 和";
    };
    zh_TW.prototype.everySecond = function () {
        return "每秒";
    };
    zh_TW.prototype.everyX0Seconds = function () {
        return "每 %s 秒";
    };
    zh_TW.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "在每分鐘的 %s 到 %s 秒";
    };
    zh_TW.prototype.atX0SecondsPastTheMinute = function () {
        return "在每分鐘的 %s 秒";
    };
    zh_TW.prototype.everyX0Minutes = function () {
        return "每 %s 分鐘";
    };
    zh_TW.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "在每小時的 %s 到 %s 分鐘";
    };
    zh_TW.prototype.atX0MinutesPastTheHour = function () {
        return "在每小時的 %s 分";
    };
    zh_TW.prototype.everyX0Hours = function () {
        return "每 %s 小時";
    };
    zh_TW.prototype.betweenX0AndX1 = function () {
        return "在 %s 和 %s 之間";
    };
    zh_TW.prototype.atX0 = function () {
        return "在 %s";
    };
    zh_TW.prototype.commaEveryDay = function () {
        return ", 每天";
    };
    zh_TW.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", 每週的每 %s 天";
    };
    zh_TW.prototype.commaX0ThroughX1 = function () {
        return ", %s 到 %s";
    };
    zh_TW.prototype.first = function () {
        return "第一個";
    };
    zh_TW.prototype.second = function () {
        return "第二個";
    };
    zh_TW.prototype.third = function () {
        return "第三個";
    };
    zh_TW.prototype.fourth = function () {
        return "第四個";
    };
    zh_TW.prototype.fifth = function () {
        return "第五個";
    };
    zh_TW.prototype.commaOnThe = function () {
        return ", 在每月 ";
    };
    zh_TW.prototype.spaceX0OfTheMonth = function () {
        return "%s ";
    };
    zh_TW.prototype.lastDay = function () {
        return "最後一天";
    };
    zh_TW.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", 每月的最後一個 %s ";
    };
    zh_TW.prototype.commaOnlyOnX0 = function () {
        return ", 僅在 %s";
    };
    zh_TW.prototype.commaAndOnX0 = function () {
        return ", 和 %s";
    };
    zh_TW.prototype.commaEveryX0Months = function () {
        return ", 每 %s 月";
    };
    zh_TW.prototype.commaOnlyInX0 = function () {
        return ", 僅在 %s";
    };
    zh_TW.prototype.commaOnlyInMonthX0 = function () {
        return ", 僅在%s";
    };
    zh_TW.prototype.commaOnlyInYearX0 = function () {
        return ", 僅在 %s 年";
    };
    zh_TW.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", 每月的最後一天";
    };
    zh_TW.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", 每月的最後一個工作日";
    };
    zh_TW.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s 這個月的最後一天的前幾天";
    };
    zh_TW.prototype.firstWeekday = function () {
        return "第一個工作日";
    };
    zh_TW.prototype.weekdayNearestDayX0 = function () {
        return "最接近 %s 號的工作日";
    };
    zh_TW.prototype.commaOnTheX0OfTheMonth = function () {
        return ", 每月的 %s ";
    };
    zh_TW.prototype.commaEveryX0Days = function () {
        return ", 每 %s 天";
    };
    zh_TW.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", 在每月的 %s 和 %s 之間";
    };
    zh_TW.prototype.commaOnDayX0OfTheMonth = function () {
        return ", 每月的 %s";
    };
    zh_TW.prototype.commaEveryX0Years = function () {
        return ", 每 %s 年";
    };
    zh_TW.prototype.commaStartingX0 = function () {
        return ", %s 開始";
    };
    zh_TW.prototype.dayX0 = function () {
        return " %s 號";
    };
    zh_TW.prototype.daysOfTheWeek = function () {
        return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    };
    zh_TW.prototype.monthsOfTheYear = function () {
        return ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
    };
    return zh_TW;
}());
exports.zh_TW = zh_TW;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ja = void 0;
var ja = (function () {
    function ja() {
    }
    ja.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    ja.prototype.everyMinute = function () {
        return "毎分";
    };
    ja.prototype.everyHour = function () {
        return "毎時";
    };
    ja.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "式の記述を生成する際にエラーが発生しました。Cron 式の構文を確認してください。";
    };
    ja.prototype.atSpace = function () {
        return "次において実施";
    };
    ja.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "%s から %s まで毎分";
    };
    ja.prototype.at = function () {
        return "次において実施";
    };
    ja.prototype.spaceAnd = function () {
        return "と";
    };
    ja.prototype.everySecond = function () {
        return "毎秒";
    };
    ja.prototype.everyX0Seconds = function () {
        return "%s 秒ごと";
    };
    ja.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "毎分 %s 秒から %s 秒まで";
    };
    ja.prototype.atX0SecondsPastTheMinute = function () {
        return "毎分 %s 秒過ぎ";
    };
    ja.prototype.everyX0Minutes = function () {
        return "%s 分ごと";
    };
    ja.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "毎時 %s 分から %s 分まで";
    };
    ja.prototype.atX0MinutesPastTheHour = function () {
        return "毎時 %s 分過ぎ";
    };
    ja.prototype.everyX0Hours = function () {
        return "%s 時間ごと";
    };
    ja.prototype.betweenX0AndX1 = function () {
        return "%s と %s の間";
    };
    ja.prototype.atX0 = function () {
        return "次において実施 %s";
    };
    ja.prototype.commaEveryDay = function () {
        return "、毎日";
    };
    ja.prototype.commaEveryX0DaysOfTheWeek = function () {
        return "、週のうち %s 日ごと";
    };
    ja.prototype.commaX0ThroughX1 = function () {
        return "、%s から %s まで";
    };
    ja.prototype.first = function () {
        return "1 番目";
    };
    ja.prototype.second = function () {
        return "2 番目";
    };
    ja.prototype.third = function () {
        return "3 番目";
    };
    ja.prototype.fourth = function () {
        return "4 番目";
    };
    ja.prototype.fifth = function () {
        return "5 番目";
    };
    ja.prototype.commaOnThe = function () {
        return "次に";
    };
    ja.prototype.spaceX0OfTheMonth = function () {
        return "月のうち %s";
    };
    ja.prototype.commaOnTheLastX0OfTheMonth = function () {
        return "月の最後の %s に";
    };
    ja.prototype.commaOnlyOnX0 = function () {
        return "%s にのみ";
    };
    ja.prototype.commaEveryX0Months = function () {
        return "、%s か月ごと";
    };
    ja.prototype.commaOnlyInX0 = function () {
        return "%s でのみ";
    };
    ja.prototype.commaOnTheLastDayOfTheMonth = function () {
        return "次の最終日に";
    };
    ja.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return "月の最後の平日に";
    };
    ja.prototype.firstWeekday = function () {
        return "最初の平日";
    };
    ja.prototype.weekdayNearestDayX0 = function () {
        return "%s 日の直近の平日";
    };
    ja.prototype.commaOnTheX0OfTheMonth = function () {
        return "月の %s に";
    };
    ja.prototype.commaEveryX0Days = function () {
        return "、%s 日ごと";
    };
    ja.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return "、月の %s 日から %s 日の間";
    };
    ja.prototype.commaOnDayX0OfTheMonth = function () {
        return "、月の %s 日目";
    };
    ja.prototype.spaceAndSpace = function () {
        return "と";
    };
    ja.prototype.commaEveryMinute = function () {
        return "、毎分";
    };
    ja.prototype.commaEveryHour = function () {
        return "、毎時";
    };
    ja.prototype.commaEveryX0Years = function () {
        return "、%s 年ごと";
    };
    ja.prototype.commaStartingX0 = function () {
        return "、%s に開始";
    };
    ja.prototype.aMPeriod = function () {
        return "AM";
    };
    ja.prototype.pMPeriod = function () {
        return "PM";
    };
    ja.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return "月の最終日の %s 日前";
    };
    ja.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    ja.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    ja.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    ja.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    ja.prototype.lastDay = function () {
        return "最終日";
    };
    ja.prototype.commaAndOnX0 = function () {
        return "、〜と %s";
    };
    ja.prototype.daysOfTheWeek = function () {
        return ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
    };
    ja.prototype.monthsOfTheYear = function () {
        return ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
    };
    return ja;
}());
exports.ja = ja;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.he = void 0;
var he = (function () {
    function he() {
    }
    he.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    he.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    he.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    he.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    he.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    he.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "אירעה שגיאה בעת יצירת תיאור הביטוי. בדוק את תחביר הביטוי cron.";
    };
    he.prototype.everyMinute = function () {
        return "כל דקה";
    };
    he.prototype.everyHour = function () {
        return "כל שעה";
    };
    he.prototype.atSpace = function () {
        return "ב ";
    };
    he.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "כל דקה %s עד %s";
    };
    he.prototype.at = function () {
        return "ב";
    };
    he.prototype.spaceAnd = function () {
        return " ו";
    };
    he.prototype.everySecond = function () {
        return "כל שניה";
    };
    he.prototype.everyX0Seconds = function () {
        return "כל %s שניות";
    };
    he.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "%s עד %s שניות של הדקה";
    };
    he.prototype.atX0SecondsPastTheMinute = function () {
        return "ב %s שניות של הדקה";
    };
    he.prototype.everyX0Minutes = function () {
        return "כל %s דקות";
    };
    he.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "%s עד %s דקות של השעה";
    };
    he.prototype.atX0MinutesPastTheHour = function () {
        return "ב %s דקות של השעה";
    };
    he.prototype.everyX0Hours = function () {
        return "כל %s שעות";
    };
    he.prototype.betweenX0AndX1 = function () {
        return "%s עד %s";
    };
    he.prototype.atX0 = function () {
        return "ב %s";
    };
    he.prototype.commaEveryDay = function () {
        return ", כל יום";
    };
    he.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", כל %s ימים בשבוע";
    };
    he.prototype.commaX0ThroughX1 = function () {
        return ", %s עד %s";
    };
    he.prototype.first = function () {
        return "ראשון";
    };
    he.prototype.second = function () {
        return "שני";
    };
    he.prototype.third = function () {
        return "שלישי";
    };
    he.prototype.fourth = function () {
        return "רביעי";
    };
    he.prototype.fifth = function () {
        return "חמישי";
    };
    he.prototype.commaOnThe = function () {
        return ", ב ";
    };
    he.prototype.spaceX0OfTheMonth = function () {
        return " %s של החודש";
    };
    he.prototype.lastDay = function () {
        return "היום האחרון";
    };
    he.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", רק ב %s של החודש";
    };
    he.prototype.commaOnlyOnX0 = function () {
        return ", רק ב %s";
    };
    he.prototype.commaAndOnX0 = function () {
        return ", וב %s";
    };
    he.prototype.commaEveryX0Months = function () {
        return ", כל %s חודשים";
    };
    he.prototype.commaOnlyInX0 = function () {
        return ", רק ב %s";
    };
    he.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", ביום האחרון של החודש";
    };
    he.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", ביום החול האחרון של החודש";
    };
    he.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s ימים לפני היום האחרון בחודש";
    };
    he.prototype.firstWeekday = function () {
        return "יום החול הראשון";
    };
    he.prototype.weekdayNearestDayX0 = function () {
        return "יום החול הראשון הקרוב אל %s";
    };
    he.prototype.commaOnTheX0OfTheMonth = function () {
        return ", ביום ה%s של החודש";
    };
    he.prototype.commaEveryX0Days = function () {
        return ", כל %s ימים";
    };
    he.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", בין היום ה%s וה%s של החודש";
    };
    he.prototype.commaOnDayX0OfTheMonth = function () {
        return ", ביום ה%s של החודש";
    };
    he.prototype.commaEveryX0Years = function () {
        return ", כל %s שנים";
    };
    he.prototype.commaStartingX0 = function () {
        return ", החל מ %s";
    };
    he.prototype.daysOfTheWeek = function () {
        return ["יום ראשון", "יום שני", "יום שלישי", "יום רביעי", "יום חמישי", "יום שישי", "יום שבת"];
    };
    he.prototype.monthsOfTheYear = function () {
        return ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"];
    };
    return he;
}());
exports.he = he;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.cs = void 0;
var cs = (function () {
    function cs() {
    }
    cs.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    cs.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    cs.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    cs.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    cs.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    cs.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Při vytváření popisu došlo k chybě. Zkontrolujte prosím správnost syntaxe cronu.";
    };
    cs.prototype.everyMinute = function () {
        return "každou minutu";
    };
    cs.prototype.everyHour = function () {
        return "každou hodinu";
    };
    cs.prototype.atSpace = function () {
        return "V ";
    };
    cs.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Každou minutu mezi %s a %s";
    };
    cs.prototype.at = function () {
        return "V";
    };
    cs.prototype.spaceAnd = function () {
        return " a";
    };
    cs.prototype.everySecond = function () {
        return "každou sekundu";
    };
    cs.prototype.everyX0Seconds = function () {
        return "každých %s sekund";
    };
    cs.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekundy od %s do %s";
    };
    cs.prototype.atX0SecondsPastTheMinute = function () {
        return "v %s sekund";
    };
    cs.prototype.everyX0Minutes = function () {
        return "každých %s minut";
    };
    cs.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minuty od %s do %s";
    };
    cs.prototype.atX0MinutesPastTheHour = function () {
        return "v %s minut";
    };
    cs.prototype.everyX0Hours = function () {
        return "každých %s hodin";
    };
    cs.prototype.betweenX0AndX1 = function () {
        return "mezi %s a %s";
    };
    cs.prototype.atX0 = function () {
        return "v %s";
    };
    cs.prototype.commaEveryDay = function () {
        return ", každý den";
    };
    cs.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", každých %s dní v týdnu";
    };
    cs.prototype.commaX0ThroughX1 = function () {
        return ", od %s do %s";
    };
    cs.prototype.first = function () {
        return "první";
    };
    cs.prototype.second = function () {
        return "druhý";
    };
    cs.prototype.third = function () {
        return "třetí";
    };
    cs.prototype.fourth = function () {
        return "čtvrtý";
    };
    cs.prototype.fifth = function () {
        return "pátý";
    };
    cs.prototype.commaOnThe = function () {
        return ", ";
    };
    cs.prototype.spaceX0OfTheMonth = function () {
        return " %s v měsíci";
    };
    cs.prototype.lastDay = function () {
        return "poslední den";
    };
    cs.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", poslední %s v měsíci";
    };
    cs.prototype.commaOnlyOnX0 = function () {
        return ", pouze v %s";
    };
    cs.prototype.commaAndOnX0 = function () {
        return ", a v %s";
    };
    cs.prototype.commaEveryX0Months = function () {
        return ", každých %s měsíců";
    };
    cs.prototype.commaOnlyInX0 = function () {
        return ", pouze v %s";
    };
    cs.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", poslední den v měsíci";
    };
    cs.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", poslední pracovní den v měsíci";
    };
    cs.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dní před posledním dnem v měsíci";
    };
    cs.prototype.firstWeekday = function () {
        return "první pracovní den";
    };
    cs.prototype.weekdayNearestDayX0 = function () {
        return "pracovní den nejblíže %s. dni";
    };
    cs.prototype.commaOnTheX0OfTheMonth = function () {
        return ", v %s v měsíci";
    };
    cs.prototype.commaEveryX0Days = function () {
        return ", každých %s dnů";
    };
    cs.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", mezi dny %s a %s v měsíci";
    };
    cs.prototype.commaOnDayX0OfTheMonth = function () {
        return ", %s. den v měsíci";
    };
    cs.prototype.commaEveryX0Years = function () {
        return ", každých %s roků";
    };
    cs.prototype.commaStartingX0 = function () {
        return ", začínající %s";
    };
    cs.prototype.daysOfTheWeek = function () {
        return ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"];
    };
    cs.prototype.monthsOfTheYear = function () {
        return [
            "Leden",
            "Únor",
            "Březen",
            "Duben",
            "Květen",
            "Červen",
            "Červenec",
            "Srpen",
            "Září",
            "Říjen",
            "Listopad",
            "Prosinec",
        ];
    };
    return cs;
}());
exports.cs = cs;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.sk = void 0;
var sk = (function () {
    function sk() {
    }
    sk.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    sk.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    sk.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    sk.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    sk.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    sk.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Pri vytváraní popisu došlo k chybe. Skontrolujte prosím správnosť syntaxe cronu.";
    };
    sk.prototype.everyMinute = function () {
        return "každú minútu";
    };
    sk.prototype.everyHour = function () {
        return "každú hodinu";
    };
    sk.prototype.atSpace = function () {
        return "V ";
    };
    sk.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Každú minútu medzi %s a %s";
    };
    sk.prototype.at = function () {
        return "V";
    };
    sk.prototype.spaceAnd = function () {
        return " a";
    };
    sk.prototype.everySecond = function () {
        return "každú sekundu";
    };
    sk.prototype.everyX0Seconds = function () {
        return "každých %s sekúnd";
    };
    sk.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekundy od %s do %s";
    };
    sk.prototype.atX0SecondsPastTheMinute = function () {
        return "v %s sekúnd";
    };
    sk.prototype.everyX0Minutes = function () {
        return "každých %s minút";
    };
    sk.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minúty od %s do %s";
    };
    sk.prototype.atX0MinutesPastTheHour = function () {
        return "v %s minút";
    };
    sk.prototype.everyX0Hours = function () {
        return "každých %s hodín";
    };
    sk.prototype.betweenX0AndX1 = function () {
        return "medzi %s a %s";
    };
    sk.prototype.atX0 = function () {
        return "v %s";
    };
    sk.prototype.commaEveryDay = function () {
        return ", každý deň";
    };
    sk.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", každých %s dní v týždni";
    };
    sk.prototype.commaX0ThroughX1 = function () {
        return ", od %s do %s";
    };
    sk.prototype.first = function () {
        return "prvý";
    };
    sk.prototype.second = function () {
        return "druhý";
    };
    sk.prototype.third = function () {
        return "tretí";
    };
    sk.prototype.fourth = function () {
        return "štvrtý";
    };
    sk.prototype.fifth = function () {
        return "piaty";
    };
    sk.prototype.commaOnThe = function () {
        return ", ";
    };
    sk.prototype.spaceX0OfTheMonth = function () {
        return " %s v mesiaci";
    };
    sk.prototype.lastDay = function () {
        return "posledný deň";
    };
    sk.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", posledný %s v mesiaci";
    };
    sk.prototype.commaOnlyOnX0 = function () {
        return ", iba v %s";
    };
    sk.prototype.commaAndOnX0 = function () {
        return ", a v %s";
    };
    sk.prototype.commaEveryX0Months = function () {
        return ", každých %s mesiacov";
    };
    sk.prototype.commaOnlyInX0 = function () {
        return ", iba v %s";
    };
    sk.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", posledný deň v mesiaci";
    };
    sk.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", posledný pracovný deň v mesiaci";
    };
    sk.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dní pred posledným dňom v mesiaci";
    };
    sk.prototype.firstWeekday = function () {
        return "prvý pracovný deň";
    };
    sk.prototype.weekdayNearestDayX0 = function () {
        return "pracovný deň najbližšie %s. dňu";
    };
    sk.prototype.commaOnTheX0OfTheMonth = function () {
        return ", v %s v mesiaci";
    };
    sk.prototype.commaEveryX0Days = function () {
        return ", každých %s dní";
    };
    sk.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", medzi dňami %s a %s v mesiaci";
    };
    sk.prototype.commaOnDayX0OfTheMonth = function () {
        return ", %s. deň v mesiaci";
    };
    sk.prototype.commaEveryX0Years = function () {
        return ", každých %s rokov";
    };
    sk.prototype.commaStartingX0 = function () {
        return ", začínajúcich %s";
    };
    sk.prototype.daysOfTheWeek = function () {
        return ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"];
    };
    sk.prototype.monthsOfTheYear = function () {
        return [
            "Január",
            "Február",
            "Marec",
            "Apríl",
            "Máj",
            "Jún",
            "Júl",
            "August",
            "September",
            "Október",
            "November",
            "December",
        ];
    };
    return sk;
}());
exports.sk = sk;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.fi = void 0;
var fi = (function () {
    function fi() {
    }
    fi.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    fi.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Virhe kuvauksen generoinnissa. Tarkista cron-syntaksi.";
    };
    fi.prototype.at = function () {
        return "Klo";
    };
    fi.prototype.atSpace = function () {
        return "Klo ";
    };
    fi.prototype.atX0 = function () {
        return "klo %s";
    };
    fi.prototype.atX0MinutesPastTheHour = function () {
        return "%s minuuttia yli";
    };
    fi.prototype.atX0MinutesPastTheHourGt20 = function () {
        return "%s minuuttia yli";
    };
    fi.prototype.atX0SecondsPastTheMinute = function () {
        return "%s sekunnnin jälkeen";
    };
    fi.prototype.betweenX0AndX1 = function () {
        return "%s - %s välillä";
    };
    fi.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", kuukauden päivien %s ja %s välillä";
    };
    fi.prototype.commaEveryDay = function () {
        return ", joka päivä";
    };
    fi.prototype.commaEveryHour = function () {
        return ", joka tunti";
    };
    fi.prototype.commaEveryMinute = function () {
        return ", joka minuutti";
    };
    fi.prototype.commaEveryX0Days = function () {
        return ", joka %s. päivä";
    };
    fi.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", joka %s. viikonpäivä";
    };
    fi.prototype.commaEveryX0Months = function () {
        return ", joka %s. kuukausi";
    };
    fi.prototype.commaEveryX0Years = function () {
        return ", joka %s. vuosi";
    };
    fi.prototype.commaOnDayX0OfTheMonth = function () {
        return ", kuukauden %s päivä";
    };
    fi.prototype.commaOnlyInX0 = function () {
        return ", vain %s";
    };
    fi.prototype.commaOnlyOnX0 = function () {
        return ", vain %s";
    };
    fi.prototype.commaOnThe = function () {
        return ",";
    };
    fi.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", kuukauden viimeisenä päivänä";
    };
    fi.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", kuukauden viimeisenä viikonpäivänä";
    };
    fi.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", kuukauden viimeinen %s";
    };
    fi.prototype.commaOnTheX0OfTheMonth = function () {
        return ", kuukauden %s";
    };
    fi.prototype.commaX0ThroughX1 = function () {
        return ", %s - %s";
    };
    fi.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s päivää ennen kuukauden viimeistä päivää";
    };
    fi.prototype.commaStartingX0 = function () {
        return ", alkaen %s";
    };
    fi.prototype.everyHour = function () {
        return "joka tunti";
    };
    fi.prototype.everyMinute = function () {
        return "joka minuutti";
    };
    fi.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "joka minuutti %s - %s välillä";
    };
    fi.prototype.everySecond = function () {
        return "joka sekunti";
    };
    fi.prototype.everyX0Hours = function () {
        return "joka %s. tunti";
    };
    fi.prototype.everyX0Minutes = function () {
        return "joka %s. minuutti";
    };
    fi.prototype.everyX0Seconds = function () {
        return "joka %s. sekunti";
    };
    fi.prototype.fifth = function () {
        return "viides";
    };
    fi.prototype.first = function () {
        return "ensimmäinen";
    };
    fi.prototype.firstWeekday = function () {
        return "ensimmäinen viikonpäivä";
    };
    fi.prototype.fourth = function () {
        return "neljäs";
    };
    fi.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "joka tunti minuuttien %s - %s välillä";
    };
    fi.prototype.second = function () {
        return "toinen";
    };
    fi.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "joka minuutti sekunttien %s - %s välillä";
    };
    fi.prototype.spaceAnd = function () {
        return " ja";
    };
    fi.prototype.spaceAndSpace = function () {
        return " ja ";
    };
    fi.prototype.spaceX0OfTheMonth = function () {
        return " %s kuukaudessa";
    };
    fi.prototype.third = function () {
        return "kolmas";
    };
    fi.prototype.weekdayNearestDayX0 = function () {
        return "viikonpäivä lähintä %s päivää";
    };
    fi.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    fi.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    fi.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    fi.prototype.lastDay = function () {
        return "viimeinen päivä";
    };
    fi.prototype.commaAndOnX0 = function () {
        return ", ja edelleen %s";
    };
    fi.prototype.daysOfTheWeek = function () {
        return ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"];
    };
    fi.prototype.monthsOfTheYear = function () {
        return [
            "tammikuu",
            "helmikuu",
            "maaliskuu",
            "huhtikuu",
            "toukokuu",
            "kesäkuu",
            "heinäkuu",
            "elokuu",
            "syyskuu",
            "lokakuu",
            "marraskuu",
            "joulukuu",
        ];
    };
    return fi;
}());
exports.fi = fi;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.sl = void 0;
var sl = (function () {
    function sl() {
    }
    sl.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    sl.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Pri generiranju opisa izraza je prišlo do napake. Preverite sintakso izraza cron.";
    };
    sl.prototype.at = function () {
        return "Ob";
    };
    sl.prototype.atSpace = function () {
        return "Ob ";
    };
    sl.prototype.atX0 = function () {
        return "ob %s";
    };
    sl.prototype.atX0MinutesPastTheHour = function () {
        return "ob %s.";
    };
    sl.prototype.atX0SecondsPastTheMinute = function () {
        return "ob %s.";
    };
    sl.prototype.betweenX0AndX1 = function () {
        return "od %s do %s";
    };
    sl.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", od %s. do %s. dne v mesecu";
    };
    sl.prototype.commaEveryDay = function () {
        return ", vsak dan";
    };
    sl.prototype.commaEveryX0Days = function () {
        return ", vsakih %s dni";
    };
    sl.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", vsakih %s dni v tednu";
    };
    sl.prototype.commaEveryX0Months = function () {
        return ", vsakih %s mesecev";
    };
    sl.prototype.commaEveryX0Years = function () {
        return ", vsakih %s let";
    };
    sl.prototype.commaOnDayX0OfTheMonth = function () {
        return ", %s. dan v mesecu";
    };
    sl.prototype.commaOnlyInX0 = function () {
        return ", samo v %s";
    };
    sl.prototype.commaOnlyOnX0 = function () {
        return ", samo v %s";
    };
    sl.prototype.commaAndOnX0 = function () {
        return "in naprej %s";
    };
    sl.prototype.commaOnThe = function () {
        return ", ";
    };
    sl.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", zadnji %s v mesecu";
    };
    sl.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", zadnji delovni dan v mesecu";
    };
    sl.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dni pred koncem meseca";
    };
    sl.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", zadnji %s v mesecu";
    };
    sl.prototype.commaOnTheX0OfTheMonth = function () {
        return ", %s v mesecu";
    };
    sl.prototype.commaX0ThroughX1 = function () {
        return ", od %s do %s";
    };
    sl.prototype.everyHour = function () {
        return "vsako uro";
    };
    sl.prototype.everyMinute = function () {
        return "vsako minuto";
    };
    sl.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Vsako minuto od %s do %s";
    };
    sl.prototype.everySecond = function () {
        return "vsako sekundo";
    };
    sl.prototype.everyX0Hours = function () {
        return "vsakih %s ur";
    };
    sl.prototype.everyX0Minutes = function () {
        return "vsakih %s minut";
    };
    sl.prototype.everyX0Seconds = function () {
        return "vsakih %s sekund";
    };
    sl.prototype.fifth = function () {
        return "peti";
    };
    sl.prototype.first = function () {
        return "prvi";
    };
    sl.prototype.firstWeekday = function () {
        return "prvi delovni dan";
    };
    sl.prototype.fourth = function () {
        return "četrti";
    };
    sl.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minute od %s do %s";
    };
    sl.prototype.second = function () {
        return "drugi";
    };
    sl.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekunde od %s do %s";
    };
    sl.prototype.spaceAnd = function () {
        return " in";
    };
    sl.prototype.spaceX0OfTheMonth = function () {
        return " %s v mesecu";
    };
    sl.prototype.lastDay = function () {
        return "zadnjič";
    };
    sl.prototype.third = function () {
        return "tretji";
    };
    sl.prototype.weekdayNearestDayX0 = function () {
        return "delovni dan, najbližji %s. dnevu";
    };
    sl.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    sl.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    sl.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    sl.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    sl.prototype.commaStartingX0 = function () {
        return ", začenši %s";
    };
    sl.prototype.daysOfTheWeek = function () {
        return ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"];
    };
    sl.prototype.monthsOfTheYear = function () {
        return [
            "januar",
            "februar",
            "marec",
            "april",
            "maj",
            "junij",
            "julij",
            "avgust",
            "september",
            "oktober",
            "november",
            "december",
        ];
    };
    return sl;
}());
exports.sl = sl;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.sw = void 0;
var sw = (function () {
    function sw() {
    }
    sw.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    sw.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    sw.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    sw.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    sw.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    sw.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "Kuna tatizo wakati wa kutunga msemo. Angalia cron expression syntax.";
    };
    sw.prototype.everyMinute = function () {
        return "kila dakika";
    };
    sw.prototype.everyHour = function () {
        return "kila saa";
    };
    sw.prototype.atSpace = function () {
        return "Kwa ";
    };
    sw.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "Kila dakika kwanzia %s hadi %s";
    };
    sw.prototype.at = function () {
        return "Kwa";
    };
    sw.prototype.spaceAnd = function () {
        return " na";
    };
    sw.prototype.everySecond = function () {
        return "kila sekunde";
    };
    sw.prototype.everyX0Seconds = function () {
        return "kila sekunde %s";
    };
    sw.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "sekunde ya %s hadi %s baada ya dakika";
    };
    sw.prototype.atX0SecondsPastTheMinute = function () {
        return "at %s seconds past the minute";
        return "sekunde %s baada ya dakika";
    };
    sw.prototype.everyX0Minutes = function () {
        return "kila dakika %s";
    };
    sw.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "minutes %s through %s past the hour";
    };
    sw.prototype.atX0MinutesPastTheHour = function () {
        return "at %s minutes past the hour";
    };
    sw.prototype.everyX0Hours = function () {
        return "every %s hours";
    };
    sw.prototype.betweenX0AndX1 = function () {
        return "kati ya %s na %s";
    };
    sw.prototype.atX0 = function () {
        return "kwenye %s";
    };
    sw.prototype.commaEveryDay = function () {
        return ", kila siku";
    };
    sw.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", kila siku %s ya wiki";
    };
    sw.prototype.commaX0ThroughX1 = function () {
        return ", %s hadi %s";
    };
    sw.prototype.first = function () {
        return "ya kwanza";
    };
    sw.prototype.second = function () {
        return "ya pili";
    };
    sw.prototype.third = function () {
        return "ya tatu";
    };
    sw.prototype.fourth = function () {
        return "ya nne";
    };
    sw.prototype.fifth = function () {
        return "ya tano";
    };
    sw.prototype.commaOnThe = function () {
        return ", kwenye ";
    };
    sw.prototype.spaceX0OfTheMonth = function () {
        return " siku %s ya mwezi";
    };
    sw.prototype.lastDay = function () {
        return "siku ya mwisho";
    };
    sw.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", siku ya %s ya mwezi";
    };
    sw.prototype.commaOnlyOnX0 = function () {
        return ", kwa %s tu";
    };
    sw.prototype.commaAndOnX0 = function () {
        return ", na pia %s";
    };
    sw.prototype.commaEveryX0Months = function () {
        return ", kila mwezi wa %s";
    };
    sw.prototype.commaOnlyInX0 = function () {
        return ", kwa %s tu";
    };
    sw.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", siku ya mwisho wa mwezi";
    };
    sw.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", wikendi ya mwisho wa mwezi";
    };
    sw.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", siku ya %s kabla ya siku ya mwisho wa mwezi";
    };
    sw.prototype.firstWeekday = function () {
        return "siku za kazi ya kwanza";
    };
    sw.prototype.weekdayNearestDayX0 = function () {
        return "siku ya kazi karibu na siku ya %s";
    };
    sw.prototype.commaOnTheX0OfTheMonth = function () {
        return ", siku ya %s ya mwezi";
    };
    sw.prototype.commaEveryX0Days = function () {
        return ", kila siku %s";
    };
    sw.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", kati ya siku %s na %s ya mwezi";
    };
    sw.prototype.commaOnDayX0OfTheMonth = function () {
        return ", siku ya %s ya mwezi";
    };
    sw.prototype.commaEveryX0Years = function () {
        return ", kila miaka %s";
    };
    sw.prototype.commaStartingX0 = function () {
        return ", kwanzia %s";
    };
    sw.prototype.daysOfTheWeek = function () {
        return ["Jumapili", "Jumatatu", "Jumanne", "Jumatano", "Alhamisi", "Ijumaa", "Jumamosi"];
    };
    sw.prototype.monthsOfTheYear = function () {
        return [
            "Januari",
            "Februari",
            "Machi",
            "Aprili",
            "Mei",
            "Juni",
            "Julai",
            "Agosti",
            "Septemba",
            "Oktoba",
            "Novemba",
            "Desemba",
        ];
    };
    return sw;
}());
exports.sw = sw;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.fa = void 0;
var fa = (function () {
    function fa() {
    }
    fa.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    fa.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    fa.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    fa.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    fa.prototype.use24HourTimeFormatByDefault = function () {
        return true;
    };
    fa.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "خطایی در نمایش توضیحات این وظیفه رخ داد. لطفا ساختار آن را بررسی کنید.";
    };
    fa.prototype.everyMinute = function () {
        return "هر دقیقه";
    };
    fa.prototype.everyHour = function () {
        return "هر ساعت";
    };
    fa.prototype.atSpace = function () {
        return "در ";
    };
    fa.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "هر دقیقه بین %s و %s";
    };
    fa.prototype.at = function () {
        return "در";
    };
    fa.prototype.spaceAnd = function () {
        return " و";
    };
    fa.prototype.everySecond = function () {
        return "هر ثانیه";
    };
    fa.prototype.everyX0Seconds = function () {
        return "هر %s ثانیه";
    };
    fa.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "ثانیه %s تا %s دقیقه گذشته";
    };
    fa.prototype.atX0SecondsPastTheMinute = function () {
        return "در %s قانیه از دقیقه گذشته";
    };
    fa.prototype.everyX0Minutes = function () {
        return "هر %s دقیقه";
    };
    fa.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "دقیقه %s تا %s ساعت گذشته";
    };
    fa.prototype.atX0MinutesPastTheHour = function () {
        return "در %s دقیقه پس از ساعت";
    };
    fa.prototype.everyX0Hours = function () {
        return "هر %s ساعت";
    };
    fa.prototype.betweenX0AndX1 = function () {
        return "بین %s و %s";
    };
    fa.prototype.atX0 = function () {
        return "در %s";
    };
    fa.prototype.commaEveryDay = function () {
        return ", هر روز";
    };
    fa.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", هر %s روز از هفته";
    };
    fa.prototype.commaX0ThroughX1 = function () {
        return ", %s تا %s";
    };
    fa.prototype.first = function () {
        return "اول";
    };
    fa.prototype.second = function () {
        return "دوم";
    };
    fa.prototype.third = function () {
        return "سوم";
    };
    fa.prototype.fourth = function () {
        return "چهارم";
    };
    fa.prototype.fifth = function () {
        return "پنجم";
    };
    fa.prototype.commaOnThe = function () {
        return ", در ";
    };
    fa.prototype.spaceX0OfTheMonth = function () {
        return " %s ماه";
    };
    fa.prototype.lastDay = function () {
        return "آخرین روز";
    };
    fa.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", در %s ماه";
    };
    fa.prototype.commaOnlyOnX0 = function () {
        return ", فقط در %s";
    };
    fa.prototype.commaAndOnX0 = function () {
        return ", و در %s";
    };
    fa.prototype.commaEveryX0Months = function () {
        return ", هر %s ماه";
    };
    fa.prototype.commaOnlyInX0 = function () {
        return ", فقط در %s";
    };
    fa.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", در آخرین روز ماه";
    };
    fa.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", در آخرین روز ماه";
    };
    fa.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s روز قبل از آخرین روز ماه";
    };
    fa.prototype.firstWeekday = function () {
        return "اولین روز";
    };
    fa.prototype.weekdayNearestDayX0 = function () {
        return "روز نزدیک به روز %s";
    };
    fa.prototype.commaOnTheX0OfTheMonth = function () {
        return ", در %s ماه";
    };
    fa.prototype.commaEveryX0Days = function () {
        return ", هر %s روز";
    };
    fa.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", بین روز %s و %s ماه";
    };
    fa.prototype.commaOnDayX0OfTheMonth = function () {
        return ", در %s ماه";
    };
    fa.prototype.commaEveryMinute = function () {
        return ", هر minute";
    };
    fa.prototype.commaEveryHour = function () {
        return ", هر ساعت";
    };
    fa.prototype.commaEveryX0Years = function () {
        return ", هر %s سال";
    };
    fa.prototype.commaStartingX0 = function () {
        return ", آغاز %s";
    };
    fa.prototype.daysOfTheWeek = function () {
        return ["یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"];
    };
    fa.prototype.monthsOfTheYear = function () {
        return ["ژانویه", "فوریه", "مارس", "آپریل", "مه", "ژوئن", "ژوئیه", "آگوست", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"];
    };
    return fa;
}());
exports.fa = fa;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ca = void 0;
var ca = (function () {
    function ca() {
    }
    ca.prototype.atX0SecondsPastTheMinuteGt20 = function () {
        return null;
    };
    ca.prototype.atX0MinutesPastTheHourGt20 = function () {
        return null;
    };
    ca.prototype.commaMonthX0ThroughMonthX1 = function () {
        return null;
    };
    ca.prototype.commaYearX0ThroughYearX1 = function () {
        return null;
    };
    ca.prototype.use24HourTimeFormatByDefault = function () {
        return false;
    };
    ca.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
        return "S'ha produït un error mentres es generava la descripció de l'expressió. Revisi la sintaxi de la expressió de cron.";
    };
    ca.prototype.at = function () {
        return "A les";
    };
    ca.prototype.atSpace = function () {
        return "A les ";
    };
    ca.prototype.atX0 = function () {
        return "a les %s";
    };
    ca.prototype.atX0MinutesPastTheHour = function () {
        return "als %s minuts de l'hora";
    };
    ca.prototype.atX0SecondsPastTheMinute = function () {
        return "als %s segonds del minut";
    };
    ca.prototype.betweenX0AndX1 = function () {
        return "entre les %s i les %s";
    };
    ca.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
        return ", entre els dies %s i %s del mes";
    };
    ca.prototype.commaEveryDay = function () {
        return ", cada dia";
    };
    ca.prototype.commaEveryX0Days = function () {
        return ", cada %s dies";
    };
    ca.prototype.commaEveryX0DaysOfTheWeek = function () {
        return ", cada %s dies de la setmana";
    };
    ca.prototype.commaEveryX0Months = function () {
        return ", cada %s mesos";
    };
    ca.prototype.commaOnDayX0OfTheMonth = function () {
        return ", el dia %s del mes";
    };
    ca.prototype.commaOnlyInX0 = function () {
        return ", sólo en %s";
    };
    ca.prototype.commaOnlyOnX0 = function () {
        return ", només el %s";
    };
    ca.prototype.commaAndOnX0 = function () {
        return ", i el %s";
    };
    ca.prototype.commaOnThe = function () {
        return ", en el ";
    };
    ca.prototype.commaOnTheLastDayOfTheMonth = function () {
        return ", en l'últim dia del mes";
    };
    ca.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
        return ", en l'últim dia de la setmana del mes";
    };
    ca.prototype.commaDaysBeforeTheLastDayOfTheMonth = function () {
        return ", %s dies abans de l'últim dia del mes";
    };
    ca.prototype.commaOnTheLastX0OfTheMonth = function () {
        return ", en l'últim %s del mes";
    };
    ca.prototype.commaOnTheX0OfTheMonth = function () {
        return ", en el %s del mes";
    };
    ca.prototype.commaX0ThroughX1 = function () {
        return ", de %s a %s";
    };
    ca.prototype.everyHour = function () {
        return "cada hora";
    };
    ca.prototype.everyMinute = function () {
        return "cada minut";
    };
    ca.prototype.everyMinuteBetweenX0AndX1 = function () {
        return "cada minut entre les %s i les %s";
    };
    ca.prototype.everySecond = function () {
        return "cada segon";
    };
    ca.prototype.everyX0Hours = function () {
        return "cada %s hores";
    };
    ca.prototype.everyX0Minutes = function () {
        return "cada %s minuts";
    };
    ca.prototype.everyX0Seconds = function () {
        return "cada %s segons";
    };
    ca.prototype.fifth = function () {
        return "cinquè";
    };
    ca.prototype.first = function () {
        return "primer";
    };
    ca.prototype.firstWeekday = function () {
        return "primer dia de la setmana";
    };
    ca.prototype.fourth = function () {
        return "quart";
    };
    ca.prototype.minutesX0ThroughX1PastTheHour = function () {
        return "del minut %s al %s passada l'hora";
    };
    ca.prototype.second = function () {
        return "segon";
    };
    ca.prototype.secondsX0ThroughX1PastTheMinute = function () {
        return "En els segons %s al %s de cada minut";
    };
    ca.prototype.spaceAnd = function () {
        return " i";
    };
    ca.prototype.spaceX0OfTheMonth = function () {
        return " %s del mes";
    };
    ca.prototype.lastDay = function () {
        return "l'últim dia";
    };
    ca.prototype.third = function () {
        return "tercer";
    };
    ca.prototype.weekdayNearestDayX0 = function () {
        return "dia de la setmana més proper al %s";
    };
    ca.prototype.commaEveryX0Years = function () {
        return ", cada %s anys";
    };
    ca.prototype.commaStartingX0 = function () {
        return ", començant %s";
    };
    ca.prototype.daysOfTheWeek = function () {
        return ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"];
    };
    ca.prototype.monthsOfTheYear = function () {
        return [
            "gener",
            "febrer",
            "març",
            "abril",
            "maig",
            "juny",
            "juliol",
            "agost",
            "setembre",
            "octubre",
            "novembre",
            "desembre",
        ];
    };
    return ca;
}());
exports.ca = ca;


/***/ })
/******/ ]);
});

/***/ }),

/***/ "130d":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "149f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("3c10");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".enable-bulma{/*! bulma.io v0.7.5 | MIT License | github.com/jgthms/bulma *//*! minireset.css v0.0.4 | MIT License | github.com/jgthms/minireset.css */}.enable-bulma .control{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.enable-bulma .centered-text{padding-left:16px;padding-right:16px}.enable-bulma .centered-checkbox-group,.enable-bulma .centered-text{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .centered-checkbox-group{-ms-flex-wrap:wrap;flex-wrap:wrap}@-webkit-keyframes spinAround{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes spinAround{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.enable-bulma .b-checkbox.checkbox,.enable-bulma .b-radio.radio,.enable-bulma .breadcrumb,.enable-bulma .button,.enable-bulma .carousel,.enable-bulma .carousel-list,.enable-bulma .delete,.enable-bulma .file,.enable-bulma .is-unselectable,.enable-bulma .modal-close,.enable-bulma .pagination-ellipsis,.enable-bulma .pagination-link,.enable-bulma .pagination-next,.enable-bulma .pagination-previous,.enable-bulma .switch,.enable-bulma .tabs{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.enable-bulma .navbar-link:not(.is-arrowless):after,.enable-bulma .select:not(.is-multiple):not(.is-loading):after{border:3px solid transparent;border-radius:2px;border-right:0;border-top:0;content:\" \";display:block;height:.625em;margin-top:-.4375em;pointer-events:none;position:absolute;top:50%;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:center;transform-origin:center;width:.625em}.enable-bulma .block:not(:last-child),.enable-bulma .box:not(:last-child),.enable-bulma .breadcrumb:not(:last-child),.enable-bulma .content:not(:last-child),.enable-bulma .highlight:not(:last-child),.enable-bulma .level:not(:last-child),.enable-bulma .list:not(:last-child),.enable-bulma .message:not(:last-child),.enable-bulma .notification:not(:last-child),.enable-bulma .progress:not(:last-child),.enable-bulma .subtitle:not(:last-child),.enable-bulma .table-container:not(:last-child),.enable-bulma .table:not(:last-child),.enable-bulma .tabs:not(:last-child),.enable-bulma .title:not(:last-child){margin-bottom:1.5rem}.enable-bulma .delete,.enable-bulma .modal-close{-moz-appearance:none;-webkit-appearance:none;background-color:rgba(10,10,10,.2);border:none;border-radius:290486px;cursor:pointer;pointer-events:auto;display:inline-block;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:0;height:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px;outline:none;position:relative;vertical-align:top;width:20px}.enable-bulma .delete:after,.enable-bulma .delete:before,.enable-bulma .modal-close:after,.enable-bulma .modal-close:before{background-color:#fff;content:\"\";display:block;left:50%;position:absolute;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);-webkit-transform-origin:center center;transform-origin:center center}.enable-bulma .delete:before,.enable-bulma .modal-close:before{height:2px;width:50%}.enable-bulma .delete:after,.enable-bulma .modal-close:after{height:50%;width:2px}.enable-bulma .delete:focus,.enable-bulma .delete:hover,.enable-bulma .modal-close:focus,.enable-bulma .modal-close:hover{background-color:rgba(10,10,10,.3)}.enable-bulma .delete:active,.enable-bulma .modal-close:active{background-color:rgba(10,10,10,.4)}.enable-bulma .is-small.delete,.enable-bulma .is-small.modal-close{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px}.enable-bulma .is-medium.delete,.enable-bulma .is-medium.modal-close{height:24px;max-height:24px;max-width:24px;min-height:24px;min-width:24px;width:24px}.enable-bulma .is-large.delete,.enable-bulma .is-large.modal-close{height:32px;max-height:32px;max-width:32px;min-height:32px;min-width:32px;width:32px}.enable-bulma .button.is-loading:after,.enable-bulma .control.is-loading:after,.enable-bulma .loader,.enable-bulma .select.is-loading:after{-webkit-animation:spinAround .5s linear infinite;animation:spinAround .5s linear infinite;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em}.enable-bulma .hero-video,.enable-bulma .image.is-1by1 .has-ratio,.enable-bulma .image.is-1by1 img,.enable-bulma .image.is-1by2 .has-ratio,.enable-bulma .image.is-1by2 img,.enable-bulma .image.is-1by3 .has-ratio,.enable-bulma .image.is-1by3 img,.enable-bulma .image.is-2by1 .has-ratio,.enable-bulma .image.is-2by1 img,.enable-bulma .image.is-2by3 .has-ratio,.enable-bulma .image.is-2by3 img,.enable-bulma .image.is-3by1 .has-ratio,.enable-bulma .image.is-3by1 img,.enable-bulma .image.is-3by2 .has-ratio,.enable-bulma .image.is-3by2 img,.enable-bulma .image.is-3by4 .has-ratio,.enable-bulma .image.is-3by4 img,.enable-bulma .image.is-3by5 .has-ratio,.enable-bulma .image.is-3by5 img,.enable-bulma .image.is-4by3 .has-ratio,.enable-bulma .image.is-4by3 img,.enable-bulma .image.is-4by5 .has-ratio,.enable-bulma .image.is-4by5 img,.enable-bulma .image.is-5by3 .has-ratio,.enable-bulma .image.is-5by3 img,.enable-bulma .image.is-5by4 .has-ratio,.enable-bulma .image.is-5by4 img,.enable-bulma .image.is-9by16 .has-ratio,.enable-bulma .image.is-9by16 img,.enable-bulma .image.is-16by9 .has-ratio,.enable-bulma .image.is-16by9 img,.enable-bulma .image.is-square .has-ratio,.enable-bulma .image.is-square img,.enable-bulma .is-overlay,.enable-bulma .modal,.enable-bulma .modal-background{bottom:0;left:0;position:absolute;right:0;top:0}.enable-bulma .button,.enable-bulma .file-cta,.enable-bulma .file-name,.enable-bulma .input,.enable-bulma .pagination-ellipsis,.enable-bulma .pagination-link,.enable-bulma .pagination-next,.enable-bulma .pagination-previous,.enable-bulma .select select,.enable-bulma .taginput .taginput-container.is-focusable,.enable-bulma .textarea{-moz-appearance:none;-webkit-appearance:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:none;box-shadow:none;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1rem;height:2.25em;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;line-height:1.5;padding-bottom:calc(.375em - 1px);padding-left:calc(.625em - 1px);padding-right:calc(.625em - 1px);padding-top:calc(.375em - 1px);position:relative;vertical-align:top}.enable-bulma .button:active,.enable-bulma .button:focus,.enable-bulma .file-cta:active,.enable-bulma .file-cta:focus,.enable-bulma .file-name:active,.enable-bulma .file-name:focus,.enable-bulma .input:active,.enable-bulma .input:focus,.enable-bulma .is-active.button,.enable-bulma .is-active.file-cta,.enable-bulma .is-active.file-name,.enable-bulma .is-active.input,.enable-bulma .is-active.pagination-ellipsis,.enable-bulma .is-active.pagination-link,.enable-bulma .is-active.pagination-next,.enable-bulma .is-active.pagination-previous,.enable-bulma .is-active.textarea,.enable-bulma .is-focused.button,.enable-bulma .is-focused.file-cta,.enable-bulma .is-focused.file-name,.enable-bulma .is-focused.input,.enable-bulma .is-focused.pagination-ellipsis,.enable-bulma .is-focused.pagination-link,.enable-bulma .is-focused.pagination-next,.enable-bulma .is-focused.pagination-previous,.enable-bulma .is-focused.textarea,.enable-bulma .pagination-ellipsis:active,.enable-bulma .pagination-ellipsis:focus,.enable-bulma .pagination-link:active,.enable-bulma .pagination-link:focus,.enable-bulma .pagination-next:active,.enable-bulma .pagination-next:focus,.enable-bulma .pagination-previous:active,.enable-bulma .pagination-previous:focus,.enable-bulma .select select.is-active,.enable-bulma .select select.is-focused,.enable-bulma .select select:active,.enable-bulma .select select:focus,.enable-bulma .taginput .is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-focused.taginput-container.is-focusable,.enable-bulma .taginput .taginput-container.is-focusable:active,.enable-bulma .taginput .taginput-container.is-focusable:focus,.enable-bulma .textarea:active,.enable-bulma .textarea:focus{outline:none}.enable-bulma .select select[disabled],.enable-bulma .taginput [disabled].taginput-container.is-focusable,.enable-bulma [disabled].button,.enable-bulma [disabled].file-cta,.enable-bulma [disabled].file-name,.enable-bulma [disabled].input,.enable-bulma [disabled].pagination-ellipsis,.enable-bulma [disabled].pagination-link,.enable-bulma [disabled].pagination-next,.enable-bulma [disabled].pagination-previous,.enable-bulma [disabled].textarea,fieldset[disabled] .enable-bulma .button,fieldset[disabled] .enable-bulma .file-cta,fieldset[disabled] .enable-bulma .file-name,fieldset[disabled] .enable-bulma .input,fieldset[disabled] .enable-bulma .pagination-ellipsis,fieldset[disabled] .enable-bulma .pagination-link,fieldset[disabled] .enable-bulma .pagination-next,fieldset[disabled] .enable-bulma .pagination-previous,fieldset[disabled] .enable-bulma .select select,fieldset[disabled] .enable-bulma .taginput .taginput-container.is-focusable,fieldset[disabled] .enable-bulma .textarea{cursor:not-allowed}.enable-bulma blockquote,.enable-bulma body,.enable-bulma dd,.enable-bulma dl,.enable-bulma dt,.enable-bulma fieldset,.enable-bulma figure,.enable-bulma h1,.enable-bulma h2,.enable-bulma h3,.enable-bulma h4,.enable-bulma h5,.enable-bulma h6,.enable-bulma hr,.enable-bulma html,.enable-bulma iframe,.enable-bulma legend,.enable-bulma li,.enable-bulma ol,.enable-bulma p,.enable-bulma pre,.enable-bulma textarea,.enable-bulma ul{margin:0;padding:0}.enable-bulma h1,.enable-bulma h2,.enable-bulma h3,.enable-bulma h4,.enable-bulma h5,.enable-bulma h6{font-size:100%;font-weight:400}.enable-bulma ul{list-style:none}.enable-bulma button,.enable-bulma input,.enable-bulma select,.enable-bulma textarea{margin:0}.enable-bulma html{-webkit-box-sizing:border-box;box-sizing:border-box}.enable-bulma *,.enable-bulma :after,.enable-bulma :before{-webkit-box-sizing:inherit;box-sizing:inherit}.enable-bulma embed,.enable-bulma iframe,.enable-bulma img,.enable-bulma object,.enable-bulma video{height:auto;max-width:100%}.enable-bulma audio{max-width:100%}.enable-bulma iframe{border:0}.enable-bulma table{border-collapse:collapse;border-spacing:0}.enable-bulma td,.enable-bulma th{padding:0}.enable-bulma td:not([align]),.enable-bulma th:not([align]){text-align:left}.enable-bulma html{background-color:#fff;font-size:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;min-width:300px;overflow-x:hidden;overflow-y:scroll;text-rendering:optimizeLegibility;-ms-text-size-adjust:100%;text-size-adjust:100%}.enable-bulma article,.enable-bulma aside,.enable-bulma figure,.enable-bulma footer,.enable-bulma header,.enable-bulma hgroup,.enable-bulma section{display:block}.enable-bulma body,.enable-bulma button,.enable-bulma input,.enable-bulma select,.enable-bulma textarea{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}.enable-bulma code,.enable-bulma pre{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:auto;font-family:monospace}.enable-bulma body{color:#4a4a4a;font-size:1em;font-weight:400;line-height:1.5}.enable-bulma a{color:#3273dc;cursor:pointer;text-decoration:none}.enable-bulma a strong{color:currentColor}.enable-bulma a:hover{color:#363636}.enable-bulma code{background-color:#f5f5f5;color:#ff3860;font-size:.875em;font-weight:400;padding:.25em .5em .25em}.enable-bulma hr{background-color:#f5f5f5;border:none;display:block;height:2px;margin:1.5rem 0}.enable-bulma img{height:auto;max-width:100%}.enable-bulma input[type=checkbox],.enable-bulma input[type=radio]{vertical-align:baseline}.enable-bulma small{font-size:.875em}.enable-bulma span{font-style:inherit;font-weight:inherit}.enable-bulma strong{color:#363636;font-weight:700}.enable-bulma fieldset{border:none}.enable-bulma pre{-webkit-overflow-scrolling:touch;background-color:#f5f5f5;color:#4a4a4a;font-size:.875em;overflow-x:auto;padding:1.25rem 1.5rem;white-space:pre;word-wrap:normal}.enable-bulma pre code{background-color:transparent;color:currentColor;font-size:1em;padding:0}.enable-bulma table td,.enable-bulma table th{vertical-align:top}.enable-bulma table td:not([align]),.enable-bulma table th:not([align]){text-align:left}.enable-bulma table th{color:#363636}.enable-bulma .is-clearfix:after{clear:both;content:\" \";display:table}.enable-bulma .is-pulled-left{float:left!important}.enable-bulma .is-pulled-right{float:right!important}.enable-bulma .is-clipped{overflow:hidden!important}.enable-bulma .is-size-1{font-size:3rem!important}.enable-bulma .is-size-2{font-size:2.5rem!important}.enable-bulma .is-size-3{font-size:2rem!important}.enable-bulma .is-size-4{font-size:1.5rem!important}.enable-bulma .is-size-5{font-size:1.25rem!important}.enable-bulma .is-size-6{font-size:1rem!important}.enable-bulma .is-size-7{font-size:.75rem!important}@media screen and (max-width:768px){.enable-bulma .is-size-1-mobile{font-size:3rem!important}.enable-bulma .is-size-2-mobile{font-size:2.5rem!important}.enable-bulma .is-size-3-mobile{font-size:2rem!important}.enable-bulma .is-size-4-mobile{font-size:1.5rem!important}.enable-bulma .is-size-5-mobile{font-size:1.25rem!important}.enable-bulma .is-size-6-mobile{font-size:1rem!important}.enable-bulma .is-size-7-mobile{font-size:.75rem!important}}@media print,screen and (min-width:769px){.enable-bulma .is-size-1-tablet{font-size:3rem!important}.enable-bulma .is-size-2-tablet{font-size:2.5rem!important}.enable-bulma .is-size-3-tablet{font-size:2rem!important}.enable-bulma .is-size-4-tablet{font-size:1.5rem!important}.enable-bulma .is-size-5-tablet{font-size:1.25rem!important}.enable-bulma .is-size-6-tablet{font-size:1rem!important}.enable-bulma .is-size-7-tablet{font-size:.75rem!important}}@media screen and (max-width:1023px){.enable-bulma .is-size-1-touch{font-size:3rem!important}.enable-bulma .is-size-2-touch{font-size:2.5rem!important}.enable-bulma .is-size-3-touch{font-size:2rem!important}.enable-bulma .is-size-4-touch{font-size:1.5rem!important}.enable-bulma .is-size-5-touch{font-size:1.25rem!important}.enable-bulma .is-size-6-touch{font-size:1rem!important}.enable-bulma .is-size-7-touch{font-size:.75rem!important}}@media screen and (min-width:1024px){.enable-bulma .is-size-1-desktop{font-size:3rem!important}.enable-bulma .is-size-2-desktop{font-size:2.5rem!important}.enable-bulma .is-size-3-desktop{font-size:2rem!important}.enable-bulma .is-size-4-desktop{font-size:1.5rem!important}.enable-bulma .is-size-5-desktop{font-size:1.25rem!important}.enable-bulma .is-size-6-desktop{font-size:1rem!important}.enable-bulma .is-size-7-desktop{font-size:.75rem!important}}@media screen and (min-width:1216px){.enable-bulma .is-size-1-widescreen{font-size:3rem!important}.enable-bulma .is-size-2-widescreen{font-size:2.5rem!important}.enable-bulma .is-size-3-widescreen{font-size:2rem!important}.enable-bulma .is-size-4-widescreen{font-size:1.5rem!important}.enable-bulma .is-size-5-widescreen{font-size:1.25rem!important}.enable-bulma .is-size-6-widescreen{font-size:1rem!important}.enable-bulma .is-size-7-widescreen{font-size:.75rem!important}}@media screen and (min-width:1408px){.enable-bulma .is-size-1-fullhd{font-size:3rem!important}.enable-bulma .is-size-2-fullhd{font-size:2.5rem!important}.enable-bulma .is-size-3-fullhd{font-size:2rem!important}.enable-bulma .is-size-4-fullhd{font-size:1.5rem!important}.enable-bulma .is-size-5-fullhd{font-size:1.25rem!important}.enable-bulma .is-size-6-fullhd{font-size:1rem!important}.enable-bulma .is-size-7-fullhd{font-size:.75rem!important}}.enable-bulma .has-text-centered{text-align:center!important}.enable-bulma .has-text-justified{text-align:justify!important}.enable-bulma .has-text-left{text-align:left!important}.enable-bulma .has-text-right{text-align:right!important}@media screen and (max-width:768px){.enable-bulma .has-text-centered-mobile{text-align:center!important}}@media print,screen and (min-width:769px){.enable-bulma .has-text-centered-tablet{text-align:center!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .has-text-centered-tablet-only{text-align:center!important}}@media screen and (max-width:1023px){.enable-bulma .has-text-centered-touch{text-align:center!important}}@media screen and (min-width:1024px){.enable-bulma .has-text-centered-desktop{text-align:center!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .has-text-centered-desktop-only{text-align:center!important}}@media screen and (min-width:1216px){.enable-bulma .has-text-centered-widescreen{text-align:center!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .has-text-centered-widescreen-only{text-align:center!important}}@media screen and (min-width:1408px){.enable-bulma .has-text-centered-fullhd{text-align:center!important}}@media screen and (max-width:768px){.enable-bulma .has-text-justified-mobile{text-align:justify!important}}@media print,screen and (min-width:769px){.enable-bulma .has-text-justified-tablet{text-align:justify!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .has-text-justified-tablet-only{text-align:justify!important}}@media screen and (max-width:1023px){.enable-bulma .has-text-justified-touch{text-align:justify!important}}@media screen and (min-width:1024px){.enable-bulma .has-text-justified-desktop{text-align:justify!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .has-text-justified-desktop-only{text-align:justify!important}}@media screen and (min-width:1216px){.enable-bulma .has-text-justified-widescreen{text-align:justify!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .has-text-justified-widescreen-only{text-align:justify!important}}@media screen and (min-width:1408px){.enable-bulma .has-text-justified-fullhd{text-align:justify!important}}@media screen and (max-width:768px){.enable-bulma .has-text-left-mobile{text-align:left!important}}@media print,screen and (min-width:769px){.enable-bulma .has-text-left-tablet{text-align:left!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .has-text-left-tablet-only{text-align:left!important}}@media screen and (max-width:1023px){.enable-bulma .has-text-left-touch{text-align:left!important}}@media screen and (min-width:1024px){.enable-bulma .has-text-left-desktop{text-align:left!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .has-text-left-desktop-only{text-align:left!important}}@media screen and (min-width:1216px){.enable-bulma .has-text-left-widescreen{text-align:left!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .has-text-left-widescreen-only{text-align:left!important}}@media screen and (min-width:1408px){.enable-bulma .has-text-left-fullhd{text-align:left!important}}@media screen and (max-width:768px){.enable-bulma .has-text-right-mobile{text-align:right!important}}@media print,screen and (min-width:769px){.enable-bulma .has-text-right-tablet{text-align:right!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .has-text-right-tablet-only{text-align:right!important}}@media screen and (max-width:1023px){.enable-bulma .has-text-right-touch{text-align:right!important}}@media screen and (min-width:1024px){.enable-bulma .has-text-right-desktop{text-align:right!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .has-text-right-desktop-only{text-align:right!important}}@media screen and (min-width:1216px){.enable-bulma .has-text-right-widescreen{text-align:right!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .has-text-right-widescreen-only{text-align:right!important}}@media screen and (min-width:1408px){.enable-bulma .has-text-right-fullhd{text-align:right!important}}.enable-bulma .is-capitalized{text-transform:capitalize!important}.enable-bulma .is-lowercase{text-transform:lowercase!important}.enable-bulma .is-uppercase{text-transform:uppercase!important}.enable-bulma .is-italic{font-style:italic!important}.enable-bulma .has-text-white{color:#fff!important}.enable-bulma a.has-text-white:focus,.enable-bulma a.has-text-white:hover{color:#e6e6e6!important}.enable-bulma .has-background-white{background-color:#fff!important}.enable-bulma .has-text-black{color:#0a0a0a!important}.enable-bulma a.has-text-black:focus,.enable-bulma a.has-text-black:hover{color:#000!important}.enable-bulma .has-background-black{background-color:#0a0a0a!important}.enable-bulma .has-text-light{color:#f5f5f5!important}.enable-bulma a.has-text-light:focus,.enable-bulma a.has-text-light:hover{color:#dbdbdb!important}.enable-bulma .has-background-light{background-color:#f5f5f5!important}.enable-bulma .has-text-dark{color:#363636!important}.enable-bulma a.has-text-dark:focus,.enable-bulma a.has-text-dark:hover{color:#1c1c1c!important}.enable-bulma .has-background-dark{background-color:#363636!important}.enable-bulma .has-text-primary{color:#3273dc!important}.enable-bulma a.has-text-primary:focus,.enable-bulma a.has-text-primary:hover{color:#205bbb!important}.enable-bulma .has-background-primary{background-color:#3273dc!important}.enable-bulma .has-text-link{color:#3273dc!important}.enable-bulma a.has-text-link:focus,.enable-bulma a.has-text-link:hover{color:#205bbc!important}.enable-bulma .has-background-link{background-color:#3273dc!important}.enable-bulma .has-text-info{color:#209cee!important}.enable-bulma a.has-text-info:focus,.enable-bulma a.has-text-info:hover{color:#0f81cc!important}.enable-bulma .has-background-info{background-color:#209cee!important}.enable-bulma .has-text-success{color:#23d160!important}.enable-bulma a.has-text-success:focus,.enable-bulma a.has-text-success:hover{color:#1ca64c!important}.enable-bulma .has-background-success{background-color:#23d160!important}.enable-bulma .has-text-warning{color:#ffdd57!important}.enable-bulma a.has-text-warning:focus,.enable-bulma a.has-text-warning:hover{color:#ffd324!important}.enable-bulma .has-background-warning{background-color:#ffdd57!important}.enable-bulma .has-text-danger{color:#ff3860!important}.enable-bulma a.has-text-danger:focus,.enable-bulma a.has-text-danger:hover{color:#ff0537!important}.enable-bulma .has-background-danger{background-color:#ff3860!important}.enable-bulma .has-text-black-bis{color:#121212!important}.enable-bulma .has-background-black-bis{background-color:#121212!important}.enable-bulma .has-text-black-ter{color:#242424!important}.enable-bulma .has-background-black-ter{background-color:#242424!important}.enable-bulma .has-text-grey-darker{color:#363636!important}.enable-bulma .has-background-grey-darker{background-color:#363636!important}.enable-bulma .has-text-grey-dark{color:#4a4a4a!important}.enable-bulma .has-background-grey-dark{background-color:#4a4a4a!important}.enable-bulma .has-text-grey{color:#7a7a7a!important}.enable-bulma .has-background-grey{background-color:#7a7a7a!important}.enable-bulma .has-text-grey-light{color:#b5b5b5!important}.enable-bulma .has-background-grey-light{background-color:#b5b5b5!important}.enable-bulma .has-text-grey-lighter{color:#dbdbdb!important}.enable-bulma .has-background-grey-lighter{background-color:#dbdbdb!important}.enable-bulma .has-text-white-ter{color:#f5f5f5!important}.enable-bulma .has-background-white-ter{background-color:#f5f5f5!important}.enable-bulma .has-text-white-bis{color:#fafafa!important}.enable-bulma .has-background-white-bis{background-color:#fafafa!important}.enable-bulma .has-text-weight-light{font-weight:300!important}.enable-bulma .has-text-weight-normal{font-weight:400!important}.enable-bulma .has-text-weight-medium{font-weight:500!important}.enable-bulma .has-text-weight-semibold{font-weight:600!important}.enable-bulma .has-text-weight-bold{font-weight:700!important}.enable-bulma .is-family-primary,.enable-bulma .is-family-sans-serif,.enable-bulma .is-family-secondary{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif!important}.enable-bulma .is-family-code,.enable-bulma .is-family-monospace{font-family:monospace!important}.enable-bulma .is-block{display:block!important}@media screen and (max-width:768px){.enable-bulma .is-block-mobile{display:block!important}}@media print,screen and (min-width:769px){.enable-bulma .is-block-tablet{display:block!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .is-block-tablet-only{display:block!important}}@media screen and (max-width:1023px){.enable-bulma .is-block-touch{display:block!important}}@media screen and (min-width:1024px){.enable-bulma .is-block-desktop{display:block!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .is-block-desktop-only{display:block!important}}@media screen and (min-width:1216px){.enable-bulma .is-block-widescreen{display:block!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .is-block-widescreen-only{display:block!important}}@media screen and (min-width:1408px){.enable-bulma .is-block-fullhd{display:block!important}}.enable-bulma .is-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}@media screen and (max-width:768px){.enable-bulma .is-flex-mobile{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media print,screen and (min-width:769px){.enable-bulma .is-flex-tablet{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .is-flex-tablet-only{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (max-width:1023px){.enable-bulma .is-flex-touch{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1024px){.enable-bulma .is-flex-desktop{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .is-flex-desktop-only{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1216px){.enable-bulma .is-flex-widescreen{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .is-flex-widescreen-only{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1408px){.enable-bulma .is-flex-fullhd{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}.enable-bulma .is-inline{display:inline!important}@media screen and (max-width:768px){.enable-bulma .is-inline-mobile{display:inline!important}}@media print,screen and (min-width:769px){.enable-bulma .is-inline-tablet{display:inline!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .is-inline-tablet-only{display:inline!important}}@media screen and (max-width:1023px){.enable-bulma .is-inline-touch{display:inline!important}}@media screen and (min-width:1024px){.enable-bulma .is-inline-desktop{display:inline!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .is-inline-desktop-only{display:inline!important}}@media screen and (min-width:1216px){.enable-bulma .is-inline-widescreen{display:inline!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .is-inline-widescreen-only{display:inline!important}}@media screen and (min-width:1408px){.enable-bulma .is-inline-fullhd{display:inline!important}}.enable-bulma .is-inline-block{display:inline-block!important}@media screen and (max-width:768px){.enable-bulma .is-inline-block-mobile{display:inline-block!important}}@media print,screen and (min-width:769px){.enable-bulma .is-inline-block-tablet{display:inline-block!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .is-inline-block-tablet-only{display:inline-block!important}}@media screen and (max-width:1023px){.enable-bulma .is-inline-block-touch{display:inline-block!important}}@media screen and (min-width:1024px){.enable-bulma .is-inline-block-desktop{display:inline-block!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .is-inline-block-desktop-only{display:inline-block!important}}@media screen and (min-width:1216px){.enable-bulma .is-inline-block-widescreen{display:inline-block!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .is-inline-block-widescreen-only{display:inline-block!important}}@media screen and (min-width:1408px){.enable-bulma .is-inline-block-fullhd{display:inline-block!important}}.enable-bulma .is-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}@media screen and (max-width:768px){.enable-bulma .is-inline-flex-mobile{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print,screen and (min-width:769px){.enable-bulma .is-inline-flex-tablet{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .is-inline-flex-tablet-only{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (max-width:1023px){.enable-bulma .is-inline-flex-touch{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1024px){.enable-bulma .is-inline-flex-desktop{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .is-inline-flex-desktop-only{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1216px){.enable-bulma .is-inline-flex-widescreen{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .is-inline-flex-widescreen-only{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1408px){.enable-bulma .is-inline-flex-fullhd{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}.enable-bulma .is-hidden{display:none!important}.enable-bulma .is-sr-only{border:none!important;clip:rect(0,0,0,0)!important;height:.01em!important;overflow:hidden!important;padding:0!important;position:absolute!important;white-space:nowrap!important;width:.01em!important}@media screen and (max-width:768px){.enable-bulma .is-hidden-mobile{display:none!important}}@media print,screen and (min-width:769px){.enable-bulma .is-hidden-tablet{display:none!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .is-hidden-tablet-only{display:none!important}}@media screen and (max-width:1023px){.enable-bulma .is-hidden-touch{display:none!important}}@media screen and (min-width:1024px){.enable-bulma .is-hidden-desktop{display:none!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .is-hidden-desktop-only{display:none!important}}@media screen and (min-width:1216px){.enable-bulma .is-hidden-widescreen{display:none!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .is-hidden-widescreen-only{display:none!important}}@media screen and (min-width:1408px){.enable-bulma .is-hidden-fullhd{display:none!important}}.enable-bulma .is-invisible{visibility:hidden!important}@media screen and (max-width:768px){.enable-bulma .is-invisible-mobile{visibility:hidden!important}}@media print,screen and (min-width:769px){.enable-bulma .is-invisible-tablet{visibility:hidden!important}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .is-invisible-tablet-only{visibility:hidden!important}}@media screen and (max-width:1023px){.enable-bulma .is-invisible-touch{visibility:hidden!important}}@media screen and (min-width:1024px){.enable-bulma .is-invisible-desktop{visibility:hidden!important}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .is-invisible-desktop-only{visibility:hidden!important}}@media screen and (min-width:1216px){.enable-bulma .is-invisible-widescreen{visibility:hidden!important}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .is-invisible-widescreen-only{visibility:hidden!important}}@media screen and (min-width:1408px){.enable-bulma .is-invisible-fullhd{visibility:hidden!important}}.enable-bulma .is-marginless{margin:0!important}.enable-bulma .is-paddingless{padding:0!important}.enable-bulma .is-radiusless{border-radius:0!important}.enable-bulma .is-shadowless{-webkit-box-shadow:none!important;box-shadow:none!important}.enable-bulma .is-relative{position:relative!important}.enable-bulma .box{background-color:#fff;border-radius:6px;-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);color:#4a4a4a;display:block;padding:1.25rem}.enable-bulma a.box:focus,.enable-bulma a.box:hover{-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px #3273dc;box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px #3273dc}.enable-bulma a.box:active{-webkit-box-shadow:inset 0 1px 2px rgba(10,10,10,.2),0 0 0 1px #3273dc;box-shadow:inset 0 1px 2px rgba(10,10,10,.2),0 0 0 1px #3273dc}.enable-bulma .button{background-color:#fff;border-color:#dbdbdb;border-width:1px;color:#363636;cursor:pointer;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-bottom:calc(.375em - 1px);padding-left:.75em;padding-right:.75em;padding-top:calc(.375em - 1px);text-align:center;white-space:nowrap}.enable-bulma .button strong{color:inherit}.enable-bulma .button .icon,.enable-bulma .button .icon.is-large,.enable-bulma .button .icon.is-medium,.enable-bulma .button .icon.is-small{height:1.5em;width:1.5em}.enable-bulma .button .icon:first-child:not(:last-child){margin-left:calc(-.375em - 1px);margin-right:.1875em}.enable-bulma .button .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:calc(-.375em - 1px)}.enable-bulma .button .icon:first-child:last-child{margin-left:calc(-.375em - 1px);margin-right:calc(-.375em - 1px)}.enable-bulma .button.is-hovered,.enable-bulma .button:hover{border-color:#b5b5b5;color:#363636}.enable-bulma .button.is-focused,.enable-bulma .button:focus{border-color:#3273dc;color:#363636}.enable-bulma .button.is-focused:not(:active),.enable-bulma .button:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .button.is-active,.enable-bulma .button:active{border-color:#4a4a4a;color:#363636}.enable-bulma .button.is-text{background-color:transparent;border-color:transparent;color:#4a4a4a;text-decoration:underline}.enable-bulma .button.is-text.is-focused,.enable-bulma .button.is-text.is-hovered,.enable-bulma .button.is-text:focus,.enable-bulma .button.is-text:hover{background-color:#f5f5f5;color:#363636}.enable-bulma .button.is-text.is-active,.enable-bulma .button.is-text:active{background-color:#e8e8e8;color:#363636}.enable-bulma .button.is-text[disabled],fieldset[disabled] .enable-bulma .button.is-text{background-color:transparent;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-white{background-color:#fff;border-color:transparent;color:#0a0a0a}.enable-bulma .button.is-white.is-hovered,.enable-bulma .button.is-white:hover{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.enable-bulma .button.is-white.is-focused,.enable-bulma .button.is-white:focus{border-color:transparent;color:#0a0a0a}.enable-bulma .button.is-white.is-focused:not(:active),.enable-bulma .button.is-white:focus:not(:active){-webkit-box-shadow:0 0 0 .125em hsla(0,0%,100%,.25);box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.enable-bulma .button.is-white.is-active,.enable-bulma .button.is-white:active{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.enable-bulma .button.is-white[disabled],fieldset[disabled] .enable-bulma .button.is-white{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-white.is-inverted{background-color:#0a0a0a;color:#fff}.enable-bulma .button.is-white.is-inverted.is-hovered,.enable-bulma .button.is-white.is-inverted:hover{background-color:#000}.enable-bulma .button.is-white.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-white.is-inverted{background-color:#0a0a0a;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-white.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.enable-bulma .button.is-white.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.enable-bulma .button.is-white.is-outlined.is-focused,.enable-bulma .button.is-white.is-outlined.is-hovered,.enable-bulma .button.is-white.is-outlined:focus,.enable-bulma .button.is-white.is-outlined:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.enable-bulma .button.is-white.is-outlined.is-loading:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-white.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-white.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-white.is-outlined.is-loading:focus:after,.enable-bulma .button.is-white.is-outlined.is-loading:hover:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.enable-bulma .button.is-white.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-white.is-outlined{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.enable-bulma .button.is-white.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-white.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-white.is-inverted.is-outlined:focus,.enable-bulma .button.is-white.is-inverted.is-outlined:hover{background-color:#0a0a0a;color:#fff}.enable-bulma .button.is-white.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-white.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-white.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-white.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-white.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;-webkit-box-shadow:none;box-shadow:none;color:#0a0a0a}.enable-bulma .button.is-black{background-color:#0a0a0a;border-color:transparent;color:#fff}.enable-bulma .button.is-black.is-hovered,.enable-bulma .button.is-black:hover{background-color:#040404;border-color:transparent;color:#fff}.enable-bulma .button.is-black.is-focused,.enable-bulma .button.is-black:focus{border-color:transparent;color:#fff}.enable-bulma .button.is-black.is-focused:not(:active),.enable-bulma .button.is-black:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(10,10,10,.25);box-shadow:0 0 0 .125em rgba(10,10,10,.25)}.enable-bulma .button.is-black.is-active,.enable-bulma .button.is-black:active{background-color:#000;border-color:transparent;color:#fff}.enable-bulma .button.is-black[disabled],fieldset[disabled] .enable-bulma .button.is-black{background-color:#0a0a0a;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-black.is-inverted{background-color:#fff;color:#0a0a0a}.enable-bulma .button.is-black.is-inverted.is-hovered,.enable-bulma .button.is-black.is-inverted:hover{background-color:#f2f2f2}.enable-bulma .button.is-black.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-black.is-inverted{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#0a0a0a}.enable-bulma .button.is-black.is-loading:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.enable-bulma .button.is-black.is-outlined.is-focused,.enable-bulma .button.is-black.is-outlined.is-hovered,.enable-bulma .button.is-black.is-outlined:focus,.enable-bulma .button.is-black.is-outlined:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.enable-bulma .button.is-black.is-outlined.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.enable-bulma .button.is-black.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-black.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-black.is-outlined.is-loading:focus:after,.enable-bulma .button.is-black.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-black.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;-webkit-box-shadow:none;box-shadow:none;color:#0a0a0a}.enable-bulma .button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.enable-bulma .button.is-black.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-black.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-black.is-inverted.is-outlined:focus,.enable-bulma .button.is-black.is-inverted.is-outlined:hover{background-color:#fff;color:#0a0a0a}.enable-bulma .button.is-black.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-black.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-black.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-black.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.enable-bulma .button.is-black.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-light{background-color:#f5f5f5;border-color:transparent;color:#363636}.enable-bulma .button.is-light.is-hovered,.enable-bulma .button.is-light:hover{background-color:#eee;border-color:transparent;color:#363636}.enable-bulma .button.is-light.is-focused,.enable-bulma .button.is-light:focus{border-color:transparent;color:#363636}.enable-bulma .button.is-light.is-focused:not(:active),.enable-bulma .button.is-light:focus:not(:active){-webkit-box-shadow:0 0 0 .125em hsla(0,0%,96.1%,.25);box-shadow:0 0 0 .125em hsla(0,0%,96.1%,.25)}.enable-bulma .button.is-light.is-active,.enable-bulma .button.is-light:active{background-color:#e8e8e8;border-color:transparent;color:#363636}.enable-bulma .button.is-light[disabled],fieldset[disabled] .enable-bulma .button.is-light{background-color:#f5f5f5;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-light.is-inverted{background-color:#363636;color:#f5f5f5}.enable-bulma .button.is-light.is-inverted.is-hovered,.enable-bulma .button.is-light.is-inverted:hover{background-color:#292929}.enable-bulma .button.is-light.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-light.is-inverted{background-color:#363636;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#f5f5f5}.enable-bulma .button.is-light.is-loading:after{border-color:transparent transparent #363636 #363636!important}.enable-bulma .button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.enable-bulma .button.is-light.is-outlined.is-focused,.enable-bulma .button.is-light.is-outlined.is-hovered,.enable-bulma .button.is-light.is-outlined:focus,.enable-bulma .button.is-light.is-outlined:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.enable-bulma .button.is-light.is-outlined.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.enable-bulma .button.is-light.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-light.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-light.is-outlined.is-loading:focus:after,.enable-bulma .button.is-light.is-outlined.is-loading:hover:after{border-color:transparent transparent #363636 #363636!important}.enable-bulma .button.is-light.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;-webkit-box-shadow:none;box-shadow:none;color:#f5f5f5}.enable-bulma .button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.enable-bulma .button.is-light.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-light.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-light.is-inverted.is-outlined:focus,.enable-bulma .button.is-light.is-inverted.is-outlined:hover{background-color:#363636;color:#f5f5f5}.enable-bulma .button.is-light.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-light.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-light.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-light.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.enable-bulma .button.is-light.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:#363636;-webkit-box-shadow:none;box-shadow:none;color:#363636}.enable-bulma .button.is-dark{background-color:#363636;border-color:transparent;color:#f5f5f5}.enable-bulma .button.is-dark.is-hovered,.enable-bulma .button.is-dark:hover{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.enable-bulma .button.is-dark.is-focused,.enable-bulma .button.is-dark:focus{border-color:transparent;color:#f5f5f5}.enable-bulma .button.is-dark.is-focused:not(:active),.enable-bulma .button.is-dark:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(54,54,54,.25);box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.enable-bulma .button.is-dark.is-active,.enable-bulma .button.is-dark:active{background-color:#292929;border-color:transparent;color:#f5f5f5}.enable-bulma .button.is-dark[disabled],fieldset[disabled] .enable-bulma .button.is-dark{background-color:#363636;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-dark.is-inverted{background-color:#f5f5f5;color:#363636}.enable-bulma .button.is-dark.is-inverted.is-hovered,.enable-bulma .button.is-dark.is-inverted:hover{background-color:#e8e8e8}.enable-bulma .button.is-dark.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-dark.is-inverted{background-color:#f5f5f5;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#363636}.enable-bulma .button.is-dark.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.enable-bulma .button.is-dark.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.enable-bulma .button.is-dark.is-outlined.is-focused,.enable-bulma .button.is-dark.is-outlined.is-hovered,.enable-bulma .button.is-dark.is-outlined:focus,.enable-bulma .button.is-dark.is-outlined:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.enable-bulma .button.is-dark.is-outlined.is-loading:after{border-color:transparent transparent #363636 #363636!important}.enable-bulma .button.is-dark.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-dark.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-dark.is-outlined.is-loading:focus:after,.enable-bulma .button.is-dark.is-outlined.is-loading:hover:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.enable-bulma .button.is-dark.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-dark.is-outlined{background-color:transparent;border-color:#363636;-webkit-box-shadow:none;box-shadow:none;color:#363636}.enable-bulma .button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.enable-bulma .button.is-dark.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-dark.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-dark.is-inverted.is-outlined:focus,.enable-bulma .button.is-dark.is-inverted.is-outlined:hover{background-color:#f5f5f5;color:#363636}.enable-bulma .button.is-dark.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-dark.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-dark.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-dark.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #363636 #363636!important}.enable-bulma .button.is-dark.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#f5f5f5;-webkit-box-shadow:none;box-shadow:none;color:#f5f5f5}.enable-bulma .button.is-primary{background-color:#3273dc;border-color:transparent;color:#fff}.enable-bulma .button.is-primary.is-hovered,.enable-bulma .button.is-primary:hover{background-color:#276cda;border-color:transparent;color:#fff}.enable-bulma .button.is-primary.is-focused,.enable-bulma .button.is-primary:focus{border-color:transparent;color:#fff}.enable-bulma .button.is-primary.is-focused:not(:active),.enable-bulma .button.is-primary:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .button.is-primary.is-active,.enable-bulma .button.is-primary:active{background-color:#2466d1;border-color:transparent;color:#fff}.enable-bulma .button.is-primary[disabled],fieldset[disabled] .enable-bulma .button.is-primary{background-color:#3273dc;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-primary.is-inverted{background-color:#fff;color:#3273dc}.enable-bulma .button.is-primary.is-inverted.is-hovered,.enable-bulma .button.is-primary.is-inverted:hover{background-color:#f2f2f2}.enable-bulma .button.is-primary.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-primary.is-inverted{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#3273dc}.enable-bulma .button.is-primary.is-loading:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-primary.is-outlined{background-color:transparent;border-color:#3273dc;color:#3273dc}.enable-bulma .button.is-primary.is-outlined.is-focused,.enable-bulma .button.is-primary.is-outlined.is-hovered,.enable-bulma .button.is-primary.is-outlined:focus,.enable-bulma .button.is-primary.is-outlined:hover{background-color:#3273dc;border-color:#3273dc;color:#fff}.enable-bulma .button.is-primary.is-outlined.is-loading:after{border-color:transparent transparent #3273dc #3273dc!important}.enable-bulma .button.is-primary.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-primary.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-primary.is-outlined.is-loading:focus:after,.enable-bulma .button.is-primary.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-primary.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-primary.is-outlined{background-color:transparent;border-color:#3273dc;-webkit-box-shadow:none;box-shadow:none;color:#3273dc}.enable-bulma .button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.enable-bulma .button.is-primary.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-primary.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-primary.is-inverted.is-outlined:focus,.enable-bulma .button.is-primary.is-inverted.is-outlined:hover{background-color:#fff;color:#3273dc}.enable-bulma .button.is-primary.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-primary.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-primary.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-primary.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #3273dc #3273dc!important}.enable-bulma .button.is-primary.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-link{background-color:#3273dc;border-color:transparent;color:#fff}.enable-bulma .button.is-link.is-hovered,.enable-bulma .button.is-link:hover{background-color:#276cda;border-color:transparent;color:#fff}.enable-bulma .button.is-link.is-focused,.enable-bulma .button.is-link:focus{border-color:transparent;color:#fff}.enable-bulma .button.is-link.is-focused:not(:active),.enable-bulma .button.is-link:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .button.is-link.is-active,.enable-bulma .button.is-link:active{background-color:#2366d1;border-color:transparent;color:#fff}.enable-bulma .button.is-link[disabled],fieldset[disabled] .enable-bulma .button.is-link{background-color:#3273dc;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-link.is-inverted{background-color:#fff;color:#3273dc}.enable-bulma .button.is-link.is-inverted.is-hovered,.enable-bulma .button.is-link.is-inverted:hover{background-color:#f2f2f2}.enable-bulma .button.is-link.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-link.is-inverted{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#3273dc}.enable-bulma .button.is-link.is-loading:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-link.is-outlined{background-color:transparent;border-color:#3273dc;color:#3273dc}.enable-bulma .button.is-link.is-outlined.is-focused,.enable-bulma .button.is-link.is-outlined.is-hovered,.enable-bulma .button.is-link.is-outlined:focus,.enable-bulma .button.is-link.is-outlined:hover{background-color:#3273dc;border-color:#3273dc;color:#fff}.enable-bulma .button.is-link.is-outlined.is-loading:after{border-color:transparent transparent #3273dc #3273dc!important}.enable-bulma .button.is-link.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-link.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-link.is-outlined.is-loading:focus:after,.enable-bulma .button.is-link.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-link.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-link.is-outlined{background-color:transparent;border-color:#3273dc;-webkit-box-shadow:none;box-shadow:none;color:#3273dc}.enable-bulma .button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.enable-bulma .button.is-link.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-link.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-link.is-inverted.is-outlined:focus,.enable-bulma .button.is-link.is-inverted.is-outlined:hover{background-color:#fff;color:#3273dc}.enable-bulma .button.is-link.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-link.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-link.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-link.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #3273dc #3273dc!important}.enable-bulma .button.is-link.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-info{background-color:#209cee;border-color:transparent;color:#fff}.enable-bulma .button.is-info.is-hovered,.enable-bulma .button.is-info:hover{background-color:#1496ed;border-color:transparent;color:#fff}.enable-bulma .button.is-info.is-focused,.enable-bulma .button.is-info:focus{border-color:transparent;color:#fff}.enable-bulma .button.is-info.is-focused:not(:active),.enable-bulma .button.is-info:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(32,156,238,.25);box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.enable-bulma .button.is-info.is-active,.enable-bulma .button.is-info:active{background-color:#118fe4;border-color:transparent;color:#fff}.enable-bulma .button.is-info[disabled],fieldset[disabled] .enable-bulma .button.is-info{background-color:#209cee;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-info.is-inverted{background-color:#fff;color:#209cee}.enable-bulma .button.is-info.is-inverted.is-hovered,.enable-bulma .button.is-info.is-inverted:hover{background-color:#f2f2f2}.enable-bulma .button.is-info.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-info.is-inverted{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#209cee}.enable-bulma .button.is-info.is-loading:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-info.is-outlined{background-color:transparent;border-color:#209cee;color:#209cee}.enable-bulma .button.is-info.is-outlined.is-focused,.enable-bulma .button.is-info.is-outlined.is-hovered,.enable-bulma .button.is-info.is-outlined:focus,.enable-bulma .button.is-info.is-outlined:hover{background-color:#209cee;border-color:#209cee;color:#fff}.enable-bulma .button.is-info.is-outlined.is-loading:after{border-color:transparent transparent #209cee #209cee!important}.enable-bulma .button.is-info.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-info.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-info.is-outlined.is-loading:focus:after,.enable-bulma .button.is-info.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-info.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-info.is-outlined{background-color:transparent;border-color:#209cee;-webkit-box-shadow:none;box-shadow:none;color:#209cee}.enable-bulma .button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.enable-bulma .button.is-info.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-info.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-info.is-inverted.is-outlined:focus,.enable-bulma .button.is-info.is-inverted.is-outlined:hover{background-color:#fff;color:#209cee}.enable-bulma .button.is-info.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-info.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-info.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-info.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #209cee #209cee!important}.enable-bulma .button.is-info.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-success{background-color:#23d160;border-color:transparent;color:#fff}.enable-bulma .button.is-success.is-hovered,.enable-bulma .button.is-success:hover{background-color:#22c65b;border-color:transparent;color:#fff}.enable-bulma .button.is-success.is-focused,.enable-bulma .button.is-success:focus{border-color:transparent;color:#fff}.enable-bulma .button.is-success.is-focused:not(:active),.enable-bulma .button.is-success:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(35,209,96,.25);box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.enable-bulma .button.is-success.is-active,.enable-bulma .button.is-success:active{background-color:#20bc56;border-color:transparent;color:#fff}.enable-bulma .button.is-success[disabled],fieldset[disabled] .enable-bulma .button.is-success{background-color:#23d160;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-success.is-inverted{background-color:#fff;color:#23d160}.enable-bulma .button.is-success.is-inverted.is-hovered,.enable-bulma .button.is-success.is-inverted:hover{background-color:#f2f2f2}.enable-bulma .button.is-success.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-success.is-inverted{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#23d160}.enable-bulma .button.is-success.is-loading:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-success.is-outlined{background-color:transparent;border-color:#23d160;color:#23d160}.enable-bulma .button.is-success.is-outlined.is-focused,.enable-bulma .button.is-success.is-outlined.is-hovered,.enable-bulma .button.is-success.is-outlined:focus,.enable-bulma .button.is-success.is-outlined:hover{background-color:#23d160;border-color:#23d160;color:#fff}.enable-bulma .button.is-success.is-outlined.is-loading:after{border-color:transparent transparent #23d160 #23d160!important}.enable-bulma .button.is-success.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-success.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-success.is-outlined.is-loading:focus:after,.enable-bulma .button.is-success.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-success.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-success.is-outlined{background-color:transparent;border-color:#23d160;-webkit-box-shadow:none;box-shadow:none;color:#23d160}.enable-bulma .button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.enable-bulma .button.is-success.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-success.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-success.is-inverted.is-outlined:focus,.enable-bulma .button.is-success.is-inverted.is-outlined:hover{background-color:#fff;color:#23d160}.enable-bulma .button.is-success.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-success.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-success.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-success.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #23d160 #23d160!important}.enable-bulma .button.is-success.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-warning{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.enable-bulma .button.is-warning.is-hovered,.enable-bulma .button.is-warning:hover{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.enable-bulma .button.is-warning.is-focused,.enable-bulma .button.is-warning:focus{border-color:transparent;color:rgba(0,0,0,.7)}.enable-bulma .button.is-warning.is-focused:not(:active),.enable-bulma .button.is-warning:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(255,221,87,.25);box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.enable-bulma .button.is-warning.is-active,.enable-bulma .button.is-warning:active{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.enable-bulma .button.is-warning[disabled],fieldset[disabled] .enable-bulma .button.is-warning{background-color:#ffdd57;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-warning.is-inverted{background-color:rgba(0,0,0,.7);color:#ffdd57}.enable-bulma .button.is-warning.is-inverted.is-hovered,.enable-bulma .button.is-warning.is-inverted:hover{background-color:rgba(0,0,0,.7)}.enable-bulma .button.is-warning.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-warning.is-inverted{background-color:rgba(0,0,0,.7);border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#ffdd57}.enable-bulma .button.is-warning.is-loading:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.enable-bulma .button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;color:#ffdd57}.enable-bulma .button.is-warning.is-outlined.is-focused,.enable-bulma .button.is-warning.is-outlined.is-hovered,.enable-bulma .button.is-warning.is-outlined:focus,.enable-bulma .button.is-warning.is-outlined:hover{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .button.is-warning.is-outlined.is-loading:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.enable-bulma .button.is-warning.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-warning.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-warning.is-outlined.is-loading:focus:after,.enable-bulma .button.is-warning.is-outlined.is-loading:hover:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.enable-bulma .button.is-warning.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;-webkit-box-shadow:none;box-shadow:none;color:#ffdd57}.enable-bulma .button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);color:rgba(0,0,0,.7)}.enable-bulma .button.is-warning.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-warning.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-warning.is-inverted.is-outlined:focus,.enable-bulma .button.is-warning.is-inverted.is-outlined:hover{background-color:rgba(0,0,0,.7);color:#ffdd57}.enable-bulma .button.is-warning.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-warning.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-warning.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-warning.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.enable-bulma .button.is-warning.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);-webkit-box-shadow:none;box-shadow:none;color:rgba(0,0,0,.7)}.enable-bulma .button.is-danger{background-color:#ff3860;border-color:transparent;color:#fff}.enable-bulma .button.is-danger.is-hovered,.enable-bulma .button.is-danger:hover{background-color:#ff2b56;border-color:transparent;color:#fff}.enable-bulma .button.is-danger.is-focused,.enable-bulma .button.is-danger:focus{border-color:transparent;color:#fff}.enable-bulma .button.is-danger.is-focused:not(:active),.enable-bulma .button.is-danger:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(255,56,96,.25);box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.enable-bulma .button.is-danger.is-active,.enable-bulma .button.is-danger:active{background-color:#ff1f4b;border-color:transparent;color:#fff}.enable-bulma .button.is-danger[disabled],fieldset[disabled] .enable-bulma .button.is-danger{background-color:#ff3860;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.enable-bulma .button.is-danger.is-inverted{background-color:#fff;color:#ff3860}.enable-bulma .button.is-danger.is-inverted.is-hovered,.enable-bulma .button.is-danger.is-inverted:hover{background-color:#f2f2f2}.enable-bulma .button.is-danger.is-inverted[disabled],fieldset[disabled] .enable-bulma .button.is-danger.is-inverted{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#ff3860}.enable-bulma .button.is-danger.is-loading:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-danger.is-outlined{background-color:transparent;border-color:#ff3860;color:#ff3860}.enable-bulma .button.is-danger.is-outlined.is-focused,.enable-bulma .button.is-danger.is-outlined.is-hovered,.enable-bulma .button.is-danger.is-outlined:focus,.enable-bulma .button.is-danger.is-outlined:hover{background-color:#ff3860;border-color:#ff3860;color:#fff}.enable-bulma .button.is-danger.is-outlined.is-loading:after{border-color:transparent transparent #ff3860 #ff3860!important}.enable-bulma .button.is-danger.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-danger.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-danger.is-outlined.is-loading:focus:after,.enable-bulma .button.is-danger.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.enable-bulma .button.is-danger.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-danger.is-outlined{background-color:transparent;border-color:#ff3860;-webkit-box-shadow:none;box-shadow:none;color:#ff3860}.enable-bulma .button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.enable-bulma .button.is-danger.is-inverted.is-outlined.is-focused,.enable-bulma .button.is-danger.is-inverted.is-outlined.is-hovered,.enable-bulma .button.is-danger.is-inverted.is-outlined:focus,.enable-bulma .button.is-danger.is-inverted.is-outlined:hover{background-color:#fff;color:#ff3860}.enable-bulma .button.is-danger.is-inverted.is-outlined.is-loading.is-focused:after,.enable-bulma .button.is-danger.is-inverted.is-outlined.is-loading.is-hovered:after,.enable-bulma .button.is-danger.is-inverted.is-outlined.is-loading:focus:after,.enable-bulma .button.is-danger.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #ff3860 #ff3860!important}.enable-bulma .button.is-danger.is-inverted.is-outlined[disabled],fieldset[disabled] .enable-bulma .button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.enable-bulma .button.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .button.is-normal{font-size:1rem}.enable-bulma .button.is-medium{font-size:1.25rem}.enable-bulma .button.is-large{font-size:1.5rem}.enable-bulma .button[disabled],fieldset[disabled] .enable-bulma .button{background-color:#fff;border-color:#dbdbdb;-webkit-box-shadow:none;box-shadow:none;opacity:.5}.enable-bulma .button.is-fullwidth{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.enable-bulma .button.is-loading{color:transparent!important;pointer-events:none}.enable-bulma .button.is-loading:after{position:absolute;left:calc(50% - .5em);top:calc(50% - .5em);position:absolute!important}.enable-bulma .button.is-static{background-color:#f5f5f5;border-color:#dbdbdb;color:#7a7a7a;-webkit-box-shadow:none;box-shadow:none;pointer-events:none}.enable-bulma .button.is-rounded{border-radius:290486px;padding-left:1em;padding-right:1em}.enable-bulma .buttons{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.enable-bulma .buttons .button{margin-bottom:.5rem}.enable-bulma .buttons .button:not(:last-child):not(.is-fullwidth){margin-right:.5rem}.enable-bulma .buttons:last-child{margin-bottom:-.5rem}.enable-bulma .buttons:not(:last-child){margin-bottom:1rem}.enable-bulma .buttons.are-small .button:not(.is-normal):not(.is-medium):not(.is-large){border-radius:2px;font-size:.75rem}.enable-bulma .buttons.are-medium .button:not(.is-small):not(.is-normal):not(.is-large){font-size:1.25rem}.enable-bulma .buttons.are-large .button:not(.is-small):not(.is-normal):not(.is-medium){font-size:1.5rem}.enable-bulma .buttons.has-addons .button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.enable-bulma .buttons.has-addons .button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.enable-bulma .buttons.has-addons .button:last-child{margin-right:0}.enable-bulma .buttons.has-addons .button.is-hovered,.enable-bulma .buttons.has-addons .button:hover{z-index:2}.enable-bulma .buttons.has-addons .button.is-active,.enable-bulma .buttons.has-addons .button.is-focused,.enable-bulma .buttons.has-addons .button.is-selected,.enable-bulma .buttons.has-addons .button:active,.enable-bulma .buttons.has-addons .button:focus{z-index:3}.enable-bulma .buttons.has-addons .button.is-active:hover,.enable-bulma .buttons.has-addons .button.is-focused:hover,.enable-bulma .buttons.has-addons .button.is-selected:hover,.enable-bulma .buttons.has-addons .button:active:hover,.enable-bulma .buttons.has-addons .button:focus:hover{z-index:4}.enable-bulma .buttons.has-addons .button.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .buttons.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .buttons.is-centered:not(.has-addons) .button:not(.is-fullwidth){margin-left:.25rem;margin-right:.25rem}.enable-bulma .buttons.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .buttons.is-right:not(.has-addons) .button:not(.is-fullwidth){margin-left:.25rem;margin-right:.25rem}.enable-bulma .container{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:0 auto;position:relative;width:auto}@media screen and (min-width:1024px){.enable-bulma .container{max-width:960px}.enable-bulma .container.is-fluid{margin-left:32px;margin-right:32px;max-width:none}}@media screen and (max-width:1215px){.enable-bulma .container.is-widescreen{max-width:1152px}}@media screen and (max-width:1407px){.enable-bulma .container.is-fullhd{max-width:1344px}}@media screen and (min-width:1216px){.enable-bulma .container{max-width:1152px}}@media screen and (min-width:1408px){.enable-bulma .container{max-width:1344px}}.enable-bulma .content li+li{margin-top:.25em}.enable-bulma .content blockquote:not(:last-child),.enable-bulma .content dl:not(:last-child),.enable-bulma .content ol:not(:last-child),.enable-bulma .content p:not(:last-child),.enable-bulma .content pre:not(:last-child),.enable-bulma .content table:not(:last-child),.enable-bulma .content ul:not(:last-child){margin-bottom:1em}.enable-bulma .content h1,.enable-bulma .content h2,.enable-bulma .content h3,.enable-bulma .content h4,.enable-bulma .content h5,.enable-bulma .content h6{color:#363636;font-weight:600;line-height:1.125}.enable-bulma .content h1{font-size:2em;margin-bottom:.5em}.enable-bulma .content h1:not(:first-child){margin-top:1em}.enable-bulma .content h2{font-size:1.75em;margin-bottom:.5714em}.enable-bulma .content h2:not(:first-child){margin-top:1.1428em}.enable-bulma .content h3{font-size:1.5em;margin-bottom:.6666em}.enable-bulma .content h3:not(:first-child){margin-top:1.3333em}.enable-bulma .content h4{font-size:1.25em;margin-bottom:.8em}.enable-bulma .content h5{font-size:1.125em;margin-bottom:.8888em}.enable-bulma .content h6{font-size:1em;margin-bottom:1em}.enable-bulma .content blockquote{background-color:#f5f5f5;border-left:5px solid #dbdbdb;padding:1.25em 1.5em}.enable-bulma .content ol{list-style-position:outside;margin-left:2em;margin-top:1em}.enable-bulma .content ol:not([type]){list-style-type:decimal}.enable-bulma .content ol:not([type]).is-lower-alpha{list-style-type:lower-alpha}.enable-bulma .content ol:not([type]).is-lower-roman{list-style-type:lower-roman}.enable-bulma .content ol:not([type]).is-upper-alpha{list-style-type:upper-alpha}.enable-bulma .content ol:not([type]).is-upper-roman{list-style-type:upper-roman}.enable-bulma .content ul{list-style:disc outside;margin-left:2em;margin-top:1em}.enable-bulma .content ul ul{list-style-type:circle;margin-top:.5em}.enable-bulma .content ul ul ul{list-style-type:square}.enable-bulma .content dd{margin-left:2em}.enable-bulma .content figure{margin-left:2em;margin-right:2em;text-align:center}.enable-bulma .content figure:not(:first-child){margin-top:2em}.enable-bulma .content figure:not(:last-child){margin-bottom:2em}.enable-bulma .content figure img{display:inline-block}.enable-bulma .content figure figcaption{font-style:italic}.enable-bulma .content pre{-webkit-overflow-scrolling:touch;overflow-x:auto;padding:1.25em 1.5em;white-space:pre;word-wrap:normal}.enable-bulma .content sub,.enable-bulma .content sup{font-size:75%}.enable-bulma .content table{width:100%}.enable-bulma .content table td,.enable-bulma .content table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.enable-bulma .content table th{color:#363636}.enable-bulma .content table th:not([align]){text-align:left}.enable-bulma .content table thead td,.enable-bulma .content table thead th{border-width:0 0 2px;color:#363636}.enable-bulma .content table tfoot td,.enable-bulma .content table tfoot th{border-width:2px 0 0;color:#363636}.enable-bulma .content table tbody tr:last-child td,.enable-bulma .content table tbody tr:last-child th{border-bottom-width:0}.enable-bulma .content .tabs li+li{margin-top:0}.enable-bulma .content.is-small{font-size:.75rem}.enable-bulma .content.is-medium{font-size:1.25rem}.enable-bulma .content.is-large{font-size:1.5rem}.enable-bulma .icon{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:1.5rem;width:1.5rem}.enable-bulma .icon.is-small{height:1rem;width:1rem}.enable-bulma .icon.is-medium{height:2rem;width:2rem}.enable-bulma .icon.is-large{height:3rem;width:3rem}.enable-bulma .image{display:block;position:relative}.enable-bulma .image img{display:block;height:auto;width:100%}.enable-bulma .image img.is-rounded{border-radius:290486px}.enable-bulma .image.is-1by1 .has-ratio,.enable-bulma .image.is-1by1 img,.enable-bulma .image.is-1by2 .has-ratio,.enable-bulma .image.is-1by2 img,.enable-bulma .image.is-1by3 .has-ratio,.enable-bulma .image.is-1by3 img,.enable-bulma .image.is-2by1 .has-ratio,.enable-bulma .image.is-2by1 img,.enable-bulma .image.is-2by3 .has-ratio,.enable-bulma .image.is-2by3 img,.enable-bulma .image.is-3by1 .has-ratio,.enable-bulma .image.is-3by1 img,.enable-bulma .image.is-3by2 .has-ratio,.enable-bulma .image.is-3by2 img,.enable-bulma .image.is-3by4 .has-ratio,.enable-bulma .image.is-3by4 img,.enable-bulma .image.is-3by5 .has-ratio,.enable-bulma .image.is-3by5 img,.enable-bulma .image.is-4by3 .has-ratio,.enable-bulma .image.is-4by3 img,.enable-bulma .image.is-4by5 .has-ratio,.enable-bulma .image.is-4by5 img,.enable-bulma .image.is-5by3 .has-ratio,.enable-bulma .image.is-5by3 img,.enable-bulma .image.is-5by4 .has-ratio,.enable-bulma .image.is-5by4 img,.enable-bulma .image.is-9by16 .has-ratio,.enable-bulma .image.is-9by16 img,.enable-bulma .image.is-16by9 .has-ratio,.enable-bulma .image.is-16by9 img,.enable-bulma .image.is-square .has-ratio,.enable-bulma .image.is-square img{height:100%;width:100%}.enable-bulma .image.is-1by1,.enable-bulma .image.is-square{padding-top:100%}.enable-bulma .image.is-5by4{padding-top:80%}.enable-bulma .image.is-4by3{padding-top:75%}.enable-bulma .image.is-3by2{padding-top:66.6666%}.enable-bulma .image.is-5by3{padding-top:60%}.enable-bulma .image.is-16by9{padding-top:56.25%}.enable-bulma .image.is-2by1{padding-top:50%}.enable-bulma .image.is-3by1{padding-top:33.3333%}.enable-bulma .image.is-4by5{padding-top:125%}.enable-bulma .image.is-3by4{padding-top:133.3333%}.enable-bulma .image.is-2by3{padding-top:150%}.enable-bulma .image.is-3by5{padding-top:166.6666%}.enable-bulma .image.is-9by16{padding-top:177.7777%}.enable-bulma .image.is-1by2{padding-top:200%}.enable-bulma .image.is-1by3{padding-top:300%}.enable-bulma .image.is-16x16{height:16px;width:16px}.enable-bulma .image.is-24x24{height:24px;width:24px}.enable-bulma .image.is-32x32{height:32px;width:32px}.enable-bulma .image.is-48x48{height:48px;width:48px}.enable-bulma .image.is-64x64{height:64px;width:64px}.enable-bulma .image.is-96x96{height:96px;width:96px}.enable-bulma .image.is-128x128{height:128px;width:128px}.enable-bulma .notification{background-color:#f5f5f5;border-radius:4px;padding:1.25rem 2.5rem 1.25rem 1.5rem;position:relative}.enable-bulma .notification a:not(.button):not(.dropdown-item){color:currentColor;text-decoration:underline}.enable-bulma .notification strong{color:currentColor}.enable-bulma .notification code,.enable-bulma .notification pre{background:#fff}.enable-bulma .notification pre code{background:transparent}.enable-bulma .notification>.delete{position:absolute;right:.5rem;top:.5rem}.enable-bulma .notification .content,.enable-bulma .notification .subtitle,.enable-bulma .notification .title{color:currentColor}.enable-bulma .notification.is-white{background-color:#fff;color:#0a0a0a}.enable-bulma .notification.is-black{background-color:#0a0a0a;color:#fff}.enable-bulma .notification.is-light{background-color:#f5f5f5;color:#363636}.enable-bulma .notification.is-dark{background-color:#363636;color:#f5f5f5}.enable-bulma .notification.is-link,.enable-bulma .notification.is-primary{background-color:#3273dc;color:#fff}.enable-bulma .notification.is-info{background-color:#209cee;color:#fff}.enable-bulma .notification.is-success{background-color:#23d160;color:#fff}.enable-bulma .notification.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .notification.is-danger{background-color:#ff3860;color:#fff}.enable-bulma .progress{-moz-appearance:none;-webkit-appearance:none;border:none;border-radius:290486px;display:block;height:1rem;overflow:hidden;padding:0;width:100%}.enable-bulma .progress::-webkit-progress-bar{background-color:#dbdbdb}.enable-bulma .progress::-webkit-progress-value{background-color:#4a4a4a}.enable-bulma .progress::-moz-progress-bar{background-color:#4a4a4a}.enable-bulma .progress::-ms-fill{background-color:#4a4a4a;border:none}.enable-bulma .progress.is-white::-webkit-progress-value{background-color:#fff}.enable-bulma .progress.is-white::-moz-progress-bar{background-color:#fff}.enable-bulma .progress.is-white::-ms-fill{background-color:#fff}.enable-bulma .progress.is-white:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#fff),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#fff 30%,#dbdbdb 0)}.enable-bulma .progress.is-black::-webkit-progress-value{background-color:#0a0a0a}.enable-bulma .progress.is-black::-moz-progress-bar{background-color:#0a0a0a}.enable-bulma .progress.is-black::-ms-fill{background-color:#0a0a0a}.enable-bulma .progress.is-black:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#0a0a0a),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#0a0a0a 30%,#dbdbdb 0)}.enable-bulma .progress.is-light::-webkit-progress-value{background-color:#f5f5f5}.enable-bulma .progress.is-light::-moz-progress-bar{background-color:#f5f5f5}.enable-bulma .progress.is-light::-ms-fill{background-color:#f5f5f5}.enable-bulma .progress.is-light:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#f5f5f5),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#f5f5f5 30%,#dbdbdb 0)}.enable-bulma .progress.is-dark::-webkit-progress-value{background-color:#363636}.enable-bulma .progress.is-dark::-moz-progress-bar{background-color:#363636}.enable-bulma .progress.is-dark::-ms-fill{background-color:#363636}.enable-bulma .progress.is-dark:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#363636),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#363636 30%,#dbdbdb 0)}.enable-bulma .progress.is-primary::-webkit-progress-value{background-color:#3273dc}.enable-bulma .progress.is-primary::-moz-progress-bar{background-color:#3273dc}.enable-bulma .progress.is-primary::-ms-fill{background-color:#3273dc}.enable-bulma .progress.is-primary:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#3273dc),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#3273dc 30%,#dbdbdb 0)}.enable-bulma .progress.is-link::-webkit-progress-value{background-color:#3273dc}.enable-bulma .progress.is-link::-moz-progress-bar{background-color:#3273dc}.enable-bulma .progress.is-link::-ms-fill{background-color:#3273dc}.enable-bulma .progress.is-link:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#3273dc),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#3273dc 30%,#dbdbdb 0)}.enable-bulma .progress.is-info::-webkit-progress-value{background-color:#209cee}.enable-bulma .progress.is-info::-moz-progress-bar{background-color:#209cee}.enable-bulma .progress.is-info::-ms-fill{background-color:#209cee}.enable-bulma .progress.is-info:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#209cee),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#209cee 30%,#dbdbdb 0)}.enable-bulma .progress.is-success::-webkit-progress-value{background-color:#23d160}.enable-bulma .progress.is-success::-moz-progress-bar{background-color:#23d160}.enable-bulma .progress.is-success::-ms-fill{background-color:#23d160}.enable-bulma .progress.is-success:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#23d160),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#23d160 30%,#dbdbdb 0)}.enable-bulma .progress.is-warning::-webkit-progress-value{background-color:#ffdd57}.enable-bulma .progress.is-warning::-moz-progress-bar{background-color:#ffdd57}.enable-bulma .progress.is-warning::-ms-fill{background-color:#ffdd57}.enable-bulma .progress.is-warning:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#ffdd57),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#ffdd57 30%,#dbdbdb 0)}.enable-bulma .progress.is-danger::-webkit-progress-value{background-color:#ff3860}.enable-bulma .progress.is-danger::-moz-progress-bar{background-color:#ff3860}.enable-bulma .progress.is-danger::-ms-fill{background-color:#ff3860}.enable-bulma .progress.is-danger:indeterminate{background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#ff3860),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#ff3860 30%,#dbdbdb 0)}.enable-bulma .progress:indeterminate{-webkit-animation-duration:1.5s;animation-duration:1.5s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:moveIndeterminate;animation-name:moveIndeterminate;-webkit-animation-timing-function:linear;animation-timing-function:linear;background-color:#dbdbdb;background-image:-webkit-gradient(linear,left top,right top,color-stop(30%,#4a4a4a),color-stop(30%,#dbdbdb));background-image:linear-gradient(90deg,#4a4a4a 30%,#dbdbdb 0);background-position:0 0;background-repeat:no-repeat;background-size:150% 150%}.enable-bulma .progress:indeterminate::-webkit-progress-bar{background-color:transparent}.enable-bulma .progress:indeterminate::-moz-progress-bar{background-color:transparent}.enable-bulma .progress.is-small{height:.75rem}.enable-bulma .progress.is-medium{height:1.25rem}.enable-bulma .progress.is-large{height:1.5rem}@-webkit-keyframes moveIndeterminate{0%{background-position:200% 0}to{background-position:-200% 0}}@keyframes moveIndeterminate{0%{background-position:200% 0}to{background-position:-200% 0}}.enable-bulma .table{background-color:#fff;color:#363636}.enable-bulma .table td,.enable-bulma .table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.enable-bulma .table td.is-white,.enable-bulma .table th.is-white{background-color:#fff;border-color:#fff;color:#0a0a0a}.enable-bulma .table td.is-black,.enable-bulma .table th.is-black{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.enable-bulma .table td.is-light,.enable-bulma .table th.is-light{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.enable-bulma .table td.is-dark,.enable-bulma .table th.is-dark{background-color:#363636;border-color:#363636;color:#f5f5f5}.enable-bulma .table td.is-link,.enable-bulma .table td.is-primary,.enable-bulma .table th.is-link,.enable-bulma .table th.is-primary{background-color:#3273dc;border-color:#3273dc;color:#fff}.enable-bulma .table td.is-info,.enable-bulma .table th.is-info{background-color:#209cee;border-color:#209cee;color:#fff}.enable-bulma .table td.is-success,.enable-bulma .table th.is-success{background-color:#23d160;border-color:#23d160;color:#fff}.enable-bulma .table td.is-warning,.enable-bulma .table th.is-warning{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .table td.is-danger,.enable-bulma .table th.is-danger{background-color:#ff3860;border-color:#ff3860;color:#fff}.enable-bulma .table td.is-narrow,.enable-bulma .table th.is-narrow{white-space:nowrap;width:1%}.enable-bulma .table td.is-selected,.enable-bulma .table th.is-selected{background-color:#3273dc;color:#fff}.enable-bulma .table td.is-selected a,.enable-bulma .table td.is-selected strong,.enable-bulma .table th.is-selected a,.enable-bulma .table th.is-selected strong{color:currentColor}.enable-bulma .table th{color:#363636}.enable-bulma .table th:not([align]){text-align:left}.enable-bulma .table tr.is-selected{background-color:#3273dc;color:#fff}.enable-bulma .table tr.is-selected a,.enable-bulma .table tr.is-selected strong{color:currentColor}.enable-bulma .table tr.is-selected td,.enable-bulma .table tr.is-selected th{border-color:#fff;color:currentColor}.enable-bulma .table thead{background-color:transparent}.enable-bulma .table thead td,.enable-bulma .table thead th{border-width:0 0 2px;color:#363636}.enable-bulma .table tfoot{background-color:transparent}.enable-bulma .table tfoot td,.enable-bulma .table tfoot th{border-width:2px 0 0;color:#363636}.enable-bulma .table tbody{background-color:transparent}.enable-bulma .table tbody tr:last-child td,.enable-bulma .table tbody tr:last-child th{border-bottom-width:0}.enable-bulma .table.is-bordered td,.enable-bulma .table.is-bordered th{border-width:1px}.enable-bulma .table.is-bordered tr:last-child td,.enable-bulma .table.is-bordered tr:last-child th{border-bottom-width:1px}.enable-bulma .table.is-fullwidth{width:100%}.enable-bulma .table.is-hoverable tbody tr:not(.is-selected):hover{background-color:#fafafa}.enable-bulma .table.is-hoverable.is-striped tbody tr:not(.is-selected):hover{background-color:#fafafa}.enable-bulma .table.is-hoverable.is-striped tbody tr:not(.is-selected):hover:nth-child(2n){background-color:#f5f5f5}.enable-bulma .table.is-narrow td,.enable-bulma .table.is-narrow th{padding:.25em .5em}.enable-bulma .table.is-striped tbody tr:not(.is-selected):nth-child(2n){background-color:#fafafa}.enable-bulma .table-container{-webkit-overflow-scrolling:touch;overflow:auto;overflow-y:hidden;max-width:100%}.enable-bulma .tags{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.enable-bulma .tags .tag{margin-bottom:.5rem}.enable-bulma .tags .tag:not(:last-child){margin-right:.5rem}.enable-bulma .tags:last-child{margin-bottom:-.5rem}.enable-bulma .tags:not(:last-child){margin-bottom:1rem}.enable-bulma .tags.are-medium .tag:not(.is-normal):not(.is-large){font-size:1rem}.enable-bulma .tags.are-large .tag:not(.is-normal):not(.is-medium){font-size:1.25rem}.enable-bulma .tags.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .tags.is-centered .tag{margin-right:.25rem;margin-left:.25rem}.enable-bulma .tags.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .tags.is-right .tag:not(:first-child){margin-left:.5rem}.enable-bulma .tags.is-right .tag:not(:last-child){margin-right:0}.enable-bulma .tags.has-addons .tag{margin-right:0}.enable-bulma .tags.has-addons .tag:not(:first-child){margin-left:0;border-bottom-left-radius:0;border-top-left-radius:0}.enable-bulma .tags.has-addons .tag:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.enable-bulma .tag:not(body){-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f5f5f5;border-radius:4px;color:#4a4a4a;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:.75rem;height:2em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1.5;padding-left:.75em;padding-right:.75em;white-space:nowrap}.enable-bulma .tag:not(body) .delete{margin-left:.25rem;margin-right:-.375rem}.enable-bulma .tag:not(body).is-white{background-color:#fff;color:#0a0a0a}.enable-bulma .tag:not(body).is-black{background-color:#0a0a0a;color:#fff}.enable-bulma .tag:not(body).is-light{background-color:#f5f5f5;color:#363636}.enable-bulma .tag:not(body).is-dark{background-color:#363636;color:#f5f5f5}.enable-bulma .tag:not(body).is-primary{background-color:#3273dc;color:#fff}.enable-bulma .tag:not(body).is-link{background-color:#3273dc;color:#fff}.enable-bulma .tag:not(body).is-info{background-color:#209cee;color:#fff}.enable-bulma .tag:not(body).is-success{background-color:#23d160;color:#fff}.enable-bulma .tag:not(body).is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .tag:not(body).is-danger{background-color:#ff3860;color:#fff}.enable-bulma .tag:not(body).is-normal{font-size:.75rem}.enable-bulma .tag:not(body).is-medium{font-size:1rem}.enable-bulma .tag:not(body).is-large{font-size:1.25rem}.enable-bulma .tag:not(body) .icon:first-child:not(:last-child){margin-left:-.375em;margin-right:.1875em}.enable-bulma .tag:not(body) .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:-.375em}.enable-bulma .tag:not(body) .icon:first-child:last-child{margin-left:-.375em;margin-right:-.375em}.enable-bulma .tag:not(body).is-delete{margin-left:1px;padding:0;position:relative;width:2em}.enable-bulma .tag:not(body).is-delete:after,.enable-bulma .tag:not(body).is-delete:before{background-color:currentColor;content:\"\";display:block;left:50%;position:absolute;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);-webkit-transform-origin:center center;transform-origin:center center}.enable-bulma .tag:not(body).is-delete:before{height:1px;width:50%}.enable-bulma .tag:not(body).is-delete:after{height:50%;width:1px}.enable-bulma .tag:not(body).is-delete:focus,.enable-bulma .tag:not(body).is-delete:hover{background-color:#e8e8e8}.enable-bulma .tag:not(body).is-delete:active{background-color:#dbdbdb}.enable-bulma .tag:not(body).is-rounded{border-radius:290486px}.enable-bulma a.tag:hover{text-decoration:underline}.enable-bulma .subtitle,.enable-bulma .title{word-break:break-word}.enable-bulma .subtitle em,.enable-bulma .subtitle span,.enable-bulma .title em,.enable-bulma .title span{font-weight:inherit}.enable-bulma .subtitle sub,.enable-bulma .subtitle sup,.enable-bulma .title sub,.enable-bulma .title sup{font-size:.75em}.enable-bulma .subtitle .tag,.enable-bulma .title .tag{vertical-align:middle}.enable-bulma .title{color:#363636;font-size:2rem;font-weight:600;line-height:1.125}.enable-bulma .title strong{color:inherit;font-weight:inherit}.enable-bulma .title+.highlight{margin-top:-.75rem}.enable-bulma .title:not(.is-spaced)+.subtitle{margin-top:-1.25rem}.enable-bulma .title.is-1{font-size:3rem}.enable-bulma .title.is-2{font-size:2.5rem}.enable-bulma .title.is-3{font-size:2rem}.enable-bulma .title.is-4{font-size:1.5rem}.enable-bulma .title.is-5{font-size:1.25rem}.enable-bulma .title.is-6{font-size:1rem}.enable-bulma .title.is-7{font-size:.75rem}.enable-bulma .subtitle{color:#4a4a4a;font-size:1.25rem;font-weight:400;line-height:1.25}.enable-bulma .subtitle strong{color:#363636;font-weight:600}.enable-bulma .subtitle:not(.is-spaced)+.title{margin-top:-1.25rem}.enable-bulma .subtitle.is-1{font-size:3rem}.enable-bulma .subtitle.is-2{font-size:2.5rem}.enable-bulma .subtitle.is-3{font-size:2rem}.enable-bulma .subtitle.is-4{font-size:1.5rem}.enable-bulma .subtitle.is-5{font-size:1.25rem}.enable-bulma .subtitle.is-6{font-size:1rem}.enable-bulma .subtitle.is-7{font-size:.75rem}.enable-bulma .heading{display:block;font-size:11px;letter-spacing:1px;margin-bottom:5px;text-transform:uppercase}.enable-bulma .highlight{font-weight:400;max-width:100%;overflow:hidden;padding:0}.enable-bulma .highlight pre{overflow:auto;max-width:100%}.enable-bulma .number{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f5f5f5;border-radius:290486px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.25rem;height:2em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:1.5rem;min-width:2.5em;padding:.25rem .5rem;text-align:center;vertical-align:top}.enable-bulma .input,.enable-bulma .select select,.enable-bulma .taginput .taginput-container.is-focusable,.enable-bulma .textarea{background-color:#fff;border-color:#dbdbdb;border-radius:4px;color:#363636}.enable-bulma .input::-moz-placeholder,.enable-bulma .select select::-moz-placeholder,.enable-bulma .taginput .taginput-container.is-focusable::-moz-placeholder,.enable-bulma .textarea::-moz-placeholder{color:rgba(54,54,54,.3)}.enable-bulma .input::-webkit-input-placeholder,.enable-bulma .select select::-webkit-input-placeholder,.enable-bulma .taginput .taginput-container.is-focusable::-webkit-input-placeholder,.enable-bulma .textarea::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.enable-bulma .input:-moz-placeholder,.enable-bulma .select select:-moz-placeholder,.enable-bulma .taginput .taginput-container.is-focusable:-moz-placeholder,.enable-bulma .textarea:-moz-placeholder{color:rgba(54,54,54,.3)}.enable-bulma .input:-ms-input-placeholder,.enable-bulma .select select:-ms-input-placeholder,.enable-bulma .taginput .taginput-container.is-focusable:-ms-input-placeholder,.enable-bulma .textarea:-ms-input-placeholder{color:rgba(54,54,54,.3)}.enable-bulma .input:hover,.enable-bulma .is-hovered.input,.enable-bulma .is-hovered.textarea,.enable-bulma .select select.is-hovered,.enable-bulma .select select:hover,.enable-bulma .taginput .is-hovered.taginput-container.is-focusable,.enable-bulma .taginput .taginput-container.is-focusable:hover,.enable-bulma .textarea:hover{border-color:#b5b5b5}.enable-bulma .input:active,.enable-bulma .input:focus,.enable-bulma .is-active.input,.enable-bulma .is-active.textarea,.enable-bulma .is-focused.input,.enable-bulma .is-focused.textarea,.enable-bulma .select select.is-active,.enable-bulma .select select.is-focused,.enable-bulma .select select:active,.enable-bulma .select select:focus,.enable-bulma .taginput .is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-focused.taginput-container.is-focusable,.enable-bulma .taginput .taginput-container.is-focusable:active,.enable-bulma .taginput .taginput-container.is-focusable:focus,.enable-bulma .textarea:active,.enable-bulma .textarea:focus{border-color:#3273dc;-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .select select[disabled],.enable-bulma .taginput [disabled].taginput-container.is-focusable,.enable-bulma [disabled].input,.enable-bulma [disabled].textarea,fieldset[disabled] .enable-bulma .input,fieldset[disabled] .enable-bulma .select select,fieldset[disabled] .enable-bulma .taginput .taginput-container.is-focusable,fieldset[disabled] .enable-bulma .textarea{background-color:#f5f5f5;border-color:#f5f5f5;-webkit-box-shadow:none;box-shadow:none;color:#7a7a7a}.enable-bulma .select select[disabled]::-moz-placeholder,.enable-bulma .taginput [disabled].taginput-container.is-focusable::-moz-placeholder,.enable-bulma [disabled].input::-moz-placeholder,.enable-bulma [disabled].textarea::-moz-placeholder,fieldset[disabled] .enable-bulma .input::-moz-placeholder,fieldset[disabled] .enable-bulma .select select::-moz-placeholder,fieldset[disabled] .enable-bulma .taginput .taginput-container.is-focusable::-moz-placeholder,fieldset[disabled] .enable-bulma .textarea::-moz-placeholder{color:hsla(0,0%,47.8%,.3)}.enable-bulma .select select[disabled]::-webkit-input-placeholder,.enable-bulma .taginput [disabled].taginput-container.is-focusable::-webkit-input-placeholder,.enable-bulma [disabled].input::-webkit-input-placeholder,.enable-bulma [disabled].textarea::-webkit-input-placeholder,fieldset[disabled] .enable-bulma .input::-webkit-input-placeholder,fieldset[disabled] .enable-bulma .select select::-webkit-input-placeholder,fieldset[disabled] .enable-bulma .taginput .taginput-container.is-focusable::-webkit-input-placeholder,fieldset[disabled] .enable-bulma .textarea::-webkit-input-placeholder{color:hsla(0,0%,47.8%,.3)}.enable-bulma .select select[disabled]:-moz-placeholder,.enable-bulma .taginput [disabled].taginput-container.is-focusable:-moz-placeholder,.enable-bulma [disabled].input:-moz-placeholder,.enable-bulma [disabled].textarea:-moz-placeholder,fieldset[disabled] .enable-bulma .input:-moz-placeholder,fieldset[disabled] .enable-bulma .select select:-moz-placeholder,fieldset[disabled] .enable-bulma .taginput .taginput-container.is-focusable:-moz-placeholder,fieldset[disabled] .enable-bulma .textarea:-moz-placeholder{color:hsla(0,0%,47.8%,.3)}.enable-bulma .select select[disabled]:-ms-input-placeholder,.enable-bulma .taginput [disabled].taginput-container.is-focusable:-ms-input-placeholder,.enable-bulma [disabled].input:-ms-input-placeholder,.enable-bulma [disabled].textarea:-ms-input-placeholder,fieldset[disabled] .enable-bulma .input:-ms-input-placeholder,fieldset[disabled] .enable-bulma .select select:-ms-input-placeholder,fieldset[disabled] .enable-bulma .taginput .taginput-container.is-focusable:-ms-input-placeholder,fieldset[disabled] .enable-bulma .textarea:-ms-input-placeholder{color:hsla(0,0%,47.8%,.3)}.enable-bulma .input,.enable-bulma .taginput .taginput-container.is-focusable,.enable-bulma .textarea{-webkit-box-shadow:inset 0 1px 2px rgba(10,10,10,.1);box-shadow:inset 0 1px 2px rgba(10,10,10,.1);max-width:100%;width:100%}.enable-bulma .taginput [readonly].taginput-container.is-focusable,.enable-bulma [readonly].input,.enable-bulma [readonly].textarea{-webkit-box-shadow:none;box-shadow:none}.enable-bulma .is-white.input,.enable-bulma .is-white.textarea,.enable-bulma .taginput .is-white.taginput-container.is-focusable{border-color:#fff}.enable-bulma .is-white.input:active,.enable-bulma .is-white.input:focus,.enable-bulma .is-white.is-active.input,.enable-bulma .is-white.is-active.textarea,.enable-bulma .is-white.is-focused.input,.enable-bulma .is-white.is-focused.textarea,.enable-bulma .is-white.textarea:active,.enable-bulma .is-white.textarea:focus,.enable-bulma .taginput .is-white.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-white.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-white.taginput-container.is-focusable:active,.enable-bulma .taginput .is-white.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,100%,.25);box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.enable-bulma .is-black.input,.enable-bulma .is-black.textarea,.enable-bulma .taginput .is-black.taginput-container.is-focusable{border-color:#0a0a0a}.enable-bulma .is-black.input:active,.enable-bulma .is-black.input:focus,.enable-bulma .is-black.is-active.input,.enable-bulma .is-black.is-active.textarea,.enable-bulma .is-black.is-focused.input,.enable-bulma .is-black.is-focused.textarea,.enable-bulma .is-black.textarea:active,.enable-bulma .is-black.textarea:focus,.enable-bulma .taginput .is-black.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-black.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-black.taginput-container.is-focusable:active,.enable-bulma .taginput .is-black.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(10,10,10,.25);box-shadow:0 0 0 .125em rgba(10,10,10,.25)}.enable-bulma .is-light.input,.enable-bulma .is-light.textarea,.enable-bulma .taginput .is-light.taginput-container.is-focusable{border-color:#f5f5f5}.enable-bulma .is-light.input:active,.enable-bulma .is-light.input:focus,.enable-bulma .is-light.is-active.input,.enable-bulma .is-light.is-active.textarea,.enable-bulma .is-light.is-focused.input,.enable-bulma .is-light.is-focused.textarea,.enable-bulma .is-light.textarea:active,.enable-bulma .is-light.textarea:focus,.enable-bulma .taginput .is-light.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-light.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-light.taginput-container.is-focusable:active,.enable-bulma .taginput .is-light.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,96.1%,.25);box-shadow:0 0 0 .125em hsla(0,0%,96.1%,.25)}.enable-bulma .is-dark.input,.enable-bulma .is-dark.textarea,.enable-bulma .taginput .is-dark.taginput-container.is-focusable{border-color:#363636}.enable-bulma .is-dark.input:active,.enable-bulma .is-dark.input:focus,.enable-bulma .is-dark.is-active.input,.enable-bulma .is-dark.is-active.textarea,.enable-bulma .is-dark.is-focused.input,.enable-bulma .is-dark.is-focused.textarea,.enable-bulma .is-dark.textarea:active,.enable-bulma .is-dark.textarea:focus,.enable-bulma .taginput .is-dark.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-dark.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-dark.taginput-container.is-focusable:active,.enable-bulma .taginput .is-dark.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(54,54,54,.25);box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.enable-bulma .is-primary.input,.enable-bulma .is-primary.textarea,.enable-bulma .taginput .is-primary.taginput-container.is-focusable{border-color:#3273dc}.enable-bulma .is-primary.input:active,.enable-bulma .is-primary.input:focus,.enable-bulma .is-primary.is-active.input,.enable-bulma .is-primary.is-active.textarea,.enable-bulma .is-primary.is-focused.input,.enable-bulma .is-primary.is-focused.textarea,.enable-bulma .is-primary.textarea:active,.enable-bulma .is-primary.textarea:focus,.enable-bulma .taginput .is-primary.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-primary.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-primary.taginput-container.is-focusable:active,.enable-bulma .taginput .is-primary.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .is-link.input,.enable-bulma .is-link.textarea,.enable-bulma .taginput .is-link.taginput-container.is-focusable{border-color:#3273dc}.enable-bulma .is-link.input:active,.enable-bulma .is-link.input:focus,.enable-bulma .is-link.is-active.input,.enable-bulma .is-link.is-active.textarea,.enable-bulma .is-link.is-focused.input,.enable-bulma .is-link.is-focused.textarea,.enable-bulma .is-link.textarea:active,.enable-bulma .is-link.textarea:focus,.enable-bulma .taginput .is-link.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-link.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-link.taginput-container.is-focusable:active,.enable-bulma .taginput .is-link.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .is-info.input,.enable-bulma .is-info.textarea,.enable-bulma .taginput .is-info.taginput-container.is-focusable{border-color:#209cee}.enable-bulma .is-info.input:active,.enable-bulma .is-info.input:focus,.enable-bulma .is-info.is-active.input,.enable-bulma .is-info.is-active.textarea,.enable-bulma .is-info.is-focused.input,.enable-bulma .is-info.is-focused.textarea,.enable-bulma .is-info.textarea:active,.enable-bulma .is-info.textarea:focus,.enable-bulma .taginput .is-info.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-info.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-info.taginput-container.is-focusable:active,.enable-bulma .taginput .is-info.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(32,156,238,.25);box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.enable-bulma .is-success.input,.enable-bulma .is-success.textarea,.enable-bulma .taginput .is-success.taginput-container.is-focusable{border-color:#23d160}.enable-bulma .is-success.input:active,.enable-bulma .is-success.input:focus,.enable-bulma .is-success.is-active.input,.enable-bulma .is-success.is-active.textarea,.enable-bulma .is-success.is-focused.input,.enable-bulma .is-success.is-focused.textarea,.enable-bulma .is-success.textarea:active,.enable-bulma .is-success.textarea:focus,.enable-bulma .taginput .is-success.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-success.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-success.taginput-container.is-focusable:active,.enable-bulma .taginput .is-success.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(35,209,96,.25);box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.enable-bulma .is-warning.input,.enable-bulma .is-warning.textarea,.enable-bulma .taginput .is-warning.taginput-container.is-focusable{border-color:#ffdd57}.enable-bulma .is-warning.input:active,.enable-bulma .is-warning.input:focus,.enable-bulma .is-warning.is-active.input,.enable-bulma .is-warning.is-active.textarea,.enable-bulma .is-warning.is-focused.input,.enable-bulma .is-warning.is-focused.textarea,.enable-bulma .is-warning.textarea:active,.enable-bulma .is-warning.textarea:focus,.enable-bulma .taginput .is-warning.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-warning.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-warning.taginput-container.is-focusable:active,.enable-bulma .taginput .is-warning.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,221,87,.25);box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.enable-bulma .is-danger.input,.enable-bulma .is-danger.textarea,.enable-bulma .taginput .is-danger.taginput-container.is-focusable{border-color:#ff3860}.enable-bulma .is-danger.input:active,.enable-bulma .is-danger.input:focus,.enable-bulma .is-danger.is-active.input,.enable-bulma .is-danger.is-active.textarea,.enable-bulma .is-danger.is-focused.input,.enable-bulma .is-danger.is-focused.textarea,.enable-bulma .is-danger.textarea:active,.enable-bulma .is-danger.textarea:focus,.enable-bulma .taginput .is-danger.is-active.taginput-container.is-focusable,.enable-bulma .taginput .is-danger.is-focused.taginput-container.is-focusable,.enable-bulma .taginput .is-danger.taginput-container.is-focusable:active,.enable-bulma .taginput .is-danger.taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,56,96,.25);box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.enable-bulma .is-small.input,.enable-bulma .is-small.textarea,.enable-bulma .taginput .is-small.taginput-container.is-focusable{border-radius:2px;font-size:.75rem}.enable-bulma .is-medium.input,.enable-bulma .is-medium.textarea,.enable-bulma .taginput .is-medium.taginput-container.is-focusable{font-size:1.25rem}.enable-bulma .is-large.input,.enable-bulma .is-large.textarea,.enable-bulma .taginput .is-large.taginput-container.is-focusable{font-size:1.5rem}.enable-bulma .is-fullwidth.input,.enable-bulma .is-fullwidth.textarea,.enable-bulma .taginput .is-fullwidth.taginput-container.is-focusable{display:block;width:100%}.enable-bulma .is-inline.input,.enable-bulma .is-inline.textarea,.enable-bulma .taginput .is-inline.taginput-container.is-focusable{display:inline;width:auto}.enable-bulma .input.is-rounded,.enable-bulma .taginput .is-rounded.taginput-container.is-focusable{border-radius:290486px;padding-left:1em;padding-right:1em}.enable-bulma .input.is-static,.enable-bulma .taginput .is-static.taginput-container.is-focusable{background-color:transparent;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;padding-left:0;padding-right:0}.enable-bulma .textarea{display:block;max-width:100%;min-width:100%;padding:.625em;resize:vertical}.enable-bulma .textarea:not([rows]){max-height:600px;min-height:120px}.enable-bulma .textarea[rows]{height:auto}.enable-bulma .textarea.has-fixed-size{resize:none}.enable-bulma .checkbox,.enable-bulma .radio{cursor:pointer;display:inline-block;line-height:1.25;position:relative}.enable-bulma .checkbox input,.enable-bulma .radio input{cursor:pointer}.enable-bulma .checkbox:hover,.enable-bulma .radio:hover{color:#363636}.enable-bulma [disabled].checkbox,.enable-bulma [disabled].radio,fieldset[disabled] .enable-bulma .checkbox,fieldset[disabled] .enable-bulma .radio{color:#7a7a7a;cursor:not-allowed}.enable-bulma .radio+.radio{margin-left:.5em}.enable-bulma .select{display:inline-block;max-width:100%;position:relative;vertical-align:top}.enable-bulma .select:not(.is-multiple){height:2.25em}.enable-bulma .select:not(.is-multiple):not(.is-loading):after{border-color:#3273dc;right:1.125em;z-index:4}.enable-bulma .select.is-rounded select{border-radius:290486px;padding-left:1em}.enable-bulma .select select{cursor:pointer;display:block;font-size:1em;max-width:100%;outline:none}.enable-bulma .select select::-ms-expand{display:none}.enable-bulma .select select[disabled]:hover,fieldset[disabled] .enable-bulma .select select:hover{border-color:#f5f5f5}.enable-bulma .select select:not([multiple]){padding-right:2.5em}.enable-bulma .select select[multiple]{height:auto;padding:0}.enable-bulma .select select[multiple] option{padding:.5em 1em}.enable-bulma .select:not(.is-multiple):not(.is-loading):hover:after{border-color:#363636}.enable-bulma .select.is-white:not(:hover):after{border-color:#fff}.enable-bulma .select.is-white select{border-color:#fff}.enable-bulma .select.is-white select.is-hovered,.enable-bulma .select.is-white select:hover{border-color:#f2f2f2}.enable-bulma .select.is-white select.is-active,.enable-bulma .select.is-white select.is-focused,.enable-bulma .select.is-white select:active,.enable-bulma .select.is-white select:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,100%,.25);box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.enable-bulma .select.is-black:not(:hover):after{border-color:#0a0a0a}.enable-bulma .select.is-black select{border-color:#0a0a0a}.enable-bulma .select.is-black select.is-hovered,.enable-bulma .select.is-black select:hover{border-color:#000}.enable-bulma .select.is-black select.is-active,.enable-bulma .select.is-black select.is-focused,.enable-bulma .select.is-black select:active,.enable-bulma .select.is-black select:focus{-webkit-box-shadow:0 0 0 .125em rgba(10,10,10,.25);box-shadow:0 0 0 .125em rgba(10,10,10,.25)}.enable-bulma .select.is-light:not(:hover):after{border-color:#f5f5f5}.enable-bulma .select.is-light select{border-color:#f5f5f5}.enable-bulma .select.is-light select.is-hovered,.enable-bulma .select.is-light select:hover{border-color:#e8e8e8}.enable-bulma .select.is-light select.is-active,.enable-bulma .select.is-light select.is-focused,.enable-bulma .select.is-light select:active,.enable-bulma .select.is-light select:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,96.1%,.25);box-shadow:0 0 0 .125em hsla(0,0%,96.1%,.25)}.enable-bulma .select.is-dark:not(:hover):after{border-color:#363636}.enable-bulma .select.is-dark select{border-color:#363636}.enable-bulma .select.is-dark select.is-hovered,.enable-bulma .select.is-dark select:hover{border-color:#292929}.enable-bulma .select.is-dark select.is-active,.enable-bulma .select.is-dark select.is-focused,.enable-bulma .select.is-dark select:active,.enable-bulma .select.is-dark select:focus{-webkit-box-shadow:0 0 0 .125em rgba(54,54,54,.25);box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.enable-bulma .select.is-primary:not(:hover):after{border-color:#3273dc}.enable-bulma .select.is-primary select{border-color:#3273dc}.enable-bulma .select.is-primary select.is-hovered,.enable-bulma .select.is-primary select:hover{border-color:#2466d1}.enable-bulma .select.is-primary select.is-active,.enable-bulma .select.is-primary select.is-focused,.enable-bulma .select.is-primary select:active,.enable-bulma .select.is-primary select:focus{-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .select.is-link:not(:hover):after{border-color:#3273dc}.enable-bulma .select.is-link select{border-color:#3273dc}.enable-bulma .select.is-link select.is-hovered,.enable-bulma .select.is-link select:hover{border-color:#2366d1}.enable-bulma .select.is-link select.is-active,.enable-bulma .select.is-link select.is-focused,.enable-bulma .select.is-link select:active,.enable-bulma .select.is-link select:focus{-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .select.is-info:not(:hover):after{border-color:#209cee}.enable-bulma .select.is-info select{border-color:#209cee}.enable-bulma .select.is-info select.is-hovered,.enable-bulma .select.is-info select:hover{border-color:#118fe4}.enable-bulma .select.is-info select.is-active,.enable-bulma .select.is-info select.is-focused,.enable-bulma .select.is-info select:active,.enable-bulma .select.is-info select:focus{-webkit-box-shadow:0 0 0 .125em rgba(32,156,238,.25);box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.enable-bulma .select.is-success:not(:hover):after{border-color:#23d160}.enable-bulma .select.is-success select{border-color:#23d160}.enable-bulma .select.is-success select.is-hovered,.enable-bulma .select.is-success select:hover{border-color:#20bc56}.enable-bulma .select.is-success select.is-active,.enable-bulma .select.is-success select.is-focused,.enable-bulma .select.is-success select:active,.enable-bulma .select.is-success select:focus{-webkit-box-shadow:0 0 0 .125em rgba(35,209,96,.25);box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.enable-bulma .select.is-warning:not(:hover):after{border-color:#ffdd57}.enable-bulma .select.is-warning select{border-color:#ffdd57}.enable-bulma .select.is-warning select.is-hovered,.enable-bulma .select.is-warning select:hover{border-color:#ffd83d}.enable-bulma .select.is-warning select.is-active,.enable-bulma .select.is-warning select.is-focused,.enable-bulma .select.is-warning select:active,.enable-bulma .select.is-warning select:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,221,87,.25);box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.enable-bulma .select.is-danger:not(:hover):after{border-color:#ff3860}.enable-bulma .select.is-danger select{border-color:#ff3860}.enable-bulma .select.is-danger select.is-hovered,.enable-bulma .select.is-danger select:hover{border-color:#ff1f4b}.enable-bulma .select.is-danger select.is-active,.enable-bulma .select.is-danger select.is-focused,.enable-bulma .select.is-danger select:active,.enable-bulma .select.is-danger select:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,56,96,.25);box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.enable-bulma .select.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .select.is-medium{font-size:1.25rem}.enable-bulma .select.is-large{font-size:1.5rem}.enable-bulma .select.is-disabled:after{border-color:#7a7a7a}.enable-bulma .select.is-fullwidth,.enable-bulma .select.is-fullwidth select{width:100%}.enable-bulma .select.is-loading:after{margin-top:0;position:absolute;right:.625em;top:.625em;-webkit-transform:none;transform:none}.enable-bulma .select.is-loading.is-small:after{font-size:.75rem}.enable-bulma .select.is-loading.is-medium:after{font-size:1.25rem}.enable-bulma .select.is-loading.is-large:after{font-size:1.5rem}.enable-bulma .file{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;position:relative}.enable-bulma .file.is-white .file-cta{background-color:#fff;border-color:transparent;color:#0a0a0a}.enable-bulma .file.is-white.is-hovered .file-cta,.enable-bulma .file.is-white:hover .file-cta{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.enable-bulma .file.is-white.is-focused .file-cta,.enable-bulma .file.is-white:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.25);box-shadow:0 0 .5em hsla(0,0%,100%,.25);color:#0a0a0a}.enable-bulma .file.is-white.is-active .file-cta,.enable-bulma .file.is-white:active .file-cta{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.enable-bulma .file.is-black .file-cta{background-color:#0a0a0a;border-color:transparent;color:#fff}.enable-bulma .file.is-black.is-hovered .file-cta,.enable-bulma .file.is-black:hover .file-cta{background-color:#040404;border-color:transparent;color:#fff}.enable-bulma .file.is-black.is-focused .file-cta,.enable-bulma .file.is-black:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(10,10,10,.25);box-shadow:0 0 .5em rgba(10,10,10,.25);color:#fff}.enable-bulma .file.is-black.is-active .file-cta,.enable-bulma .file.is-black:active .file-cta{background-color:#000;border-color:transparent;color:#fff}.enable-bulma .file.is-light .file-cta{background-color:#f5f5f5;border-color:transparent;color:#363636}.enable-bulma .file.is-light.is-hovered .file-cta,.enable-bulma .file.is-light:hover .file-cta{background-color:#eee;border-color:transparent;color:#363636}.enable-bulma .file.is-light.is-focused .file-cta,.enable-bulma .file.is-light:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em hsla(0,0%,96.1%,.25);box-shadow:0 0 .5em hsla(0,0%,96.1%,.25);color:#363636}.enable-bulma .file.is-light.is-active .file-cta,.enable-bulma .file.is-light:active .file-cta{background-color:#e8e8e8;border-color:transparent;color:#363636}.enable-bulma .file.is-dark .file-cta{background-color:#363636;border-color:transparent;color:#f5f5f5}.enable-bulma .file.is-dark.is-hovered .file-cta,.enable-bulma .file.is-dark:hover .file-cta{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.enable-bulma .file.is-dark.is-focused .file-cta,.enable-bulma .file.is-dark:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(54,54,54,.25);box-shadow:0 0 .5em rgba(54,54,54,.25);color:#f5f5f5}.enable-bulma .file.is-dark.is-active .file-cta,.enable-bulma .file.is-dark:active .file-cta{background-color:#292929;border-color:transparent;color:#f5f5f5}.enable-bulma .file.is-primary .file-cta{background-color:#3273dc;border-color:transparent;color:#fff}.enable-bulma .file.is-primary.is-hovered .file-cta,.enable-bulma .file.is-primary:hover .file-cta{background-color:#276cda;border-color:transparent;color:#fff}.enable-bulma .file.is-primary.is-focused .file-cta,.enable-bulma .file.is-primary:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(50,115,220,.25);box-shadow:0 0 .5em rgba(50,115,220,.25);color:#fff}.enable-bulma .file.is-primary.is-active .file-cta,.enable-bulma .file.is-primary:active .file-cta{background-color:#2466d1;border-color:transparent;color:#fff}.enable-bulma .file.is-link .file-cta{background-color:#3273dc;border-color:transparent;color:#fff}.enable-bulma .file.is-link.is-hovered .file-cta,.enable-bulma .file.is-link:hover .file-cta{background-color:#276cda;border-color:transparent;color:#fff}.enable-bulma .file.is-link.is-focused .file-cta,.enable-bulma .file.is-link:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(50,115,220,.25);box-shadow:0 0 .5em rgba(50,115,220,.25);color:#fff}.enable-bulma .file.is-link.is-active .file-cta,.enable-bulma .file.is-link:active .file-cta{background-color:#2366d1;border-color:transparent;color:#fff}.enable-bulma .file.is-info .file-cta{background-color:#209cee;border-color:transparent;color:#fff}.enable-bulma .file.is-info.is-hovered .file-cta,.enable-bulma .file.is-info:hover .file-cta{background-color:#1496ed;border-color:transparent;color:#fff}.enable-bulma .file.is-info.is-focused .file-cta,.enable-bulma .file.is-info:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(32,156,238,.25);box-shadow:0 0 .5em rgba(32,156,238,.25);color:#fff}.enable-bulma .file.is-info.is-active .file-cta,.enable-bulma .file.is-info:active .file-cta{background-color:#118fe4;border-color:transparent;color:#fff}.enable-bulma .file.is-success .file-cta{background-color:#23d160;border-color:transparent;color:#fff}.enable-bulma .file.is-success.is-hovered .file-cta,.enable-bulma .file.is-success:hover .file-cta{background-color:#22c65b;border-color:transparent;color:#fff}.enable-bulma .file.is-success.is-focused .file-cta,.enable-bulma .file.is-success:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(35,209,96,.25);box-shadow:0 0 .5em rgba(35,209,96,.25);color:#fff}.enable-bulma .file.is-success.is-active .file-cta,.enable-bulma .file.is-success:active .file-cta{background-color:#20bc56;border-color:transparent;color:#fff}.enable-bulma .file.is-warning .file-cta{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.enable-bulma .file.is-warning.is-hovered .file-cta,.enable-bulma .file.is-warning:hover .file-cta{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.enable-bulma .file.is-warning.is-focused .file-cta,.enable-bulma .file.is-warning:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(255,221,87,.25);box-shadow:0 0 .5em rgba(255,221,87,.25);color:rgba(0,0,0,.7)}.enable-bulma .file.is-warning.is-active .file-cta,.enable-bulma .file.is-warning:active .file-cta{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.enable-bulma .file.is-danger .file-cta{background-color:#ff3860;border-color:transparent;color:#fff}.enable-bulma .file.is-danger.is-hovered .file-cta,.enable-bulma .file.is-danger:hover .file-cta{background-color:#ff2b56;border-color:transparent;color:#fff}.enable-bulma .file.is-danger.is-focused .file-cta,.enable-bulma .file.is-danger:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(255,56,96,.25);box-shadow:0 0 .5em rgba(255,56,96,.25);color:#fff}.enable-bulma .file.is-danger.is-active .file-cta,.enable-bulma .file.is-danger:active .file-cta{background-color:#ff1f4b;border-color:transparent;color:#fff}.enable-bulma .file.is-small{font-size:.75rem}.enable-bulma .file.is-medium{font-size:1.25rem}.enable-bulma .file.is-medium .file-icon .fa{font-size:21px}.enable-bulma .file.is-large{font-size:1.5rem}.enable-bulma .file.is-large .file-icon .fa{font-size:28px}.enable-bulma .file.has-name .file-cta{border-bottom-right-radius:0;border-top-right-radius:0}.enable-bulma .file.has-name .file-name{border-bottom-left-radius:0;border-top-left-radius:0}.enable-bulma .file.has-name.is-empty .file-cta{border-radius:4px}.enable-bulma .file.has-name.is-empty .file-name{display:none}.enable-bulma .file.is-boxed .file-cta,.enable-bulma .file.is-boxed .file-label{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.enable-bulma .file.is-boxed .file-cta{height:auto;padding:1em 3em}.enable-bulma .file.is-boxed .file-name{border-width:0 1px 1px}.enable-bulma .file.is-boxed .file-icon{height:1.5em;width:1.5em}.enable-bulma .file.is-boxed .file-icon .fa{font-size:21px}.enable-bulma .file.is-boxed.is-small .file-icon .fa{font-size:14px}.enable-bulma .file.is-boxed.is-medium .file-icon .fa{font-size:28px}.enable-bulma .file.is-boxed.is-large .file-icon .fa{font-size:35px}.enable-bulma .file.is-boxed.has-name .file-cta{border-radius:4px 4px 0 0}.enable-bulma .file.is-boxed.has-name .file-name{border-radius:0 0 4px 4px;border-width:0 1px 1px}.enable-bulma .file.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .file.is-fullwidth .file-label{width:100%}.enable-bulma .file.is-fullwidth .file-name{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:none}.enable-bulma .file.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .file.is-right .file-cta{border-radius:0 4px 4px 0}.enable-bulma .file.is-right .file-name{border-radius:4px 0 0 4px;border-width:1px 0 1px 1px;-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.enable-bulma .file-label{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;overflow:hidden;position:relative}.enable-bulma .file-label:hover .file-cta{background-color:#eee;color:#363636}.enable-bulma .file-label:hover .file-name{border-color:#d5d5d5}.enable-bulma .file-label:active .file-cta{background-color:#e8e8e8;color:#363636}.enable-bulma .file-label:active .file-name{border-color:#cfcfcf}.enable-bulma .file-input{height:100%;left:0;opacity:0;outline:none;position:absolute;top:0;width:100%}.enable-bulma .file-cta,.enable-bulma .file-name{border-color:#dbdbdb;border-radius:4px;font-size:1em;padding-left:1em;padding-right:1em;white-space:nowrap}.enable-bulma .file-cta{background-color:#f5f5f5;color:#4a4a4a}.enable-bulma .file-name{border-color:#dbdbdb;border-style:solid;border-width:1px 1px 1px 0;display:block;max-width:16em;overflow:hidden;text-align:left;text-overflow:ellipsis}.enable-bulma .file-icon{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:1em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:.5em;width:1em}.enable-bulma .file-icon .fa{font-size:14px}.enable-bulma .label{color:#363636;display:block;font-size:1rem;font-weight:700}.enable-bulma .label:not(:last-child){margin-bottom:.5em}.enable-bulma .label.is-small{font-size:.75rem}.enable-bulma .label.is-medium{font-size:1.25rem}.enable-bulma .label.is-large{font-size:1.5rem}.enable-bulma .help{display:block;font-size:.75rem;margin-top:.25rem}.enable-bulma .help.is-white{color:#fff}.enable-bulma .help.is-black{color:#0a0a0a}.enable-bulma .help.is-light{color:#f5f5f5}.enable-bulma .help.is-dark{color:#363636}.enable-bulma .help.is-link,.enable-bulma .help.is-primary{color:#3273dc}.enable-bulma .help.is-info{color:#209cee}.enable-bulma .help.is-success{color:#23d160}.enable-bulma .help.is-warning{color:#ffdd57}.enable-bulma .help.is-danger{color:#ff3860}.enable-bulma .field:not(:last-child){margin-bottom:.75rem}.enable-bulma .field.has-addons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.enable-bulma .field.has-addons .control:not(:last-child){margin-right:-1px}.enable-bulma .field.has-addons .control:not(:first-child):not(:last-child) .button,.enable-bulma .field.has-addons .control:not(:first-child):not(:last-child) .input,.enable-bulma .field.has-addons .control:not(:first-child):not(:last-child) .select select,.enable-bulma .field.has-addons .control:not(:first-child):not(:last-child) .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .control:not(:first-child):not(:last-child) .taginput-container.is-focusable{border-radius:0}.enable-bulma .field.has-addons .control:first-child:not(:only-child) .button,.enable-bulma .field.has-addons .control:first-child:not(:only-child) .input,.enable-bulma .field.has-addons .control:first-child:not(:only-child) .select select,.enable-bulma .field.has-addons .control:first-child:not(:only-child) .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .control:first-child:not(:only-child) .taginput-container.is-focusable{border-bottom-right-radius:0;border-top-right-radius:0}.enable-bulma .field.has-addons .control:last-child:not(:only-child) .button,.enable-bulma .field.has-addons .control:last-child:not(:only-child) .input,.enable-bulma .field.has-addons .control:last-child:not(:only-child) .select select,.enable-bulma .field.has-addons .control:last-child:not(:only-child) .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .control:last-child:not(:only-child) .taginput-container.is-focusable{border-bottom-left-radius:0;border-top-left-radius:0}.enable-bulma .field.has-addons .control .button:not([disabled]).is-hovered,.enable-bulma .field.has-addons .control .button:not([disabled]):hover,.enable-bulma .field.has-addons .control .input:not([disabled]).is-hovered,.enable-bulma .field.has-addons .control .input:not([disabled]):hover,.enable-bulma .field.has-addons .control .select select:not([disabled]).is-hovered,.enable-bulma .field.has-addons .control .select select:not([disabled]):hover,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-hovered,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):hover,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-hovered,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):hover{z-index:2}.enable-bulma .field.has-addons .control .button:not([disabled]).is-active,.enable-bulma .field.has-addons .control .button:not([disabled]).is-focused,.enable-bulma .field.has-addons .control .button:not([disabled]):active,.enable-bulma .field.has-addons .control .button:not([disabled]):focus,.enable-bulma .field.has-addons .control .input:not([disabled]).is-active,.enable-bulma .field.has-addons .control .input:not([disabled]).is-focused,.enable-bulma .field.has-addons .control .input:not([disabled]):active,.enable-bulma .field.has-addons .control .input:not([disabled]):focus,.enable-bulma .field.has-addons .control .select select:not([disabled]).is-active,.enable-bulma .field.has-addons .control .select select:not([disabled]).is-focused,.enable-bulma .field.has-addons .control .select select:not([disabled]):active,.enable-bulma .field.has-addons .control .select select:not([disabled]):focus,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-active,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-focused,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):active,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):focus,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-active,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-focused,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):active,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):focus{z-index:3}.enable-bulma .field.has-addons .control .button:not([disabled]).is-active:hover,.enable-bulma .field.has-addons .control .button:not([disabled]).is-focused:hover,.enable-bulma .field.has-addons .control .button:not([disabled]):active:hover,.enable-bulma .field.has-addons .control .button:not([disabled]):focus:hover,.enable-bulma .field.has-addons .control .input:not([disabled]).is-active:hover,.enable-bulma .field.has-addons .control .input:not([disabled]).is-focused:hover,.enable-bulma .field.has-addons .control .input:not([disabled]):active:hover,.enable-bulma .field.has-addons .control .input:not([disabled]):focus:hover,.enable-bulma .field.has-addons .control .select select:not([disabled]).is-active:hover,.enable-bulma .field.has-addons .control .select select:not([disabled]).is-focused:hover,.enable-bulma .field.has-addons .control .select select:not([disabled]):active:hover,.enable-bulma .field.has-addons .control .select select:not([disabled]):focus:hover,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-active:hover,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-focused:hover,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):active:hover,.enable-bulma .field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):focus:hover,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-active:hover,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-focused:hover,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):active:hover,.enable-bulma .taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):focus:hover{z-index:4}.enable-bulma .field.has-addons .control.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .field.has-addons.has-addons-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .field.has-addons.has-addons-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .field.has-addons.has-addons-fullwidth .control{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .field.is-grouped{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.enable-bulma .field.is-grouped>.control{-ms-flex-negative:0;flex-shrink:0}.enable-bulma .field.is-grouped>.control:not(:last-child){margin-bottom:0;margin-right:.75rem}.enable-bulma .field.is-grouped>.control.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .field.is-grouped.is-grouped-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .field.is-grouped.is-grouped-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .field.is-grouped.is-grouped-multiline{-ms-flex-wrap:wrap;flex-wrap:wrap}.enable-bulma .field.is-grouped.is-grouped-multiline>.control:last-child,.enable-bulma .field.is-grouped.is-grouped-multiline>.control:not(:last-child){margin-bottom:.75rem}.enable-bulma .field.is-grouped.is-grouped-multiline:last-child{margin-bottom:-.75rem}.enable-bulma .field.is-grouped.is-grouped-multiline:not(:last-child){margin-bottom:0}@media print,screen and (min-width:769px){.enable-bulma .field.is-horizontal{display:-webkit-box;display:-ms-flexbox;display:flex}}.enable-bulma .field-label .label{font-size:inherit}@media screen and (max-width:768px){.enable-bulma .field-label{margin-bottom:.5rem}}@media print,screen and (min-width:769px){.enable-bulma .field-label{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;margin-right:1.5rem;text-align:right}.enable-bulma .field-label.is-small{font-size:.75rem;padding-top:.375em}.enable-bulma .field-label.is-normal{padding-top:.375em}.enable-bulma .field-label.is-medium{font-size:1.25rem;padding-top:.375em}.enable-bulma .field-label.is-large{font-size:1.5rem;padding-top:.375em}}.enable-bulma .field-body .field .field{margin-bottom:0}@media print,screen and (min-width:769px){.enable-bulma .field-body{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:5;-ms-flex-positive:5;flex-grow:5;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .field-body .field{margin-bottom:0}.enable-bulma .field-body>.field{-ms-flex-negative:1;flex-shrink:1}.enable-bulma .field-body>.field:not(.is-narrow){-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.enable-bulma .field-body>.field:not(:last-child){margin-right:.75rem}}.enable-bulma .control{-webkit-box-sizing:border-box;box-sizing:border-box;clear:both;font-size:1rem;position:relative;text-align:left}.enable-bulma .control.has-icons-left .input:focus~.icon,.enable-bulma .control.has-icons-left .select:focus~.icon,.enable-bulma .control.has-icons-left .taginput .taginput-container.is-focusable:focus~.icon,.enable-bulma .control.has-icons-right .input:focus~.icon,.enable-bulma .control.has-icons-right .select:focus~.icon,.enable-bulma .control.has-icons-right .taginput .taginput-container.is-focusable:focus~.icon,.enable-bulma .taginput .control.has-icons-left .taginput-container.is-focusable:focus~.icon,.enable-bulma .taginput .control.has-icons-right .taginput-container.is-focusable:focus~.icon{color:#7a7a7a}.enable-bulma .control.has-icons-left .input.is-small~.icon,.enable-bulma .control.has-icons-left .select.is-small~.icon,.enable-bulma .control.has-icons-left .taginput .is-small.taginput-container.is-focusable~.icon,.enable-bulma .control.has-icons-right .input.is-small~.icon,.enable-bulma .control.has-icons-right .select.is-small~.icon,.enable-bulma .control.has-icons-right .taginput .is-small.taginput-container.is-focusable~.icon,.enable-bulma .taginput .control.has-icons-left .is-small.taginput-container.is-focusable~.icon,.enable-bulma .taginput .control.has-icons-right .is-small.taginput-container.is-focusable~.icon{font-size:.75rem}.enable-bulma .control.has-icons-left .input.is-medium~.icon,.enable-bulma .control.has-icons-left .select.is-medium~.icon,.enable-bulma .control.has-icons-left .taginput .is-medium.taginput-container.is-focusable~.icon,.enable-bulma .control.has-icons-right .input.is-medium~.icon,.enable-bulma .control.has-icons-right .select.is-medium~.icon,.enable-bulma .control.has-icons-right .taginput .is-medium.taginput-container.is-focusable~.icon,.enable-bulma .taginput .control.has-icons-left .is-medium.taginput-container.is-focusable~.icon,.enable-bulma .taginput .control.has-icons-right .is-medium.taginput-container.is-focusable~.icon{font-size:1.25rem}.enable-bulma .control.has-icons-left .input.is-large~.icon,.enable-bulma .control.has-icons-left .select.is-large~.icon,.enable-bulma .control.has-icons-left .taginput .is-large.taginput-container.is-focusable~.icon,.enable-bulma .control.has-icons-right .input.is-large~.icon,.enable-bulma .control.has-icons-right .select.is-large~.icon,.enable-bulma .control.has-icons-right .taginput .is-large.taginput-container.is-focusable~.icon,.enable-bulma .taginput .control.has-icons-left .is-large.taginput-container.is-focusable~.icon,.enable-bulma .taginput .control.has-icons-right .is-large.taginput-container.is-focusable~.icon{font-size:1.5rem}.enable-bulma .control.has-icons-left .icon,.enable-bulma .control.has-icons-right .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.enable-bulma .control.has-icons-left .input,.enable-bulma .control.has-icons-left .select select,.enable-bulma .control.has-icons-left .taginput .taginput-container.is-focusable,.enable-bulma .taginput .control.has-icons-left .taginput-container.is-focusable{padding-left:2.25em}.enable-bulma .control.has-icons-left .icon.is-left{left:0}.enable-bulma .control.has-icons-right .input,.enable-bulma .control.has-icons-right .select select,.enable-bulma .control.has-icons-right .taginput .taginput-container.is-focusable,.enable-bulma .taginput .control.has-icons-right .taginput-container.is-focusable{padding-right:2.25em}.enable-bulma .control.has-icons-right .icon.is-right{right:0}.enable-bulma .control.is-loading:after{position:absolute!important;right:.625em;top:.625em;z-index:4}.enable-bulma .control.is-loading.is-small:after{font-size:.75rem}.enable-bulma .control.is-loading.is-medium:after{font-size:1.25rem}.enable-bulma .control.is-loading.is-large:after{font-size:1.5rem}.enable-bulma .breadcrumb{font-size:1rem;white-space:nowrap}.enable-bulma .breadcrumb a{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#3273dc;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 .75em}.enable-bulma .breadcrumb a:hover{color:#363636}.enable-bulma .breadcrumb li{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .breadcrumb li:first-child a{padding-left:0}.enable-bulma .breadcrumb li.is-active a{color:#363636;cursor:default;pointer-events:none}.enable-bulma .breadcrumb li+li:before{color:#b5b5b5;content:\"/\"}.enable-bulma .breadcrumb ol,.enable-bulma .breadcrumb ul{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.enable-bulma .breadcrumb .icon:first-child{margin-right:.5em}.enable-bulma .breadcrumb .icon:last-child{margin-left:.5em}.enable-bulma .breadcrumb.is-centered ol,.enable-bulma .breadcrumb.is-centered ul{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .breadcrumb.is-right ol,.enable-bulma .breadcrumb.is-right ul{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .breadcrumb.is-small{font-size:.75rem}.enable-bulma .breadcrumb.is-medium{font-size:1.25rem}.enable-bulma .breadcrumb.is-large{font-size:1.5rem}.enable-bulma .breadcrumb.has-arrow-separator li+li:before{content:\"→\"}.enable-bulma .breadcrumb.has-bullet-separator li+li:before{content:\"•\"}.enable-bulma .breadcrumb.has-dot-separator li+li:before{content:\"·\"}.enable-bulma .breadcrumb.has-succeeds-separator li+li:before{content:\"≻\"}.enable-bulma .card{background-color:#fff;-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);color:#4a4a4a;max-width:100%;position:relative}.enable-bulma .card-header{background-color:transparent;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-shadow:0 1px 2px rgba(10,10,10,.1);box-shadow:0 1px 2px rgba(10,10,10,.1);display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .card-header-title{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#363636;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-weight:700;padding:.75rem}.enable-bulma .card-header-icon,.enable-bulma .card-header-title.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .card-header-icon{-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;padding:.75rem}.enable-bulma .card-image{display:block;position:relative}.enable-bulma .card-content{background-color:transparent;padding:1.5rem}.enable-bulma .card-footer{background-color:transparent;border-top:1px solid #dbdbdb;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .card-footer-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:.75rem}.enable-bulma .card-footer-item:not(:last-child){border-right:1px solid #dbdbdb}.enable-bulma .card .media:not(:last-child){margin-bottom:1.5rem}.enable-bulma .dropdown{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;position:relative;vertical-align:top}.enable-bulma .dropdown.is-active .dropdown-menu,.enable-bulma .dropdown.is-hoverable:hover .dropdown-menu{display:block}.enable-bulma .dropdown.is-right .dropdown-menu{left:auto;right:0}.enable-bulma .dropdown.is-up .dropdown-menu{bottom:100%;padding-bottom:4px;padding-top:0;top:auto}.enable-bulma .dropdown-menu{display:none;left:0;min-width:12rem;padding-top:4px;position:absolute;top:100%;z-index:20}.enable-bulma .dropdown-content{background-color:#fff;border-radius:4px;-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);padding-bottom:.5rem;padding-top:.5rem}.enable-bulma .dropdown-item,.enable-bulma .dropdown .dropdown-menu .has-link a{color:#4a4a4a;display:block;font-size:.875rem;line-height:1.5;padding:.375rem 1rem;position:relative}.enable-bulma .dropdown .dropdown-menu .has-link a,.enable-bulma a.dropdown-item,.enable-bulma button.dropdown-item{padding-right:3rem;text-align:left;white-space:nowrap;width:100%}.enable-bulma .dropdown .dropdown-menu .has-link a:hover,.enable-bulma a.dropdown-item:hover,.enable-bulma button.dropdown-item:hover{background-color:#f5f5f5;color:#0a0a0a}.enable-bulma .dropdown .dropdown-menu .has-link a.is-active,.enable-bulma a.dropdown-item.is-active,.enable-bulma button.dropdown-item.is-active{background-color:#3273dc;color:#fff}.enable-bulma .dropdown-divider{background-color:#dbdbdb;border:none;display:block;height:1px;margin:.5rem 0}.enable-bulma .level{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.enable-bulma .level code{border-radius:4px}.enable-bulma .level img{display:inline-block;vertical-align:top}.enable-bulma .level.is-mobile,.enable-bulma .level.is-mobile .level-left,.enable-bulma .level.is-mobile .level-right{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .level.is-mobile .level-left+.level-right{margin-top:0}.enable-bulma .level.is-mobile .level-item:not(:last-child){margin-bottom:0;margin-right:.75rem}.enable-bulma .level.is-mobile .level-item:not(.is-narrow){-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}@media print,screen and (min-width:769px){.enable-bulma .level{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .level>.level-item:not(.is-narrow){-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.enable-bulma .level-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .level-item .subtitle,.enable-bulma .level-item .title{margin-bottom:0}@media screen and (max-width:768px){.enable-bulma .level-item:not(:last-child){margin-bottom:.75rem}}.enable-bulma .level-left,.enable-bulma .level-right{-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .level-left .level-item.is-flexible,.enable-bulma .level-right .level-item.is-flexible{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}@media print,screen and (min-width:769px){.enable-bulma .level-left .level-item:not(:last-child),.enable-bulma .level-right .level-item:not(:last-child){margin-right:.75rem}}.enable-bulma .level-left{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}@media screen and (max-width:768px){.enable-bulma .level-left+.level-right{margin-top:1.5rem}}@media print,screen and (min-width:769px){.enable-bulma .level-left{display:-webkit-box;display:-ms-flexbox;display:flex}}.enable-bulma .level-right{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}@media print,screen and (min-width:769px){.enable-bulma .level-right{display:-webkit-box;display:-ms-flexbox;display:flex}}.enable-bulma .list{background-color:#fff;border-radius:4px;-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1)}.enable-bulma .list-item{display:block;padding:.5em 1em}.enable-bulma .list-item:not(a){color:#4a4a4a}.enable-bulma .list-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.enable-bulma .list-item:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px}.enable-bulma .list-item:not(:last-child){border-bottom:1px solid #dbdbdb}.enable-bulma .list-item.is-active{background-color:#3273dc;color:#fff}.enable-bulma a.list-item{background-color:#f5f5f5;cursor:pointer}.enable-bulma .media{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left}.enable-bulma .media .content:not(:last-child){margin-bottom:.75rem}.enable-bulma .media .media{border-top:1px solid hsla(0,0%,85.9%,.5);display:-webkit-box;display:-ms-flexbox;display:flex;padding-top:.75rem}.enable-bulma .media .media .content:not(:last-child),.enable-bulma .media .media .control:not(:last-child){margin-bottom:.5rem}.enable-bulma .media .media .media{padding-top:.5rem}.enable-bulma .media .media .media+.media{margin-top:.5rem}.enable-bulma .media+.media{border-top:1px solid hsla(0,0%,85.9%,.5);margin-top:1rem;padding-top:1rem}.enable-bulma .media.is-large+.media{margin-top:1.5rem;padding-top:1.5rem}.enable-bulma .media-left,.enable-bulma .media-right{-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .media-left{margin-right:1rem}.enable-bulma .media-right{margin-left:1rem}.enable-bulma .media-content{-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;text-align:left}@media screen and (max-width:768px){.enable-bulma .media-content{overflow-x:auto}}.enable-bulma .menu{font-size:1rem}.enable-bulma .menu.is-small{font-size:.75rem}.enable-bulma .menu.is-medium{font-size:1.25rem}.enable-bulma .menu.is-large{font-size:1.5rem}.enable-bulma .menu-list{line-height:1.25}.enable-bulma .menu-list a{border-radius:2px;color:#4a4a4a;display:block;padding:.5em .75em}.enable-bulma .menu-list a:hover{background-color:#f5f5f5;color:#363636}.enable-bulma .menu-list a.is-active{background-color:#3273dc;color:#fff}.enable-bulma .menu-list li ul{border-left:1px solid #dbdbdb;margin:.75em;padding-left:.75em}.enable-bulma .menu-label{color:#7a7a7a;font-size:.75em;letter-spacing:.1em;text-transform:uppercase}.enable-bulma .menu-label:not(:first-child){margin-top:1em}.enable-bulma .menu-label:not(:last-child){margin-bottom:1em}.enable-bulma .message{background-color:#f5f5f5;border-radius:4px;font-size:1rem}.enable-bulma .message strong{color:currentColor}.enable-bulma .message a:not(.button):not(.tag):not(.dropdown-item){color:currentColor;text-decoration:underline}.enable-bulma .message.is-small{font-size:.75rem}.enable-bulma .message.is-medium{font-size:1.25rem}.enable-bulma .message.is-large{font-size:1.5rem}.enable-bulma .message.is-white{background-color:#fff}.enable-bulma .message.is-white .message-header{background-color:#fff;color:#0a0a0a}.enable-bulma .message.is-white .message-body{border-color:#fff;color:#4d4d4d}.enable-bulma .message.is-black{background-color:#fafafa}.enable-bulma .message.is-black .message-header{background-color:#0a0a0a;color:#fff}.enable-bulma .message.is-black .message-body{border-color:#0a0a0a;color:#0a0a0a}.enable-bulma .message.is-light{background-color:#fafafa}.enable-bulma .message.is-light .message-header{background-color:#f5f5f5;color:#363636}.enable-bulma .message.is-light .message-body{border-color:#f5f5f5;color:#4f4f4f}.enable-bulma .message.is-dark{background-color:#fafafa}.enable-bulma .message.is-dark .message-header{background-color:#363636;color:#f5f5f5}.enable-bulma .message.is-dark .message-body{border-color:#363636;color:#2a2a2a}.enable-bulma .message.is-primary{background-color:#f6f9fe}.enable-bulma .message.is-primary .message-header{background-color:#3273dc;color:#fff}.enable-bulma .message.is-primary .message-body{border-color:#3273dc;color:#22509a}.enable-bulma .message.is-link{background-color:#f6f9fe}.enable-bulma .message.is-link .message-header{background-color:#3273dc;color:#fff}.enable-bulma .message.is-link .message-body{border-color:#3273dc;color:#22509a}.enable-bulma .message.is-info{background-color:#f6fbfe}.enable-bulma .message.is-info .message-header{background-color:#209cee;color:#fff}.enable-bulma .message.is-info .message-body{border-color:#209cee;color:#12537e}.enable-bulma .message.is-success{background-color:#f6fef9}.enable-bulma .message.is-success .message-header{background-color:#23d160;color:#fff}.enable-bulma .message.is-success .message-body{border-color:#23d160;color:#0e311a}.enable-bulma .message.is-warning{background-color:#fffdf5}.enable-bulma .message.is-warning .message-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .message.is-warning .message-body{border-color:#ffdd57;color:#3c3108}.enable-bulma .message.is-danger{background-color:#fff5f7}.enable-bulma .message.is-danger .message-header{background-color:#ff3860;color:#fff}.enable-bulma .message.is-danger .message-body{border-color:#ff3860;color:#cd0930}.enable-bulma .message-header{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#4a4a4a;border-radius:4px 4px 0 0;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;font-weight:700;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;line-height:1.25;padding:.75em 1em;position:relative}.enable-bulma .message-header .delete{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin-left:.75em}.enable-bulma .message-header+.message-body{border-width:0;border-top-left-radius:0;border-top-right-radius:0}.enable-bulma .message-body{border-color:#dbdbdb;border-radius:4px;border-style:solid;border-width:0 0 0 4px;color:#4a4a4a;padding:1.25em 1.5em}.enable-bulma .message-body code,.enable-bulma .message-body pre{background-color:#fff}.enable-bulma .message-body pre code{background-color:transparent}.enable-bulma .modal{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;position:fixed;z-index:40}.enable-bulma .modal.is-active{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .modal-background{background-color:rgba(10,10,10,.86)}.enable-bulma .modal-card,.enable-bulma .modal-content{margin:0 20px;max-height:calc(100vh - 160px);overflow:auto;position:relative;width:100%}@media print,screen and (min-width:769px){.enable-bulma .modal-card,.enable-bulma .modal-content{margin:0 auto;max-height:calc(100vh - 40px);width:640px}}.enable-bulma .modal-close{background:none;height:40px;position:fixed;right:20px;top:20px;width:40px}.enable-bulma .modal-card{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-height:calc(100vh - 40px);overflow:hidden;-ms-overflow-y:visible}.enable-bulma .modal-card-foot,.enable-bulma .modal-card-head{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f5f5f5;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:20px;position:relative}.enable-bulma .modal-card-head{border-bottom:1px solid #dbdbdb;border-top-left-radius:6px;border-top-right-radius:6px}.enable-bulma .modal-card-title{color:#363636;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;font-size:1.5rem;line-height:1}.enable-bulma .modal-card-foot{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:1px solid #dbdbdb}.enable-bulma .modal-card-foot .button:not(:last-child){margin-right:.5em}.enable-bulma .modal-card-body{-webkit-overflow-scrolling:touch;background-color:#fff;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto;padding:20px}.enable-bulma .navbar{background-color:#fff;min-height:3.25rem;position:relative;z-index:30}.enable-bulma .navbar.is-white{background-color:#fff;color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-brand .navbar-link,.enable-bulma .navbar.is-white .navbar-brand>.navbar-item{color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-white .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-white .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-white .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-white .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-white .navbar-brand>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-brand .navbar-link:after{border-color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-burger{color:#0a0a0a}@media screen and (min-width:1024px){.enable-bulma .navbar.is-white .navbar-end .navbar-link,.enable-bulma .navbar.is-white .navbar-end>.navbar-item,.enable-bulma .navbar.is-white .navbar-start .navbar-link,.enable-bulma .navbar.is-white .navbar-start>.navbar-item{color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-white .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-white .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-white .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-white .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-white .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-white .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-white .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-white .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-white .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-white .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-white .navbar-start>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-end .navbar-link:after,.enable-bulma .navbar.is-white .navbar-start .navbar-link:after{border-color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-white .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-white .navbar-item.has-dropdown:hover .navbar-link{background-color:#f2f2f2;color:#0a0a0a}.enable-bulma .navbar.is-white .navbar-dropdown a.navbar-item.is-active{background-color:#fff;color:#0a0a0a}}.enable-bulma .navbar.is-black{background-color:#0a0a0a;color:#fff}.enable-bulma .navbar.is-black .navbar-brand .navbar-link,.enable-bulma .navbar.is-black .navbar-brand>.navbar-item{color:#fff}.enable-bulma .navbar.is-black .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-black .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-black .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-black .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-black .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-black .navbar-brand>a.navbar-item:hover{background-color:#000;color:#fff}.enable-bulma .navbar.is-black .navbar-brand .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-black .navbar-burger{color:#fff}@media screen and (min-width:1024px){.enable-bulma .navbar.is-black .navbar-end .navbar-link,.enable-bulma .navbar.is-black .navbar-end>.navbar-item,.enable-bulma .navbar.is-black .navbar-start .navbar-link,.enable-bulma .navbar.is-black .navbar-start>.navbar-item{color:#fff}.enable-bulma .navbar.is-black .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-black .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-black .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-black .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-black .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-black .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-black .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-black .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-black .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-black .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-black .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-black .navbar-start>a.navbar-item:hover{background-color:#000;color:#fff}.enable-bulma .navbar.is-black .navbar-end .navbar-link:after,.enable-bulma .navbar.is-black .navbar-start .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-black .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-black .navbar-item.has-dropdown:hover .navbar-link{background-color:#000;color:#fff}.enable-bulma .navbar.is-black .navbar-dropdown a.navbar-item.is-active{background-color:#0a0a0a;color:#fff}}.enable-bulma .navbar.is-light{background-color:#f5f5f5;color:#363636}.enable-bulma .navbar.is-light .navbar-brand .navbar-link,.enable-bulma .navbar.is-light .navbar-brand>.navbar-item{color:#363636}.enable-bulma .navbar.is-light .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-light .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-light .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-light .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-light .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-light .navbar-brand>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.enable-bulma .navbar.is-light .navbar-brand .navbar-link:after{border-color:#363636}.enable-bulma .navbar.is-light .navbar-burger{color:#363636}@media screen and (min-width:1024px){.enable-bulma .navbar.is-light .navbar-end .navbar-link,.enable-bulma .navbar.is-light .navbar-end>.navbar-item,.enable-bulma .navbar.is-light .navbar-start .navbar-link,.enable-bulma .navbar.is-light .navbar-start>.navbar-item{color:#363636}.enable-bulma .navbar.is-light .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-light .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-light .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-light .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-light .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-light .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-light .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-light .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-light .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-light .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-light .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-light .navbar-start>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.enable-bulma .navbar.is-light .navbar-end .navbar-link:after,.enable-bulma .navbar.is-light .navbar-start .navbar-link:after{border-color:#363636}.enable-bulma .navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-light .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-light .navbar-item.has-dropdown:hover .navbar-link{background-color:#e8e8e8;color:#363636}.enable-bulma .navbar.is-light .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#363636}}.enable-bulma .navbar.is-dark{background-color:#363636;color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-brand .navbar-link,.enable-bulma .navbar.is-dark .navbar-brand>.navbar-item{color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-dark .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-dark .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-dark .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-dark .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-dark .navbar-brand>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-brand .navbar-link:after{border-color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-burger{color:#f5f5f5}@media screen and (min-width:1024px){.enable-bulma .navbar.is-dark .navbar-end .navbar-link,.enable-bulma .navbar.is-dark .navbar-end>.navbar-item,.enable-bulma .navbar.is-dark .navbar-start .navbar-link,.enable-bulma .navbar.is-dark .navbar-start>.navbar-item{color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-dark .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-dark .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-dark .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-dark .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-dark .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-dark .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-dark .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-dark .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-dark .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-dark .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-dark .navbar-start>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-end .navbar-link:after,.enable-bulma .navbar.is-dark .navbar-start .navbar-link:after{border-color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-dark .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link{background-color:#292929;color:#f5f5f5}.enable-bulma .navbar.is-dark .navbar-dropdown a.navbar-item.is-active{background-color:#363636;color:#f5f5f5}}.enable-bulma .navbar.is-primary{background-color:#3273dc;color:#fff}.enable-bulma .navbar.is-primary .navbar-brand .navbar-link,.enable-bulma .navbar.is-primary .navbar-brand>.navbar-item{color:#fff}.enable-bulma .navbar.is-primary .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-primary .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-primary .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-primary .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-primary .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-primary .navbar-brand>a.navbar-item:hover{background-color:#2466d1;color:#fff}.enable-bulma .navbar.is-primary .navbar-brand .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-primary .navbar-burger{color:#fff}@media screen and (min-width:1024px){.enable-bulma .navbar.is-primary .navbar-end .navbar-link,.enable-bulma .navbar.is-primary .navbar-end>.navbar-item,.enable-bulma .navbar.is-primary .navbar-start .navbar-link,.enable-bulma .navbar.is-primary .navbar-start>.navbar-item{color:#fff}.enable-bulma .navbar.is-primary .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-primary .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-primary .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-primary .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-primary .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-primary .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-primary .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-primary .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-primary .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-primary .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-primary .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-primary .navbar-start>a.navbar-item:hover{background-color:#2466d1;color:#fff}.enable-bulma .navbar.is-primary .navbar-end .navbar-link:after,.enable-bulma .navbar.is-primary .navbar-start .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-primary .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link{background-color:#2466d1;color:#fff}.enable-bulma .navbar.is-primary .navbar-dropdown a.navbar-item.is-active{background-color:#3273dc;color:#fff}}.enable-bulma .navbar.is-link{background-color:#3273dc;color:#fff}.enable-bulma .navbar.is-link .navbar-brand .navbar-link,.enable-bulma .navbar.is-link .navbar-brand>.navbar-item{color:#fff}.enable-bulma .navbar.is-link .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-link .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-link .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-link .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-link .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-link .navbar-brand>a.navbar-item:hover{background-color:#2366d1;color:#fff}.enable-bulma .navbar.is-link .navbar-brand .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-link .navbar-burger{color:#fff}@media screen and (min-width:1024px){.enable-bulma .navbar.is-link .navbar-end .navbar-link,.enable-bulma .navbar.is-link .navbar-end>.navbar-item,.enable-bulma .navbar.is-link .navbar-start .navbar-link,.enable-bulma .navbar.is-link .navbar-start>.navbar-item{color:#fff}.enable-bulma .navbar.is-link .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-link .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-link .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-link .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-link .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-link .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-link .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-link .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-link .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-link .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-link .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-link .navbar-start>a.navbar-item:hover{background-color:#2366d1;color:#fff}.enable-bulma .navbar.is-link .navbar-end .navbar-link:after,.enable-bulma .navbar.is-link .navbar-start .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-link .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-link .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-link .navbar-item.has-dropdown:hover .navbar-link{background-color:#2366d1;color:#fff}.enable-bulma .navbar.is-link .navbar-dropdown a.navbar-item.is-active{background-color:#3273dc;color:#fff}}.enable-bulma .navbar.is-info{background-color:#209cee;color:#fff}.enable-bulma .navbar.is-info .navbar-brand .navbar-link,.enable-bulma .navbar.is-info .navbar-brand>.navbar-item{color:#fff}.enable-bulma .navbar.is-info .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-info .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-info .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-info .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-info .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-info .navbar-brand>a.navbar-item:hover{background-color:#118fe4;color:#fff}.enable-bulma .navbar.is-info .navbar-brand .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-info .navbar-burger{color:#fff}@media screen and (min-width:1024px){.enable-bulma .navbar.is-info .navbar-end .navbar-link,.enable-bulma .navbar.is-info .navbar-end>.navbar-item,.enable-bulma .navbar.is-info .navbar-start .navbar-link,.enable-bulma .navbar.is-info .navbar-start>.navbar-item{color:#fff}.enable-bulma .navbar.is-info .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-info .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-info .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-info .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-info .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-info .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-info .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-info .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-info .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-info .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-info .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-info .navbar-start>a.navbar-item:hover{background-color:#118fe4;color:#fff}.enable-bulma .navbar.is-info .navbar-end .navbar-link:after,.enable-bulma .navbar.is-info .navbar-start .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-info .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-info .navbar-item.has-dropdown:hover .navbar-link{background-color:#118fe4;color:#fff}.enable-bulma .navbar.is-info .navbar-dropdown a.navbar-item.is-active{background-color:#209cee;color:#fff}}.enable-bulma .navbar.is-success{background-color:#23d160;color:#fff}.enable-bulma .navbar.is-success .navbar-brand .navbar-link,.enable-bulma .navbar.is-success .navbar-brand>.navbar-item{color:#fff}.enable-bulma .navbar.is-success .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-success .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-success .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-success .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-success .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-success .navbar-brand>a.navbar-item:hover{background-color:#20bc56;color:#fff}.enable-bulma .navbar.is-success .navbar-brand .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-success .navbar-burger{color:#fff}@media screen and (min-width:1024px){.enable-bulma .navbar.is-success .navbar-end .navbar-link,.enable-bulma .navbar.is-success .navbar-end>.navbar-item,.enable-bulma .navbar.is-success .navbar-start .navbar-link,.enable-bulma .navbar.is-success .navbar-start>.navbar-item{color:#fff}.enable-bulma .navbar.is-success .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-success .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-success .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-success .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-success .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-success .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-success .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-success .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-success .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-success .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-success .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-success .navbar-start>a.navbar-item:hover{background-color:#20bc56;color:#fff}.enable-bulma .navbar.is-success .navbar-end .navbar-link:after,.enable-bulma .navbar.is-success .navbar-start .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-success .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-success .navbar-item.has-dropdown:hover .navbar-link{background-color:#20bc56;color:#fff}.enable-bulma .navbar.is-success .navbar-dropdown a.navbar-item.is-active{background-color:#23d160;color:#fff}}.enable-bulma .navbar.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-brand .navbar-link,.enable-bulma .navbar.is-warning .navbar-brand>.navbar-item{color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-warning .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-warning .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-warning .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-warning .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-warning .navbar-brand>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-brand .navbar-link:after{border-color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-burger{color:rgba(0,0,0,.7)}@media screen and (min-width:1024px){.enable-bulma .navbar.is-warning .navbar-end .navbar-link,.enable-bulma .navbar.is-warning .navbar-end>.navbar-item,.enable-bulma .navbar.is-warning .navbar-start .navbar-link,.enable-bulma .navbar.is-warning .navbar-start>.navbar-item{color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-warning .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-warning .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-warning .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-warning .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-warning .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-warning .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-warning .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-warning .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-warning .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-warning .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-warning .navbar-start>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-end .navbar-link:after,.enable-bulma .navbar.is-warning .navbar-start .navbar-link:after{border-color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-warning .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link{background-color:#ffd83d;color:rgba(0,0,0,.7)}.enable-bulma .navbar.is-warning .navbar-dropdown a.navbar-item.is-active{background-color:#ffdd57;color:rgba(0,0,0,.7)}}.enable-bulma .navbar.is-danger{background-color:#ff3860;color:#fff}.enable-bulma .navbar.is-danger .navbar-brand .navbar-link,.enable-bulma .navbar.is-danger .navbar-brand>.navbar-item{color:#fff}.enable-bulma .navbar.is-danger .navbar-brand .navbar-link.is-active,.enable-bulma .navbar.is-danger .navbar-brand .navbar-link:focus,.enable-bulma .navbar.is-danger .navbar-brand .navbar-link:hover,.enable-bulma .navbar.is-danger .navbar-brand>a.navbar-item.is-active,.enable-bulma .navbar.is-danger .navbar-brand>a.navbar-item:focus,.enable-bulma .navbar.is-danger .navbar-brand>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.enable-bulma .navbar.is-danger .navbar-brand .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-danger .navbar-burger{color:#fff}@media screen and (min-width:1024px){.enable-bulma .navbar.is-danger .navbar-end .navbar-link,.enable-bulma .navbar.is-danger .navbar-end>.navbar-item,.enable-bulma .navbar.is-danger .navbar-start .navbar-link,.enable-bulma .navbar.is-danger .navbar-start>.navbar-item{color:#fff}.enable-bulma .navbar.is-danger .navbar-end .navbar-link.is-active,.enable-bulma .navbar.is-danger .navbar-end .navbar-link:focus,.enable-bulma .navbar.is-danger .navbar-end .navbar-link:hover,.enable-bulma .navbar.is-danger .navbar-end>a.navbar-item.is-active,.enable-bulma .navbar.is-danger .navbar-end>a.navbar-item:focus,.enable-bulma .navbar.is-danger .navbar-end>a.navbar-item:hover,.enable-bulma .navbar.is-danger .navbar-start .navbar-link.is-active,.enable-bulma .navbar.is-danger .navbar-start .navbar-link:focus,.enable-bulma .navbar.is-danger .navbar-start .navbar-link:hover,.enable-bulma .navbar.is-danger .navbar-start>a.navbar-item.is-active,.enable-bulma .navbar.is-danger .navbar-start>a.navbar-item:focus,.enable-bulma .navbar.is-danger .navbar-start>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.enable-bulma .navbar.is-danger .navbar-end .navbar-link:after,.enable-bulma .navbar.is-danger .navbar-start .navbar-link:after{border-color:#fff}.enable-bulma .navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-danger .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link{background-color:#ff1f4b;color:#fff}.enable-bulma .navbar.is-danger .navbar-dropdown a.navbar-item.is-active{background-color:#ff3860;color:#fff}}.enable-bulma .navbar>.container{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:3.25rem;width:100%}.enable-bulma .navbar.has-shadow{-webkit-box-shadow:0 2px 0 0 #f5f5f5;box-shadow:0 2px 0 0 #f5f5f5}.enable-bulma .navbar.is-fixed-bottom,.enable-bulma .navbar.is-fixed-top{left:0;position:fixed;right:0;z-index:30}.enable-bulma .navbar.is-fixed-bottom{bottom:0}.enable-bulma .navbar.is-fixed-bottom.has-shadow{-webkit-box-shadow:0 -2px 0 0 #f5f5f5;box-shadow:0 -2px 0 0 #f5f5f5}.enable-bulma .navbar.is-fixed-top{top:0}.enable-bulma body.has-navbar-fixed-top,.enable-bulma html.has-navbar-fixed-top{padding-top:3.25rem}.enable-bulma body.has-navbar-fixed-bottom,.enable-bulma html.has-navbar-fixed-bottom{padding-bottom:3.25rem}.enable-bulma .navbar-brand,.enable-bulma .navbar-tabs{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;min-height:3.25rem}.enable-bulma .navbar-brand a.navbar-item:focus,.enable-bulma .navbar-brand a.navbar-item:hover{background-color:transparent}.enable-bulma .navbar-tabs{-webkit-overflow-scrolling:touch;max-width:100vw;overflow-x:auto;overflow-y:hidden}.enable-bulma .navbar-burger{color:#4a4a4a;cursor:pointer;display:block;height:3.25rem;position:relative;width:3.25rem;margin-left:auto}.enable-bulma .navbar-burger span{background-color:currentColor;display:block;height:1px;left:calc(50% - 8px);position:absolute;-webkit-transform-origin:center;transform-origin:center;-webkit-transition-duration:86ms;transition-duration:86ms;-webkit-transition-property:background-color,opacity,-webkit-transform;transition-property:background-color,opacity,-webkit-transform;transition-property:background-color,opacity,transform;transition-property:background-color,opacity,transform,-webkit-transform;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out;width:16px}.enable-bulma .navbar-burger span:first-child{top:calc(50% - 6px)}.enable-bulma .navbar-burger span:nth-child(2){top:calc(50% - 1px)}.enable-bulma .navbar-burger span:nth-child(3){top:calc(50% + 4px)}.enable-bulma .navbar-burger:hover{background-color:rgba(0,0,0,.05)}.enable-bulma .navbar-burger.is-active span:first-child{-webkit-transform:translateY(5px) rotate(45deg);transform:translateY(5px) rotate(45deg)}.enable-bulma .navbar-burger.is-active span:nth-child(2){opacity:0}.enable-bulma .navbar-burger.is-active span:nth-child(3){-webkit-transform:translateY(-5px) rotate(-45deg);transform:translateY(-5px) rotate(-45deg)}.enable-bulma .navbar-menu{display:none}.enable-bulma .navbar-item,.enable-bulma .navbar-link{color:#4a4a4a;display:block;line-height:1.5;padding:.5rem .75rem;position:relative}.enable-bulma .navbar-item .icon:only-child,.enable-bulma .navbar-link .icon:only-child{margin-left:-.25rem;margin-right:-.25rem}.enable-bulma .navbar-link,.enable-bulma a.navbar-item{cursor:pointer}.enable-bulma .navbar-link.is-active,.enable-bulma .navbar-link:focus,.enable-bulma .navbar-link:focus-within,.enable-bulma .navbar-link:hover,.enable-bulma a.navbar-item.is-active,.enable-bulma a.navbar-item:focus,.enable-bulma a.navbar-item:focus-within,.enable-bulma a.navbar-item:hover{background-color:#fafafa;color:#3273dc}.enable-bulma .navbar-item{display:block;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .navbar-item img{max-height:1.75rem}.enable-bulma .navbar-item.has-dropdown{padding:0}.enable-bulma .navbar-item.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .navbar-item.is-tab{border-bottom:1px solid transparent;min-height:3.25rem;padding-bottom:calc(.5rem - 1px)}.enable-bulma .navbar-item.is-tab:focus,.enable-bulma .navbar-item.is-tab:hover{background-color:transparent;border-bottom-color:#3273dc}.enable-bulma .navbar-item.is-tab.is-active{background-color:transparent;border-bottom-color:#3273dc;border-bottom-style:solid;border-bottom-width:3px;color:#3273dc;padding-bottom:calc(.5rem - 3px)}.enable-bulma .navbar-content{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .navbar-link:not(.is-arrowless){padding-right:2.5em}.enable-bulma .navbar-link:not(.is-arrowless):after{border-color:#3273dc;margin-top:-.375em;right:1.125em}.enable-bulma .navbar-dropdown{font-size:.875rem;padding-bottom:.5rem;padding-top:.5rem}.enable-bulma .navbar-dropdown .navbar-item{padding-left:1.5rem;padding-right:1.5rem}.enable-bulma .navbar-divider{background-color:#f5f5f5;border:none;display:none;height:2px;margin:.5rem 0}@media screen and (max-width:1023px){.enable-bulma .navbar>.container{display:block}.enable-bulma .navbar-brand .navbar-item,.enable-bulma .navbar-tabs .navbar-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .navbar-link:after{display:none}.enable-bulma .navbar-menu{background-color:#fff;-webkit-box-shadow:0 8px 16px rgba(10,10,10,.1);box-shadow:0 8px 16px rgba(10,10,10,.1);padding:.5rem 0}.enable-bulma .navbar-menu.is-active{display:block}.enable-bulma .navbar.is-fixed-bottom-touch,.enable-bulma .navbar.is-fixed-top-touch{left:0;position:fixed;right:0;z-index:30}.enable-bulma .navbar.is-fixed-bottom-touch{bottom:0}.enable-bulma .navbar.is-fixed-bottom-touch.has-shadow{-webkit-box-shadow:0 -2px 3px rgba(10,10,10,.1);box-shadow:0 -2px 3px rgba(10,10,10,.1)}.enable-bulma .navbar.is-fixed-top-touch{top:0}.enable-bulma .navbar.is-fixed-top-touch .navbar-menu,.enable-bulma .navbar.is-fixed-top .navbar-menu{-webkit-overflow-scrolling:touch;max-height:calc(100vh - 3.25rem);overflow:auto}.enable-bulma body.has-navbar-fixed-top-touch,.enable-bulma html.has-navbar-fixed-top-touch{padding-top:3.25rem}.enable-bulma body.has-navbar-fixed-bottom-touch,.enable-bulma html.has-navbar-fixed-bottom-touch{padding-bottom:3.25rem}}@media screen and (min-width:1024px){.enable-bulma .navbar,.enable-bulma .navbar-end,.enable-bulma .navbar-menu,.enable-bulma .navbar-start{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .navbar{min-height:3.25rem}.enable-bulma .navbar.is-spaced{padding:1rem 2rem}.enable-bulma .navbar.is-spaced .navbar-end,.enable-bulma .navbar.is-spaced .navbar-start{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.enable-bulma .navbar.is-spaced .navbar-link,.enable-bulma .navbar.is-spaced a.navbar-item{border-radius:4px}.enable-bulma .navbar.is-transparent .navbar-link.is-active,.enable-bulma .navbar.is-transparent .navbar-link:focus,.enable-bulma .navbar.is-transparent .navbar-link:hover,.enable-bulma .navbar.is-transparent a.navbar-item.is-active,.enable-bulma .navbar.is-transparent a.navbar-item:focus,.enable-bulma .navbar.is-transparent a.navbar-item:hover{background-color:transparent!important}.enable-bulma .navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus-within .navbar-link,.enable-bulma .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus .navbar-link,.enable-bulma .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link{background-color:transparent!important}.enable-bulma .navbar.is-transparent .navbar-dropdown a.navbar-item:focus,.enable-bulma .navbar.is-transparent .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.enable-bulma .navbar.is-transparent .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.enable-bulma .navbar-burger{display:none}.enable-bulma .navbar-item,.enable-bulma .navbar-link{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .navbar-item{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .navbar-item.has-dropdown{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.enable-bulma .navbar-item.has-dropdown-up .navbar-link:after{-webkit-transform:rotate(135deg) translate(.25em,-.25em);transform:rotate(135deg) translate(.25em,-.25em)}.enable-bulma .navbar-item.has-dropdown-up .navbar-dropdown{border-bottom:2px solid #dbdbdb;border-radius:6px 6px 0 0;border-top:none;bottom:100%;-webkit-box-shadow:0 -8px 8px rgba(10,10,10,.1);box-shadow:0 -8px 8px rgba(10,10,10,.1);top:auto}.enable-bulma .navbar-item.is-active .navbar-dropdown,.enable-bulma .navbar-item.is-hoverable:focus-within .navbar-dropdown,.enable-bulma .navbar-item.is-hoverable:focus .navbar-dropdown,.enable-bulma .navbar-item.is-hoverable:hover .navbar-dropdown{display:block}.enable-bulma .navbar-item.is-active .navbar-dropdown.is-boxed,.enable-bulma .navbar-item.is-hoverable:focus-within .navbar-dropdown.is-boxed,.enable-bulma .navbar-item.is-hoverable:focus .navbar-dropdown.is-boxed,.enable-bulma .navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed,.navbar.is-spaced .enable-bulma .navbar-item.is-active .navbar-dropdown,.navbar.is-spaced .enable-bulma .navbar-item.is-hoverable:focus-within .navbar-dropdown,.navbar.is-spaced .enable-bulma .navbar-item.is-hoverable:focus .navbar-dropdown,.navbar.is-spaced .enable-bulma .navbar-item.is-hoverable:hover .navbar-dropdown{opacity:1;pointer-events:auto;-webkit-transform:translateY(0);transform:translateY(0)}.enable-bulma .navbar-menu{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .navbar-start{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-right:auto}.enable-bulma .navbar-end{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-left:auto}.enable-bulma .navbar-dropdown{background-color:#fff;border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:2px solid #dbdbdb;-webkit-box-shadow:0 8px 8px rgba(10,10,10,.1);box-shadow:0 8px 8px rgba(10,10,10,.1);display:none;font-size:.875rem;left:0;min-width:100%;position:absolute;top:100%;z-index:20}.enable-bulma .navbar-dropdown .navbar-item{padding:.375rem 1rem;white-space:nowrap}.enable-bulma .navbar-dropdown a.navbar-item{padding-right:3rem}.enable-bulma .navbar-dropdown a.navbar-item:focus,.enable-bulma .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.enable-bulma .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.enable-bulma .navbar-dropdown.is-boxed,.navbar.is-spaced .enable-bulma .navbar-dropdown{border-radius:6px;border-top:none;-webkit-box-shadow:0 8px 8px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 8px 8px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);display:block;opacity:0;pointer-events:none;top:calc(100% - 4px);-webkit-transform:translateY(-5px);transform:translateY(-5px);-webkit-transition-duration:86ms;transition-duration:86ms;-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform}.enable-bulma .navbar-dropdown.is-right{left:auto;right:0}.enable-bulma .navbar-divider{display:block}.enable-bulma .container>.navbar .navbar-brand,.enable-bulma .navbar>.container .navbar-brand{margin-left:-.75rem}.enable-bulma .container>.navbar .navbar-menu,.enable-bulma .navbar>.container .navbar-menu{margin-right:-.75rem}.enable-bulma .navbar.is-fixed-bottom-desktop,.enable-bulma .navbar.is-fixed-top-desktop{left:0;position:fixed;right:0;z-index:30}.enable-bulma .navbar.is-fixed-bottom-desktop{bottom:0}.enable-bulma .navbar.is-fixed-bottom-desktop.has-shadow{-webkit-box-shadow:0 -2px 3px rgba(10,10,10,.1);box-shadow:0 -2px 3px rgba(10,10,10,.1)}.enable-bulma .navbar.is-fixed-top-desktop{top:0}.enable-bulma body.has-navbar-fixed-top-desktop,.enable-bulma html.has-navbar-fixed-top-desktop{padding-top:3.25rem}.enable-bulma body.has-navbar-fixed-bottom-desktop,.enable-bulma html.has-navbar-fixed-bottom-desktop{padding-bottom:3.25rem}.enable-bulma body.has-spaced-navbar-fixed-top,.enable-bulma html.has-spaced-navbar-fixed-top{padding-top:5.25rem}.enable-bulma body.has-spaced-navbar-fixed-bottom,.enable-bulma html.has-spaced-navbar-fixed-bottom{padding-bottom:5.25rem}.enable-bulma .navbar-link.is-active,.enable-bulma a.navbar-item.is-active{color:#0a0a0a}.enable-bulma .navbar-link.is-active:not(:focus):not(:hover),.enable-bulma a.navbar-item.is-active:not(:focus):not(:hover){background-color:transparent}.enable-bulma .navbar-item.has-dropdown.is-active .navbar-link,.enable-bulma .navbar-item.has-dropdown:focus .navbar-link,.enable-bulma .navbar-item.has-dropdown:hover .navbar-link{background-color:#fafafa}}.enable-bulma .hero.is-fullheight-with-navbar{min-height:calc(100vh - 3.25rem)}.enable-bulma .pagination{font-size:1rem;margin:-.25rem}.enable-bulma .pagination.is-small{font-size:.75rem}.enable-bulma .pagination.is-medium{font-size:1.25rem}.enable-bulma .pagination.is-large{font-size:1.5rem}.enable-bulma .pagination.is-rounded .pagination-next,.enable-bulma .pagination.is-rounded .pagination-previous{padding-left:1em;padding-right:1em;border-radius:290486px}.enable-bulma .pagination.is-rounded .pagination-link{border-radius:290486px}.enable-bulma .pagination,.enable-bulma .pagination-list{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.enable-bulma .pagination-ellipsis,.enable-bulma .pagination-link,.enable-bulma .pagination-next,.enable-bulma .pagination-previous{font-size:1em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:.25rem;padding-left:.5em;padding-right:.5em;text-align:center}.enable-bulma .pagination-link,.enable-bulma .pagination-next,.enable-bulma .pagination-previous{border-color:#dbdbdb;color:#363636;min-width:2.25em}.enable-bulma .pagination-link:hover,.enable-bulma .pagination-next:hover,.enable-bulma .pagination-previous:hover{border-color:#b5b5b5;color:#363636}.enable-bulma .pagination-link:focus,.enable-bulma .pagination-next:focus,.enable-bulma .pagination-previous:focus{border-color:#3273dc}.enable-bulma .pagination-link:active,.enable-bulma .pagination-next:active,.enable-bulma .pagination-previous:active{-webkit-box-shadow:inset 0 1px 2px rgba(10,10,10,.2);box-shadow:inset 0 1px 2px rgba(10,10,10,.2)}.enable-bulma .pagination-link[disabled],.enable-bulma .pagination-next[disabled],.enable-bulma .pagination-previous[disabled]{background-color:#dbdbdb;border-color:#dbdbdb;-webkit-box-shadow:none;box-shadow:none;color:#7a7a7a;opacity:.5}.enable-bulma .pagination-next,.enable-bulma .pagination-previous{padding-left:.75em;padding-right:.75em;white-space:nowrap}.enable-bulma .pagination-link.is-current{background-color:#3273dc;border-color:#3273dc;color:#fff}.enable-bulma .pagination-ellipsis{color:#b5b5b5;pointer-events:none}.enable-bulma .pagination-list{-ms-flex-wrap:wrap;flex-wrap:wrap}@media screen and (max-width:768px){.enable-bulma .pagination{-ms-flex-wrap:wrap;flex-wrap:wrap}.enable-bulma .pagination-list li,.enable-bulma .pagination-next,.enable-bulma .pagination-previous{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}}@media print,screen and (min-width:769px){.enable-bulma .pagination-list{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.enable-bulma .pagination-previous{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.enable-bulma .pagination-next{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.enable-bulma .pagination{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.enable-bulma .pagination.is-centered .pagination-previous{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.enable-bulma .pagination.is-centered .pagination-list{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.enable-bulma .pagination.is-centered .pagination-next{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.enable-bulma .pagination.is-right .pagination-previous{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.enable-bulma .pagination.is-right .pagination-next{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.enable-bulma .pagination.is-right .pagination-list{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}}.enable-bulma .panel{font-size:1rem}.enable-bulma .panel:not(:last-child){margin-bottom:1.5rem}.enable-bulma .panel-block,.enable-bulma .panel-heading,.enable-bulma .panel-tabs{border-bottom:1px solid #dbdbdb;border-left:1px solid #dbdbdb;border-right:1px solid #dbdbdb}.enable-bulma .panel-block:first-child,.enable-bulma .panel-heading:first-child,.enable-bulma .panel-tabs:first-child{border-top:1px solid #dbdbdb}.enable-bulma .panel-heading{background-color:#f5f5f5;border-radius:4px 4px 0 0;color:#363636;font-size:1.25em;font-weight:300;line-height:1.25;padding:.5em .75em}.enable-bulma .panel-tabs{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .panel-tabs a{border-bottom:1px solid #dbdbdb;margin-bottom:-1px;padding:.5em}.enable-bulma .panel-tabs a.is-active{border-bottom-color:#4a4a4a;color:#363636}.enable-bulma .panel-list a{color:#4a4a4a}.enable-bulma .panel-list a:hover{color:#3273dc}.enable-bulma .panel-block{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#363636;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:.5em .75em}.enable-bulma .panel-block input[type=checkbox]{margin-right:.75em}.enable-bulma .panel-block>.control{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;width:100%}.enable-bulma .panel-block.is-wrapped{-ms-flex-wrap:wrap;flex-wrap:wrap}.enable-bulma .panel-block.is-active{border-left-color:#3273dc;color:#363636}.enable-bulma .panel-block.is-active .panel-icon{color:#3273dc}.enable-bulma a.panel-block,.enable-bulma label.panel-block{cursor:pointer}.enable-bulma a.panel-block:hover,.enable-bulma label.panel-block:hover{background-color:#f5f5f5}.enable-bulma .panel-icon{display:inline-block;font-size:14px;height:1em;line-height:1em;text-align:center;vertical-align:top;width:1em;color:#7a7a7a;margin-right:.75em}.enable-bulma .panel-icon .fa{font-size:inherit;line-height:inherit}.enable-bulma .tabs{-webkit-overflow-scrolling:touch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;font-size:1rem;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden;overflow-x:auto;white-space:nowrap}.enable-bulma .tabs,.enable-bulma .tabs a{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .tabs a{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;color:#4a4a4a;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:-1px;padding:.5em 1em;vertical-align:top}.enable-bulma .tabs a:hover{border-bottom-color:#363636;color:#363636}.enable-bulma .tabs li{display:block}.enable-bulma .tabs li.is-active a{border-bottom-color:#3273dc;color:#3273dc}.enable-bulma .tabs ul{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.enable-bulma .tabs ul.is-left{padding-right:.75em}.enable-bulma .tabs ul.is-center{-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:.75em;padding-right:.75em}.enable-bulma .tabs ul.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:.75em}.enable-bulma .tabs .icon:first-child{margin-right:.5em}.enable-bulma .tabs .icon:last-child{margin-left:.5em}.enable-bulma .tabs.is-centered ul{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .tabs.is-right ul{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .tabs.is-boxed a{border:1px solid transparent;border-radius:4px 4px 0 0}.enable-bulma .tabs.is-boxed a:hover{background-color:#f5f5f5;border-bottom-color:#dbdbdb}.enable-bulma .tabs.is-boxed li.is-active a{background-color:#fff;border-color:#dbdbdb;border-bottom-color:transparent!important}.enable-bulma .tabs.is-fullwidth li{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .tabs.is-toggle a{border-color:#dbdbdb;border-style:solid;border-width:1px;margin-bottom:0;position:relative}.enable-bulma .tabs.is-toggle a:hover{background-color:#f5f5f5;border-color:#b5b5b5;z-index:2}.enable-bulma .tabs.is-toggle li+li{margin-left:-1px}.enable-bulma .tabs.is-toggle li:first-child a{border-radius:4px 0 0 4px}.enable-bulma .tabs.is-toggle li:last-child a{border-radius:0 4px 4px 0}.enable-bulma .tabs.is-toggle li.is-active a{background-color:#3273dc;border-color:#3273dc;color:#fff;z-index:1}.enable-bulma .tabs.is-toggle ul{border-bottom:none}.enable-bulma .tabs.is-toggle.is-toggle-rounded li:first-child a{border-bottom-left-radius:290486px;border-top-left-radius:290486px;padding-left:1.25em}.enable-bulma .tabs.is-toggle.is-toggle-rounded li:last-child a{border-bottom-right-radius:290486px;border-top-right-radius:290486px;padding-right:1.25em}.enable-bulma .tabs.is-small{font-size:.75rem}.enable-bulma .tabs.is-medium{font-size:1.25rem}.enable-bulma .tabs.is-large{font-size:1.5rem}.enable-bulma .column{display:block;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;padding:.75rem}.columns.is-mobile>.enable-bulma .column.is-narrow{-webkit-box-flex:0;-ms-flex:none;flex:none}.columns.is-mobile>.enable-bulma .column.is-full{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.columns.is-mobile>.enable-bulma .column.is-three-quarters{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.columns.is-mobile>.enable-bulma .column.is-two-thirds{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.columns.is-mobile>.enable-bulma .column.is-half{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.columns.is-mobile>.enable-bulma .column.is-one-third{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.columns.is-mobile>.enable-bulma .column.is-one-quarter{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.columns.is-mobile>.enable-bulma .column.is-one-fifth{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.columns.is-mobile>.enable-bulma .column.is-two-fifths{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.columns.is-mobile>.enable-bulma .column.is-three-fifths{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.columns.is-mobile>.enable-bulma .column.is-four-fifths{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.columns.is-mobile>.enable-bulma .column.is-offset-three-quarters{margin-left:75%}.columns.is-mobile>.enable-bulma .column.is-offset-two-thirds{margin-left:66.6666%}.columns.is-mobile>.enable-bulma .column.is-offset-half{margin-left:50%}.columns.is-mobile>.enable-bulma .column.is-offset-one-third{margin-left:33.3333%}.columns.is-mobile>.enable-bulma .column.is-offset-one-quarter{margin-left:25%}.columns.is-mobile>.enable-bulma .column.is-offset-one-fifth{margin-left:20%}.columns.is-mobile>.enable-bulma .column.is-offset-two-fifths{margin-left:40%}.columns.is-mobile>.enable-bulma .column.is-offset-three-fifths{margin-left:60%}.columns.is-mobile>.enable-bulma .column.is-offset-four-fifths{margin-left:80%}.columns.is-mobile>.enable-bulma .column.is-0{-webkit-box-flex:0;-ms-flex:none;flex:none;width:0}.columns.is-mobile>.enable-bulma .column.is-offset-0{margin-left:0}.columns.is-mobile>.enable-bulma .column.is-1{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.columns.is-mobile>.enable-bulma .column.is-offset-1{margin-left:8.3333333333%}.columns.is-mobile>.enable-bulma .column.is-2{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.columns.is-mobile>.enable-bulma .column.is-offset-2{margin-left:16.6666666667%}.columns.is-mobile>.enable-bulma .column.is-3{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.columns.is-mobile>.enable-bulma .column.is-offset-3{margin-left:25%}.columns.is-mobile>.enable-bulma .column.is-4{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.columns.is-mobile>.enable-bulma .column.is-offset-4{margin-left:33.3333333333%}.columns.is-mobile>.enable-bulma .column.is-5{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.columns.is-mobile>.enable-bulma .column.is-offset-5{margin-left:41.6666666667%}.columns.is-mobile>.enable-bulma .column.is-6{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.columns.is-mobile>.enable-bulma .column.is-offset-6{margin-left:50%}.columns.is-mobile>.enable-bulma .column.is-7{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.columns.is-mobile>.enable-bulma .column.is-offset-7{margin-left:58.3333333333%}.columns.is-mobile>.enable-bulma .column.is-8{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.columns.is-mobile>.enable-bulma .column.is-offset-8{margin-left:66.6666666667%}.columns.is-mobile>.enable-bulma .column.is-9{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.columns.is-mobile>.enable-bulma .column.is-offset-9{margin-left:75%}.columns.is-mobile>.enable-bulma .column.is-10{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.columns.is-mobile>.enable-bulma .column.is-offset-10{margin-left:83.3333333333%}.columns.is-mobile>.enable-bulma .column.is-11{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.columns.is-mobile>.enable-bulma .column.is-offset-11{margin-left:91.6666666667%}.columns.is-mobile>.enable-bulma .column.is-12{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.columns.is-mobile>.enable-bulma .column.is-offset-12{margin-left:100%}@media screen and (max-width:768px){.enable-bulma .column.is-full-mobile,.enable-bulma .column.is-narrow-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none}.enable-bulma .column.is-full-mobile{width:100%}.enable-bulma .column.is-three-quarters-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-two-thirds-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.enable-bulma .column.is-half-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-one-third-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.enable-bulma .column.is-one-quarter-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-one-fifth-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.enable-bulma .column.is-two-fifths-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.enable-bulma .column.is-three-fifths-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.enable-bulma .column.is-four-fifths-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.enable-bulma .column.is-offset-three-quarters-mobile{margin-left:75%}.enable-bulma .column.is-offset-two-thirds-mobile{margin-left:66.6666%}.enable-bulma .column.is-offset-half-mobile{margin-left:50%}.enable-bulma .column.is-offset-one-third-mobile{margin-left:33.3333%}.enable-bulma .column.is-offset-one-quarter-mobile{margin-left:25%}.enable-bulma .column.is-offset-one-fifth-mobile{margin-left:20%}.enable-bulma .column.is-offset-two-fifths-mobile{margin-left:40%}.enable-bulma .column.is-offset-three-fifths-mobile{margin-left:60%}.enable-bulma .column.is-offset-four-fifths-mobile{margin-left:80%}.enable-bulma .column.is-0-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:0}.enable-bulma .column.is-offset-0-mobile{margin-left:0}.enable-bulma .column.is-1-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.enable-bulma .column.is-offset-1-mobile{margin-left:8.3333333333%}.enable-bulma .column.is-2-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.enable-bulma .column.is-offset-2-mobile{margin-left:16.6666666667%}.enable-bulma .column.is-3-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-offset-3-mobile{margin-left:25%}.enable-bulma .column.is-4-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.enable-bulma .column.is-offset-4-mobile{margin-left:33.3333333333%}.enable-bulma .column.is-5-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.enable-bulma .column.is-offset-5-mobile{margin-left:41.6666666667%}.enable-bulma .column.is-6-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-offset-6-mobile{margin-left:50%}.enable-bulma .column.is-7-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.enable-bulma .column.is-offset-7-mobile{margin-left:58.3333333333%}.enable-bulma .column.is-8-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.enable-bulma .column.is-offset-8-mobile{margin-left:66.6666666667%}.enable-bulma .column.is-9-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-offset-9-mobile{margin-left:75%}.enable-bulma .column.is-10-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.enable-bulma .column.is-offset-10-mobile{margin-left:83.3333333333%}.enable-bulma .column.is-11-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.enable-bulma .column.is-offset-11-mobile{margin-left:91.6666666667%}.enable-bulma .column.is-12-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.enable-bulma .column.is-offset-12-mobile{margin-left:100%}}@media print,screen and (min-width:769px){.enable-bulma .column.is-narrow,.enable-bulma .column.is-narrow-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none}.enable-bulma .column.is-full,.enable-bulma .column.is-full-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.enable-bulma .column.is-three-quarters,.enable-bulma .column.is-three-quarters-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-two-thirds,.enable-bulma .column.is-two-thirds-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.enable-bulma .column.is-half,.enable-bulma .column.is-half-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-one-third,.enable-bulma .column.is-one-third-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.enable-bulma .column.is-one-quarter,.enable-bulma .column.is-one-quarter-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-one-fifth,.enable-bulma .column.is-one-fifth-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.enable-bulma .column.is-two-fifths,.enable-bulma .column.is-two-fifths-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.enable-bulma .column.is-three-fifths,.enable-bulma .column.is-three-fifths-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.enable-bulma .column.is-four-fifths,.enable-bulma .column.is-four-fifths-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.enable-bulma .column.is-offset-three-quarters,.enable-bulma .column.is-offset-three-quarters-tablet{margin-left:75%}.enable-bulma .column.is-offset-two-thirds,.enable-bulma .column.is-offset-two-thirds-tablet{margin-left:66.6666%}.enable-bulma .column.is-offset-half,.enable-bulma .column.is-offset-half-tablet{margin-left:50%}.enable-bulma .column.is-offset-one-third,.enable-bulma .column.is-offset-one-third-tablet{margin-left:33.3333%}.enable-bulma .column.is-offset-one-quarter,.enable-bulma .column.is-offset-one-quarter-tablet{margin-left:25%}.enable-bulma .column.is-offset-one-fifth,.enable-bulma .column.is-offset-one-fifth-tablet{margin-left:20%}.enable-bulma .column.is-offset-two-fifths,.enable-bulma .column.is-offset-two-fifths-tablet{margin-left:40%}.enable-bulma .column.is-offset-three-fifths,.enable-bulma .column.is-offset-three-fifths-tablet{margin-left:60%}.enable-bulma .column.is-offset-four-fifths,.enable-bulma .column.is-offset-four-fifths-tablet{margin-left:80%}.enable-bulma .column.is-0,.enable-bulma .column.is-0-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:0}.enable-bulma .column.is-offset-0,.enable-bulma .column.is-offset-0-tablet{margin-left:0}.enable-bulma .column.is-1,.enable-bulma .column.is-1-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.enable-bulma .column.is-offset-1,.enable-bulma .column.is-offset-1-tablet{margin-left:8.3333333333%}.enable-bulma .column.is-2,.enable-bulma .column.is-2-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.enable-bulma .column.is-offset-2,.enable-bulma .column.is-offset-2-tablet{margin-left:16.6666666667%}.enable-bulma .column.is-3,.enable-bulma .column.is-3-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-offset-3,.enable-bulma .column.is-offset-3-tablet{margin-left:25%}.enable-bulma .column.is-4,.enable-bulma .column.is-4-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.enable-bulma .column.is-offset-4,.enable-bulma .column.is-offset-4-tablet{margin-left:33.3333333333%}.enable-bulma .column.is-5,.enable-bulma .column.is-5-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.enable-bulma .column.is-offset-5,.enable-bulma .column.is-offset-5-tablet{margin-left:41.6666666667%}.enable-bulma .column.is-6,.enable-bulma .column.is-6-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-offset-6,.enable-bulma .column.is-offset-6-tablet{margin-left:50%}.enable-bulma .column.is-7,.enable-bulma .column.is-7-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.enable-bulma .column.is-offset-7,.enable-bulma .column.is-offset-7-tablet{margin-left:58.3333333333%}.enable-bulma .column.is-8,.enable-bulma .column.is-8-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.enable-bulma .column.is-offset-8,.enable-bulma .column.is-offset-8-tablet{margin-left:66.6666666667%}.enable-bulma .column.is-9,.enable-bulma .column.is-9-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-offset-9,.enable-bulma .column.is-offset-9-tablet{margin-left:75%}.enable-bulma .column.is-10,.enable-bulma .column.is-10-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.enable-bulma .column.is-offset-10,.enable-bulma .column.is-offset-10-tablet{margin-left:83.3333333333%}.enable-bulma .column.is-11,.enable-bulma .column.is-11-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.enable-bulma .column.is-offset-11,.enable-bulma .column.is-offset-11-tablet{margin-left:91.6666666667%}.enable-bulma .column.is-12,.enable-bulma .column.is-12-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.enable-bulma .column.is-offset-12,.enable-bulma .column.is-offset-12-tablet{margin-left:100%}}@media screen and (max-width:1023px){.enable-bulma .column.is-full-touch,.enable-bulma .column.is-narrow-touch{-webkit-box-flex:0;-ms-flex:none;flex:none}.enable-bulma .column.is-full-touch{width:100%}.enable-bulma .column.is-three-quarters-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-two-thirds-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.enable-bulma .column.is-half-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-one-third-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.enable-bulma .column.is-one-quarter-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-one-fifth-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.enable-bulma .column.is-two-fifths-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.enable-bulma .column.is-three-fifths-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.enable-bulma .column.is-four-fifths-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.enable-bulma .column.is-offset-three-quarters-touch{margin-left:75%}.enable-bulma .column.is-offset-two-thirds-touch{margin-left:66.6666%}.enable-bulma .column.is-offset-half-touch{margin-left:50%}.enable-bulma .column.is-offset-one-third-touch{margin-left:33.3333%}.enable-bulma .column.is-offset-one-quarter-touch{margin-left:25%}.enable-bulma .column.is-offset-one-fifth-touch{margin-left:20%}.enable-bulma .column.is-offset-two-fifths-touch{margin-left:40%}.enable-bulma .column.is-offset-three-fifths-touch{margin-left:60%}.enable-bulma .column.is-offset-four-fifths-touch{margin-left:80%}.enable-bulma .column.is-0-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:0}.enable-bulma .column.is-offset-0-touch{margin-left:0}.enable-bulma .column.is-1-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.enable-bulma .column.is-offset-1-touch{margin-left:8.3333333333%}.enable-bulma .column.is-2-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.enable-bulma .column.is-offset-2-touch{margin-left:16.6666666667%}.enable-bulma .column.is-3-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-offset-3-touch{margin-left:25%}.enable-bulma .column.is-4-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.enable-bulma .column.is-offset-4-touch{margin-left:33.3333333333%}.enable-bulma .column.is-5-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.enable-bulma .column.is-offset-5-touch{margin-left:41.6666666667%}.enable-bulma .column.is-6-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-offset-6-touch{margin-left:50%}.enable-bulma .column.is-7-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.enable-bulma .column.is-offset-7-touch{margin-left:58.3333333333%}.enable-bulma .column.is-8-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.enable-bulma .column.is-offset-8-touch{margin-left:66.6666666667%}.enable-bulma .column.is-9-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-offset-9-touch{margin-left:75%}.enable-bulma .column.is-10-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.enable-bulma .column.is-offset-10-touch{margin-left:83.3333333333%}.enable-bulma .column.is-11-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.enable-bulma .column.is-offset-11-touch{margin-left:91.6666666667%}.enable-bulma .column.is-12-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.enable-bulma .column.is-offset-12-touch{margin-left:100%}}@media screen and (min-width:1024px){.enable-bulma .column.is-full-desktop,.enable-bulma .column.is-narrow-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none}.enable-bulma .column.is-full-desktop{width:100%}.enable-bulma .column.is-three-quarters-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-two-thirds-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.enable-bulma .column.is-half-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-one-third-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.enable-bulma .column.is-one-quarter-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-one-fifth-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.enable-bulma .column.is-two-fifths-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.enable-bulma .column.is-three-fifths-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.enable-bulma .column.is-four-fifths-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.enable-bulma .column.is-offset-three-quarters-desktop{margin-left:75%}.enable-bulma .column.is-offset-two-thirds-desktop{margin-left:66.6666%}.enable-bulma .column.is-offset-half-desktop{margin-left:50%}.enable-bulma .column.is-offset-one-third-desktop{margin-left:33.3333%}.enable-bulma .column.is-offset-one-quarter-desktop{margin-left:25%}.enable-bulma .column.is-offset-one-fifth-desktop{margin-left:20%}.enable-bulma .column.is-offset-two-fifths-desktop{margin-left:40%}.enable-bulma .column.is-offset-three-fifths-desktop{margin-left:60%}.enable-bulma .column.is-offset-four-fifths-desktop{margin-left:80%}.enable-bulma .column.is-0-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:0}.enable-bulma .column.is-offset-0-desktop{margin-left:0}.enable-bulma .column.is-1-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.enable-bulma .column.is-offset-1-desktop{margin-left:8.3333333333%}.enable-bulma .column.is-2-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.enable-bulma .column.is-offset-2-desktop{margin-left:16.6666666667%}.enable-bulma .column.is-3-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-offset-3-desktop{margin-left:25%}.enable-bulma .column.is-4-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.enable-bulma .column.is-offset-4-desktop{margin-left:33.3333333333%}.enable-bulma .column.is-5-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.enable-bulma .column.is-offset-5-desktop{margin-left:41.6666666667%}.enable-bulma .column.is-6-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-offset-6-desktop{margin-left:50%}.enable-bulma .column.is-7-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.enable-bulma .column.is-offset-7-desktop{margin-left:58.3333333333%}.enable-bulma .column.is-8-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.enable-bulma .column.is-offset-8-desktop{margin-left:66.6666666667%}.enable-bulma .column.is-9-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-offset-9-desktop{margin-left:75%}.enable-bulma .column.is-10-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.enable-bulma .column.is-offset-10-desktop{margin-left:83.3333333333%}.enable-bulma .column.is-11-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.enable-bulma .column.is-offset-11-desktop{margin-left:91.6666666667%}.enable-bulma .column.is-12-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.enable-bulma .column.is-offset-12-desktop{margin-left:100%}}@media screen and (min-width:1216px){.enable-bulma .column.is-full-widescreen,.enable-bulma .column.is-narrow-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none}.enable-bulma .column.is-full-widescreen{width:100%}.enable-bulma .column.is-three-quarters-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-two-thirds-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.enable-bulma .column.is-half-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-one-third-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.enable-bulma .column.is-one-quarter-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-one-fifth-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.enable-bulma .column.is-two-fifths-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.enable-bulma .column.is-three-fifths-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.enable-bulma .column.is-four-fifths-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.enable-bulma .column.is-offset-three-quarters-widescreen{margin-left:75%}.enable-bulma .column.is-offset-two-thirds-widescreen{margin-left:66.6666%}.enable-bulma .column.is-offset-half-widescreen{margin-left:50%}.enable-bulma .column.is-offset-one-third-widescreen{margin-left:33.3333%}.enable-bulma .column.is-offset-one-quarter-widescreen{margin-left:25%}.enable-bulma .column.is-offset-one-fifth-widescreen{margin-left:20%}.enable-bulma .column.is-offset-two-fifths-widescreen{margin-left:40%}.enable-bulma .column.is-offset-three-fifths-widescreen{margin-left:60%}.enable-bulma .column.is-offset-four-fifths-widescreen{margin-left:80%}.enable-bulma .column.is-0-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:0}.enable-bulma .column.is-offset-0-widescreen{margin-left:0}.enable-bulma .column.is-1-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.enable-bulma .column.is-offset-1-widescreen{margin-left:8.3333333333%}.enable-bulma .column.is-2-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.enable-bulma .column.is-offset-2-widescreen{margin-left:16.6666666667%}.enable-bulma .column.is-3-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-offset-3-widescreen{margin-left:25%}.enable-bulma .column.is-4-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.enable-bulma .column.is-offset-4-widescreen{margin-left:33.3333333333%}.enable-bulma .column.is-5-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.enable-bulma .column.is-offset-5-widescreen{margin-left:41.6666666667%}.enable-bulma .column.is-6-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-offset-6-widescreen{margin-left:50%}.enable-bulma .column.is-7-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.enable-bulma .column.is-offset-7-widescreen{margin-left:58.3333333333%}.enable-bulma .column.is-8-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.enable-bulma .column.is-offset-8-widescreen{margin-left:66.6666666667%}.enable-bulma .column.is-9-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-offset-9-widescreen{margin-left:75%}.enable-bulma .column.is-10-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.enable-bulma .column.is-offset-10-widescreen{margin-left:83.3333333333%}.enable-bulma .column.is-11-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.enable-bulma .column.is-offset-11-widescreen{margin-left:91.6666666667%}.enable-bulma .column.is-12-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.enable-bulma .column.is-offset-12-widescreen{margin-left:100%}}@media screen and (min-width:1408px){.enable-bulma .column.is-full-fullhd,.enable-bulma .column.is-narrow-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none}.enable-bulma .column.is-full-fullhd{width:100%}.enable-bulma .column.is-three-quarters-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-two-thirds-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.enable-bulma .column.is-half-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-one-third-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.enable-bulma .column.is-one-quarter-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-one-fifth-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.enable-bulma .column.is-two-fifths-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.enable-bulma .column.is-three-fifths-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.enable-bulma .column.is-four-fifths-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.enable-bulma .column.is-offset-three-quarters-fullhd{margin-left:75%}.enable-bulma .column.is-offset-two-thirds-fullhd{margin-left:66.6666%}.enable-bulma .column.is-offset-half-fullhd{margin-left:50%}.enable-bulma .column.is-offset-one-third-fullhd{margin-left:33.3333%}.enable-bulma .column.is-offset-one-quarter-fullhd{margin-left:25%}.enable-bulma .column.is-offset-one-fifth-fullhd{margin-left:20%}.enable-bulma .column.is-offset-two-fifths-fullhd{margin-left:40%}.enable-bulma .column.is-offset-three-fifths-fullhd{margin-left:60%}.enable-bulma .column.is-offset-four-fifths-fullhd{margin-left:80%}.enable-bulma .column.is-0-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:0}.enable-bulma .column.is-offset-0-fullhd{margin-left:0}.enable-bulma .column.is-1-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.enable-bulma .column.is-offset-1-fullhd{margin-left:8.3333333333%}.enable-bulma .column.is-2-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.enable-bulma .column.is-offset-2-fullhd{margin-left:16.6666666667%}.enable-bulma .column.is-3-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .column.is-offset-3-fullhd{margin-left:25%}.enable-bulma .column.is-4-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.enable-bulma .column.is-offset-4-fullhd{margin-left:33.3333333333%}.enable-bulma .column.is-5-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.enable-bulma .column.is-offset-5-fullhd{margin-left:41.6666666667%}.enable-bulma .column.is-6-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .column.is-offset-6-fullhd{margin-left:50%}.enable-bulma .column.is-7-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.enable-bulma .column.is-offset-7-fullhd{margin-left:58.3333333333%}.enable-bulma .column.is-8-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.enable-bulma .column.is-offset-8-fullhd{margin-left:66.6666666667%}.enable-bulma .column.is-9-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .column.is-offset-9-fullhd{margin-left:75%}.enable-bulma .column.is-10-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.enable-bulma .column.is-offset-10-fullhd{margin-left:83.3333333333%}.enable-bulma .column.is-11-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.enable-bulma .column.is-offset-11-fullhd{margin-left:91.6666666667%}.enable-bulma .column.is-12-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.enable-bulma .column.is-offset-12-fullhd{margin-left:100%}}.enable-bulma .columns{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.enable-bulma .columns:last-child{margin-bottom:-.75rem}.enable-bulma .columns:not(:last-child){margin-bottom:.75rem}.enable-bulma .columns.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .columns.is-gapless{margin-left:0;margin-right:0;margin-top:0}.enable-bulma .columns.is-gapless>.column{margin:0;padding:0!important}.enable-bulma .columns.is-gapless:not(:last-child){margin-bottom:1.5rem}.enable-bulma .columns.is-gapless:last-child{margin-bottom:0}.enable-bulma .columns.is-mobile{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .columns.is-multiline{-ms-flex-wrap:wrap;flex-wrap:wrap}.enable-bulma .columns.is-vcentered{-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media print,screen and (min-width:769px){.enable-bulma .columns:not(.is-desktop){display:-webkit-box;display:-ms-flexbox;display:flex}}@media screen and (min-width:1024px){.enable-bulma .columns.is-desktop{display:-webkit-box;display:-ms-flexbox;display:flex}}.enable-bulma .columns.is-variable{--columnGap:0.75rem;margin-left:calc(var(--columnGap)*-1);margin-right:calc(var(--columnGap)*-1)}.enable-bulma .columns.is-variable .column{padding-left:var(--columnGap);padding-right:var(--columnGap)}.enable-bulma .columns.is-variable.is-0{--columnGap:0rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-0-mobile{--columnGap:0rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-0-tablet{--columnGap:0rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-0-tablet-only{--columnGap:0rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-0-touch{--columnGap:0rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-0-desktop{--columnGap:0rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-0-desktop-only{--columnGap:0rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-0-widescreen{--columnGap:0rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-0-widescreen-only{--columnGap:0rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-0-fullhd{--columnGap:0rem}}.enable-bulma .columns.is-variable.is-1{--columnGap:0.25rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-1-mobile{--columnGap:0.25rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-1-tablet{--columnGap:0.25rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-1-tablet-only{--columnGap:0.25rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-1-touch{--columnGap:0.25rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-1-desktop{--columnGap:0.25rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-1-desktop-only{--columnGap:0.25rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-1-widescreen{--columnGap:0.25rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-1-widescreen-only{--columnGap:0.25rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-1-fullhd{--columnGap:0.25rem}}.enable-bulma .columns.is-variable.is-2{--columnGap:0.5rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-2-mobile{--columnGap:0.5rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-2-tablet{--columnGap:0.5rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-2-tablet-only{--columnGap:0.5rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-2-touch{--columnGap:0.5rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-2-desktop{--columnGap:0.5rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-2-desktop-only{--columnGap:0.5rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-2-widescreen{--columnGap:0.5rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-2-widescreen-only{--columnGap:0.5rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-2-fullhd{--columnGap:0.5rem}}.enable-bulma .columns.is-variable.is-3{--columnGap:0.75rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-3-mobile{--columnGap:0.75rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-3-tablet{--columnGap:0.75rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-3-tablet-only{--columnGap:0.75rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-3-touch{--columnGap:0.75rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-3-desktop{--columnGap:0.75rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-3-desktop-only{--columnGap:0.75rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-3-widescreen{--columnGap:0.75rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-3-widescreen-only{--columnGap:0.75rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-3-fullhd{--columnGap:0.75rem}}.enable-bulma .columns.is-variable.is-4{--columnGap:1rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-4-mobile{--columnGap:1rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-4-tablet{--columnGap:1rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-4-tablet-only{--columnGap:1rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-4-touch{--columnGap:1rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-4-desktop{--columnGap:1rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-4-desktop-only{--columnGap:1rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-4-widescreen{--columnGap:1rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-4-widescreen-only{--columnGap:1rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-4-fullhd{--columnGap:1rem}}.enable-bulma .columns.is-variable.is-5{--columnGap:1.25rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-5-mobile{--columnGap:1.25rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-5-tablet{--columnGap:1.25rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-5-tablet-only{--columnGap:1.25rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-5-touch{--columnGap:1.25rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-5-desktop{--columnGap:1.25rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-5-desktop-only{--columnGap:1.25rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-5-widescreen{--columnGap:1.25rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-5-widescreen-only{--columnGap:1.25rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-5-fullhd{--columnGap:1.25rem}}.enable-bulma .columns.is-variable.is-6{--columnGap:1.5rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-6-mobile{--columnGap:1.5rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-6-tablet{--columnGap:1.5rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-6-tablet-only{--columnGap:1.5rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-6-touch{--columnGap:1.5rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-6-desktop{--columnGap:1.5rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-6-desktop-only{--columnGap:1.5rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-6-widescreen{--columnGap:1.5rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-6-widescreen-only{--columnGap:1.5rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-6-fullhd{--columnGap:1.5rem}}.enable-bulma .columns.is-variable.is-7{--columnGap:1.75rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-7-mobile{--columnGap:1.75rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-7-tablet{--columnGap:1.75rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-7-tablet-only{--columnGap:1.75rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-7-touch{--columnGap:1.75rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-7-desktop{--columnGap:1.75rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-7-desktop-only{--columnGap:1.75rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-7-widescreen{--columnGap:1.75rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-7-widescreen-only{--columnGap:1.75rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-7-fullhd{--columnGap:1.75rem}}.enable-bulma .columns.is-variable.is-8{--columnGap:2rem}@media screen and (max-width:768px){.enable-bulma .columns.is-variable.is-8-mobile{--columnGap:2rem}}@media print,screen and (min-width:769px){.enable-bulma .columns.is-variable.is-8-tablet{--columnGap:2rem}}@media screen and (min-width:769px)and (max-width:1023px){.enable-bulma .columns.is-variable.is-8-tablet-only{--columnGap:2rem}}@media screen and (max-width:1023px){.enable-bulma .columns.is-variable.is-8-touch{--columnGap:2rem}}@media screen and (min-width:1024px){.enable-bulma .columns.is-variable.is-8-desktop{--columnGap:2rem}}@media screen and (min-width:1024px)and (max-width:1215px){.enable-bulma .columns.is-variable.is-8-desktop-only{--columnGap:2rem}}@media screen and (min-width:1216px){.enable-bulma .columns.is-variable.is-8-widescreen{--columnGap:2rem}}@media screen and (min-width:1216px)and (max-width:1407px){.enable-bulma .columns.is-variable.is-8-widescreen-only{--columnGap:2rem}}@media screen and (min-width:1408px){.enable-bulma .columns.is-variable.is-8-fullhd{--columnGap:2rem}}.enable-bulma .tile{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:block;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-height:-webkit-min-content;min-height:-moz-min-content;min-height:min-content}.enable-bulma .tile.is-ancestor{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.enable-bulma .tile.is-ancestor:last-child{margin-bottom:-.75rem}.enable-bulma .tile.is-ancestor:not(:last-child){margin-bottom:.75rem}.enable-bulma .tile.is-child{margin:0!important}.enable-bulma .tile.is-parent{padding:.75rem}.enable-bulma .tile.is-vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.enable-bulma .tile.is-vertical>.tile.is-child:not(:last-child){margin-bottom:1.5rem!important}@media print,screen and (min-width:769px){.enable-bulma .tile:not(.is-child){display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .tile.is-1{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.3333333333%}.enable-bulma .tile.is-2{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.6666666667%}.enable-bulma .tile.is-3{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.enable-bulma .tile.is-4{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333333333%}.enable-bulma .tile.is-5{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.6666666667%}.enable-bulma .tile.is-6{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.enable-bulma .tile.is-7{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.3333333333%}.enable-bulma .tile.is-8{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666666667%}.enable-bulma .tile.is-9{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.enable-bulma .tile.is-10{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.3333333333%}.enable-bulma .tile.is-11{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.6666666667%}.enable-bulma .tile.is-12{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}}.enable-bulma .hero{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.enable-bulma .hero .navbar{background:none}.enable-bulma .hero .tabs ul{border-bottom:none}.enable-bulma .hero.is-white{background-color:#fff;color:#0a0a0a}.enable-bulma .hero.is-white a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-white strong{color:inherit}.enable-bulma .hero.is-white .title{color:#0a0a0a}.enable-bulma .hero.is-white .subtitle{color:rgba(10,10,10,.9)}.enable-bulma .hero.is-white .subtitle a:not(.button),.enable-bulma .hero.is-white .subtitle strong{color:#0a0a0a}@media screen and (max-width:1023px){.enable-bulma .hero.is-white .navbar-menu{background-color:#fff}}.enable-bulma .hero.is-white .navbar-item,.enable-bulma .hero.is-white .navbar-link{color:rgba(10,10,10,.7)}.enable-bulma .hero.is-white .navbar-link.is-active,.enable-bulma .hero.is-white .navbar-link:hover,.enable-bulma .hero.is-white a.navbar-item.is-active,.enable-bulma .hero.is-white a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.enable-bulma .hero.is-white .tabs a{color:#0a0a0a;opacity:.9}.enable-bulma .hero.is-white .tabs a:hover{opacity:1}.enable-bulma .hero.is-white .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-white .tabs.is-boxed a,.enable-bulma .hero.is-white .tabs.is-toggle a{color:#0a0a0a}.enable-bulma .hero.is-white .tabs.is-boxed a:hover,.enable-bulma .hero.is-white .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-white .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-white .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-white .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-white .tabs.is-toggle li.is-active a:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.enable-bulma .hero.is-white.is-bold{background-image:linear-gradient(141deg,#e8e3e4,#fff 71%,#fff)}@media screen and (max-width:768px){.enable-bulma .hero.is-white.is-bold .navbar-menu{background-image:linear-gradient(141deg,#e8e3e4,#fff 71%,#fff)}}.enable-bulma .hero.is-black{background-color:#0a0a0a;color:#fff}.enable-bulma .hero.is-black a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-black strong{color:inherit}.enable-bulma .hero.is-black .title{color:#fff}.enable-bulma .hero.is-black .subtitle{color:hsla(0,0%,100%,.9)}.enable-bulma .hero.is-black .subtitle a:not(.button),.enable-bulma .hero.is-black .subtitle strong{color:#fff}@media screen and (max-width:1023px){.enable-bulma .hero.is-black .navbar-menu{background-color:#0a0a0a}}.enable-bulma .hero.is-black .navbar-item,.enable-bulma .hero.is-black .navbar-link{color:hsla(0,0%,100%,.7)}.enable-bulma .hero.is-black .navbar-link.is-active,.enable-bulma .hero.is-black .navbar-link:hover,.enable-bulma .hero.is-black a.navbar-item.is-active,.enable-bulma .hero.is-black a.navbar-item:hover{background-color:#000;color:#fff}.enable-bulma .hero.is-black .tabs a{color:#fff;opacity:.9}.enable-bulma .hero.is-black .tabs a:hover{opacity:1}.enable-bulma .hero.is-black .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-black .tabs.is-boxed a,.enable-bulma .hero.is-black .tabs.is-toggle a{color:#fff}.enable-bulma .hero.is-black .tabs.is-boxed a:hover,.enable-bulma .hero.is-black .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-black .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-black .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-black .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-black .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.enable-bulma .hero.is-black.is-bold{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}@media screen and (max-width:768px){.enable-bulma .hero.is-black.is-bold .navbar-menu{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}}.enable-bulma .hero.is-light{background-color:#f5f5f5;color:#363636}.enable-bulma .hero.is-light a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-light strong{color:inherit}.enable-bulma .hero.is-light .title{color:#363636}.enable-bulma .hero.is-light .subtitle{color:rgba(54,54,54,.9)}.enable-bulma .hero.is-light .subtitle a:not(.button),.enable-bulma .hero.is-light .subtitle strong{color:#363636}@media screen and (max-width:1023px){.enable-bulma .hero.is-light .navbar-menu{background-color:#f5f5f5}}.enable-bulma .hero.is-light .navbar-item,.enable-bulma .hero.is-light .navbar-link{color:rgba(54,54,54,.7)}.enable-bulma .hero.is-light .navbar-link.is-active,.enable-bulma .hero.is-light .navbar-link:hover,.enable-bulma .hero.is-light a.navbar-item.is-active,.enable-bulma .hero.is-light a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.enable-bulma .hero.is-light .tabs a{color:#363636;opacity:.9}.enable-bulma .hero.is-light .tabs a:hover{opacity:1}.enable-bulma .hero.is-light .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-light .tabs.is-boxed a,.enable-bulma .hero.is-light .tabs.is-toggle a{color:#363636}.enable-bulma .hero.is-light .tabs.is-boxed a:hover,.enable-bulma .hero.is-light .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-light .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-light .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-light .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-light .tabs.is-toggle li.is-active a:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.enable-bulma .hero.is-light.is-bold{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}@media screen and (max-width:768px){.enable-bulma .hero.is-light.is-bold .navbar-menu{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}}.enable-bulma .hero.is-dark{background-color:#363636;color:#f5f5f5}.enable-bulma .hero.is-dark a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-dark strong{color:inherit}.enable-bulma .hero.is-dark .title{color:#f5f5f5}.enable-bulma .hero.is-dark .subtitle{color:hsla(0,0%,96.1%,.9)}.enable-bulma .hero.is-dark .subtitle a:not(.button),.enable-bulma .hero.is-dark .subtitle strong{color:#f5f5f5}@media screen and (max-width:1023px){.enable-bulma .hero.is-dark .navbar-menu{background-color:#363636}}.enable-bulma .hero.is-dark .navbar-item,.enable-bulma .hero.is-dark .navbar-link{color:hsla(0,0%,96.1%,.7)}.enable-bulma .hero.is-dark .navbar-link.is-active,.enable-bulma .hero.is-dark .navbar-link:hover,.enable-bulma .hero.is-dark a.navbar-item.is-active,.enable-bulma .hero.is-dark a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.enable-bulma .hero.is-dark .tabs a{color:#f5f5f5;opacity:.9}.enable-bulma .hero.is-dark .tabs a:hover{opacity:1}.enable-bulma .hero.is-dark .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-dark .tabs.is-boxed a,.enable-bulma .hero.is-dark .tabs.is-toggle a{color:#f5f5f5}.enable-bulma .hero.is-dark .tabs.is-boxed a:hover,.enable-bulma .hero.is-dark .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-dark .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-dark .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-dark .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-dark .tabs.is-toggle li.is-active a:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.enable-bulma .hero.is-dark.is-bold{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}@media screen and (max-width:768px){.enable-bulma .hero.is-dark.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}}.enable-bulma .hero.is-primary{background-color:#3273dc;color:#fff}.enable-bulma .hero.is-primary a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-primary strong{color:inherit}.enable-bulma .hero.is-primary .title{color:#fff}.enable-bulma .hero.is-primary .subtitle{color:hsla(0,0%,100%,.9)}.enable-bulma .hero.is-primary .subtitle a:not(.button),.enable-bulma .hero.is-primary .subtitle strong{color:#fff}@media screen and (max-width:1023px){.enable-bulma .hero.is-primary .navbar-menu{background-color:#3273dc}}.enable-bulma .hero.is-primary .navbar-item,.enable-bulma .hero.is-primary .navbar-link{color:hsla(0,0%,100%,.7)}.enable-bulma .hero.is-primary .navbar-link.is-active,.enable-bulma .hero.is-primary .navbar-link:hover,.enable-bulma .hero.is-primary a.navbar-item.is-active,.enable-bulma .hero.is-primary a.navbar-item:hover{background-color:#2466d1;color:#fff}.enable-bulma .hero.is-primary .tabs a{color:#fff;opacity:.9}.enable-bulma .hero.is-primary .tabs a:hover{opacity:1}.enable-bulma .hero.is-primary .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-primary .tabs.is-boxed a,.enable-bulma .hero.is-primary .tabs.is-toggle a{color:#fff}.enable-bulma .hero.is-primary .tabs.is-boxed a:hover,.enable-bulma .hero.is-primary .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-primary .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-primary .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-primary .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-primary .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#3273dc}.enable-bulma .hero.is-primary.is-bold{background-image:linear-gradient(141deg,#1576c6,#3273dc 71%,#4266e5)}@media screen and (max-width:768px){.enable-bulma .hero.is-primary.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1576c6,#3273dc 71%,#4266e5)}}.enable-bulma .hero.is-link{background-color:#3273dc;color:#fff}.enable-bulma .hero.is-link a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-link strong{color:inherit}.enable-bulma .hero.is-link .title{color:#fff}.enable-bulma .hero.is-link .subtitle{color:hsla(0,0%,100%,.9)}.enable-bulma .hero.is-link .subtitle a:not(.button),.enable-bulma .hero.is-link .subtitle strong{color:#fff}@media screen and (max-width:1023px){.enable-bulma .hero.is-link .navbar-menu{background-color:#3273dc}}.enable-bulma .hero.is-link .navbar-item,.enable-bulma .hero.is-link .navbar-link{color:hsla(0,0%,100%,.7)}.enable-bulma .hero.is-link .navbar-link.is-active,.enable-bulma .hero.is-link .navbar-link:hover,.enable-bulma .hero.is-link a.navbar-item.is-active,.enable-bulma .hero.is-link a.navbar-item:hover{background-color:#2366d1;color:#fff}.enable-bulma .hero.is-link .tabs a{color:#fff;opacity:.9}.enable-bulma .hero.is-link .tabs a:hover{opacity:1}.enable-bulma .hero.is-link .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-link .tabs.is-boxed a,.enable-bulma .hero.is-link .tabs.is-toggle a{color:#fff}.enable-bulma .hero.is-link .tabs.is-boxed a:hover,.enable-bulma .hero.is-link .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-link .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-link .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-link .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-link .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#3273dc}.enable-bulma .hero.is-link.is-bold{background-image:linear-gradient(141deg,#1577c6,#3273dc 71%,#4366e5)}@media screen and (max-width:768px){.enable-bulma .hero.is-link.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1577c6,#3273dc 71%,#4366e5)}}.enable-bulma .hero.is-info{background-color:#209cee;color:#fff}.enable-bulma .hero.is-info a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-info strong{color:inherit}.enable-bulma .hero.is-info .title{color:#fff}.enable-bulma .hero.is-info .subtitle{color:hsla(0,0%,100%,.9)}.enable-bulma .hero.is-info .subtitle a:not(.button),.enable-bulma .hero.is-info .subtitle strong{color:#fff}@media screen and (max-width:1023px){.enable-bulma .hero.is-info .navbar-menu{background-color:#209cee}}.enable-bulma .hero.is-info .navbar-item,.enable-bulma .hero.is-info .navbar-link{color:hsla(0,0%,100%,.7)}.enable-bulma .hero.is-info .navbar-link.is-active,.enable-bulma .hero.is-info .navbar-link:hover,.enable-bulma .hero.is-info a.navbar-item.is-active,.enable-bulma .hero.is-info a.navbar-item:hover{background-color:#118fe4;color:#fff}.enable-bulma .hero.is-info .tabs a{color:#fff;opacity:.9}.enable-bulma .hero.is-info .tabs a:hover{opacity:1}.enable-bulma .hero.is-info .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-info .tabs.is-boxed a,.enable-bulma .hero.is-info .tabs.is-toggle a{color:#fff}.enable-bulma .hero.is-info .tabs.is-boxed a:hover,.enable-bulma .hero.is-info .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-info .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-info .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-info .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-info .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#209cee}.enable-bulma .hero.is-info.is-bold{background-image:linear-gradient(141deg,#04a6d7,#209cee 71%,#3287f5)}@media screen and (max-width:768px){.enable-bulma .hero.is-info.is-bold .navbar-menu{background-image:linear-gradient(141deg,#04a6d7,#209cee 71%,#3287f5)}}.enable-bulma .hero.is-success{background-color:#23d160;color:#fff}.enable-bulma .hero.is-success a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-success strong{color:inherit}.enable-bulma .hero.is-success .title{color:#fff}.enable-bulma .hero.is-success .subtitle{color:hsla(0,0%,100%,.9)}.enable-bulma .hero.is-success .subtitle a:not(.button),.enable-bulma .hero.is-success .subtitle strong{color:#fff}@media screen and (max-width:1023px){.enable-bulma .hero.is-success .navbar-menu{background-color:#23d160}}.enable-bulma .hero.is-success .navbar-item,.enable-bulma .hero.is-success .navbar-link{color:hsla(0,0%,100%,.7)}.enable-bulma .hero.is-success .navbar-link.is-active,.enable-bulma .hero.is-success .navbar-link:hover,.enable-bulma .hero.is-success a.navbar-item.is-active,.enable-bulma .hero.is-success a.navbar-item:hover{background-color:#20bc56;color:#fff}.enable-bulma .hero.is-success .tabs a{color:#fff;opacity:.9}.enable-bulma .hero.is-success .tabs a:hover{opacity:1}.enable-bulma .hero.is-success .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-success .tabs.is-boxed a,.enable-bulma .hero.is-success .tabs.is-toggle a{color:#fff}.enable-bulma .hero.is-success .tabs.is-boxed a:hover,.enable-bulma .hero.is-success .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-success .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-success .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-success .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-success .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#23d160}.enable-bulma .hero.is-success.is-bold{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}@media screen and (max-width:768px){.enable-bulma .hero.is-success.is-bold .navbar-menu{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}}.enable-bulma .hero.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .hero.is-warning a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-warning strong{color:inherit}.enable-bulma .hero.is-warning .title{color:rgba(0,0,0,.7)}.enable-bulma .hero.is-warning .subtitle{color:rgba(0,0,0,.9)}.enable-bulma .hero.is-warning .subtitle a:not(.button),.enable-bulma .hero.is-warning .subtitle strong{color:rgba(0,0,0,.7)}@media screen and (max-width:1023px){.enable-bulma .hero.is-warning .navbar-menu{background-color:#ffdd57}}.enable-bulma .hero.is-warning .navbar-item,.enable-bulma .hero.is-warning .navbar-link{color:rgba(0,0,0,.7)}.enable-bulma .hero.is-warning .navbar-link.is-active,.enable-bulma .hero.is-warning .navbar-link:hover,.enable-bulma .hero.is-warning a.navbar-item.is-active,.enable-bulma .hero.is-warning a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.enable-bulma .hero.is-warning .tabs a{color:rgba(0,0,0,.7);opacity:.9}.enable-bulma .hero.is-warning .tabs a:hover{opacity:1}.enable-bulma .hero.is-warning .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-warning .tabs.is-boxed a,.enable-bulma .hero.is-warning .tabs.is-toggle a{color:rgba(0,0,0,.7)}.enable-bulma .hero.is-warning .tabs.is-boxed a:hover,.enable-bulma .hero.is-warning .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-warning .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-warning .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-warning .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-warning .tabs.is-toggle li.is-active a:hover{background-color:rgba(0,0,0,.7);border-color:rgba(0,0,0,.7);color:#ffdd57}.enable-bulma .hero.is-warning.is-bold{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}@media screen and (max-width:768px){.enable-bulma .hero.is-warning.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}}.enable-bulma .hero.is-danger{background-color:#ff3860;color:#fff}.enable-bulma .hero.is-danger a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.enable-bulma .hero.is-danger strong{color:inherit}.enable-bulma .hero.is-danger .title{color:#fff}.enable-bulma .hero.is-danger .subtitle{color:hsla(0,0%,100%,.9)}.enable-bulma .hero.is-danger .subtitle a:not(.button),.enable-bulma .hero.is-danger .subtitle strong{color:#fff}@media screen and (max-width:1023px){.enable-bulma .hero.is-danger .navbar-menu{background-color:#ff3860}}.enable-bulma .hero.is-danger .navbar-item,.enable-bulma .hero.is-danger .navbar-link{color:hsla(0,0%,100%,.7)}.enable-bulma .hero.is-danger .navbar-link.is-active,.enable-bulma .hero.is-danger .navbar-link:hover,.enable-bulma .hero.is-danger a.navbar-item.is-active,.enable-bulma .hero.is-danger a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.enable-bulma .hero.is-danger .tabs a{color:#fff;opacity:.9}.enable-bulma .hero.is-danger .tabs a:hover{opacity:1}.enable-bulma .hero.is-danger .tabs li.is-active a{opacity:1}.enable-bulma .hero.is-danger .tabs.is-boxed a,.enable-bulma .hero.is-danger .tabs.is-toggle a{color:#fff}.enable-bulma .hero.is-danger .tabs.is-boxed a:hover,.enable-bulma .hero.is-danger .tabs.is-toggle a:hover{background-color:rgba(10,10,10,.1)}.enable-bulma .hero.is-danger .tabs.is-boxed li.is-active a,.enable-bulma .hero.is-danger .tabs.is-boxed li.is-active a:hover,.enable-bulma .hero.is-danger .tabs.is-toggle li.is-active a,.enable-bulma .hero.is-danger .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#ff3860}.enable-bulma .hero.is-danger.is-bold{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}@media screen and (max-width:768px){.enable-bulma .hero.is-danger.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}}.enable-bulma .hero.is-small .hero-body{padding-bottom:1.5rem;padding-top:1.5rem}@media print,screen and (min-width:769px){.enable-bulma .hero.is-medium .hero-body{padding-bottom:9rem;padding-top:9rem}}@media print,screen and (min-width:769px){.enable-bulma .hero.is-large .hero-body{padding-bottom:18rem;padding-top:18rem}}.enable-bulma .hero.is-fullheight-with-navbar .hero-body,.enable-bulma .hero.is-fullheight .hero-body,.enable-bulma .hero.is-halfheight .hero-body{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .hero.is-fullheight-with-navbar .hero-body>.container,.enable-bulma .hero.is-fullheight .hero-body>.container,.enable-bulma .hero.is-halfheight .hero-body>.container{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .hero.is-halfheight{min-height:50vh}.enable-bulma .hero.is-fullheight{min-height:100vh}.enable-bulma .hero-video{overflow:hidden}.enable-bulma .hero-video video{left:50%;min-height:100%;min-width:100%;position:absolute;top:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.enable-bulma .hero-video.is-transparent{opacity:.3}@media screen and (max-width:768px){.enable-bulma .hero-video{display:none}}.enable-bulma .hero-buttons{margin-top:1.5rem}@media screen and (max-width:768px){.enable-bulma .hero-buttons .button{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .hero-buttons .button:not(:last-child){margin-bottom:.75rem}}@media print,screen and (min-width:769px){.enable-bulma .hero-buttons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .hero-buttons .button:not(:last-child){margin-right:1.5rem}}.enable-bulma .hero-foot,.enable-bulma .hero-head{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .hero-body{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;padding:3rem 1.5rem}.enable-bulma .section{padding:3rem 1.5rem}@media screen and (min-width:1024px){.enable-bulma .section.is-medium{padding:9rem 1.5rem}.enable-bulma .section.is-large{padding:18rem 1.5rem}}.enable-bulma .footer{background-color:#fafafa;padding:3rem 1.5rem 6rem}.enable-bulma .is-noscroll{position:fixed;overflow-y:hidden;width:100%;bottom:0}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.enable-bulma .fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.enable-bulma .fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.enable-bulma .fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.enable-bulma .fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.enable-bulma .fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.enable-bulma .fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}.enable-bulma .fade-enter-active,.enable-bulma .fade-leave-active{-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out}.enable-bulma .fade-enter,.enable-bulma .fade-leave-to{opacity:0}.enable-bulma .zoom-in-enter-active,.enable-bulma .zoom-in-leave-active{-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out}.enable-bulma .zoom-in-enter-active .animation-content,.enable-bulma .zoom-in-leave-active .animation-content{-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out}.enable-bulma .zoom-in-enter,.enable-bulma .zoom-in-leave-active{opacity:0}.enable-bulma .zoom-in-enter .animation-content,.enable-bulma .zoom-in-leave-active .animation-content{-webkit-transform:scale(.95);transform:scale(.95)}.enable-bulma .zoom-out-enter-active,.enable-bulma .zoom-out-leave-active{-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out}.enable-bulma .zoom-out-enter-active .animation-content,.enable-bulma .zoom-out-leave-active .animation-content{-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out}.enable-bulma .zoom-out-enter,.enable-bulma .zoom-out-leave-active{opacity:0}.enable-bulma .zoom-out-enter .animation-content,.enable-bulma .zoom-out-leave-active .animation-content{-webkit-transform:scale(1.05);transform:scale(1.05)}.enable-bulma .slide-next-enter-active,.enable-bulma .slide-next-leave-active,.enable-bulma .slide-prev-enter-active,.enable-bulma .slide-prev-leave-active{-webkit-transition:-webkit-transform .25s cubic-bezier(.785,.135,.15,.86);transition:-webkit-transform .25s cubic-bezier(.785,.135,.15,.86);transition:transform .25s cubic-bezier(.785,.135,.15,.86);transition:transform .25s cubic-bezier(.785,.135,.15,.86),-webkit-transform .25s cubic-bezier(.785,.135,.15,.86)}.enable-bulma .slide-next-enter,.enable-bulma .slide-prev-leave-to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);position:absolute;width:100%}.enable-bulma .slide-next-leave-to,.enable-bulma .slide-prev-enter{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);position:absolute;width:100%}.enable-bulma .slide-down-enter-active,.enable-bulma .slide-down-leave-active,.enable-bulma .slide-up-enter-active,.enable-bulma .slide-up-leave-active{-webkit-transition:-webkit-transform .25s cubic-bezier(.785,.135,.15,.86);transition:-webkit-transform .25s cubic-bezier(.785,.135,.15,.86);transition:transform .25s cubic-bezier(.785,.135,.15,.86);transition:transform .25s cubic-bezier(.785,.135,.15,.86),-webkit-transform .25s cubic-bezier(.785,.135,.15,.86)}.enable-bulma .slide-down-enter,.enable-bulma .slide-up-leave-to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);position:absolute;height:100%}.enable-bulma .slide-down-leave-to,.enable-bulma .slide-up-enter{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);position:absolute;height:100%}.enable-bulma .slide-enter-active,.enable-bulma .slide-leave-active{-webkit-transition:.15s ease-out;transition:.15s ease-out}.enable-bulma .slide-leave-active{-webkit-transition-timing-function:cubic-bezier(0,1,.5,1);transition-timing-function:cubic-bezier(0,1,.5,1)}.enable-bulma .slide-enter-to,.enable-bulma .slide-leave{max-height:100px;overflow:hidden}.enable-bulma .slide-enter,.enable-bulma .slide-leave-to{overflow:hidden;max-height:0}.enable-bulma .autocomplete{position:relative}.enable-bulma .autocomplete .dropdown-menu{display:block;min-width:100%;max-width:100%}.enable-bulma .autocomplete .dropdown-menu.is-opened-top{top:auto;bottom:100%}.enable-bulma .autocomplete .dropdown-content{overflow:auto;max-height:200px}.enable-bulma .autocomplete .dropdown-item,.enable-bulma .autocomplete .dropdown .dropdown-menu .has-link a,.enable-bulma .dropdown .dropdown-menu .has-link .autocomplete a{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.enable-bulma .autocomplete .dropdown-item.is-hovered,.enable-bulma .autocomplete .dropdown .dropdown-menu .has-link a.is-hovered,.enable-bulma .dropdown .dropdown-menu .has-link .autocomplete a.is-hovered{background:#f5f5f5;color:#0a0a0a}.enable-bulma .autocomplete .dropdown-item.is-disabled,.enable-bulma .autocomplete .dropdown .dropdown-menu .has-link a.is-disabled,.enable-bulma .dropdown .dropdown-menu .has-link .autocomplete a.is-disabled{opacity:.5;cursor:not-allowed}.enable-bulma .autocomplete.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .autocomplete.is-medium{font-size:1.25rem}.enable-bulma .autocomplete.is-large{font-size:1.5rem}.enable-bulma .carousel{min-height:120px;position:relative}.enable-bulma .carousel.is-overlay{background-color:rgba(10,10,10,.86);-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;max-height:100vh;position:fixed;z-index:40}.enable-bulma .carousel.is-overlay .carousel-item img{cursor:default}.enable-bulma .carousel.is-overlay .carousel-indicator.has-background{background:transparent}.enable-bulma .carousel .progress{border-radius:2px;height:.25rem;margin-bottom:0}.enable-bulma .carousel .carousel-items{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden;width:100%}@media print,screen and (min-width:769px){.enable-bulma .carousel .carousel-items:hover .carousel-arrow.is-hovered{opacity:1}}.enable-bulma .carousel .carousel-items .carousel-item{-ms-flex-negative:0;flex-shrink:0;width:100%}.enable-bulma .carousel .carousel-pause{pointer-events:none;position:absolute;top:0;right:.15rem;z-index:1}.enable-bulma .carousel .carousel-indicator{width:100%;padding:.5rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .carousel .carousel-indicator.has-background{background:rgba(10,10,10,.5)}.enable-bulma .carousel .carousel-indicator.has-custom{-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-overflow-scrolling:touch;overflow:hidden;overflow-x:auto}.enable-bulma .carousel .carousel-indicator.has-custom.is-small .indicator-item{-webkit-box-flex:1;-ms-flex:1 0 10%;flex:1 0 10%}.enable-bulma .carousel .carousel-indicator.has-custom.is-medium .indicator-item{-webkit-box-flex:1;-ms-flex:1 0 16.66667%;flex:1 0 16.66667%}.enable-bulma .carousel .carousel-indicator.is-inside{position:absolute}.enable-bulma .carousel .carousel-indicator.is-inside.is-bottom{bottom:0}.enable-bulma .carousel .carousel-indicator.is-inside.is-top{top:0}.enable-bulma .carousel .carousel-indicator .indicator-item:not(:last-child){margin-right:.5rem}.enable-bulma .carousel .carousel-indicator .indicator-item .indicator-style:hover,.enable-bulma .carousel .carousel-indicator .indicator-item.is-active .indicator-style{background:#3273dc;border:1px solid #fff}.enable-bulma .carousel .carousel-indicator .indicator-item .indicator-style{display:block;border:1px solid #3273dc;background:#fff;outline:none;-webkit-transition:.15s ease-out;transition:.15s ease-out}.enable-bulma .carousel .carousel-indicator .indicator-item .indicator-style.is-boxes{height:10px;width:10px}.enable-bulma .carousel .carousel-indicator .indicator-item .indicator-style.is-dots{border-radius:10px;height:10px;width:10px}.enable-bulma .carousel .carousel-indicator .indicator-item .indicator-style.is-lines{height:5px;width:25px}.enable-bulma .carousel-list{position:relative;overflow:hidden;width:100%}.enable-bulma .carousel-list.has-shadow{-webkit-box-shadow:0 0 10px rgba(0,0,0,.25);box-shadow:0 0 10px rgba(0,0,0,.25)}@media print,screen and (min-width:769px){.enable-bulma .carousel-list:hover .carousel-arrow.is-hovered{opacity:1}}.enable-bulma .carousel-list .carousel-slides{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.enable-bulma .carousel-list .carousel-slides:not(.is-dragging){-webkit-transition:all .25s ease-out 0s;transition:all .25s ease-out 0s}.enable-bulma .carousel-list .carousel-slides.has-grayscale .carousel-slide img{-webkit-filter:grayscale(100%);filter:grayscale(100%)}.enable-bulma .carousel-list .carousel-slides.has-grayscale .carousel-slide.is-active img{-webkit-filter:grayscale(0);filter:grayscale(0)}.enable-bulma .carousel-list .carousel-slides.has-opacity .carousel-slide img{opacity:.25}.enable-bulma .carousel-list .carousel-slides.has-opacity .carousel-slide.is-active img{opacity:1}.enable-bulma .carousel-list .carousel-slides .carousel-slide{border:2px solid transparent;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .carousel-arrow{-webkit-transition:.15s ease-out;transition:.15s ease-out}.enable-bulma .carousel-arrow.is-hovered{opacity:0}.enable-bulma .carousel-arrow .icon{background:#fff;color:#3273dc;cursor:pointer;border:1px solid #fff;border-radius:290486px;outline:0}.enable-bulma .carousel-arrow .icon:hover{border:1px solid #3273dc;opacity:1}.enable-bulma .carousel-arrow .icon.has-icons-left,.enable-bulma .carousel-arrow .icon.has-icons-right{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);z-index:1}.enable-bulma .carousel-arrow .icon.has-icons-left{left:1.5rem}.enable-bulma .carousel-arrow .icon.has-icons-right{right:1.5rem}.enable-bulma .b-checkbox.checkbox{outline:none;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.enable-bulma .b-checkbox.checkbox:not(.button){margin-right:.5em}.enable-bulma .b-checkbox.checkbox:not(.button)+.checkbox:last-child{margin-right:0}.enable-bulma .b-checkbox.checkbox input[type=checkbox]{position:absolute;left:0;opacity:0;outline:none;z-index:-1}.enable-bulma .b-checkbox.checkbox input[type=checkbox]+.check{width:1.25em;height:1.25em;-ms-flex-negative:0;flex-shrink:0;border-radius:4px;border:2px solid #7a7a7a;-webkit-transition:background .15s ease-out;transition:background .15s ease-out;background:transparent}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check{background:#3273dc url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#3273dc}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-white{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%230a0a0a'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#fff}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-black{background:#0a0a0a url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#0a0a0a}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-light{background:#f5f5f5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23363636'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#f5f5f5}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-dark{background:#363636 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23f5f5f5'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#363636}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-primary{background:#3273dc url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#3273dc}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-link{background:#3273dc url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#3273dc}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-info{background:#209cee url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#209cee}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-success{background:#23d160 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#23d160}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-warning{background:#ffdd57 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='rgba(0,0,0,.7)'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ffdd57}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:checked+.check.is-danger{background:#ff3860 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ff3860}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check{background:#3273dc url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#3273dc}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-white{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%230a0a0a' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#fff}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-black{background:#0a0a0a url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#0a0a0a}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-light{background:#f5f5f5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23363636' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#f5f5f5}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-dark{background:#363636 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23f5f5f5' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#363636}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-primary{background:#3273dc url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#3273dc}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-link{background:#3273dc url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#3273dc}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-info{background:#209cee url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#209cee}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-success{background:#23d160 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#23d160}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-warning{background:#ffdd57 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='rgba(0,0,0,.7)' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ffdd57}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:indeterminate+.check.is-danger{background:#ff3860 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23fff' d='M.15.4h.7v.2h-.7z'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ff3860}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus+.check{-webkit-box-shadow:0 0 .5em hsla(0,0%,47.8%,.8);box-shadow:0 0 .5em hsla(0,0%,47.8%,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-white{-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.8);box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-black{-webkit-box-shadow:0 0 .5em rgba(10,10,10,.8);box-shadow:0 0 .5em rgba(10,10,10,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-light{-webkit-box-shadow:0 0 .5em hsla(0,0%,96.1%,.8);box-shadow:0 0 .5em hsla(0,0%,96.1%,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-dark{-webkit-box-shadow:0 0 .5em rgba(54,54,54,.8);box-shadow:0 0 .5em rgba(54,54,54,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-primary{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-link{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-info{-webkit-box-shadow:0 0 .5em rgba(32,156,238,.8);box-shadow:0 0 .5em rgba(32,156,238,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-success{-webkit-box-shadow:0 0 .5em rgba(35,209,96,.8);box-shadow:0 0 .5em rgba(35,209,96,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-warning{-webkit-box-shadow:0 0 .5em rgba(255,221,87,.8);box-shadow:0 0 .5em rgba(255,221,87,.8)}.enable-bulma .b-checkbox.checkbox input[type=checkbox]:focus:checked+.check.is-danger{-webkit-box-shadow:0 0 .5em rgba(255,56,96,.8);box-shadow:0 0 .5em rgba(255,56,96,.8)}.enable-bulma .b-checkbox.checkbox .control-label{padding-left:.5em}.enable-bulma .b-checkbox.checkbox.button{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .b-checkbox.checkbox[disabled]{opacity:.5}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check{border-color:#3273dc}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-white{border-color:#fff}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-black{border-color:#0a0a0a}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-light{border-color:#f5f5f5}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-dark{border-color:#363636}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-primary{border-color:#3273dc}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-link{border-color:#3273dc}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-info{border-color:#209cee}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-success{border-color:#23d160}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-warning{border-color:#ffdd57}.enable-bulma .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled)+.check.is-danger{border-color:#ff3860}.enable-bulma .b-checkbox.checkbox.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .b-checkbox.checkbox.is-medium{font-size:1.25rem}.enable-bulma .b-checkbox.checkbox.is-large{font-size:1.5rem}.enable-bulma .b-clockpicker .card-header{background-color:#3273dc;color:#fff}.enable-bulma .b-clockpicker .b-clockpicker-face:after{background-color:#3273dc}.enable-bulma .b-clockpicker .b-clockpicker-face-hand{background-color:#3273dc;border-color:#3273dc}.enable-bulma .b-clockpicker .b-clockpicker-face-number.active{background-color:#3273dc;color:#fff}.enable-bulma .b-clockpicker.is-white .card-header{background-color:#fff;color:#0a0a0a}.enable-bulma .b-clockpicker.is-white .b-clockpicker-face:after{background-color:#fff}.enable-bulma .b-clockpicker.is-white .b-clockpicker-face-hand{background-color:#fff;border-color:#fff}.enable-bulma .b-clockpicker.is-white .b-clockpicker-face-number.active{background-color:#fff;color:#0a0a0a}.enable-bulma .b-clockpicker.is-black .card-header{background-color:#0a0a0a;color:#fff}.enable-bulma .b-clockpicker.is-black .b-clockpicker-face:after{background-color:#0a0a0a}.enable-bulma .b-clockpicker.is-black .b-clockpicker-face-hand{background-color:#0a0a0a;border-color:#0a0a0a}.enable-bulma .b-clockpicker.is-black .b-clockpicker-face-number.active{background-color:#0a0a0a;color:#fff}.enable-bulma .b-clockpicker.is-light .card-header{background-color:#f5f5f5;color:#363636}.enable-bulma .b-clockpicker.is-light .b-clockpicker-face:after{background-color:#f5f5f5}.enable-bulma .b-clockpicker.is-light .b-clockpicker-face-hand{background-color:#f5f5f5;border-color:#f5f5f5}.enable-bulma .b-clockpicker.is-light .b-clockpicker-face-number.active{background-color:#f5f5f5;color:#363636}.enable-bulma .b-clockpicker.is-dark .card-header{background-color:#363636;color:#f5f5f5}.enable-bulma .b-clockpicker.is-dark .b-clockpicker-face:after{background-color:#363636}.enable-bulma .b-clockpicker.is-dark .b-clockpicker-face-hand{background-color:#363636;border-color:#363636}.enable-bulma .b-clockpicker.is-dark .b-clockpicker-face-number.active{background-color:#363636;color:#f5f5f5}.enable-bulma .b-clockpicker.is-primary .card-header{background-color:#3273dc;color:#fff}.enable-bulma .b-clockpicker.is-primary .b-clockpicker-face:after{background-color:#3273dc}.enable-bulma .b-clockpicker.is-primary .b-clockpicker-face-hand{background-color:#3273dc;border-color:#3273dc}.enable-bulma .b-clockpicker.is-link .card-header,.enable-bulma .b-clockpicker.is-primary .b-clockpicker-face-number.active{background-color:#3273dc;color:#fff}.enable-bulma .b-clockpicker.is-link .b-clockpicker-face:after{background-color:#3273dc}.enable-bulma .b-clockpicker.is-link .b-clockpicker-face-hand{background-color:#3273dc;border-color:#3273dc}.enable-bulma .b-clockpicker.is-link .b-clockpicker-face-number.active{background-color:#3273dc;color:#fff}.enable-bulma .b-clockpicker.is-info .card-header{background-color:#209cee;color:#fff}.enable-bulma .b-clockpicker.is-info .b-clockpicker-face:after{background-color:#209cee}.enable-bulma .b-clockpicker.is-info .b-clockpicker-face-hand{background-color:#209cee;border-color:#209cee}.enable-bulma .b-clockpicker.is-info .b-clockpicker-face-number.active{background-color:#209cee;color:#fff}.enable-bulma .b-clockpicker.is-success .card-header{background-color:#23d160;color:#fff}.enable-bulma .b-clockpicker.is-success .b-clockpicker-face:after{background-color:#23d160}.enable-bulma .b-clockpicker.is-success .b-clockpicker-face-hand{background-color:#23d160;border-color:#23d160}.enable-bulma .b-clockpicker.is-success .b-clockpicker-face-number.active{background-color:#23d160;color:#fff}.enable-bulma .b-clockpicker.is-warning .card-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .b-clockpicker.is-warning .b-clockpicker-face:after{background-color:#ffdd57}.enable-bulma .b-clockpicker.is-warning .b-clockpicker-face-hand{background-color:#ffdd57;border-color:#ffdd57}.enable-bulma .b-clockpicker.is-warning .b-clockpicker-face-number.active{background-color:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .b-clockpicker.is-danger .card-header{background-color:#ff3860;color:#fff}.enable-bulma .b-clockpicker.is-danger .b-clockpicker-face:after{background-color:#ff3860}.enable-bulma .b-clockpicker.is-danger .b-clockpicker-face-hand{background-color:#ff3860;border-color:#ff3860}.enable-bulma .b-clockpicker.is-danger .b-clockpicker-face-number.active{background-color:#ff3860;color:#fff}.enable-bulma .b-clockpicker .dropdown-menu{min-width:0}.enable-bulma .b-clockpicker .dropdown,.enable-bulma .b-clockpicker .dropdown-trigger{width:100%}.enable-bulma .b-clockpicker .dropdown-trigger .input[readonly],.enable-bulma .b-clockpicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable,.enable-bulma .b-clockpicker .dropdown .input[readonly],.enable-bulma .b-clockpicker .dropdown .taginput [readonly].taginput-container.is-focusable,.enable-bulma .taginput .b-clockpicker .dropdown-trigger [readonly].taginput-container.is-focusable,.enable-bulma .taginput .b-clockpicker .dropdown [readonly].taginput-container.is-focusable{cursor:pointer;-webkit-box-shadow:inset 0 1px 2px rgba(10,10,10,.1);box-shadow:inset 0 1px 2px rgba(10,10,10,.1)}.enable-bulma .b-clockpicker .dropdown-trigger .input[readonly].is-active,.enable-bulma .b-clockpicker .dropdown-trigger .input[readonly].is-focused,.enable-bulma .b-clockpicker .dropdown-trigger .input[readonly]:active,.enable-bulma .b-clockpicker .dropdown-trigger .input[readonly]:focus,.enable-bulma .b-clockpicker .dropdown-trigger .taginput [readonly].is-active.taginput-container.is-focusable,.enable-bulma .b-clockpicker .dropdown-trigger .taginput [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .b-clockpicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable:active,.enable-bulma .b-clockpicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable:focus,.enable-bulma .b-clockpicker .dropdown .input[readonly].is-active,.enable-bulma .b-clockpicker .dropdown .input[readonly].is-focused,.enable-bulma .b-clockpicker .dropdown .input[readonly]:active,.enable-bulma .b-clockpicker .dropdown .input[readonly]:focus,.enable-bulma .b-clockpicker .dropdown .taginput [readonly].is-active.taginput-container.is-focusable,.enable-bulma .b-clockpicker .dropdown .taginput [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .b-clockpicker .dropdown .taginput [readonly].taginput-container.is-focusable:active,.enable-bulma .b-clockpicker .dropdown .taginput [readonly].taginput-container.is-focusable:focus,.enable-bulma .taginput .b-clockpicker .dropdown-trigger [readonly].is-active.taginput-container.is-focusable,.enable-bulma .taginput .b-clockpicker .dropdown-trigger [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .taginput .b-clockpicker .dropdown-trigger [readonly].taginput-container.is-focusable:active,.enable-bulma .taginput .b-clockpicker .dropdown-trigger [readonly].taginput-container.is-focusable:focus,.enable-bulma .taginput .b-clockpicker .dropdown [readonly].is-active.taginput-container.is-focusable,.enable-bulma .taginput .b-clockpicker .dropdown [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .taginput .b-clockpicker .dropdown [readonly].taginput-container.is-focusable:active,.enable-bulma .taginput .b-clockpicker .dropdown [readonly].taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .b-clockpicker .dropdown-item,.enable-bulma .b-clockpicker .dropdown .dropdown-menu .has-link a,.enable-bulma .dropdown .dropdown-menu .has-link .b-clockpicker a{font-size:inherit;padding:0}.enable-bulma .b-clockpicker .dropdown-content{padding-top:0;padding-bottom:0}.enable-bulma .b-clockpicker .card{border-radius:4px}.enable-bulma .b-clockpicker .card-header{border-top-left-radius:4px;border-top-right-radius:4px}.enable-bulma .b-clockpicker .card-content{padding:12px}.enable-bulma .b-clockpicker-btn{cursor:pointer;opacity:.6}.enable-bulma .b-clockpicker-btn.active,.enable-bulma .b-clockpicker-btn:hover{opacity:1}.enable-bulma .b-clockpicker-period .b-clockpicker-btn{font-size:16px;text-transform:uppercase}.enable-bulma .b-clockpicker-time span{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .b-clockpicker-header{display:-webkit-box;display:-ms-flexbox;display:flex;line-height:1;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;color:inherit}.enable-bulma .b-clockpicker-header .b-clockpicker-time{white-space:nowrap}.enable-bulma .b-clockpicker-header .b-clockpicker-time span{height:60px;font-size:60px}.enable-bulma .b-clockpicker-header .b-clockpicker-period{-ms-flex-item-align:end;align-self:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:8px 0 6px 8px}.enable-bulma .b-clockpicker-body{-webkit-transition:.9s cubic-bezier(.25,.8,.5,1);transition:.9s cubic-bezier(.25,.8,.5,1)}.enable-bulma .b-clockpicker-body .b-clockpicker-btn{padding:0 8px;border-radius:290486px;margin-bottom:2px}.enable-bulma .b-clockpicker-body .b-clockpicker-btn.active,.enable-bulma .b-clockpicker-body .b-clockpicker-btn:hover{background-color:#3273dc;color:#fff}.enable-bulma .b-clockpicker-body .b-clockpicker-period{position:absolute;top:5px;right:5px}.enable-bulma .b-clockpicker-body .b-clockpicker-time{position:absolute;top:5px;left:5px;font-size:16px}.enable-bulma .b-clockpicker-body .b-clockpicker-face{border-radius:50%;position:relative;background-color:#dbdbdb;width:100%;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .b-clockpicker-body .b-clockpicker-face:after{border-radius:50%;content:\"\";position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:12px;height:12px;z-index:10}.enable-bulma .b-clockpicker-body .b-clockpicker-face-outer-ring{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:calc(100% - 50px);width:calc(100% - 50px);position:relative;border-radius:50%}.enable-bulma .b-clockpicker-body .b-clockpicker-face-number{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:100%;cursor:default;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:18px;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;width:40px;height:40px;left:calc(50% - 20px);top:calc(50% - 20px);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.enable-bulma .b-clockpicker-body .b-clockpicker-face-number>span{z-index:1}.enable-bulma .b-clockpicker-body .b-clockpicker-face-number:after,.enable-bulma .b-clockpicker-body .b-clockpicker-face-number:before{content:\"\";height:40px;width:40px;border-radius:100%;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.enable-bulma .b-clockpicker-body .b-clockpicker-face-number.active{cursor:default;z-index:2}.enable-bulma .b-clockpicker-body .b-clockpicker-face-number.disabled{pointer-events:none;opacity:.25}.enable-bulma .b-clockpicker-body .b-clockpicker-face-hand{height:calc(50% - 6px);width:2px;bottom:50%;left:calc(50% - 1px);-webkit-transform-origin:center bottom;transform-origin:center bottom;position:absolute;will-change:transform;z-index:1}.enable-bulma .b-clockpicker-body .b-clockpicker-face-hand:before{background:transparent;border-width:2px;border-style:solid;border-color:inherit;border-radius:100%;width:12px;height:12px;content:\"\";position:absolute;top:-6px;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.enable-bulma .b-clockpicker-footer{display:block;padding:12px}.enable-bulma .b-clockpicker.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .b-clockpicker.is-medium{font-size:1.25rem}.enable-bulma .b-clockpicker.is-large{font-size:1.5rem}.enable-bulma .collapse .collapse-trigger{display:inline;cursor:pointer}.enable-bulma .collapse .collapse-content{display:inherit}.enable-bulma .datepicker{font-size:.875rem}.enable-bulma .datepicker .dropdown,.enable-bulma .datepicker .dropdown-trigger{width:100%}.enable-bulma .datepicker .dropdown-trigger .input[readonly],.enable-bulma .datepicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable,.enable-bulma .datepicker .dropdown .input[readonly],.enable-bulma .datepicker .dropdown .taginput [readonly].taginput-container.is-focusable,.enable-bulma .taginput .datepicker .dropdown-trigger [readonly].taginput-container.is-focusable,.enable-bulma .taginput .datepicker .dropdown [readonly].taginput-container.is-focusable{cursor:pointer;-webkit-box-shadow:inset 0 1px 2px rgba(10,10,10,.1);box-shadow:inset 0 1px 2px rgba(10,10,10,.1)}.enable-bulma .datepicker .dropdown-trigger .input[readonly].is-active,.enable-bulma .datepicker .dropdown-trigger .input[readonly].is-focused,.enable-bulma .datepicker .dropdown-trigger .input[readonly]:active,.enable-bulma .datepicker .dropdown-trigger .input[readonly]:focus,.enable-bulma .datepicker .dropdown-trigger .taginput [readonly].is-active.taginput-container.is-focusable,.enable-bulma .datepicker .dropdown-trigger .taginput [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .datepicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable:active,.enable-bulma .datepicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable:focus,.enable-bulma .datepicker .dropdown .input[readonly].is-active,.enable-bulma .datepicker .dropdown .input[readonly].is-focused,.enable-bulma .datepicker .dropdown .input[readonly]:active,.enable-bulma .datepicker .dropdown .input[readonly]:focus,.enable-bulma .datepicker .dropdown .taginput [readonly].is-active.taginput-container.is-focusable,.enable-bulma .datepicker .dropdown .taginput [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .datepicker .dropdown .taginput [readonly].taginput-container.is-focusable:active,.enable-bulma .datepicker .dropdown .taginput [readonly].taginput-container.is-focusable:focus,.enable-bulma .taginput .datepicker .dropdown-trigger [readonly].is-active.taginput-container.is-focusable,.enable-bulma .taginput .datepicker .dropdown-trigger [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .taginput .datepicker .dropdown-trigger [readonly].taginput-container.is-focusable:active,.enable-bulma .taginput .datepicker .dropdown-trigger [readonly].taginput-container.is-focusable:focus,.enable-bulma .taginput .datepicker .dropdown [readonly].is-active.taginput-container.is-focusable,.enable-bulma .taginput .datepicker .dropdown [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .taginput .datepicker .dropdown [readonly].taginput-container.is-focusable:active,.enable-bulma .taginput .datepicker .dropdown [readonly].taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .datepicker .dropdown.is-disabled{opacity:1}.enable-bulma .datepicker .dropdown-content{background-color:#fff;border-radius:4px;-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1)}.enable-bulma .datepicker .dropdown-item,.enable-bulma .datepicker .dropdown .dropdown-menu .has-link a,.enable-bulma .dropdown .dropdown-menu .has-link .datepicker a{font-size:inherit}.enable-bulma .datepicker .datepicker-header{padding-bottom:.875rem;margin-bottom:.875rem;border-bottom:1px solid #dbdbdb}.enable-bulma .datepicker .datepicker-footer{margin-top:.875rem;padding-top:.875rem;border-top:1px solid #dbdbdb}.enable-bulma .datepicker .datepicker-table{display:table;margin:0 auto 0 auto}.enable-bulma .datepicker .datepicker-table .datepicker-cell{text-align:center;vertical-align:middle;display:table-cell;border-radius:4px;padding:.5rem .75rem}.enable-bulma .datepicker .datepicker-table .datepicker-header{display:table-header-group}.enable-bulma .datepicker .datepicker-table .datepicker-header .datepicker-cell{color:#7a7a7a;font-weight:600}.enable-bulma .datepicker .datepicker-table .datepicker-body{display:table-row-group}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-row{display:table-row}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-months{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:17rem}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-months .datepicker-cell{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:33.33%;height:2.5rem}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-unselectable{color:#b5b5b5}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-today{border:1px solid rgba(50,115,220,.5)}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable{color:#4a4a4a}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable:focus:not(.is-selected),.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable:hover:not(.is-selected){background-color:#f5f5f5;color:#0a0a0a;cursor:pointer}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable.is-within-hovered-range.is-first-hovered{background-color:#7a7a7a;color:#dbdbdb;border-bottom-right-radius:0;border-top-right-radius:0}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable.is-within-hovered-range.is-within-hovered{background-color:#f5f5f5;color:#0a0a0a;border-radius:0}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable.is-within-hovered-range.is-last-hovered{background-color:#7a7a7a;color:#dbdbdb;border-bottom-left-radius:0;border-top-left-radius:0}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selected{background-color:#3273dc;color:#fff}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selected.is-first-selected{background-color:#3273dc;color:#fff;border-bottom-right-radius:0;border-top-right-radius:0}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selected.is-within-selected{background-color:rgba(50,115,220,.5);border-radius:0}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selected.is-last-selected{background-color:#3273dc;color:#fff;border-bottom-left-radius:0;border-top-left-radius:0}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-nearby:not(.is-selected){color:#b5b5b5}.enable-bulma .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-week-number{cursor:default}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell{padding:.3rem .75rem .75rem}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event{position:relative}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events{bottom:.425rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;padding:0 .35rem;position:absolute;width:100%}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-white{background-color:#fff}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-black{background-color:#0a0a0a}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-light{background-color:#f5f5f5}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-dark{background-color:#363636}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-link,.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-primary{background-color:#3273dc}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-info{background-color:#209cee}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-success{background-color:#23d160}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-warning{background-color:#ffdd57}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-danger{background-color:#ff3860}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.dots .event{border-radius:50%;height:.35em;margin:0 .1em;width:.35em}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.bars .event{height:.25em;width:100%}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected{overflow:hidden}.enable-bulma .datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected .events .event.is-primary{background-color:#73a0e7}.enable-bulma .datepicker.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .datepicker.is-medium{font-size:1.25rem}.enable-bulma .datepicker.is-large{font-size:1.5rem}@media screen and (min-width:1024px){.enable-bulma .datepicker .footer-horizontal-timepicker{border:none;padding-left:10px;margin-left:5px;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .datepicker .dropdown-horizonal-timepicker{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .datepicker .content-horizonal-timepicker{border-right:1px solid #dbdbdb}}.enable-bulma .dialog .modal-card{max-width:460px;width:auto}.enable-bulma .dialog .modal-card .modal-card-head{font-size:1.25rem;font-weight:600}.enable-bulma .dialog .modal-card .modal-card-body .field{margin-top:16px}.enable-bulma .dialog .modal-card .modal-card-body.is-titleless{border-top-left-radius:6px;border-top-right-radius:6px}.enable-bulma .dialog .modal-card .modal-card-foot{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .dialog .modal-card .modal-card-foot .button{display:inline;min-width:5em;font-weight:600}@media print,screen and (min-width:769px){.enable-bulma .dialog .modal-card{min-width:320px}}.enable-bulma .dialog.is-small .button,.enable-bulma .dialog.is-small .input,.enable-bulma .dialog.is-small .modal-card,.enable-bulma .dialog.is-small .taginput .taginput-container.is-focusable,.enable-bulma .taginput .dialog.is-small .taginput-container.is-focusable{border-radius:2px;font-size:.75rem}.enable-bulma .dialog.is-medium .button,.enable-bulma .dialog.is-medium .input,.enable-bulma .dialog.is-medium .modal-card,.enable-bulma .dialog.is-medium .taginput .taginput-container.is-focusable,.enable-bulma .taginput .dialog.is-medium .taginput-container.is-focusable{font-size:1.25rem}.enable-bulma .dialog.is-large .button,.enable-bulma .dialog.is-large .input,.enable-bulma .dialog.is-large .modal-card,.enable-bulma .dialog.is-large .taginput .taginput-container.is-focusable,.enable-bulma .taginput .dialog.is-large .taginput-container.is-focusable{font-size:1.5rem}.enable-bulma .dialog.has-custom-container{position:absolute}.enable-bulma .dropdown+.dropdown{margin-left:.5em}.enable-bulma .dropdown .background{bottom:0;left:0;position:absolute;right:0;top:0;position:fixed;background-color:rgba(10,10,10,.86);z-index:40;cursor:pointer}@media screen and (min-width:1024px){.enable-bulma .dropdown .background{display:none}}.enable-bulma .dropdown.dropdown-menu-animation .dropdown-menu{display:block}.enable-bulma .dropdown .dropdown-menu .dropdown-item.is-disabled,.enable-bulma .dropdown .dropdown-menu .has-link a.is-disabled{cursor:not-allowed}.enable-bulma .dropdown .dropdown-menu .dropdown-item.is-disabled:hover,.enable-bulma .dropdown .dropdown-menu .has-link a.is-disabled:hover{background:inherit;color:inherit}.enable-bulma .dropdown .dropdown-menu .has-link a{padding-right:3rem;white-space:nowrap}.enable-bulma .dropdown.is-hoverable:not(.is-active) .dropdown-menu{display:none}.enable-bulma .dropdown.is-hoverable:hover .dropdown-menu{display:inherit}.enable-bulma .dropdown.is-expanded,.enable-bulma .dropdown.is-expanded .dropdown-menu,.enable-bulma .dropdown.is-expanded .dropdown-trigger{width:100%}.enable-bulma .dropdown.is-expanded.is-mobile-modal .dropdown-menu{max-width:100%}.enable-bulma .dropdown:not(.is-disabled) .dropdown-menu .dropdown-item.is-disabled,.enable-bulma .dropdown:not(.is-disabled) .dropdown-menu .has-link a.is-disabled{opacity:.5}.enable-bulma .dropdown .navbar-item{height:100%}.enable-bulma .dropdown.is-disabled{opacity:.5;cursor:not-allowed}.enable-bulma .dropdown.is-disabled .dropdown-trigger{pointer-events:none}.enable-bulma .dropdown.is-inline .dropdown-menu{position:static;display:inline-block;padding:0}.enable-bulma .dropdown.is-top-right .dropdown-menu{top:auto;bottom:100%}.enable-bulma .dropdown.is-top-left .dropdown-menu{top:auto;bottom:100%;right:0;left:auto}.enable-bulma .dropdown.is-bottom-left .dropdown-menu{right:0;left:auto}@media screen and (max-width:1023px){.enable-bulma .dropdown.is-mobile-modal>.dropdown-menu{position:fixed!important;width:calc(100vw - 40px);max-width:460px;max-height:calc(100vh - 120px);top:25%!important;left:50%!important;bottom:auto!important;right:auto!important;-webkit-transform:translate3d(-50%,-25%,0);transform:translate3d(-50%,-25%,0);white-space:normal;overflow-y:auto;z-index:50!important}.enable-bulma .dropdown .dropdown-menu .has-link .dropdown.is-mobile-modal>.dropdown-menu>.dropdown-content>a,.enable-bulma .dropdown.is-mobile-modal>.dropdown-menu>.dropdown-content>.dropdown-item,.enable-bulma .dropdown.is-mobile-modal>.dropdown-menu>.dropdown-content>.has-link a{padding:1rem 1.5rem}}.enable-bulma .field.is-grouped .field{-ms-flex-negative:0;flex-shrink:0}.enable-bulma .field.is-grouped .field:not(:last-child){margin-right:.75rem}.enable-bulma .field.is-grouped .field.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .field.has-addons .control:first-child .control .button,.enable-bulma .field.has-addons .control:first-child .control .input,.enable-bulma .field.has-addons .control:first-child .control .select select,.enable-bulma .field.has-addons .control:first-child .control .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .control:first-child .control .taginput-container.is-focusable{border-bottom-left-radius:4px;border-top-left-radius:4px}.enable-bulma .field.has-addons .control:last-child .control .button,.enable-bulma .field.has-addons .control:last-child .control .input,.enable-bulma .field.has-addons .control:last-child .control .select select,.enable-bulma .field.has-addons .control:last-child .control .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .control:last-child .control .taginput-container.is-focusable{border-bottom-right-radius:4px;border-top-right-radius:4px}.enable-bulma .field.has-addons .control .control .button,.enable-bulma .field.has-addons .control .control .input,.enable-bulma .field.has-addons .control .control .select select,.enable-bulma .field.has-addons .control .control .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .control .control .taginput-container.is-focusable{border-radius:0}.enable-bulma .field.has-addons .b-numberinput:not(:first-child) .control:first-child .button,.enable-bulma .field.has-addons .b-numberinput:not(:first-child) .control:first-child .input,.enable-bulma .field.has-addons .b-numberinput:not(:first-child) .control:first-child .select select,.enable-bulma .field.has-addons .b-numberinput:not(:first-child) .control:first-child .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .b-numberinput:not(:first-child) .control:first-child .taginput-container.is-focusable{border-bottom-left-radius:0;border-top-left-radius:0}.enable-bulma .field.has-addons .b-numberinput:not(:last-child) .control:last-child .button,.enable-bulma .field.has-addons .b-numberinput:not(:last-child) .control:last-child .input,.enable-bulma .field.has-addons .b-numberinput:not(:last-child) .control:last-child .select select,.enable-bulma .field.has-addons .b-numberinput:not(:last-child) .control:last-child .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.has-addons .b-numberinput:not(:last-child) .control:last-child .taginput-container.is-focusable{border-bottom-right-radius:0;border-top-right-radius:0}.enable-bulma .field.is-floating-in-label,.enable-bulma .field.is-floating-label{position:relative}.enable-bulma .field.is-floating-in-label .label,.enable-bulma .field.is-floating-label .label{position:absolute;left:1em;font-size:.75rem;background-color:transparent;z-index:5}.enable-bulma .field.is-floating-in-label .label.is-small,.enable-bulma .field.is-floating-label .label.is-small{font-size:.5625rem}.enable-bulma .field.is-floating-in-label .label.is-medium,.enable-bulma .field.is-floating-label .label.is-medium{font-size:.9375rem}.enable-bulma .field.is-floating-in-label .label.is-large,.enable-bulma .field.is-floating-label .label.is-large{font-size:1.125rem}.enable-bulma .field.is-floating-in-label .taginput .counter,.enable-bulma .field.is-floating-label .taginput .counter{float:none;text-align:right}.enable-bulma .field.is-floating-in-label.has-addons>.label+.control .button,.enable-bulma .field.is-floating-in-label.has-addons>.label+.control .input,.enable-bulma .field.is-floating-in-label.has-addons>.label+.control .select select,.enable-bulma .field.is-floating-in-label.has-addons>.label+.control .taginput .taginput-container.is-focusable,.enable-bulma .field.is-floating-label.has-addons>.label+.control .button,.enable-bulma .field.is-floating-label.has-addons>.label+.control .input,.enable-bulma .field.is-floating-label.has-addons>.label+.control .select select,.enable-bulma .field.is-floating-label.has-addons>.label+.control .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.is-floating-in-label.has-addons>.label+.control .taginput-container.is-focusable,.enable-bulma .taginput .field.is-floating-label.has-addons>.label+.control .taginput-container.is-focusable{border-bottom-left-radius:4px;border-top-left-radius:4px}.enable-bulma .field.is-floating-label .label{top:-.775em;padding-left:.125em;padding-right:.125em}.enable-bulma .field.is-floating-label .label:before{content:\"\";display:block;position:absolute;top:.775em;left:0;right:0;height:.375em;background-color:#fff;z-index:-1}.enable-bulma .field.is-floating-label .input:focus,.enable-bulma .field.is-floating-label .select select:focus,.enable-bulma .field.is-floating-label .taginput .taginput-container.is-focusable:focus,.enable-bulma .field.is-floating-label .textarea:focus,.enable-bulma .taginput .field.is-floating-label .taginput-container.is-focusable:focus{-webkit-box-shadow:none;box-shadow:none}.enable-bulma .field.is-floating-label .taginput .taginput-container{padding-top:.475em}.enable-bulma .field.is-floating-label .taginput .taginput-container.is-focused{-webkit-box-shadow:none;box-shadow:none}.enable-bulma .field.is-floating-in-label .label{top:.25em}.enable-bulma .field.is-floating-in-label>.datepicker .input,.enable-bulma .field.is-floating-in-label>.datepicker .taginput .taginput-container.is-focusable,.enable-bulma .field.is-floating-in-label>.timepicker .input,.enable-bulma .field.is-floating-in-label>.timepicker .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.is-floating-in-label>.datepicker .taginput-container.is-focusable,.enable-bulma .taginput .field.is-floating-in-label>.timepicker .taginput-container.is-focusable{padding-top:calc(1.625em - .5625rem);padding-bottom:1px;height:3.25em}.enable-bulma .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .input,.enable-bulma .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .taginput .taginput-container.is-focusable,.enable-bulma .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .textarea,.enable-bulma .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) select,.enable-bulma .taginput .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .taginput-container.is-focusable{padding-top:calc(1.625em - .5625rem);padding-bottom:1px;height:3.25em}.enable-bulma .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .select:not(multiple){height:3.25em}.enable-bulma .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .select:not(multiple).is-loading:after{margin-top:calc(1.625em - .5625rem)}.enable-bulma .field.is-floating-in-label>:not(.datepicker):not(.timepicker):not(.taginput) .select:not(multiple):after{margin-top:1px}.enable-bulma .field.is-floating-in-label>:not(.taginput) .is-left.icon,.enable-bulma .field.is-floating-in-label>:not(.taginput) .is-right.icon{height:3.25em}.enable-bulma .field.is-floating-in-label>:not(.taginput) .is-left.icon{padding-top:calc(1.625em - .5625rem)}.enable-bulma .field.is-floating-in-label .control.is-loading:after{margin-top:calc(1.625em - .5625rem)}.enable-bulma .field.is-floating-in-label .taginput .taginput-container{padding-top:calc(1.9em - .5625rem - 1px)}.enable-bulma .field.is-floating-in-label.has-addons .control .button,.enable-bulma .field.is-floating-in-label.has-addons .control .input,.enable-bulma .field.is-floating-in-label.has-addons .control .select select,.enable-bulma .field.is-floating-in-label.has-addons .control .taginput .taginput-container.is-focusable,.enable-bulma .field.is-floating-in-label.has-numberinput .b-numberinput .control .button,.enable-bulma .field.is-floating-in-label.is-grouped .control .button,.enable-bulma .field.is-floating-in-label.is-grouped .control .input,.enable-bulma .field.is-floating-in-label.is-grouped .control .select select,.enable-bulma .field.is-floating-in-label.is-grouped .control .taginput .taginput-container.is-focusable,.enable-bulma .taginput .field.is-floating-in-label.has-addons .control .taginput-container.is-focusable,.enable-bulma .taginput .field.is-floating-in-label.is-grouped .control .taginput-container.is-focusable{height:3.25em}.enable-bulma .field.is-floating-in-label.has-numberinput .label,.enable-bulma .field.is-floating-label.has-numberinput .label{margin-left:3rem}.enable-bulma .field.is-floating-in-label.has-numberinput.has-numberinput-is-small .label,.enable-bulma .field.is-floating-label.has-numberinput.has-numberinput-is-small .label{margin-left:2.25rem}.enable-bulma .field.is-floating-in-label.has-numberinput.has-numberinput-is-medium .label,.enable-bulma .field.is-floating-label.has-numberinput.has-numberinput-is-medium .label{margin-left:3.75rem}.enable-bulma .field.is-floating-in-label.has-numberinput.has-numberinput-is-large .label,.enable-bulma .field.is-floating-label.has-numberinput.has-numberinput-is-large .label{margin-left:4.5rem}.enable-bulma .field.is-floating-in-label.has-numberinput-compact .label,.enable-bulma .field.is-floating-label.has-numberinput-compact .label{margin-left:2.25rem}.enable-bulma .field.is-floating-in-label.has-numberinput-compact.has-numberinput-is-small .label,.enable-bulma .field.is-floating-label.has-numberinput-compact.has-numberinput-is-small .label{margin-left:1.6875rem}.enable-bulma .field.is-floating-in-label.has-numberinput-compact.has-numberinput-is-medium .label,.enable-bulma .field.is-floating-label.has-numberinput-compact.has-numberinput-is-medium .label{margin-left:2.8125rem}.enable-bulma .field.is-floating-in-label.has-numberinput-compact.has-numberinput-is-large .label,.enable-bulma .field.is-floating-label.has-numberinput-compact.has-numberinput-is-large .label{margin-left:3.375rem}.enable-bulma .field.has-addons-right.is-floating-in-label .label,.enable-bulma .field.has-addons-right.is-floating-label .label,.enable-bulma .field.is-grouped-right.is-floating-in-label .label,.enable-bulma .field.is-grouped-right.is-floating-label .label{position:relative;left:5.25em}.enable-bulma .control .help.counter{float:right;margin-left:.5em}.enable-bulma .control .icon.is-clickable{pointer-events:auto;cursor:pointer}.enable-bulma .icon{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:inherit}.enable-bulma .icon svg{background-color:transparent;fill:currentColor;stroke-width:0;stroke:currentColor;pointer-events:none;width:1.5rem;height:1.5rem}.enable-bulma .loading-overlay{bottom:0;left:0;position:absolute;right:0;top:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;z-index:999}.enable-bulma .loading-overlay.is-active{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .loading-overlay.is-full-page{position:fixed}.enable-bulma .loading-overlay.is-full-page .loading-icon:after{top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.enable-bulma .loading-overlay .loading-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#7f7f7f;background:hsla(0,0%,100%,.5)}.enable-bulma .loading-overlay .loading-icon{position:relative}.enable-bulma .loading-overlay .loading-icon:after{-webkit-animation:spinAround .5s linear infinite;animation:spinAround .5s linear infinite;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em;position:absolute;top:calc(50% - 1.5em);left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.enable-bulma .menu .menu-list li>a.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.enable-bulma .message .media,.enable-bulma .notification .media{padding-top:0;border:0}.enable-bulma .modal.is-full-screen>.animation-content,.enable-bulma .modal.is-full-screen>.animation-content>.modal-card{width:100%;height:100%;max-height:100vh;margin:0;background-color:#f5f5f5}.enable-bulma .modal .animation-content{margin:0 20px}.enable-bulma .modal .animation-content .modal-card{margin:0}@media screen and (max-width:768px){.enable-bulma .modal .animation-content{width:100%}}.enable-bulma .modal .modal-content{width:100%}.enable-bulma .notices{position:fixed;display:-webkit-box;display:-ms-flexbox;display:flex;top:0;bottom:0;left:0;right:0;padding:2em;overflow:hidden;z-index:1000;pointer-events:none}.enable-bulma .notices .toast{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-animation-duration:.15s;animation-duration:.15s;margin:.5em 0;text-align:center;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:2em;padding:.75em 1.5em;pointer-events:auto;opacity:.92}.enable-bulma .notices .toast.is-white{color:#0a0a0a;background:#fff}.enable-bulma .notices .toast.is-black{color:#fff;background:#0a0a0a}.enable-bulma .notices .toast.is-light{color:#363636;background:#f5f5f5}.enable-bulma .notices .toast.is-dark{color:#f5f5f5;background:#363636}.enable-bulma .notices .toast.is-link,.enable-bulma .notices .toast.is-primary{color:#fff;background:#3273dc}.enable-bulma .notices .toast.is-info{color:#fff;background:#209cee}.enable-bulma .notices .toast.is-success{color:#fff;background:#23d160}.enable-bulma .notices .toast.is-warning{color:rgba(0,0,0,.7);background:#ffdd57}.enable-bulma .notices .toast.is-danger{color:#fff;background:#ff3860}.enable-bulma .notices .snackbar{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around;-webkit-animation-duration:.15s;animation-duration:.15s;margin:.5em 0;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:4px;pointer-events:auto;background:#363636;color:#f5f5f5;min-height:3em}.enable-bulma .notices .snackbar .text{padding:.5em 1em}.enable-bulma .notices .snackbar .action{margin-left:auto;padding:.5em;padding-left:0}.enable-bulma .notices .snackbar .action .button{font-weight:600;text-transform:uppercase;background:#363636;border:transparent}.enable-bulma .notices .snackbar .action .button:hover{background:#292929}.enable-bulma .notices .snackbar .action .button:active{background:#292929}.enable-bulma .notices .snackbar .action.is-white .button{color:#fff}.enable-bulma .notices .snackbar .action.is-black .button{color:#0a0a0a}.enable-bulma .notices .snackbar .action.is-light .button{color:#f5f5f5}.enable-bulma .notices .snackbar .action.is-dark .button{color:#363636}.enable-bulma .notices .snackbar .action.is-link .button,.enable-bulma .notices .snackbar .action.is-primary .button{color:#3273dc}.enable-bulma .notices .snackbar .action.is-info .button{color:#209cee}.enable-bulma .notices .snackbar .action.is-success .button{color:#23d160}.enable-bulma .notices .snackbar .action.is-warning .button{color:#ffdd57}.enable-bulma .notices .snackbar .action.is-danger .button{color:#ff3860}@media screen and (max-width:768px){.enable-bulma .notices .snackbar{width:100%;margin:0;border-radius:0}}@media print,screen and (min-width:769px){.enable-bulma .notices .snackbar{min-width:350px;max-width:600px;overflow:hidden}}.enable-bulma .notices .notification{max-width:600px}.enable-bulma .notices .notification.is-bottom,.enable-bulma .notices .notification.is-top,.enable-bulma .notices .snackbar.is-bottom,.enable-bulma .notices .snackbar.is-top,.enable-bulma .notices .toast.is-bottom,.enable-bulma .notices .toast.is-top{-ms-flex-item-align:center;align-self:center}.enable-bulma .notices .notification.is-bottom-right,.enable-bulma .notices .notification.is-top-right,.enable-bulma .notices .snackbar.is-bottom-right,.enable-bulma .notices .snackbar.is-top-right,.enable-bulma .notices .toast.is-bottom-right,.enable-bulma .notices .toast.is-top-right{-ms-flex-item-align:end;align-self:flex-end}.enable-bulma .notices .notification.is-bottom-left,.enable-bulma .notices .notification.is-top-left,.enable-bulma .notices .snackbar.is-bottom-left,.enable-bulma .notices .snackbar.is-top-left,.enable-bulma .notices .toast.is-bottom-left,.enable-bulma .notices .toast.is-top-left{-ms-flex-item-align:start;align-self:flex-start}.enable-bulma .notices .notification.is-toast,.enable-bulma .notices .snackbar.is-toast,.enable-bulma .notices .toast.is-toast{opacity:.92}.enable-bulma .notices.is-top{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.enable-bulma .notices.is-bottom{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.enable-bulma .notices.is-bottom .notification{margin-bottom:0}.enable-bulma .notices.is-bottom .notification:not(:first-child){margin-bottom:1.5rem}.enable-bulma .notices.has-custom-container{position:absolute}@media screen and (max-width:768px){.enable-bulma .notices{padding:0;position:fixed!important}}.enable-bulma .b-numberinput.field{margin-bottom:0}.enable-bulma .b-numberinput.field.has-addons.is-expanded,.enable-bulma .b-numberinput.field.is-grouped div.control{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .b-numberinput input[type=number]::-webkit-inner-spin-button,.enable-bulma .b-numberinput input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none}.enable-bulma .b-numberinput input[type=number]{-moz-appearance:textfield}.enable-bulma .b-numberinput input[type=number]{text-align:center}.enable-bulma .b-numberinput .button.is-rounded{padding-left:.75em;padding-right:.75em}.enable-bulma .pagination .pagination-next,.enable-bulma .pagination .pagination-previous{padding-left:.25em;padding-right:.25em}.enable-bulma .pagination .pagination-next.is-disabled,.enable-bulma .pagination .pagination-previous.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.enable-bulma .pagination.is-simple{-webkit-box-pack:normal;-ms-flex-pack:normal;justify-content:normal}.enable-bulma .pagination.is-simple.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.enable-bulma .pagination.is-simple.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .pagination .is-current{pointer-events:none;cursor:not-allowed}.enable-bulma .progress-wrapper{position:relative;overflow:hidden}.enable-bulma .progress-wrapper:not(:last-child){margin-bottom:1.5rem}.enable-bulma .progress-wrapper .progress-value{position:absolute;top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);font-size:.66667rem;line-height:1rem;font-weight:700;color:#fff;white-space:nowrap}.enable-bulma .progress-wrapper .progress{margin-bottom:0}.enable-bulma .progress-wrapper .progress.is-small+.progress-value{font-size:.5rem;line-height:.75rem}.enable-bulma .progress-wrapper .progress.is-medium+.progress-value{font-size:.83333rem;line-height:1.25rem}.enable-bulma .progress-wrapper .progress.is-large+.progress-value{font-size:1rem;line-height:1.5rem}.enable-bulma .progress-wrapper .progress:indeterminate::-ms-fill{animation-name:none}.enable-bulma .progress-wrapper .progress::-webkit-progress-value{-webkit-transition:width .5s ease;transition:width .5s ease}.enable-bulma .b-radio.radio{outline:none;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.enable-bulma .b-radio.radio:not(.button){margin-right:.5em}.enable-bulma .b-radio.radio:not(.button)+.radio:last-child{margin-right:0}.enable-bulma .b-radio.radio+.radio{margin-left:0}.enable-bulma .b-radio.radio input[type=radio]{position:absolute;left:0;opacity:0;outline:none;z-index:-1}.enable-bulma .b-radio.radio input[type=radio]+.check{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;position:relative;cursor:pointer;width:1.25em;height:1.25em;-webkit-transition:background .15s ease-out;transition:background .15s ease-out;border-radius:50%;border:2px solid #7a7a7a}.enable-bulma .b-radio.radio input[type=radio]+.check:before{content:\"\";display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;left:50%;margin-left:-.625em;bottom:50%;margin-bottom:-.625em;width:1.25em;height:1.25em;-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out;border-radius:50%;-webkit-transform:scale(0);transform:scale(0);background-color:#3273dc}.enable-bulma .b-radio.radio input[type=radio]+.check.is-white:before{background:#fff}.enable-bulma .b-radio.radio input[type=radio]+.check.is-black:before{background:#0a0a0a}.enable-bulma .b-radio.radio input[type=radio]+.check.is-light:before{background:#f5f5f5}.enable-bulma .b-radio.radio input[type=radio]+.check.is-dark:before{background:#363636}.enable-bulma .b-radio.radio input[type=radio]+.check.is-primary:before{background:#3273dc}.enable-bulma .b-radio.radio input[type=radio]+.check.is-link:before{background:#3273dc}.enable-bulma .b-radio.radio input[type=radio]+.check.is-info:before{background:#209cee}.enable-bulma .b-radio.radio input[type=radio]+.check.is-success:before{background:#23d160}.enable-bulma .b-radio.radio input[type=radio]+.check.is-warning:before{background:#ffdd57}.enable-bulma .b-radio.radio input[type=radio]+.check.is-danger:before{background:#ff3860}.enable-bulma .b-radio.radio input[type=radio]:checked+.check{border-color:#3273dc}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-white{border-color:#fff}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-black{border-color:#0a0a0a}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-light{border-color:#f5f5f5}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-dark{border-color:#363636}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-primary{border-color:#3273dc}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-link{border-color:#3273dc}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-info{border-color:#209cee}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-success{border-color:#23d160}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-warning{border-color:#ffdd57}.enable-bulma .b-radio.radio input[type=radio]:checked+.check.is-danger{border-color:#ff3860}.enable-bulma .b-radio.radio input[type=radio]:checked+.check:before{-webkit-transform:scale(.5);transform:scale(.5)}.enable-bulma .b-radio.radio input[type=radio]:focus+.check{-webkit-box-shadow:0 0 .5em hsla(0,0%,47.8%,.8);box-shadow:0 0 .5em hsla(0,0%,47.8%,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-white{-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.8);box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-black{-webkit-box-shadow:0 0 .5em rgba(10,10,10,.8);box-shadow:0 0 .5em rgba(10,10,10,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-light{-webkit-box-shadow:0 0 .5em hsla(0,0%,96.1%,.8);box-shadow:0 0 .5em hsla(0,0%,96.1%,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-dark{-webkit-box-shadow:0 0 .5em rgba(54,54,54,.8);box-shadow:0 0 .5em rgba(54,54,54,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-primary{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-link{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-info{-webkit-box-shadow:0 0 .5em rgba(32,156,238,.8);box-shadow:0 0 .5em rgba(32,156,238,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-success{-webkit-box-shadow:0 0 .5em rgba(35,209,96,.8);box-shadow:0 0 .5em rgba(35,209,96,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-warning{-webkit-box-shadow:0 0 .5em rgba(255,221,87,.8);box-shadow:0 0 .5em rgba(255,221,87,.8)}.enable-bulma .b-radio.radio input[type=radio]:focus:checked+.check.is-danger{-webkit-box-shadow:0 0 .5em rgba(255,56,96,.8);box-shadow:0 0 .5em rgba(255,56,96,.8)}.enable-bulma .b-radio.radio .control-label{padding-left:.5em}.enable-bulma .b-radio.radio.button{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .b-radio.radio[disabled]{opacity:.5}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check{border-color:#3273dc}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-white{border-color:#fff}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-black{border-color:#0a0a0a}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-light{border-color:#f5f5f5}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-dark{border-color:#363636}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-primary{border-color:#3273dc}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-link{border-color:#3273dc}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-info{border-color:#209cee}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-success{border-color:#23d160}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-warning{border-color:#ffdd57}.enable-bulma .b-radio.radio:hover input[type=radio]:not(:disabled)+.check.is-danger{border-color:#ff3860}.enable-bulma .b-radio.radio.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .b-radio.radio.is-medium{font-size:1.25rem}.enable-bulma .b-radio.radio.is-large{font-size:1.5rem}.enable-bulma .rate{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .rate:not(:last-child){margin-bottom:.75rem}.enable-bulma .rate.is-spaced .rate-item:not(:last-child){margin-right:.25rem}.enable-bulma .rate.is-disabled .rate-item{cursor:auto}.enable-bulma .rate.is-disabled .rate-item:hover{-webkit-transform:none;transform:none}.enable-bulma .rate.is-rtl .rate-item{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.enable-bulma .rate.is-rtl .rate-text{margin-left:0;margin-right:.35rem}.enable-bulma .rate .rate-item{cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;position:relative;-webkit-transition:all .3s;transition:all .3s}.enable-bulma .rate .rate-item:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}.enable-bulma .rate .rate-item.set-half .is-half,.enable-bulma .rate .rate-item.set-on .icon{color:#ffd83d}.enable-bulma .rate .rate-item.set-half .is-half{position:absolute;left:0;top:0;overflow:hidden}.enable-bulma .rate .icon{color:#dbdbdb;line-height:1;pointer-events:none;width:inherit}.enable-bulma .rate .is-half>i{position:absolute;left:0}.enable-bulma .rate .rate-text{font-size:.8rem;margin-left:.35rem}.enable-bulma .rate .rate-text.is-small{font-size:.6rem}.enable-bulma .rate .rate-text.is-medium{font-size:1rem}.enable-bulma .rate .rate-text.is-large{font-size:1.2rem}.enable-bulma .select select{text-rendering:auto!important;padding-right:2.5em}.enable-bulma .select select option{color:#4a4a4a;padding:.25em .5em}.enable-bulma .select select option:disabled{cursor:not-allowed;opacity:.5}.enable-bulma .select select optgroup{color:#b5b5b5;font-weight:400;font-style:normal;padding:.25em 0}.enable-bulma .select.is-empty select{color:hsla(0,0%,47.8%,.7)}.enable-bulma .b-skeleton{width:100%}.enable-bulma .b-skeleton>.b-skeleton-item{background:-webkit-gradient(linear,left top,right top,color-stop(25%,#dbdbdb),color-stop(50%,hsla(0,0%,85.9%,.5)),color-stop(75%,#dbdbdb));background:linear-gradient(90deg,#dbdbdb 25%,hsla(0,0%,85.9%,.5) 50%,#dbdbdb 75%);background-size:400% 100%;width:100%}.enable-bulma .b-skeleton>.b-skeleton-item.is-rounded{border-radius:4px}.enable-bulma .b-skeleton>.b-skeleton-item:after{content:\" \"}.enable-bulma .b-skeleton>.b-skeleton-item+.b-skeleton-item{margin-top:.5rem}.enable-bulma .b-skeleton.is-animated>.b-skeleton-item{-webkit-animation:skeleton-loading 1.5s infinite;animation:skeleton-loading 1.5s infinite}.enable-bulma .b-skeleton+.b-skeleton{margin-top:.5rem}.enable-bulma .b-skeleton>.b-skeleton-item{line-height:1rem}.enable-bulma .b-skeleton.is-small>.b-skeleton-item{line-height:.75rem}.enable-bulma .b-skeleton.is-medium>.b-skeleton-item{line-height:1.25rem}.enable-bulma .b-skeleton.is-large>.b-skeleton-item{line-height:1.5rem}@-webkit-keyframes skeleton-loading{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes skeleton-loading{0%{background-position:100% 50%}to{background-position:0 50%}}.enable-bulma .b-sidebar .sidebar-content{background-color:#f5f5f5;-webkit-box-shadow:5px 0 13px 3px rgba(10,10,10,.1);box-shadow:5px 0 13px 3px rgba(10,10,10,.1);width:260px;z-index:41}.enable-bulma .b-sidebar .sidebar-content.is-white{background-color:#fff}.enable-bulma .b-sidebar .sidebar-content.is-black{background-color:#0a0a0a}.enable-bulma .b-sidebar .sidebar-content.is-light{background-color:#f5f5f5}.enable-bulma .b-sidebar .sidebar-content.is-dark{background-color:#363636}.enable-bulma .b-sidebar .sidebar-content.is-link,.enable-bulma .b-sidebar .sidebar-content.is-primary{background-color:#3273dc}.enable-bulma .b-sidebar .sidebar-content.is-info{background-color:#209cee}.enable-bulma .b-sidebar .sidebar-content.is-success{background-color:#23d160}.enable-bulma .b-sidebar .sidebar-content.is-warning{background-color:#ffdd57}.enable-bulma .b-sidebar .sidebar-content.is-danger{background-color:#ff3860}.enable-bulma .b-sidebar .sidebar-content.is-fixed{position:fixed;left:0;top:0}.enable-bulma .b-sidebar .sidebar-content.is-fixed.is-right{left:auto;right:0}.enable-bulma .b-sidebar .sidebar-content.is-absolute{position:absolute;left:0;top:0}.enable-bulma .b-sidebar .sidebar-content.is-absolute.is-right{left:auto;right:0}.enable-bulma .b-sidebar .sidebar-content.is-mini{width:80px}.enable-bulma .b-sidebar .sidebar-content.is-mini.is-mini-expand:hover{-webkit-transition:width .15s ease-out;transition:width .15s ease-out}.enable-bulma .b-sidebar .sidebar-content.is-mini.is-mini-expand:hover:not(.is-fullwidth){width:260px}.enable-bulma .b-sidebar .sidebar-content.is-mini.is-mini-expand:hover:not(.is-fullwidth).is-mini-expand-fixed{position:fixed}.enable-bulma .b-sidebar .sidebar-content.is-static{position:static}.enable-bulma .b-sidebar .sidebar-content.is-absolute,.enable-bulma .b-sidebar .sidebar-content.is-static{-webkit-transition:width .15s ease-out;transition:width .15s ease-out}.enable-bulma .b-sidebar .sidebar-content.is-fullwidth{width:100%;max-width:100%}.enable-bulma .b-sidebar .sidebar-content.is-fullheight{height:100%;max-height:100%;overflow:hidden;overflow-y:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-line-pack:stretch;align-content:stretch}@media screen and (max-width:1023px){.enable-bulma .b-sidebar .sidebar-content.is-mini-mobile{width:80px}.enable-bulma .b-sidebar .sidebar-content.is-mini-mobile.is-mini-expand:hover:not(.is-fullwidth-mobile){width:260px}.enable-bulma .b-sidebar .sidebar-content.is-mini-mobile.is-mini-expand:hover:not(.is-fullwidth-mobile).is-mini-expand-fixed{position:fixed}.enable-bulma .b-sidebar .sidebar-content.is-hidden-mobile{width:0;height:0;overflow:hidden}.enable-bulma .b-sidebar .sidebar-content.is-fullwidth-mobile{width:100%;max-width:100%}}.enable-bulma .b-sidebar .sidebar-background{bottom:0;left:0;position:absolute;right:0;top:0;background:rgba(10,10,10,.86);position:fixed;z-index:40}.enable-bulma .b-slider{margin:1em 0;background:transparent;width:100%}.enable-bulma .b-slider .b-slider-track{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;cursor:pointer;background:#dbdbdb;border-radius:4px}.enable-bulma .b-slider .b-slider-fill{position:absolute;height:100%;-webkit-box-shadow:0 0 0 #7a7a7a;box-shadow:0 0 0 #7a7a7a;background:#dbdbdb;border-radius:4px;border:0 solid #7a7a7a;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.enable-bulma .b-slider .b-slider-thumb-wrapper{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;cursor:-webkit-grab;cursor:grab;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);top:50%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.enable-bulma .b-slider .b-slider-thumb-wrapper .b-slider-thumb{-webkit-box-shadow:none;box-shadow:none;border:1px solid #b5b5b5;border-radius:4px;background:#fff}.enable-bulma .b-slider .b-slider-thumb-wrapper .b-slider-thumb:focus{-webkit-transform:scale(1.25);transform:scale(1.25)}.enable-bulma .b-slider .b-slider-thumb-wrapper.is-dragging{cursor:-webkit-grabbing;cursor:grabbing}.enable-bulma .b-slider .b-slider-thumb-wrapper.is-dragging .b-slider-thumb{-webkit-transform:scale(1.25);transform:scale(1.25)}.enable-bulma .b-slider.slider-focus{padding-top:20px;padding-bottom:20px;margin-top:-20px;margin-bottom:-20px;cursor:pointer}.enable-bulma .b-slider.is-rounded .b-slider-thumb{border-radius:290486px}.enable-bulma .b-slider.is-disabled .b-slider-track{cursor:not-allowed;opacity:.5}.enable-bulma .b-slider.is-disabled .b-slider-thumb-wrapper{cursor:not-allowed}.enable-bulma .b-slider.is-disabled .b-slider-thumb-wrapper .b-slider-thumb{-webkit-transform:scale(1);transform:scale(1)}.enable-bulma .b-slider .b-slider-track{height:.5rem}.enable-bulma .b-slider .b-slider-thumb{height:1rem;width:1rem}.enable-bulma .b-slider .b-slider-tick{height:.25rem}.enable-bulma .b-slider .b-slider-tick-label{font-size:.75rem;position:absolute;top:calc(.25rem + 2px);left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.enable-bulma .b-slider.is-small .b-slider-track{height:.375rem}.enable-bulma .b-slider.is-small .b-slider-thumb{height:.75rem;width:.75rem}.enable-bulma .b-slider.is-small .b-slider-tick{height:.1875rem}.enable-bulma .b-slider.is-small .b-slider-tick-label{font-size:.75rem;position:absolute;top:calc(.1875rem + 2px);left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.enable-bulma .b-slider.is-medium .b-slider-track{height:.625rem}.enable-bulma .b-slider.is-medium .b-slider-thumb{height:1.25rem;width:1.25rem}.enable-bulma .b-slider.is-medium .b-slider-tick{height:.3125rem}.enable-bulma .b-slider.is-medium .b-slider-tick-label{font-size:.75rem;position:absolute;top:calc(.3125rem + 2px);left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.enable-bulma .b-slider.is-large .b-slider-track{height:.75rem}.enable-bulma .b-slider.is-large .b-slider-thumb{height:1.5rem;width:1.5rem}.enable-bulma .b-slider.is-large .b-slider-tick{height:.375rem}.enable-bulma .b-slider.is-large .b-slider-tick-label{font-size:.75rem;position:absolute;top:calc(.375rem + 2px);left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.enable-bulma .b-slider.is-white .b-slider-fill{background:#fff!important}.enable-bulma .b-slider.is-black .b-slider-fill{background:#0a0a0a!important}.enable-bulma .b-slider.is-light .b-slider-fill{background:#f5f5f5!important}.enable-bulma .b-slider.is-dark .b-slider-fill{background:#363636!important}.enable-bulma .b-slider.is-link .b-slider-fill,.enable-bulma .b-slider.is-primary .b-slider-fill{background:#3273dc!important}.enable-bulma .b-slider.is-info .b-slider-fill{background:#209cee!important}.enable-bulma .b-slider.is-success .b-slider-fill{background:#23d160!important}.enable-bulma .b-slider.is-warning .b-slider-fill{background:#ffdd57!important}.enable-bulma .b-slider.is-danger .b-slider-fill{background:#ff3860!important}.enable-bulma .b-slider .b-slider-tick{position:absolute;width:3px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);top:50%;background:#b5b5b5;border-radius:4px}.enable-bulma .b-slider .b-slider-tick.is-tick-hidden{background:transparent}.enable-bulma .b-steps .steps .step-items{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.enable-bulma .b-steps .steps .step-items .step-item{margin-top:0;position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:1em;flex-basis:1em}.enable-bulma .b-steps .steps .step-items .step-item .step-link{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#4a4a4a}.enable-bulma .b-steps .steps .step-items .step-item .step-link:not(.is-clickable){cursor:not-allowed}.enable-bulma .b-steps .steps .step-items .step-item .step-marker{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;border-radius:4px;font-weight:700;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#b5b5b5;border:.2em solid #fff;z-index:1;overflow:hidden}.enable-bulma .b-steps .steps .step-items .step-item.is-white:after,.enable-bulma .b-steps .steps .step-items .step-item.is-white:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#fff));background:linear-gradient(270deg,#dbdbdb 50%,#fff 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-white.is-active .step-marker{background-color:#fff;border-color:#fff;color:#fff}.enable-bulma .b-steps .steps .step-items .step-item.is-white.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-white.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-white.is-previous .step-marker{color:#0a0a0a;background-color:#fff}.enable-bulma .b-steps .steps .step-items .step-item.is-white.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-white.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-black:after,.enable-bulma .b-steps .steps .step-items .step-item.is-black:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#0a0a0a));background:linear-gradient(270deg,#dbdbdb 50%,#0a0a0a 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-black.is-active .step-marker{background-color:#fff;border-color:#0a0a0a;color:#0a0a0a}.enable-bulma .b-steps .steps .step-items .step-item.is-black.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-black.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-black.is-previous .step-marker{color:#fff;background-color:#0a0a0a}.enable-bulma .b-steps .steps .step-items .step-item.is-black.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-black.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-light:after,.enable-bulma .b-steps .steps .step-items .step-item.is-light:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#f5f5f5));background:linear-gradient(270deg,#dbdbdb 50%,#f5f5f5 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-light.is-active .step-marker{background-color:#fff;border-color:#f5f5f5;color:#f5f5f5}.enable-bulma .b-steps .steps .step-items .step-item.is-light.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-light.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-light.is-previous .step-marker{color:#363636;background-color:#f5f5f5}.enable-bulma .b-steps .steps .step-items .step-item.is-light.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-light.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-dark:after,.enable-bulma .b-steps .steps .step-items .step-item.is-dark:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#363636));background:linear-gradient(270deg,#dbdbdb 50%,#363636 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-dark.is-active .step-marker{background-color:#fff;border-color:#363636;color:#363636}.enable-bulma .b-steps .steps .step-items .step-item.is-dark.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-dark.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-dark.is-previous .step-marker{color:#f5f5f5;background-color:#363636}.enable-bulma .b-steps .steps .step-items .step-item.is-dark.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-dark.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-primary:after,.enable-bulma .b-steps .steps .step-items .step-item.is-primary:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#3273dc));background:linear-gradient(270deg,#dbdbdb 50%,#3273dc 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-primary.is-active .step-marker{background-color:#fff;border-color:#3273dc;color:#3273dc}.enable-bulma .b-steps .steps .step-items .step-item.is-primary.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-primary.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-primary.is-previous .step-marker{color:#fff;background-color:#3273dc}.enable-bulma .b-steps .steps .step-items .step-item.is-primary.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-primary.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-link:after,.enable-bulma .b-steps .steps .step-items .step-item.is-link:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#3273dc));background:linear-gradient(270deg,#dbdbdb 50%,#3273dc 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-link.is-active .step-marker{background-color:#fff;border-color:#3273dc;color:#3273dc}.enable-bulma .b-steps .steps .step-items .step-item.is-link.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-link.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-link.is-previous .step-marker{color:#fff;background-color:#3273dc}.enable-bulma .b-steps .steps .step-items .step-item.is-link.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-link.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-info:after,.enable-bulma .b-steps .steps .step-items .step-item.is-info:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#209cee));background:linear-gradient(270deg,#dbdbdb 50%,#209cee 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-info.is-active .step-marker{background-color:#fff;border-color:#209cee;color:#209cee}.enable-bulma .b-steps .steps .step-items .step-item.is-info.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-info.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-info.is-previous .step-marker{color:#fff;background-color:#209cee}.enable-bulma .b-steps .steps .step-items .step-item.is-info.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-info.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-success:after,.enable-bulma .b-steps .steps .step-items .step-item.is-success:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#23d160));background:linear-gradient(270deg,#dbdbdb 50%,#23d160 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-success.is-active .step-marker{background-color:#fff;border-color:#23d160;color:#23d160}.enable-bulma .b-steps .steps .step-items .step-item.is-success.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-success.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-success.is-previous .step-marker{color:#fff;background-color:#23d160}.enable-bulma .b-steps .steps .step-items .step-item.is-success.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-success.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-warning:after,.enable-bulma .b-steps .steps .step-items .step-item.is-warning:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#ffdd57));background:linear-gradient(270deg,#dbdbdb 50%,#ffdd57 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-warning.is-active .step-marker{background-color:#fff;border-color:#ffdd57;color:#ffdd57}.enable-bulma .b-steps .steps .step-items .step-item.is-warning.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-warning.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-warning.is-previous .step-marker{color:rgba(0,0,0,.7);background-color:#ffdd57}.enable-bulma .b-steps .steps .step-items .step-item.is-warning.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-warning.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-danger:after,.enable-bulma .b-steps .steps .step-items .step-item.is-danger:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#ff3860));background:linear-gradient(270deg,#dbdbdb 50%,#ff3860 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-danger.is-active .step-marker{background-color:#fff;border-color:#ff3860;color:#ff3860}.enable-bulma .b-steps .steps .step-items .step-item.is-danger.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-danger.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-danger.is-previous .step-marker{color:#fff;background-color:#ff3860}.enable-bulma .b-steps .steps .step-items .step-item.is-danger.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-danger.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item .step-marker{color:#fff}.enable-bulma .b-steps .steps .step-items .step-item .step-details{text-align:center;z-index:1}.enable-bulma .b-steps .steps .step-items .step-item:not(:first-child),.enable-bulma .b-steps .steps .step-items .step-item:only-child{-ms-flex-negative:1;flex-shrink:1}.enable-bulma .b-steps .steps .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps .steps .step-items .step-item:only-child:before{content:\" \";display:block;position:absolute;width:100%;bottom:0;left:-50%}.enable-bulma .b-steps .steps .step-items .step-item:only-child:after{content:\" \";display:block;position:absolute;height:.2em;bottom:0}.enable-bulma .b-steps .steps .step-items .step-item:only-child:after,.enable-bulma .b-steps .steps .step-items .step-item:only-child:before{width:25%;left:50%}.enable-bulma .b-steps .steps .step-items .step-item:only-child:before{right:50%;left:auto}.enable-bulma .b-steps .steps .step-items .step-item:after,.enable-bulma .b-steps .steps .step-items .step-item:before{background:-webkit-gradient(linear,right top,left top,color-stop(50%,#dbdbdb),color-stop(50%,#3273dc));background:linear-gradient(270deg,#dbdbdb 50%,#3273dc 0);background-size:200% 100%;background-position:100% 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-active .step-link{cursor:default}.enable-bulma .b-steps .steps .step-items .step-item.is-active .step-marker{background-color:#fff;border-color:#3273dc;color:#3273dc}.enable-bulma .b-steps .steps .step-items .step-item.is-active:after,.enable-bulma .b-steps .steps .step-items .step-item.is-active:before{background-position:0 100%}.enable-bulma .b-steps .steps .step-items .step-item.is-previous .step-marker{color:#fff;background-color:#3273dc}.enable-bulma .b-steps .steps .step-items .step-item.is-previous:after,.enable-bulma .b-steps .steps .step-items .step-item.is-previous:before{background-position:0 100%}.enable-bulma .b-steps .steps+.step-content{position:relative;overflow:visible;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:1rem}.enable-bulma .b-steps .steps+.step-content .step-item{-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.enable-bulma .b-steps .steps+.step-content.is-transitioning{overflow:hidden}.enable-bulma .b-steps .steps.is-rounded .step-item .step-marker{border-radius:290486px}.enable-bulma .b-steps .steps.is-animated .step-item:not(:first-child):before,.enable-bulma .b-steps .steps.is-animated .step-item:only-child:before{-webkit-transition:background .15s ease-out;transition:background .15s ease-out}.enable-bulma .b-steps .steps.has-label-left .step-items .step-item .step-link,.enable-bulma .b-steps .steps.has-label-right .step-items .step-item .step-link{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.enable-bulma .b-steps .steps.has-label-left .step-items .step-item .step-link>.step-details,.enable-bulma .b-steps .steps.has-label-right .step-items .step-item .step-link>.step-details{background-color:#fff;padding:.2em}.enable-bulma .b-steps .steps.has-label-left .step-items .step-item .step-link{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.enable-bulma .b-steps .steps{font-size:1rem;min-height:2rem}.enable-bulma .b-steps .steps .step-items .step-item .step-marker{height:2rem;width:2rem}.enable-bulma .b-steps .steps .step-items .step-item .step-marker .icon *,.enable-bulma .b-steps .steps .step-items .step-item .step-marker .icon :before{font-size:1rem}.enable-bulma .b-steps .steps .step-items .step-item .step-details .step-title{font-size:1.2rem;font-weight:600;line-height:1rem}.enable-bulma .b-steps .steps .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps .steps .step-items .step-item:only-child:before{height:.2em;top:1rem}.enable-bulma .b-steps .steps .step-items .step-item:only-child:after{top:1rem}@media screen and (max-width:768px){.enable-bulma .b-steps .steps .step-items .step-item:after,.enable-bulma .b-steps .steps .step-items .step-item:before,.enable-bulma .b-steps .steps .step-items .step-item:not(:first-child):before{top:1rem}}.enable-bulma .b-steps.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-vertical>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-vertical>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(1rem - .1em)}.enable-bulma .b-steps.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-vertical>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-vertical>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(1rem - .1em)}.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(1rem - .1em)}.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(1rem - .1em)}.enable-bulma .b-steps.is-small .steps{font-size:.75rem;min-height:1.5rem}.enable-bulma .b-steps.is-small .steps .step-items .step-item .step-marker{height:1.5rem;width:1.5rem}.enable-bulma .b-steps.is-small .steps .step-items .step-item .step-marker .icon *,.enable-bulma .b-steps.is-small .steps .step-items .step-item .step-marker .icon :before{font-size:.75rem}.enable-bulma .b-steps.is-small .steps .step-items .step-item .step-details .step-title{font-size:.9rem;font-weight:600;line-height:.75rem}.enable-bulma .b-steps.is-small .steps .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-small .steps .step-items .step-item:only-child:before{height:.2em;top:.75rem}.enable-bulma .b-steps.is-small .steps .step-items .step-item:only-child:after{top:.75rem}@media screen and (max-width:768px){.enable-bulma .b-steps.is-small .steps .step-items .step-item:after,.enable-bulma .b-steps.is-small .steps .step-items .step-item:before,.enable-bulma .b-steps.is-small .steps .step-items .step-item:not(:first-child):before{top:.75rem}}.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(.75rem - .1em)}.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-small.is-vertical>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(.75rem - .1em)}.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(.75rem - .1em)}.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-small.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(.75rem - .1em)}.enable-bulma .b-steps.is-medium .steps{font-size:1.25rem;min-height:2.5rem}.enable-bulma .b-steps.is-medium .steps .step-items .step-item .step-marker{height:2.5rem;width:2.5rem}.enable-bulma .b-steps.is-medium .steps .step-items .step-item .step-marker .icon *,.enable-bulma .b-steps.is-medium .steps .step-items .step-item .step-marker .icon :before{font-size:1.25rem}.enable-bulma .b-steps.is-medium .steps .step-items .step-item .step-details .step-title{font-size:1.5rem;font-weight:600;line-height:1.25rem}.enable-bulma .b-steps.is-medium .steps .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-medium .steps .step-items .step-item:only-child:before{height:.2em;top:1.25rem}.enable-bulma .b-steps.is-medium .steps .step-items .step-item:only-child:after{top:1.25rem}@media screen and (max-width:768px){.enable-bulma .b-steps.is-medium .steps .step-items .step-item:after,.enable-bulma .b-steps.is-medium .steps .step-items .step-item:before,.enable-bulma .b-steps.is-medium .steps .step-items .step-item:not(:first-child):before{top:1.25rem}}.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(1.25rem - .1em)}.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-medium.is-vertical>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(1.25rem - .1em)}.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(1.25rem - .1em)}.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-medium.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(1.25rem - .1em)}.enable-bulma .b-steps.is-large .steps{font-size:1.5rem;min-height:3rem}.enable-bulma .b-steps.is-large .steps .step-items .step-item .step-marker{height:3rem;width:3rem}.enable-bulma .b-steps.is-large .steps .step-items .step-item .step-marker .icon *,.enable-bulma .b-steps.is-large .steps .step-items .step-item .step-marker .icon :before{font-size:1.5rem}.enable-bulma .b-steps.is-large .steps .step-items .step-item .step-details .step-title{font-size:1.8rem;font-weight:600;line-height:1.5rem}.enable-bulma .b-steps.is-large .steps .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-large .steps .step-items .step-item:only-child:before{height:.2em;top:1.5rem}.enable-bulma .b-steps.is-large .steps .step-items .step-item:only-child:after{top:1.5rem}@media screen and (max-width:768px){.enable-bulma .b-steps.is-large .steps .step-items .step-item:after,.enable-bulma .b-steps.is-large .steps .step-items .step-item:before,.enable-bulma .b-steps.is-large .steps .step-items .step-item:not(:first-child):before{top:1.5rem}}.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(1.5rem - .1em)}.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-large.is-vertical>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(1.5rem - .1em)}.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-right .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-right .step-items .step-item:only-child:before{left:calc(1.5rem - .1em)}.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):after,.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-left .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-large.is-vertical.is-right>.steps.has-label-left .step-items .step-item:only-child:before{left:auto;right:calc(1.5rem - .1em)}.enable-bulma .b-steps.is-vertical{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.enable-bulma .b-steps.is-vertical>.steps .step-items{height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-bottom-color:transparent}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:1em 0}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#3273dc));background:linear-gradient(0deg,#dbdbdb 50%,#3273dc 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-white:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-white:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#fff));background:linear-gradient(0deg,#dbdbdb 50%,#fff 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-black:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-black:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#0a0a0a));background:linear-gradient(0deg,#dbdbdb 50%,#0a0a0a 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-light:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-light:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#f5f5f5));background:linear-gradient(0deg,#dbdbdb 50%,#f5f5f5 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-dark:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-dark:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#363636));background:linear-gradient(0deg,#dbdbdb 50%,#363636 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-primary:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-primary:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#3273dc));background:linear-gradient(0deg,#dbdbdb 50%,#3273dc 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-link:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-link:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#3273dc));background:linear-gradient(0deg,#dbdbdb 50%,#3273dc 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-info:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-info:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#209cee));background:linear-gradient(0deg,#dbdbdb 50%,#209cee 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-success:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-success:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#23d160));background:linear-gradient(0deg,#dbdbdb 50%,#23d160 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-warning:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-warning:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#ffdd57));background:linear-gradient(0deg,#dbdbdb 50%,#ffdd57 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-danger:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-danger:before{background:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#dbdbdb),color-stop(50%,#ff3860));background:linear-gradient(0deg,#dbdbdb 50%,#ff3860 0);background-size:100% 200%;background-position:0 100%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:not(:first-child):before,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:only-child:before{height:100%;width:.2em;top:-50%;left:calc(50% - .1em)}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-active:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-active:before,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-previous:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item.is-previous:before{background-position:100% 0}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:only-child:before{top:50%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:only-child:after{width:.2em;top:auto;bottom:50%}.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:only-child:after,.enable-bulma .b-steps.is-vertical>.steps .step-items .step-item:only-child:before{height:25%}.enable-bulma .b-steps.is-vertical>.steps.has-label-right .step-items .step-item{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.enable-bulma .b-steps.is-vertical>.steps.has-label-left .step-items .step-item{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.enable-bulma .b-steps.is-vertical>.steps:not(.has-label-right):not(.has-label-left) .step-items .step-item .step-link>.step-details{background-color:#fff}.enable-bulma .b-steps.is-vertical>.step-content{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.enable-bulma .b-steps.is-vertical>.step-navigation{-ms-flex-preferred-size:100%;flex-basis:100%}.enable-bulma .b-steps.is-vertical.is-right{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}@media screen and (max-width:768px){.enable-bulma .b-steps:not(.is-vertical) .steps.mobile-minimalist .step-items .step-item:not(.is-active){display:none}.enable-bulma .b-steps:not(.is-vertical) .steps.mobile-minimalist .step-items .step-item:after,.enable-bulma .b-steps:not(.is-vertical) .steps.mobile-minimalist .step-items .step-item:before,.enable-bulma .b-steps:not(.is-vertical) .steps.mobile-minimalist .step-items .step-item:not(:first-child):before{content:\" \";display:block;position:absolute;height:.2em;width:25%;bottom:0;left:50%}.enable-bulma .b-steps:not(.is-vertical) .steps.mobile-minimalist .step-items .step-item:before,.enable-bulma .b-steps:not(.is-vertical) .steps.mobile-minimalist .step-items .step-item:not(:first-child):before{right:50%;left:auto}.enable-bulma .b-steps:not(.is-vertical) .steps.mobile-compact .step-items .step-item:not(.is-active) .step-details{display:none}}.enable-bulma .switch{cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;margin-right:.5em}.enable-bulma .switch+.switch:last-child{margin-right:0}.enable-bulma .switch input[type=checkbox]{position:absolute;left:0;opacity:0;outline:none;z-index:-1}.enable-bulma .switch input[type=checkbox]+.check{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;width:2.75em;height:1.575em;padding:.2em;background:#b5b5b5;border-radius:4px;-webkit-transition:background .15s ease-out,-webkit-box-shadow .15s ease-out;transition:background .15s ease-out,-webkit-box-shadow .15s ease-out;transition:background .15s ease-out,box-shadow .15s ease-out;transition:background .15s ease-out,box-shadow .15s ease-out,-webkit-box-shadow .15s ease-out}.enable-bulma .switch input[type=checkbox]+.check.is-white-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#fff}.enable-bulma .switch input[type=checkbox]+.check.is-black-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#0a0a0a}.enable-bulma .switch input[type=checkbox]+.check.is-light-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#f5f5f5}.enable-bulma .switch input[type=checkbox]+.check.is-dark-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#363636}.enable-bulma .switch input[type=checkbox]+.check.is-primary-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#3273dc}.enable-bulma .switch input[type=checkbox]+.check.is-link-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#3273dc}.enable-bulma .switch input[type=checkbox]+.check.is-info-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#209cee}.enable-bulma .switch input[type=checkbox]+.check.is-success-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#23d160}.enable-bulma .switch input[type=checkbox]+.check.is-warning-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#ffdd57}.enable-bulma .switch input[type=checkbox]+.check.is-danger-passive,.enable-bulma .switch input[type=checkbox]+.check:hover{background:#ff3860}.enable-bulma .switch .taginput input[type=checkbox]+.check[type=checkbox].taginput-container.is-focusable+.enable-bulma .switch input[type=checkbox]+.check.check,.enable-bulma .switch input[type=checkbox]+.check.input[type=checkbox]+.enable-bulma .switch input[type=checkbox]+.check.check,.enable-bulma .taginput .switch input[type=checkbox]+.check[type=checkbox].taginput-container.is-focusable+.enable-bulma .switch input[type=checkbox]+.check.check{background:\"pink\"}.enable-bulma .switch input[type=checkbox]+.check:before{content:\"\";display:block;border-radius:4px;width:1.175em;height:1.175em;background:#f5f5f5;-webkit-box-shadow:0 3px 1px 0 rgba(0,0,0,.05),0 2px 2px 0 rgba(0,0,0,.1),0 3px 3px 0 rgba(0,0,0,.05);box-shadow:0 3px 1px 0 rgba(0,0,0,.05),0 2px 2px 0 rgba(0,0,0,.1),0 3px 3px 0 rgba(0,0,0,.05);-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out;will-change:transform;-webkit-transform-origin:left;transform-origin:left}.enable-bulma .switch input[type=checkbox]+.check.is-elastic:before{-webkit-transform:scaleX(1.5);transform:scaleX(1.5);border-radius:4px}.enable-bulma .switch input[type=checkbox]:checked+.check{background:#3273dc}.enable-bulma .switch input[type=checkbox]:checked+.check.is-white{background:#fff}.enable-bulma .switch input[type=checkbox]:checked+.check.is-black{background:#0a0a0a}.enable-bulma .switch input[type=checkbox]:checked+.check.is-light{background:#f5f5f5}.enable-bulma .switch input[type=checkbox]:checked+.check.is-dark{background:#363636}.enable-bulma .switch input[type=checkbox]:checked+.check.is-primary{background:#3273dc}.enable-bulma .switch input[type=checkbox]:checked+.check.is-link{background:#3273dc}.enable-bulma .switch input[type=checkbox]:checked+.check.is-info{background:#209cee}.enable-bulma .switch input[type=checkbox]:checked+.check.is-success{background:#23d160}.enable-bulma .switch input[type=checkbox]:checked+.check.is-warning{background:#ffdd57}.enable-bulma .switch input[type=checkbox]:checked+.check.is-danger{background:#ff3860}.enable-bulma .switch input[type=checkbox]:checked+.check:before{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.enable-bulma .switch input[type=checkbox]:checked+.check.is-elastic:before{-webkit-transform:translate3d(50%,0,0) scaleX(1.5);transform:translate3d(50%,0,0) scaleX(1.5)}.enable-bulma .switch input[type=checkbox]:active,.enable-bulma .switch input[type=checkbox]:focus{outline:none}.enable-bulma .switch input[type=checkbox]:active+.check,.enable-bulma .switch input[type=checkbox]:focus+.check{-webkit-box-shadow:0 0 .5em hsla(0,0%,47.8%,.6);box-shadow:0 0 .5em hsla(0,0%,47.8%,.6)}.enable-bulma .switch input[type=checkbox]:active+.check.is-white-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-white-passive{-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.8);box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-black-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-black-passive{-webkit-box-shadow:0 0 .5em rgba(10,10,10,.8);box-shadow:0 0 .5em rgba(10,10,10,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-light-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-light-passive{-webkit-box-shadow:0 0 .5em hsla(0,0%,96.1%,.8);box-shadow:0 0 .5em hsla(0,0%,96.1%,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-dark-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-dark-passive{-webkit-box-shadow:0 0 .5em rgba(54,54,54,.8);box-shadow:0 0 .5em rgba(54,54,54,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-primary-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-primary-passive{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-link-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-link-passive{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-info-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-info-passive{-webkit-box-shadow:0 0 .5em rgba(32,156,238,.8);box-shadow:0 0 .5em rgba(32,156,238,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-success-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-success-passive{-webkit-box-shadow:0 0 .5em rgba(35,209,96,.8);box-shadow:0 0 .5em rgba(35,209,96,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-warning-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-warning-passive{-webkit-box-shadow:0 0 .5em rgba(255,221,87,.8);box-shadow:0 0 .5em rgba(255,221,87,.8)}.enable-bulma .switch input[type=checkbox]:active+.check.is-danger-passive,.enable-bulma .switch input[type=checkbox]:focus+.check.is-danger-passive{-webkit-box-shadow:0 0 .5em rgba(255,56,96,.8);box-shadow:0 0 .5em rgba(255,56,96,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check,.enable-bulma .switch input[type=checkbox]:focus:checked+.check{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-white,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-white{-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.8);box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-black,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-black{-webkit-box-shadow:0 0 .5em rgba(10,10,10,.8);box-shadow:0 0 .5em rgba(10,10,10,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-light,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-light{-webkit-box-shadow:0 0 .5em hsla(0,0%,96.1%,.8);box-shadow:0 0 .5em hsla(0,0%,96.1%,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-dark,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-dark{-webkit-box-shadow:0 0 .5em rgba(54,54,54,.8);box-shadow:0 0 .5em rgba(54,54,54,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-primary,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-primary{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-link,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-link{-webkit-box-shadow:0 0 .5em rgba(50,115,220,.8);box-shadow:0 0 .5em rgba(50,115,220,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-info,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-info{-webkit-box-shadow:0 0 .5em rgba(32,156,238,.8);box-shadow:0 0 .5em rgba(32,156,238,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-success,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-success{-webkit-box-shadow:0 0 .5em rgba(35,209,96,.8);box-shadow:0 0 .5em rgba(35,209,96,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-warning,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-warning{-webkit-box-shadow:0 0 .5em rgba(255,221,87,.8);box-shadow:0 0 .5em rgba(255,221,87,.8)}.enable-bulma .switch input[type=checkbox]:active:checked+.check.is-danger,.enable-bulma .switch input[type=checkbox]:focus:checked+.check.is-danger{-webkit-box-shadow:0 0 .5em rgba(255,56,96,.8);box-shadow:0 0 .5em rgba(255,56,96,.8)}.enable-bulma .switch .control-label{padding-left:.5em}.enable-bulma .switch:hover input[type=checkbox]+.check{background:hsla(0,0%,71%,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-white-passive{background:hsla(0,0%,100%,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-black-passive{background:rgba(10,10,10,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-light-passive{background:hsla(0,0%,96.1%,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-dark-passive{background:rgba(54,54,54,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-primary-passive{background:rgba(50,115,220,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-link-passive{background:rgba(50,115,220,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-info-passive{background:rgba(32,156,238,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-success-passive{background:rgba(35,209,96,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-warning-passive{background:rgba(255,221,87,.9)}.enable-bulma .switch:hover input[type=checkbox]+.check.is-danger-passive{background:rgba(255,56,96,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check{background:rgba(50,115,220,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-white{background:hsla(0,0%,100%,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-black{background:rgba(10,10,10,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-light{background:hsla(0,0%,96.1%,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-dark{background:rgba(54,54,54,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-primary{background:rgba(50,115,220,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-link{background:rgba(50,115,220,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-info{background:rgba(32,156,238,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-success{background:rgba(35,209,96,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-warning{background:rgba(255,221,87,.9)}.enable-bulma .switch:hover input[type=checkbox]:checked+.check.is-danger{background:rgba(255,56,96,.9)}.enable-bulma .switch.is-rounded input[type=checkbox]+.check{border-radius:290486px}.enable-bulma .switch.is-rounded input[type=checkbox]+.check:before{border-radius:290486px}.enable-bulma .switch.is-rounded input[type=checkbox].is-elastic:before{-webkit-transform:scaleX(1.5);transform:scaleX(1.5);border-radius:290486px}.enable-bulma .switch.is-outlined input[type=checkbox]+.check{background:transparent;border:.1rem solid #b5b5b5}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-white-passive{border:.1rem solid hsla(0,0%,100%,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-white-passive:before{background:#fff}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-white-passive:hover{border-color:hsla(0,0%,100%,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-black-passive{border:.1rem solid rgba(10,10,10,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-black-passive:before{background:#0a0a0a}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-black-passive:hover{border-color:rgba(10,10,10,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-light-passive{border:.1rem solid hsla(0,0%,96.1%,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-light-passive:before{background:#f5f5f5}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-light-passive:hover{border-color:hsla(0,0%,96.1%,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-dark-passive{border:.1rem solid rgba(54,54,54,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-dark-passive:before{background:#363636}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-dark-passive:hover{border-color:rgba(54,54,54,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-primary-passive{border:.1rem solid rgba(50,115,220,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-primary-passive:before{background:#3273dc}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-primary-passive:hover{border-color:rgba(50,115,220,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-link-passive{border:.1rem solid rgba(50,115,220,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-link-passive:before{background:#3273dc}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-link-passive:hover{border-color:rgba(50,115,220,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-info-passive{border:.1rem solid rgba(32,156,238,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-info-passive:before{background:#209cee}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-info-passive:hover{border-color:rgba(32,156,238,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-success-passive{border:.1rem solid rgba(35,209,96,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-success-passive:before{background:#23d160}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-success-passive:hover{border-color:rgba(35,209,96,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-warning-passive{border:.1rem solid rgba(255,221,87,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-warning-passive:before{background:#ffdd57}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-warning-passive:hover{border-color:rgba(255,221,87,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-danger-passive{border:.1rem solid rgba(255,56,96,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-danger-passive:before{background:#ff3860}.enable-bulma .switch.is-outlined input[type=checkbox]+.check.is-danger-passive:hover{border-color:rgba(255,56,96,.9)}.enable-bulma .switch.is-outlined input[type=checkbox]+.check:before{background:#b5b5b5}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check{border-color:#3273dc}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-white{background:transparent;border-color:#fff}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-white:before{background:#fff}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-black{background:transparent;border-color:#0a0a0a}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-black:before{background:#0a0a0a}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-light{background:transparent;border-color:#f5f5f5}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-light:before{background:#f5f5f5}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-dark{background:transparent;border-color:#363636}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-dark:before{background:#363636}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-primary{background:transparent;border-color:#3273dc}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-primary:before{background:#3273dc}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-link{background:transparent;border-color:#3273dc}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-link:before{background:#3273dc}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-info{background:transparent;border-color:#209cee}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-info:before{background:#209cee}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-success{background:transparent;border-color:#23d160}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-success:before{background:#23d160}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-warning{background:transparent;border-color:#ffdd57}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-warning:before{background:#ffdd57}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-danger{background:transparent;border-color:#ff3860}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check.is-danger:before{background:#ff3860}.enable-bulma .switch.is-outlined input[type=checkbox]:checked+.check:before{background:#3273dc}.enable-bulma .switch.is-outlined:hover input[type=checkbox]+.check{background:transparent;border-color:hsla(0,0%,71%,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check{background:transparent;border-color:rgba(50,115,220,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-white{border-color:hsla(0,0%,100%,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-black{border-color:rgba(10,10,10,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-light{border-color:hsla(0,0%,96.1%,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-dark{border-color:rgba(54,54,54,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-primary{border-color:rgba(50,115,220,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-link{border-color:rgba(50,115,220,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-info{border-color:rgba(32,156,238,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-success{border-color:rgba(35,209,96,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-warning{border-color:rgba(255,221,87,.9)}.enable-bulma .switch.is-outlined:hover input[type=checkbox]:checked+.check.is-danger{border-color:rgba(255,56,96,.9)}.enable-bulma .switch.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .switch.is-medium{font-size:1.25rem}.enable-bulma .switch.is-large{font-size:1.5rem}.enable-bulma .switch[disabled]{opacity:.5;cursor:not-allowed;color:#7a7a7a}.enable-bulma .table-wrapper .table{margin-bottom:0}.enable-bulma .table-wrapper:not(:last-child){margin-bottom:1.5rem}@media screen and (max-width:1023px){.enable-bulma .table-wrapper{overflow-x:auto}}.enable-bulma .b-table{-webkit-transition:opacity 86ms ease-out;transition:opacity 86ms ease-out}@media print,screen and (min-width:769px){.enable-bulma .b-table .table-mobile-sort{display:none}}.enable-bulma .b-table .icon{-webkit-transition:opacity 86ms ease-out,-webkit-transform .15s ease-out;transition:opacity 86ms ease-out,-webkit-transform .15s ease-out;transition:transform .15s ease-out,opacity 86ms ease-out;transition:transform .15s ease-out,opacity 86ms ease-out,-webkit-transform .15s ease-out}.enable-bulma .b-table .icon.is-desc{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.enable-bulma .b-table .icon.is-expanded{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.enable-bulma .b-table .table{width:100%;border:1px solid transparent;border-radius:4px;border-collapse:separate}.enable-bulma .b-table .table th{font-weight:600}.enable-bulma .b-table .table th .th-wrap{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.enable-bulma .b-table .table th .th-wrap .icon{margin-left:.5rem;margin-right:0;font-size:1rem}.enable-bulma .b-table .table th .th-wrap.is-numeric{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;text-align:right}.enable-bulma .b-table .table th .th-wrap.is-numeric .icon{margin-left:0;margin-right:.5rem}.enable-bulma .b-table .table th .th-wrap.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.enable-bulma .b-table .table th.is-current-sort{border-color:#7a7a7a;font-weight:700}.enable-bulma .b-table .table th.is-sortable:hover{border-color:#7a7a7a}.enable-bulma .b-table .table th.is-sortable,.enable-bulma .b-table .table th.is-sortable .th-wrap{cursor:pointer}.enable-bulma .b-table .table th .multi-sort-cancel-icon{margin-left:10px}.enable-bulma .b-table .table th.is-sticky{position:sticky;left:0;z-index:3!important;background:#fff}.enable-bulma .b-table .table tr.is-selected .checkbox input:checked+.check{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%233273dc'/%3E%3C/svg%3E\") no-repeat 50%}.enable-bulma .b-table .table tr.is-selected .checkbox input+.check{border-color:#fff}.enable-bulma .b-table .table tr.is-empty:hover{background-color:transparent}.enable-bulma .b-table .table .chevron-cell{vertical-align:middle}.enable-bulma .b-table .table .checkbox-cell{width:40px}.enable-bulma .b-table .table .checkbox-cell .checkbox{vertical-align:middle}.enable-bulma .b-table .table .checkbox-cell .checkbox .check{-webkit-transition:none;transition:none}.enable-bulma .b-table .table tr.detail{-webkit-box-shadow:inset 0 1px 3px #dbdbdb;box-shadow:inset 0 1px 3px #dbdbdb;background:#fafafa}.enable-bulma .b-table .table tr.detail .detail-container{padding:1rem}.enable-bulma .b-table .table:focus{border-color:#3273dc;-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .b-table .table.is-bordered th.is-current-sort,.enable-bulma .b-table .table.is-bordered th.is-sortable:hover{border-color:#dbdbdb;background:#f5f5f5}.enable-bulma .b-table .table td.is-sticky{position:sticky;left:0;z-index:1;background:#fff}.enable-bulma .b-table .level:not(.top){padding-bottom:1.5rem}.enable-bulma .b-table .table-wrapper.has-sticky-header{height:300px;overflow-y:auto}@media screen and (max-width:768px){.enable-bulma .b-table .table-wrapper.has-sticky-header.has-mobile-cards{height:auto!important;overflow-y:initial!important}}.enable-bulma .b-table .table-wrapper.has-sticky-header tr:first-child th{position:sticky;top:0;z-index:2;background:#fff}@media screen and (max-width:768px){.enable-bulma .b-table .table-wrapper.has-mobile-cards thead{display:none}.enable-bulma .b-table .table-wrapper.has-mobile-cards tfoot th{border:0;display:inherit}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr{-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);max-width:100%;position:relative;display:block}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr td{border:0;display:inherit}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr td:last-child{border-bottom:0}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr:not(:last-child){margin-bottom:1rem}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr:not([class*=is-]){background:inherit}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr:not([class*=is-]):hover{background-color:inherit}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr.detail{margin-top:-1rem}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td{display:-webkit-box;display:-ms-flexbox;display:flex;width:auto;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-align:right;border-bottom:1px solid #f5f5f5}.enable-bulma .b-table .table-wrapper.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td:before{content:attr(data-label);font-weight:600;padding-right:.5em;text-align:left}}.enable-bulma .b-table .table-wrapper.is-card-list thead{display:none}.enable-bulma .b-table .table-wrapper.is-card-list tfoot th{border:0;display:inherit}.enable-bulma .b-table .table-wrapper.is-card-list tr{-webkit-box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);box-shadow:0 2px 3px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);max-width:100%;position:relative;display:block}.enable-bulma .b-table .table-wrapper.is-card-list tr td{border:0;display:inherit}.enable-bulma .b-table .table-wrapper.is-card-list tr td:last-child{border-bottom:0}.enable-bulma .b-table .table-wrapper.is-card-list tr:not(:last-child){margin-bottom:1rem}.enable-bulma .b-table .table-wrapper.is-card-list tr:not([class*=is-]){background:inherit}.enable-bulma .b-table .table-wrapper.is-card-list tr:not([class*=is-]):hover{background-color:inherit}.enable-bulma .b-table .table-wrapper.is-card-list tr.detail{margin-top:-1rem}.enable-bulma .b-table .table-wrapper.is-card-list tr:not(.detail):not(.is-empty):not(.table-footer) td{display:-webkit-box;display:-ms-flexbox;display:flex;width:auto;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-align:right;border-bottom:1px solid #f5f5f5}.enable-bulma .b-table .table-wrapper.is-card-list tr:not(.detail):not(.is-empty):not(.table-footer) td:before{content:attr(data-label);font-weight:600;padding-right:.5em;text-align:left}.enable-bulma .b-table.is-loading{position:relative;pointer-events:none;opacity:.5}.enable-bulma .b-table.is-loading:after{-webkit-animation:spinAround .5s linear infinite;animation:spinAround .5s linear infinite;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em;position:absolute;top:4em;left:calc(50% - 2.5em);width:5em;height:5em;border-width:.25em}.enable-bulma .b-tabs .tabs{margin-bottom:0;-ms-flex-negative:0;flex-shrink:0}.enable-bulma .b-tabs .tabs li.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.enable-bulma .b-tabs .tab-content{position:relative;overflow:visible;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:1rem}.enable-bulma .b-tabs .tab-content .tab-item{-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.enable-bulma .b-tabs .tab-content.is-transitioning{overflow:hidden}.enable-bulma .b-tabs:not(:last-child){margin-bottom:1.5rem}.enable-bulma .b-tabs.is-fullwidth{width:100%}.enable-bulma .b-tabs.is-vertical{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.enable-bulma .b-tabs.is-vertical>.tabs ul{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-bottom-color:transparent}.enable-bulma .b-tabs.is-vertical>.tabs ul li{width:100%}.enable-bulma .b-tabs.is-vertical>.tabs ul li a{-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left}.enable-bulma .b-tabs.is-vertical>.tabs.is-boxed li a{border-bottom-color:transparent!important;border-right-color:#dbdbdb!important;border-radius:4px 0 0 4px}.enable-bulma .b-tabs.is-vertical>.tabs.is-boxed li.is-active a{border-bottom-color:#dbdbdb!important;border-right-color:transparent!important}.enable-bulma .b-tabs.is-vertical>.tabs.is-toggle li+li{margin-left:0}.enable-bulma .b-tabs.is-vertical>.tabs.is-toggle li:first-child a{border-radius:4px 4px 0 0}.enable-bulma .b-tabs.is-vertical>.tabs.is-toggle li:last-child a{border-radius:0 0 4px 4px}.enable-bulma .b-tabs.is-vertical>.tabs.is-fullwidth li a{height:100%}.enable-bulma .b-tabs.is-vertical>.tab-content{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.enable-bulma .b-tabs.is-vertical.is-right{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.enable-bulma .b-tabs.is-vertical.is-right>.tabs ul a{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.enable-bulma .b-tabs.is-vertical.is-right>.tabs ul a .icon:first-child{margin-right:0;margin-left:.5em}.enable-bulma .b-tabs.is-vertical.is-right>.tabs.is-boxed li a{border-bottom-color:transparent!important;border-right-color:transparent!important;border-left-color:#dbdbdb!important;border-radius:0 4px 4px 0}.enable-bulma .b-tabs.is-vertical.is-right>.tabs.is-boxed li.is-active a{border-bottom-color:#dbdbdb!important;border-right-color:#dbdbdb!important;border-left-color:transparent!important}.enable-bulma .b-tabs.is-multiline>.tabs ul{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-negative:1;flex-shrink:1}.enable-bulma .tag .has-ellipsis{max-width:10em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.enable-bulma .tag .delete.is-white,.enable-bulma .tag.is-delete.is-white{background:#fff}.enable-bulma .tag .delete.is-white:hover,.enable-bulma .tag.is-delete.is-white:hover{background-color:#e6e6e6}.enable-bulma .tag .delete.is-black,.enable-bulma .tag.is-delete.is-black{background:#0a0a0a}.enable-bulma .tag .delete.is-black:hover,.enable-bulma .tag.is-delete.is-black:hover{background-color:#000}.enable-bulma .tag .delete.is-light,.enable-bulma .tag.is-delete.is-light{background:#f5f5f5}.enable-bulma .tag .delete.is-light:hover,.enable-bulma .tag.is-delete.is-light:hover{background-color:#dbdbdb}.enable-bulma .tag .delete.is-dark,.enable-bulma .tag.is-delete.is-dark{background:#363636}.enable-bulma .tag .delete.is-dark:hover,.enable-bulma .tag.is-delete.is-dark:hover{background-color:#1c1c1c}.enable-bulma .tag .delete.is-primary,.enable-bulma .tag.is-delete.is-primary{background:#3273dc}.enable-bulma .tag .delete.is-primary:hover,.enable-bulma .tag.is-delete.is-primary:hover{background-color:#205bbb}.enable-bulma .tag .delete.is-link,.enable-bulma .tag.is-delete.is-link{background:#3273dc}.enable-bulma .tag .delete.is-link:hover,.enable-bulma .tag.is-delete.is-link:hover{background-color:#205bbc}.enable-bulma .tag .delete.is-info,.enable-bulma .tag.is-delete.is-info{background:#209cee}.enable-bulma .tag .delete.is-info:hover,.enable-bulma .tag.is-delete.is-info:hover{background-color:#0f81cc}.enable-bulma .tag .delete.is-success,.enable-bulma .tag.is-delete.is-success{background:#23d160}.enable-bulma .tag .delete.is-success:hover,.enable-bulma .tag.is-delete.is-success:hover{background-color:#1ca64c}.enable-bulma .tag .delete.is-warning,.enable-bulma .tag.is-delete.is-warning{background:#ffdd57}.enable-bulma .tag .delete.is-warning:hover,.enable-bulma .tag.is-delete.is-warning:hover{background-color:#ffd324}.enable-bulma .tag .delete.is-danger,.enable-bulma .tag.is-delete.is-danger{background:#ff3860}.enable-bulma .tag .delete.is-danger:hover,.enable-bulma .tag.is-delete.is-danger:hover{background-color:#ff0537}.enable-bulma .taginput .taginput-container{display:-webkit-box;display:-ms-flexbox;display:flex}.enable-bulma .taginput .taginput-container.is-focusable{padding-bottom:0;padding-top:calc(.275em - 1px);padding-left:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;height:auto;cursor:text}.enable-bulma .taginput .taginput-container:not(.is-focusable){-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;height:auto}.enable-bulma .taginput .taginput-container:not(.is-focusable).is-small{border-radius:2px;font-size:.75rem}.enable-bulma .taginput .taginput-container:not(.is-focusable).is-medium{font-size:1.25rem}.enable-bulma .taginput .taginput-container:not(.is-focusable).is-large{font-size:1.5rem}.enable-bulma .taginput .taginput-container>.tag,.enable-bulma .taginput .taginput-container>.tags{margin-left:.275rem;margin-bottom:calc(.275em - 1px);font-size:.9em;height:1.7em}.enable-bulma .taginput .taginput-container>.tag .tag,.enable-bulma .taginput .taginput-container>.tags .tag{margin-bottom:0;font-size:.9em;height:1.7em}.enable-bulma .taginput .taginput-container>.tag .tag.is-delete,.enable-bulma .taginput .taginput-container>.tags .tag.is-delete{width:1.7em}.enable-bulma .taginput .taginput-container .autocomplete{position:static;-webkit-box-flex:1;-ms-flex:1;flex:1}.enable-bulma .taginput .taginput-container .autocomplete input{height:1.7em;margin-bottom:calc(.275em - 1px);padding-top:0;padding-bottom:0;border:none;-webkit-box-shadow:none;box-shadow:none;min-width:8em}.enable-bulma .taginput .taginput-container .autocomplete input:focus{-webkit-box-shadow:none!important;box-shadow:none!important}.enable-bulma .taginput .taginput-container .autocomplete .icon{height:1.7em}.enable-bulma .taginput .taginput-container .autocomplete>.control.is-loading:after{top:.375em}.enable-bulma .timepicker .dropdown-menu{min-width:0}.enable-bulma .timepicker .dropdown,.enable-bulma .timepicker .dropdown-trigger{width:100%}.enable-bulma .taginput .timepicker .dropdown-trigger [readonly].taginput-container.is-focusable,.enable-bulma .taginput .timepicker .dropdown [readonly].taginput-container.is-focusable,.enable-bulma .timepicker .dropdown-trigger .input[readonly],.enable-bulma .timepicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable,.enable-bulma .timepicker .dropdown .input[readonly],.enable-bulma .timepicker .dropdown .taginput [readonly].taginput-container.is-focusable{cursor:pointer;-webkit-box-shadow:inset 0 1px 2px rgba(10,10,10,.1);box-shadow:inset 0 1px 2px rgba(10,10,10,.1)}.enable-bulma .taginput .timepicker .dropdown-trigger [readonly].is-active.taginput-container.is-focusable,.enable-bulma .taginput .timepicker .dropdown-trigger [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .taginput .timepicker .dropdown-trigger [readonly].taginput-container.is-focusable:active,.enable-bulma .taginput .timepicker .dropdown-trigger [readonly].taginput-container.is-focusable:focus,.enable-bulma .taginput .timepicker .dropdown [readonly].is-active.taginput-container.is-focusable,.enable-bulma .taginput .timepicker .dropdown [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .taginput .timepicker .dropdown [readonly].taginput-container.is-focusable:active,.enable-bulma .taginput .timepicker .dropdown [readonly].taginput-container.is-focusable:focus,.enable-bulma .timepicker .dropdown-trigger .input[readonly].is-active,.enable-bulma .timepicker .dropdown-trigger .input[readonly].is-focused,.enable-bulma .timepicker .dropdown-trigger .input[readonly]:active,.enable-bulma .timepicker .dropdown-trigger .input[readonly]:focus,.enable-bulma .timepicker .dropdown-trigger .taginput [readonly].is-active.taginput-container.is-focusable,.enable-bulma .timepicker .dropdown-trigger .taginput [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .timepicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable:active,.enable-bulma .timepicker .dropdown-trigger .taginput [readonly].taginput-container.is-focusable:focus,.enable-bulma .timepicker .dropdown .input[readonly].is-active,.enable-bulma .timepicker .dropdown .input[readonly].is-focused,.enable-bulma .timepicker .dropdown .input[readonly]:active,.enable-bulma .timepicker .dropdown .input[readonly]:focus,.enable-bulma .timepicker .dropdown .taginput [readonly].is-active.taginput-container.is-focusable,.enable-bulma .timepicker .dropdown .taginput [readonly].is-focused.taginput-container.is-focusable,.enable-bulma .timepicker .dropdown .taginput [readonly].taginput-container.is-focusable:active,.enable-bulma .timepicker .dropdown .taginput [readonly].taginput-container.is-focusable:focus{-webkit-box-shadow:0 0 0 .125em rgba(50,115,220,.25);box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.enable-bulma .timepicker .dropdown.is-disabled{opacity:1}.enable-bulma .dropdown .dropdown-menu .has-link .timepicker a,.enable-bulma .timepicker .dropdown-item,.enable-bulma .timepicker .dropdown .dropdown-menu .has-link a{font-size:inherit;padding:0}.enable-bulma .timepicker .timepicker-footer{padding:0 .5rem 0 .5rem}.enable-bulma .timepicker .dropdown-content .control{font-size:1.25em;margin-right:0!important}.enable-bulma .timepicker .dropdown-content .control .select select{font-weight:600;padding-right:calc(.625em - 1px);border:0}.enable-bulma .timepicker .dropdown-content .control .select select option:disabled{color:hsla(0,0%,47.8%,.7)}.enable-bulma .timepicker .dropdown-content .control .select:after{display:none}.enable-bulma .timepicker .dropdown-content .control.is-colon{font-size:1.7em}.enable-bulma .timepicker.is-small{border-radius:2px;font-size:.75rem}.enable-bulma .timepicker.is-medium{font-size:1.25rem}.enable-bulma .timepicker.is-large{font-size:1.5rem}.enable-bulma .b-tooltip{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.enable-bulma .b-tooltip.is-top:after,.enable-bulma .b-tooltip.is-top:before{top:auto;right:auto;bottom:calc(100% + 7px);left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.enable-bulma .b-tooltip.is-top.is-white:before{border-top:5px solid #fff;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-black:before{border-top:5px solid #0a0a0a;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-light:before{border-top:5px solid #f5f5f5;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-dark:before{border-top:5px solid #363636;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-primary:before{border-top:5px solid #3273dc;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-link:before{border-top:5px solid #3273dc;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-info:before{border-top:5px solid #209cee;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-success:before{border-top:5px solid #23d160;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-warning:before{border-top:5px solid #ffdd57;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-danger:before{border-top:5px solid #ff3860;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.enable-bulma .b-tooltip.is-top.is-multiline.is-small:after{width:180px}.enable-bulma .b-tooltip.is-top.is-multiline.is-medium:after{width:240px}.enable-bulma .b-tooltip.is-top.is-multiline.is-large:after{width:300px}.enable-bulma .b-tooltip.is-right:after,.enable-bulma .b-tooltip.is-right:before{top:50%;right:auto;bottom:auto;left:calc(100% + 7px);-webkit-transform:translateY(-50%);transform:translateY(-50%)}.enable-bulma .b-tooltip.is-right.is-white:before{border-top:5px solid transparent;border-right:5px solid #fff;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-black:before{border-top:5px solid transparent;border-right:5px solid #0a0a0a;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-light:before{border-top:5px solid transparent;border-right:5px solid #f5f5f5;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-dark:before{border-top:5px solid transparent;border-right:5px solid #363636;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-primary:before{border-top:5px solid transparent;border-right:5px solid #3273dc;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-link:before{border-top:5px solid transparent;border-right:5px solid #3273dc;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-info:before{border-top:5px solid transparent;border-right:5px solid #209cee;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-success:before{border-top:5px solid transparent;border-right:5px solid #23d160;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-warning:before{border-top:5px solid transparent;border-right:5px solid #ffdd57;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-danger:before{border-top:5px solid transparent;border-right:5px solid #ff3860;border-bottom:5px solid transparent;left:calc(100% + 2px)}.enable-bulma .b-tooltip.is-right.is-multiline.is-small:after{width:180px}.enable-bulma .b-tooltip.is-right.is-multiline.is-medium:after{width:240px}.enable-bulma .b-tooltip.is-right.is-multiline.is-large:after{width:300px}.enable-bulma .b-tooltip.is-bottom:after,.enable-bulma .b-tooltip.is-bottom:before{top:calc(100% + 7px);right:auto;bottom:auto;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.enable-bulma .b-tooltip.is-bottom.is-white:before{border-right:5px solid transparent;border-bottom:5px solid #fff;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-black:before{border-right:5px solid transparent;border-bottom:5px solid #0a0a0a;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-light:before{border-right:5px solid transparent;border-bottom:5px solid #f5f5f5;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-dark:before{border-right:5px solid transparent;border-bottom:5px solid #363636;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-primary:before{border-right:5px solid transparent;border-bottom:5px solid #3273dc;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-link:before{border-right:5px solid transparent;border-bottom:5px solid #3273dc;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-info:before{border-right:5px solid transparent;border-bottom:5px solid #209cee;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-success:before{border-right:5px solid transparent;border-bottom:5px solid #23d160;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-warning:before{border-right:5px solid transparent;border-bottom:5px solid #ffdd57;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-danger:before{border-right:5px solid transparent;border-bottom:5px solid #ff3860;border-left:5px solid transparent;top:calc(100% + 2px)}.enable-bulma .b-tooltip.is-bottom.is-multiline.is-small:after{width:180px}.enable-bulma .b-tooltip.is-bottom.is-multiline.is-medium:after{width:240px}.enable-bulma .b-tooltip.is-bottom.is-multiline.is-large:after{width:300px}.enable-bulma .b-tooltip.is-left:after,.enable-bulma .b-tooltip.is-left:before{top:50%;right:calc(100% + 7px);bottom:auto;left:auto;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.enable-bulma .b-tooltip.is-left.is-white:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #fff;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-black:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #0a0a0a;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-light:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #f5f5f5;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-dark:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #363636;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-primary:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #3273dc;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-link:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #3273dc;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-info:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #209cee;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-success:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #23d160;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-warning:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #ffdd57;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-danger:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #ff3860;right:calc(100% + 2px)}.enable-bulma .b-tooltip.is-left.is-multiline.is-small:after{width:180px}.enable-bulma .b-tooltip.is-left.is-multiline.is-medium:after{width:240px}.enable-bulma .b-tooltip.is-left.is-multiline.is-large:after{width:300px}.enable-bulma .b-tooltip:after,.enable-bulma .b-tooltip:before{position:absolute;content:\"\";opacity:0;visibility:hidden;pointer-events:none}.enable-bulma .b-tooltip:before{z-index:39}.enable-bulma .b-tooltip:after{content:attr(data-label);width:auto;padding:.35rem .75rem;border-radius:6px;font-size:.85rem;font-weight:400;-webkit-box-shadow:0 1px 2px 1px rgba(0,1,0,.2);box-shadow:0 1px 2px 1px rgba(0,1,0,.2);z-index:38;white-space:nowrap}.enable-bulma .b-tooltip:not([data-label=\"\"]):hover:after,.enable-bulma .b-tooltip:not([data-label=\"\"]):hover:before{-webkit-transition-delay:inherit;transition-delay:inherit;opacity:1;visibility:visible}.enable-bulma .b-tooltip.is-white:after{background:#fff;color:#0a0a0a}.enable-bulma .b-tooltip.is-black:after{background:#0a0a0a;color:#fff}.enable-bulma .b-tooltip.is-light:after{background:#f5f5f5;color:#363636}.enable-bulma .b-tooltip.is-dark:after{background:#363636;color:#f5f5f5}.enable-bulma .b-tooltip.is-primary:after{background:#3273dc;color:#fff}.enable-bulma .b-tooltip.is-link:after{background:#3273dc;color:#fff}.enable-bulma .b-tooltip.is-info:after{background:#209cee;color:#fff}.enable-bulma .b-tooltip.is-success:after{background:#23d160;color:#fff}.enable-bulma .b-tooltip.is-warning:after{background:#ffdd57;color:rgba(0,0,0,.7)}.enable-bulma .b-tooltip.is-danger:after{background:#ff3860;color:#fff}.enable-bulma .b-tooltip:not([data-label=\"\"]).is-always:after,.enable-bulma .b-tooltip:not([data-label=\"\"]).is-always:before{opacity:1;visibility:visible}.enable-bulma .b-tooltip.is-multiline:after{display:flex-block;text-align:center;white-space:normal}.enable-bulma .b-tooltip.is-dashed{border-bottom:1px dashed #b5b5b5;cursor:default}.enable-bulma .b-tooltip.is-square:after{border-radius:0}.enable-bulma .b-tooltip.is-animated:after,.enable-bulma .b-tooltip.is-animated:before{-webkit-transition:opacity 86ms ease-out,visibility 86ms ease-out;transition:opacity 86ms ease-out,visibility 86ms ease-out}.enable-bulma .upload{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.enable-bulma .upload input[type=file]{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;outline:none;cursor:pointer;z-index:-1}.enable-bulma .upload .upload-draggable{cursor:pointer;padding:.25em;border:1px dashed #b5b5b5;border-radius:6px}.enable-bulma .upload .upload-draggable.is-disabled{opacity:.5;cursor:not-allowed}.enable-bulma .upload .upload-draggable.is-loading{position:relative;pointer-events:none;opacity:.5}.enable-bulma .upload .upload-draggable.is-loading:after{-webkit-animation:spinAround .5s linear infinite;animation:spinAround .5s linear infinite;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em;top:0;left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.enable-bulma .upload .upload-draggable.is-hovered.is-white,.enable-bulma .upload .upload-draggable:hover.is-white{border-color:#fff;background:hsla(0,0%,100%,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-black,.enable-bulma .upload .upload-draggable:hover.is-black{border-color:#0a0a0a;background:rgba(10,10,10,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-light,.enable-bulma .upload .upload-draggable:hover.is-light{border-color:#f5f5f5;background:hsla(0,0%,96.1%,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-dark,.enable-bulma .upload .upload-draggable:hover.is-dark{border-color:#363636;background:rgba(54,54,54,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-primary,.enable-bulma .upload .upload-draggable:hover.is-primary{border-color:#3273dc;background:rgba(50,115,220,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-link,.enable-bulma .upload .upload-draggable:hover.is-link{border-color:#3273dc;background:rgba(50,115,220,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-info,.enable-bulma .upload .upload-draggable:hover.is-info{border-color:#209cee;background:rgba(32,156,238,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-success,.enable-bulma .upload .upload-draggable:hover.is-success{border-color:#23d160;background:rgba(35,209,96,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-warning,.enable-bulma .upload .upload-draggable:hover.is-warning{border-color:#ffdd57;background:rgba(255,221,87,.05)}.enable-bulma .upload .upload-draggable.is-hovered.is-danger,.enable-bulma .upload .upload-draggable:hover.is-danger{border-color:#ff3860;background:rgba(255,56,96,.05)}.enable-bulma .upload.is-expanded,.enable-bulma .upload .upload-draggable.is-expanded{width:100%}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){.enable-bulma .upload input[type=file]{z-index:auto}.enable-bulma .upload .upload-draggable+input[type=file]{z-index:-1}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "157c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "16d1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var DESCRIPTORS = __webpack_require__("d4cb");
var ownKeys = __webpack_require__("a03e");
var toIndexedObject = __webpack_require__("378c");
var getOwnPropertyDescriptorModule = __webpack_require__("185a");
var createProperty = __webpack_require__("dac6");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "174d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("d4cb");
var fails = __webpack_require__("72df");
var objectKeys = __webpack_require__("0c47");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var propertyIsEnumerableModule = __webpack_require__("e129");
var toObject = __webpack_require__("37d1");
var IndexedObject = __webpack_require__("83a6");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  /* global Symbol -- required for testing */
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "185a":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var propertyIsEnumerableModule = __webpack_require__("e129");
var createPropertyDescriptor = __webpack_require__("9618");
var toIndexedObject = __webpack_require__("378c");
var toPrimitive = __webpack_require__("083f");
var has = __webpack_require__("f1a7");
var IE8_DOM_DEFINE = __webpack_require__("7c3f");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "189b":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var wellKnownSymbol = __webpack_require__("7d53");
var V8_VERSION = __webpack_require__("4fed");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1a5f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidCron = void 0;
// This comes from the fact that parseInt trims characters coming
// after digits and consider it a valid int, so `1*` becomes `1`.
var safeParseInt = function (value) {
    if (/^\d+$/.test(value)) {
        return Number(value);
    }
    else {
        return NaN;
    }
};
var isWildcard = function (value) {
    return value === '*';
};
var isQuestionMark = function (value) {
    return value === '?';
};
var isInRange = function (value, start, stop) {
    return value >= start && value <= stop;
};
var isValidRange = function (value, start, stop) {
    var sides = value.split('-');
    switch (sides.length) {
        case 1:
            return isWildcard(value) || isInRange(safeParseInt(value), start, stop);
        case 2:
            var _a = sides.map(function (side) { return safeParseInt(side); }), small = _a[0], big = _a[1];
            return small <= big && isInRange(small, start, stop) && isInRange(big, start, stop);
        default:
            return false;
    }
};
var isValidStep = function (value) {
    return value === undefined || (value.search(/[^\d]/) === -1 && safeParseInt(value) > 0);
};
var validateForRange = function (value, start, stop) {
    if (value.search(/[^\d-,\/*]/) !== -1) {
        return false;
    }
    var list = value.split(',');
    return list.every(function (condition) {
        var splits = condition.split('/');
        // Prevents `*/ * * * *` from being accepted.
        if (condition.trim().endsWith('/')) {
            return false;
        }
        // Prevents `*/*/* * * * *` from being accepted
        if (splits.length > 2) {
            return false;
        }
        // If we don't have a `/`, right will be undefined which is considered a valid step if we don't a `/`.
        var left = splits[0], right = splits[1];
        return isValidRange(left, start, stop) && isValidStep(right);
    });
};
var hasValidSeconds = function (seconds) {
    return validateForRange(seconds, 0, 59);
};
var hasValidMinutes = function (minutes) {
    return validateForRange(minutes, 0, 59);
};
var hasValidHours = function (hours) {
    return validateForRange(hours, 0, 23);
};
var hasValidDays = function (days, allowBlankDay) {
    return (allowBlankDay && isQuestionMark(days)) || validateForRange(days, 1, 31);
};
var monthAlias = {
    jan: '1',
    feb: '2',
    mar: '3',
    apr: '4',
    may: '5',
    jun: '6',
    jul: '7',
    aug: '8',
    sep: '9',
    oct: '10',
    nov: '11',
    dec: '12'
};
var hasValidMonths = function (months, alias) {
    // Prevents alias to be used as steps
    if (months.search(/\/[a-zA-Z]/) !== -1) {
        return false;
    }
    if (alias) {
        var remappedMonths = months.toLowerCase().replace(/[a-z]{3}/g, function (match) {
            return monthAlias[match] === undefined ? match : monthAlias[match];
        });
        // If any invalid alias was used, it won't pass the other checks as there will be non-numeric values in the months
        return validateForRange(remappedMonths, 1, 12);
    }
    return validateForRange(months, 1, 12);
};
var weekdaysAlias = {
    sun: '0',
    mon: '1',
    tue: '2',
    wed: '3',
    thu: '4',
    fri: '5',
    sat: '6'
};
var hasValidWeekdays = function (weekdays, alias, allowBlankDay, allowSevenAsSunday) {
    // If there is a question mark, checks if the allowBlankDay flag is set
    if (allowBlankDay && isQuestionMark(weekdays)) {
        return true;
    }
    else if (!allowBlankDay && isQuestionMark(weekdays)) {
        return false;
    }
    // Prevents alias to be used as steps
    if (weekdays.search(/\/[a-zA-Z]/) !== -1) {
        return false;
    }
    if (alias) {
        var remappedWeekdays = weekdays.toLowerCase().replace(/[a-z]{3}/g, function (match) {
            return weekdaysAlias[match] === undefined ? match : weekdaysAlias[match];
        });
        // If any invalid alias was used, it won't pass the other checks as there will be non-numeric values in the weekdays
        return validateForRange(remappedWeekdays, 0, allowSevenAsSunday ? 7 : 6);
    }
    return validateForRange(weekdays, 0, allowSevenAsSunday ? 7 : 6);
};
var hasCompatibleDayFormat = function (days, weekdays, allowBlankDay) {
    return !(allowBlankDay && isQuestionMark(days) && isQuestionMark(weekdays));
};
var split = function (cron) {
    return cron.trim().split(/\s+/);
};
var defaultOptions = {
    alias: false,
    seconds: false,
    allowBlankDay: false,
    allowSevenAsSunday: false
};
exports.isValidCron = function (cron, options) {
    options = __assign(__assign({}, defaultOptions), options);
    var splits = split(cron);
    if (splits.length > (options.seconds ? 6 : 5) || splits.length < 5) {
        return false;
    }
    var checks = [];
    if (splits.length === 6) {
        var seconds = splits.shift();
        if (seconds) {
            checks.push(hasValidSeconds(seconds));
        }
    }
    // We could only check the steps gradually and return false on the first invalid block,
    // However, this won't have any performance impact so why bother for now.
    var minutes = splits[0], hours = splits[1], days = splits[2], months = splits[3], weekdays = splits[4];
    checks.push(hasValidMinutes(minutes));
    checks.push(hasValidHours(hours));
    checks.push(hasValidDays(days, options.allowBlankDay));
    checks.push(hasValidMonths(months, options.alias));
    checks.push(hasValidWeekdays(weekdays, options.alias, options.allowBlankDay, options.allowSevenAsSunday));
    checks.push(hasCompatibleDayFormat(days, weekdays, options.allowBlankDay));
    return checks.every(Boolean);
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "1c25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("405b")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"6264aff6-vue-loader-template"}!C:/dev/wrk/vue-cron-editor/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/dev/wrk/vue-cron-editor/node_modules/cache-loader/dist/cjs.js??ref--0-0!C:/dev/wrk/vue-cron-editor/node_modules/vue-loader/lib??vue-loader-options!./VueCronEditorBuefy.vue?vue&type=template&id=f981891a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.visibleTabs.join(),staticClass:"enable-bulma"},[_c('b-tabs',{on:{"input":_vm.reset},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.visibleTabs.includes('minutes'))?_c('b-tab-item',{staticClass:"minutes-tab",attrs:{"value":"0","label":_vm._$t('minutes')}},[_c('div',{staticClass:"card"},[_c('b-field',[_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("every")))]),_c('b-numberinput',{attrs:{"controls":false},model:{value:(_vm.editorData.minuteInterval),callback:function ($$v) {_vm.$set(_vm.editorData, "minuteInterval", $$v)},expression:"editorData.minuteInterval"}}),_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("mminutes")))])],1)],1)]):_vm._e(),(_vm.visibleTabs.includes('hourly'))?_c('b-tab-item',{staticClass:"hourly-tab",attrs:{"value":"1","label":_vm._$t('hourly')}},[_c('div',{staticClass:"card"},[_c('b-field',[_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("every")))]),_c('b-numberinput',{attrs:{"controls":false},model:{value:(_vm.editorData.hourInterval),callback:function ($$v) {_vm.$set(_vm.editorData, "hourInterval", $$v)},expression:"editorData.hourInterval"}}),_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("hoursOnMinute")))]),_c('b-numberinput',{attrs:{"controls":false,"min":0,"max":59},model:{value:(_vm.editorData.minutes),callback:function ($$v) {_vm.$set(_vm.editorData, "minutes", $$v)},expression:"editorData.minutes"}})],1)],1)]):_vm._e(),(_vm.visibleTabs.includes('daily'))?_c('b-tab-item',{staticClass:"daily-tab",attrs:{"value":"2","label":_vm._$t('daily')}},[_c('div',{staticClass:"card"},[_c('b-field',[_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("every")))]),_c('b-numberinput',{attrs:{"controls":false},model:{value:(_vm.editorData.dayInterval),callback:function ($$v) {_vm.$set(_vm.editorData, "dayInterval", $$v)},expression:"editorData.dayInterval"}}),_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("daysAt")))]),_c('b-timepicker',{attrs:{"icon":"clock","editable":"","value":_vm.dateTime,"hour-format":"12","mobile-native":false},on:{"input":_vm.setDateTime}})],1)],1)]):_vm._e(),(_vm.visibleTabs.includes('weekly'))?_c('b-tab-item',{staticClass:"weekly-tab",attrs:{"value":"3","label":_vm._$t('weekly')}},[_c('div',{staticClass:"card"},[_c('b-field',[_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("everyDay")))]),_c('div',{staticClass:"centered-checkbox-group"},[_c('b-checkbox',{attrs:{"native-value":"SUN"},model:{value:(_vm.editorData.days),callback:function ($$v) {_vm.$set(_vm.editorData, "days", $$v)},expression:"editorData.days"}},[_vm._v(" "+_vm._s(_vm._$t("sun"))+" ")]),_c('b-checkbox',{attrs:{"native-value":"MON"},model:{value:(_vm.editorData.days),callback:function ($$v) {_vm.$set(_vm.editorData, "days", $$v)},expression:"editorData.days"}},[_vm._v(" "+_vm._s(_vm._$t("mon"))+" ")]),_c('b-checkbox',{attrs:{"native-value":"TUE"},model:{value:(_vm.editorData.days),callback:function ($$v) {_vm.$set(_vm.editorData, "days", $$v)},expression:"editorData.days"}},[_vm._v(" "+_vm._s(_vm._$t("tue"))+" ")]),_c('b-checkbox',{attrs:{"native-value":"WED"},model:{value:(_vm.editorData.days),callback:function ($$v) {_vm.$set(_vm.editorData, "days", $$v)},expression:"editorData.days"}},[_vm._v(" "+_vm._s(_vm._$t("wed"))+" ")]),_c('b-checkbox',{attrs:{"native-value":"THU"},model:{value:(_vm.editorData.days),callback:function ($$v) {_vm.$set(_vm.editorData, "days", $$v)},expression:"editorData.days"}},[_vm._v(" "+_vm._s(_vm._$t("thu"))+" ")]),_c('b-checkbox',{attrs:{"native-value":"FRI"},model:{value:(_vm.editorData.days),callback:function ($$v) {_vm.$set(_vm.editorData, "days", $$v)},expression:"editorData.days"}},[_vm._v(" "+_vm._s(_vm._$t("fri"))+" ")]),_c('b-checkbox',{attrs:{"native-value":"SAT"},model:{value:(_vm.editorData.days),callback:function ($$v) {_vm.$set(_vm.editorData, "days", $$v)},expression:"editorData.days"}},[_vm._v(" "+_vm._s(_vm._$t("sat"))+" ")])],1),_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("at")))]),_c('b-timepicker',{attrs:{"icon":"clock","editable":"","value":_vm.dateTime,"hour-format":"12","mobile-native":false},on:{"input":_vm.setDateTime}})],1)],1)]):_vm._e(),(_vm.visibleTabs.includes('monthly'))?_c('b-tab-item',{staticClass:"monthly-tab",attrs:{"value":"4","label":_vm._$t('monthly')}},[_c('div',{staticClass:"card"},[_c('b-field',[_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("onThe")))]),_c('b-numberinput',{attrs:{"controls":false},model:{value:(_vm.editorData.day),callback:function ($$v) {_vm.$set(_vm.editorData, "day", $$v)},expression:"editorData.day"}}),_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("dayOfEvery")))]),_c('b-numberinput',{attrs:{"min":1,"max":12,"controls":false},model:{value:(_vm.editorData.monthInterval),callback:function ($$v) {_vm.$set(_vm.editorData, "monthInterval", $$v)},expression:"editorData.monthInterval"}}),_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("monthsAt")))]),_c('b-timepicker',{attrs:{"icon":"clock","editable":"","value":_vm.dateTime,"hour-format":"12","mobile-native":false},on:{"input":_vm.setDateTime}})],1)],1)]):_vm._e(),(_vm.visibleTabs.includes('advanced'))?_c('b-tab-item',{staticClass:"advanced-tab",attrs:{"value":"5","label":_vm._$t('advanced')}},[_c('div',{staticClass:"card"},[_c('b-field',[_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm._$t("cronExpression")))]),_c('b-input',{model:{value:(_vm.editorData.cronExpression),callback:function ($$v) {_vm.$set(_vm.editorData, "cronExpression", $$v)},expression:"editorData.cronExpression"}}),_c('span',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm.explanation))])],1)],1)]):_vm._e()],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./VueCronEditorBuefy.vue?vue&type=template&id=f981891a&

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("841a");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("f8a5");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("d6de");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("2d6d");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("75a4");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("fa8c");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("16d1");

// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/@babel/runtime/helpers/esm/objectSpread2.js








function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("2007");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("8d0d");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("c78b");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/cron-validator/lib/index.js
var lib = __webpack_require__("1a5f");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/cronstrue/i18n.js
var i18n = __webpack_require__("5bed");

// CONCATENATED MODULE: ./core/i18n.ts

var defaultLocales = {
  en: {
    every: "Every",
    mminutes: "minute(s)",
    hoursOnMinute: "hour(s) on minute",
    daysAt: "day(s) at",
    at: "at",
    onThe: "On the",
    dayOfEvery: "day, of every",
    monthsAt: "month(s), at",
    everyDay: "Every",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    hasToBeBetween: "Has to be between",
    and: "and",
    minutes: "MINUTES",
    hourly: "HOURLY",
    daily: "DAILY",
    weekly: "WEEKLY",
    monthly: "MONTHLY",
    advanced: "ADVANCED",
    cronExpression: "Cron expression:"
  },
  pl: {
    every: "Co",
    mminutes: "minut",
    hoursOnMinute: "godzin w minucie",
    daysAt: "dni o",
    at: "o",
    onThe: "",
    dayOfEvery: "dzień miesiąca, co",
    monthsAt: "miesięcy, o godzinie",
    everyDay: "W każdy",
    mon: "Pon",
    tue: "Wt",
    wed: "Śr",
    thu: "Czw",
    fri: "Pt",
    sat: "So",
    sun: "Nie",
    hasToBeBetween: "Wymagana wartość pomiędzy",
    and: "i",
    minutes: "MINUTY",
    hourly: "GODZINY",
    daily: "DNI",
    weekly: "TYGODNIE",
    monthly: "MIESIĄCE",
    advanced: "ZAAWANSOWANE",
    cronExpression: "Wyrażenie cron:"
  },
  it: {
    every: "Ogni",
    mminutes: "minuto/i",
    hoursOnMinute: "ora/e al minuto",
    daysAt: "giorno/i alle",
    at: "alle",
    onThe: "Al",
    dayOfEvery: "giorno, di ogni",
    monthsAt: "mese/i, alle",
    everyDay: "Ogni",
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Gio",
    fri: "Ven",
    sat: "Sab",
    sun: "Dom",
    hasToBeBetween: "Deve essere tra",
    and: "e",
    minutes: "MINUTI",
    hourly: "OGNI ORA",
    daily: "OGNI GIORNO",
    weekly: "OGNI SETTIMANA",
    monthly: "OGNI MESE",
    advanced: "AVANZATO",
    cronExpression: "Espressione cron:"
  },
  pt: {
    every: "A cada",
    mminutes: "minuto(s)",
    hoursOnMinute: "horas(s) deste minuto",
    daysAt: "dias(s) às",
    at: "às",
    onThe: "No ",
    dayOfEvery: "dia, de todos",
    monthsAt: "mês(es), às",
    everyDay: "Todo(a)",
    mon: "Seg",
    tue: "Ter",
    wed: "Qua",
    thu: "Qui",
    fri: "Sex",
    sat: "Sab",
    sun: "Dom",
    hasToBeBetween: "Deve ser entre",
    and: "e",
    minutes: "MINUTOS",
    hourly: "HORAS",
    daily: "DIÁRIO",
    weekly: "SEMANAL",
    monthly: "MENSAL",
    advanced: "AVANÇADO",
    cronExpression: "Expressão cron:"
  },
  es: {
    every: "Cada",
    mminutes: "minuto(s)",
    hoursOnMinute: "hora(s), en el minuto",
    daysAt: "dia(s) a las",
    at: "a las",
    onThe: "El día",
    dayOfEvery: "del mes, cada",
    monthsAt: "mes(es), a las",
    everyDay: "Cada",
    mon: "Lun",
    tue: "Mar",
    wed: "Mie",
    thu: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom",
    hasToBeBetween: "Entre",
    and: "y",
    minutes: "CADA MINUTO(s)",
    hourly: "CADA HORA(s)",
    daily: "DIARIAMENTE",
    weekly: "SEMANALMENTE",
    monthly: "MENSUALMENTE",
    advanced: "AVANZADO",
    cronExpression: "Expresión CRON:"
  }
};
function toCronstrueLocale(locale) {
  if (locale == "pt") return "pt_BR";else return locale;
}
function createI18n(customLocales, locale) {
  var allLocales = _objectSpread2(_objectSpread2({}, defaultLocales), customLocales);

  return allLocales[locale] || allLocales["en"];
}
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("b55a");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("58d3");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("2aa5");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("cfce");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("33ef");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("32f5");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("62c8");

// CONCATENATED MODULE: ./core/dayAliases.ts




var aliasToNumberMapping = {
  SUN: 0,
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6
};
function toDayNumber(alias) {
  var number = aliasToNumberMapping[alias];

  if (number == undefined) {
    throw new Error("unhandled alias " + alias);
  }

  return number;
}
function toDayAlias(num) {
  var alias = Object.keys(aliasToNumberMapping).find(function (k) {
    return aliasToNumberMapping[k] === num;
  });

  if (alias == undefined) {
    throw new Error("unhandled number ".concat(num));
  }

  return alias;
}
function isDayAlias(s) {
  return Object.keys(aliasToNumberMapping).includes(s);
}
// CONCATENATED MODULE: ./core/parseExpression.ts









/**
 * parseExpression
 * Parses given expression and picks a matching tab for it.
 * It would be best if it was not dependent on cron syntax or too many configurable options.
 */


function parseSubExpr(expr) {
  expr = expr.trim();
  var match;

  if ((match = expr.match(/\*\/(\d+)/)) != null) {
    return {
      type: "cronNumber",
      at: {
        type: "asterisk"
      },
      every: {
        type: "number",
        value: parseInt(match[1])
      }
    };
  }

  if ((match = expr.match(/(\d+)\/(\d+)/)) != null) {
    return {
      type: "cronNumber",
      at: {
        type: "number",
        value: parseInt(match[1])
      },
      every: {
        type: "number",
        value: parseInt(match[2])
      }
    };
  }

  if ((match = expr.match(/(\d+)/)) != null) {
    return {
      type: "number",
      value: parseInt(match[1])
    };
  }

  if (expr == "?") {
    return {
      type: "question"
    };
  }

  if (expr == "*") {
    return {
      type: "asterisk"
    };
  }

  throw new Error("Unhandled subexpression: ".concat(expr));
}

function parseDayOfWeek(expr) {
  expr = expr.trim();
  if (expr == "*") return {
    type: "asterisk"
  };
  if (expr == "?") return {
    type: "question"
  };
  var groups = expr.match(/([a-zA-Z0-9]+)(,[a-zA-Z0-9]+)?(,[a-zA-Z0-9]+)?(,[a-zA-Z0-9]+)?(,[a-zA-Z0-9]+)?(,[a-zA-Z0-9]+)?(,[a-zA-Z0-9]+)?/);
  if (groups == null) throw new Error("invalid days expression: ".concat(expr));
  return {
    type: "setOfDays",
    days: groups.slice(1).map(function (d) {
      return d && d.replace(/,/, "");
    }).filter(function (d) {
      return d;
    }).map(function (d) {
      return !isDayAlias(d) ? toDayAlias(parseInt(d)) : d;
    })
  };
}

var isAny = function isAny(token) {
  return token.type == "question" || token.type == "asterisk";
};

var isAnyTime = function isAnyTime(token) {
  return token.type == "asterisk" || token.type == "number" && token.value == 0;
};

var parseExpression = function parseExpression(expression) {
  var advanced = {
    type: "advanced",
    cronExpression: expression
  };
  var groups = expression.split(" ");

  if (groups.length != 5 && groups.length != 6) {
    return advanced;
  }

  var cron = groups.length == 6 ? {
    seconds: parseSubExpr(groups[0]),
    minutes: parseSubExpr(groups[1]),
    hours: parseSubExpr(groups[2]),
    dayOfTheMonth: parseSubExpr(groups[3]),
    month: parseSubExpr(groups[4]),
    dayOfWeek: parseDayOfWeek(groups[5])
  } : {
    minutes: parseSubExpr(groups[0]),
    hours: parseSubExpr(groups[1]),
    dayOfTheMonth: parseSubExpr(groups[2]),
    month: parseSubExpr(groups[3]),
    dayOfWeek: parseDayOfWeek(groups[4])
  };
  if (cron.minutes.type == "cronNumber" && isAnyTime(cron.minutes.at) && cron.hours.type == "asterisk" && cron.dayOfTheMonth.type == "asterisk" && cron.month.type == "asterisk" && isAny(cron.dayOfWeek)) return {
    type: "minutes",
    minuteInterval: cron.minutes.every.value
  };
  if (cron.minutes.type == "number" && cron.hours.type == "cronNumber" && isAnyTime(cron.hours.at) && cron.dayOfTheMonth.type == "asterisk" && cron.month.type == "asterisk" && isAny(cron.dayOfWeek)) return {
    type: "hourly",
    minutes: cron.minutes.value,
    hourInterval: cron.hours.every.value
  };
  if (cron.minutes.type == "number" && cron.hours.type == "number" && cron.dayOfTheMonth.type == "cronNumber" && cron.dayOfTheMonth.at.type == "asterisk" && cron.month.type == "asterisk" && isAny(cron.dayOfWeek)) return {
    type: "daily",
    minutes: cron.minutes.value,
    hours: cron.hours.value,
    dayInterval: cron.dayOfTheMonth.every.value
  };
  if (cron.minutes.type == "number" && cron.hours.type == "number" && isAny(cron.dayOfTheMonth) && cron.month.type == "asterisk" && cron.dayOfWeek.type == "setOfDays") return {
    type: "weekly",
    minutes: cron.minutes.value,
    hours: cron.hours.value,
    days: cron.dayOfWeek.days
  };
  if (cron.minutes.type == "number" && cron.hours.type == "number" && cron.dayOfTheMonth.type == "number" && cron.month.type == "cronNumber" && cron.month.at.type == "asterisk" && isAny(cron.dayOfWeek)) return {
    type: "monthly",
    minutes: cron.minutes.value,
    hours: cron.hours.value,
    day: cron.dayOfTheMonth.value,
    monthInterval: cron.month.every.value
  };
  return advanced;
};
// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("d86f");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("ef14");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("ef1f");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("0d9f");

// CONCATENATED MODULE: ./core/buildExpression.ts






function isStateValid(e) {
  if (e.type == "weekly" && e.days.length == 0) return false;else return true;
}
var buildExpression_buildExpression = function buildExpression(syntax, state) {
  if (syntax == "basic") {
    if (state.type === "minutes") {
      return "*/".concat(state.minuteInterval, " * * * *");
    }

    if (state.type === "hourly") {
      return "".concat(state.minutes, " */").concat(state.hourInterval, " * * *");
    }

    if (state.type === "daily") {
      return "".concat(state.minutes, " ").concat(state.hours, " */").concat(state.dayInterval, " * *");
    }

    if (state.type === "weekly") {
      var days = state.days.map(function (d) {
        return toDayNumber(d).toString();
      }).sort().join(",");
      return "".concat(state.minutes, " ").concat(state.hours, " * * ").concat(days);
    }

    if (state.type === "monthly") {
      return "".concat(state.minutes, " ").concat(state.hours, " ").concat(state.day, " */").concat(state.monthInterval, " *");
    }

    if (state.type === "advanced") {
      return state.cronExpression;
    }

    throw "unknown event type: ".concat(state);
  } else if (syntax === "quartz") {
    if (state.type === "minutes") {
      return "0 0/".concat(state.minuteInterval, " * * * ?");
    }

    if (state.type === "hourly") {
      return "0 ".concat(state.minutes, " 0/").concat(state.hourInterval, " * * ?");
    }

    if (state.type === "daily") {
      return "0 ".concat(state.minutes, " ").concat(state.hours, " */").concat(state.dayInterval, " * ?");
    }

    if (state.type === "weekly") {
      var _days = state.days.map(function (d) {
        return toDayNumber(d);
      }).sort().map(function (d) {
        return toDayAlias(d);
      }).join(",");

      return "0 ".concat(state.minutes, " ").concat(state.hours, " ? * ").concat(_days);
    }

    if (state.type === "monthly") {
      return "0 ".concat(state.minutes, " ").concat(state.hours, " ").concat(state.day, " */").concat(state.monthInterval, " ?");
    }

    if (state.type === "advanced") {
      return state.cronExpression;
    }

    throw "unknown event type: ".concat(state);
  }

  throw "unknown syntax: ".concat(syntax);
};
// CONCATENATED MODULE: ./core/vueCronEditorMixin.ts





/**
 * vueCronEditorMixin
 * Core logic of a component.
 * Functionality dependent on UI frameworks should be implemented in derived components
 */






var initialData = {
  minutes: {
    type: "minutes",
    minuteInterval: 1
  },
  hourly: {
    type: "hourly",
    minutes: 0,
    hourInterval: 1
  },
  daily: {
    type: "daily",
    minutes: 0,
    hours: 0,
    dayInterval: 1
  },
  weekly: {
    type: "weekly",
    minutes: 0,
    hours: 0,
    days: ["MON"]
  },
  monthly: {
    type: "monthly",
    hours: 0,
    minutes: 0,
    day: 1,
    monthInterval: 1
  },
  advanced: {
    type: "advanced",
    cronExpression: ""
  }
};
/* harmony default export */ var vueCronEditorMixin = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  created: function created() {
    this.i18n = createI18n(this.customLocales, this.locale);
    this.innerValue = this.value;

    this.__loadDataFromExpression();
  },
  props: {
    value: {
      type: String,
      default: "*/1 * * * *"
    },
    visibleTabs: {
      type: Array,
      default: function _default() {
        return ["minutes", "hourly", "daily", "weekly", "monthly", "advanced"];
      }
    },
    preserveStateOnSwitchToAdvanced: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: "en"
    },
    customLocales: {
      type: Object,
      default: null
    },
    cronSyntax: {
      type: String,
      default: "basic"
    }
  },
  data: function data() {
    return {
      innerValue: "*/1 * * * *",
      editorData: Object.assign({}, initialData.minutes),
      currentTab: "minutes",
      i18n: null
    };
  },
  computed: {
    explanation: function explanation() {
      if (!this.innerValue) return "";
      var cronstrueLocale = toCronstrueLocale(this.locale);
      return i18n["toString"](this.innerValue, {
        locale: cronstrueLocale
      });
    }
  },
  methods: {
    _$t: function _$t(key) {
      return this.i18n[key];
    },
    __loadDataFromExpression: function __loadDataFromExpression() {
      var tabData = parseExpression(this.value);

      if (!this.visibleTabs.includes(tabData.type)) {
        this.editorData = {
          type: "advanced",
          cronExpression: this.value
        };
        this.currentTab = "advanced";
        return;
      }

      this.editorData = _objectSpread2({}, tabData);
      this.currentTab = tabData.type;
    },
    __updateCronExpression: function __updateCronExpression(state) {
      if (!isStateValid(state)) {
        this.innerValue = null;
        this.$emit("input", null);
        return;
      }

      var cronExpression = buildExpression_buildExpression(this.cronSyntax, _objectSpread2({}, state));

      if (!this._isValidExpression(cronExpression)) {
        this.innerValue = null;
        this.$emit("input", null);
        return;
      }

      this.innerValue = cronExpression;
      this.$emit("input", cronExpression);
    },
    _isValidExpression: function _isValidExpression(cronExpression) {
      var options = this.cronSyntax == "quartz" ? {
        seconds: true,
        allowBlankDay: true,
        alias: true
      } : undefined;
      return lib["isValidCron"](cronExpression, options);
    },
    _resetToTab: function _resetToTab(tabKey) {
      this.currentTab = tabKey;

      if (this.preserveStateOnSwitchToAdvanced && tabKey === "advanced") {
        this.editorData = {
          type: "advanced",
          cronExpression: this.innerValue
        };
        return;
      }

      this.editorData = Object.assign({}, initialData[tabKey]);

      this.__updateCronExpression(initialData[tabKey]);
    }
  },
  watch: {
    locale: function locale() {
      this.i18n = createI18n(this.customLocales, this.locale);
    },
    value: {
      handler: function handler() {
        if (this.value == this.innerValue) {
          return;
        }

        this.__loadDataFromExpression();
      }
    },
    cronSyntax: function cronSyntax() {
      this.__updateCronExpression(JSON.parse(JSON.stringify(this.editorData)));
    },
    editorData: {
      deep: true,
      handler: function handler(changedData) {
        var nonReactiveData = JSON.parse(JSON.stringify(changedData));

        this.__updateCronExpression(nonReactiveData);
      }
    }
  }
}));
// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/buefy/dist/components/field/index.js
var field = __webpack_require__("b2ff");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/buefy/dist/components/input/index.js
var input = __webpack_require__("6203");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/buefy/dist/components/tabs/index.js
var tabs = __webpack_require__("7c9b");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/buefy/dist/components/timepicker/index.js
var timepicker = __webpack_require__("d1c3");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/buefy/dist/components/numberinput/index.js
var numberinput = __webpack_require__("d74b");

// EXTERNAL MODULE: C:/dev/wrk/vue-cron-editor/node_modules/buefy/dist/components/checkbox/index.js
var components_checkbox = __webpack_require__("9e10");

// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/cache-loader/dist/cjs.js??ref--12-0!C:/dev/wrk/vue-cron-editor/node_modules/thread-loader/dist/cjs.js!C:/dev/wrk/vue-cron-editor/node_modules/babel-loader/lib!C:/dev/wrk/vue-cron-editor/node_modules/cache-loader/dist/cjs.js??ref--0-0!C:/dev/wrk/vue-cron-editor/node_modules/vue-loader/lib??vue-loader-options!./VueCronEditorBuefy.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var lib_vue_loader_options_VueCronEditorBuefyvue_type_script_lang_js_ = ({
  name: "VueCronEditorBuefy",
  mixins: [vueCronEditorMixin],
  components: {
    BField: field["BField"],
    BInput: input["BInput"],
    BTabs: tabs["BTabs"],
    BTabItem: tabs["BTabItem"],
    BTimepicker: timepicker["BTimepicker"],
    BNumberinput: numberinput["BNumberinput"],
    BCheckbox: components_checkbox["BCheckbox"]
  },
  data: function data() {
    return {
      activeTab: null,
      tabs: [{
        id: "0",
        key: "minutes"
      }, {
        id: "1",
        key: "hourly"
      }, {
        id: "2",
        key: "daily"
      }, {
        id: "3",
        key: "weekly"
      }, {
        id: "4",
        key: "monthly"
      }, {
        id: "5",
        key: "advanced"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.activeTab = this.tabs.find(function (t) {
      return t.key === _this.currentTab;
    }).id;
  },
  watch: {
    currentTab: function currentTab() {
      var _this2 = this;

      this.activeTab = this.tabs.find(function (t) {
        return t.key === _this2.currentTab;
      }).id;
    }
  },
  computed: {
    dateTime: function dateTime() {
      var dateTime = new Date();
      dateTime.setHours(this.editorData.hours);
      dateTime.setMinutes(this.editorData.minutes);
      return dateTime;
    }
  },
  methods: {
    reset: function reset(e) {
      var tabKey = this.tabs.find(function (t) {
        return t.id === e;
      }).key;

      this._resetToTab(tabKey);
    },
    setDateTime: function setDateTime(e) {
      if (e == null) {
        return;
      }

      this.editorData.hours = e.getHours();
      this.editorData.minutes = e.getMinutes();
    }
  }
});
// CONCATENATED MODULE: ./VueCronEditorBuefy.vue?vue&type=script&lang=js&
 /* harmony default export */ var VueCronEditorBuefyvue_type_script_lang_js_ = (lib_vue_loader_options_VueCronEditorBuefyvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./VueCronEditorBuefy.vue?vue&type=style&index=0&lang=scss&
var VueCronEditorBuefyvue_type_style_index_0_lang_scss_ = __webpack_require__("e345");

// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./VueCronEditorBuefy.vue






/* normalize component */

var component = normalizeComponent(
  VueCronEditorBuefyvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VueCronEditorBuefy = (component.exports);
// CONCATENATED MODULE: C:/dev/wrk/vue-cron-editor/node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (VueCronEditorBuefy);



/***/ }),

/***/ "1d8a":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "1f5e":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("378c");
var toLength = __webpack_require__("b495");
var toAbsoluteIndex = __webpack_require__("9a0f");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "2007":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var assign = __webpack_require__("174d");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "2117":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("8697");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "2402":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var exec = __webpack_require__("42c5");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "2d6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $filter = __webpack_require__("d054").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "2f6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("72df");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "32f5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("95b2");
var anObject = __webpack_require__("157c");
var toLength = __webpack_require__("b495");
var toInteger = __webpack_require__("8bb2");
var requireObjectCoercible = __webpack_require__("730c");
var advanceStringIndex = __webpack_require__("e3f6");
var getSubstitution = __webpack_require__("79b4");
var regExpExec = __webpack_require__("df8c");

var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
});


/***/ }),

/***/ "332c":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("4cdd");
var uid = __webpack_require__("1d8a");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "33ef":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var isObject = __webpack_require__("7526");
var isArray = __webpack_require__("c6de");
var toAbsoluteIndex = __webpack_require__("9a0f");
var toLength = __webpack_require__("b495");
var toIndexedObject = __webpack_require__("378c");
var createProperty = __webpack_require__("dac6");
var wellKnownSymbol = __webpack_require__("7d53");
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "378c":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("83a6");
var requireObjectCoercible = __webpack_require__("730c");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "37d1":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("730c");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "3c10":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "3cec":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "3e32":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "3e34":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var createNonEnumerableProperty = __webpack_require__("5b12");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "3e36":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");

module.exports = global;


/***/ }),

/***/ "405b":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "42c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("abfd");
var stickyHelpers = __webpack_require__("2f6a");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
// eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "433a":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("157c");
var aFunction = __webpack_require__("8697");
var wellKnownSymbol = __webpack_require__("7d53");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4a27":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("149f");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("0ed3").default
var update = add("0b5d0a8b", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4cdd":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("0e93");
var store = __webpack_require__("c607");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.9.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "4db4":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("e7a0");

module.exports = NATIVE_SYMBOL
  /* global Symbol -- safe */
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "4e41":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "4fed":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var userAgent = __webpack_require__("64e4");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "5268":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("3cec");
var classof = __webpack_require__("da06");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "5428":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("3e36");
var global = __webpack_require__("f498");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "58d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("95b2");
var anObject = __webpack_require__("157c");
var toLength = __webpack_require__("b495");
var requireObjectCoercible = __webpack_require__("730c");
var advanceStringIndex = __webpack_require__("e3f6");
var regExpExec = __webpack_require__("df8c");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "5b12":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var definePropertyModule = __webpack_require__("abdf");
var createPropertyDescriptor = __webpack_require__("9618");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "5bed":
/***/ (function(module, exports, __webpack_require__) {

// This file allows dist/cronstrue-i18n.js to be required from Node as:
// var cronstrue = require('cronstrue/i18n');

var cronstrueWithLocales = __webpack_require__("0fdd");
module.exports = cronstrueWithLocales;


/***/ }),

/***/ "61ad":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("730c");
var whitespaces = __webpack_require__("fbf7");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "6203":
/***/ (function(module, exports, __webpack_require__) {

/*! Buefy v0.8.20 | MIT License | github.com/buefy/buefy */
(function (global, factory) {
   true ? factory(exports) :
  undefined;
}(this, function (exports) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  var config = {
    defaultContainerElement: null,
    defaultIconPack: 'mdi',
    defaultIconComponent: null,
    defaultIconPrev: 'chevron-left',
    defaultIconNext: 'chevron-right',
    defaultDialogConfirmText: null,
    defaultDialogCancelText: null,
    defaultSnackbarDuration: 3500,
    defaultSnackbarPosition: null,
    defaultToastDuration: 2000,
    defaultToastPosition: null,
    defaultNotificationDuration: 2000,
    defaultNotificationPosition: null,
    defaultTooltipType: 'is-primary',
    defaultTooltipAnimated: false,
    defaultTooltipDelay: 0,
    defaultInputAutocomplete: 'on',
    defaultDateFormatter: null,
    defaultDateParser: null,
    defaultDateCreator: null,
    defaultTimeCreator: null,
    defaultDayNames: null,
    defaultMonthNames: null,
    defaultFirstDayOfWeek: null,
    defaultUnselectableDaysOfWeek: null,
    defaultTimeFormatter: null,
    defaultTimeParser: null,
    defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
    defaultModalScroll: null,
    defaultDatepickerMobileNative: true,
    defaultTimepickerMobileNative: true,
    defaultNoticeQueue: true,
    defaultInputHasCounter: true,
    defaultTaginputHasCounter: true,
    defaultUseHtml5Validation: true,
    defaultDropdownMobileModal: true,
    defaultFieldLabelPosition: null,
    defaultDatepickerYearsRange: [-100, 3],
    defaultDatepickerNearbyMonthDays: true,
    defaultDatepickerNearbySelectableMonthDays: false,
    defaultDatepickerShowWeekNumber: false,
    defaultDatepickerMobileModal: true,
    defaultTrapFocus: false,
    defaultButtonRounded: false,
    defaultCarouselInterval: 3500,
    defaultTabsAnimated: true,
    defaultLinkTags: ['a', 'button', 'input', 'router-link', 'nuxt-link', 'n-link', 'RouterLink', 'NuxtLink', 'NLink'],
    customIconPacks: null
  }; // TODO defaultTrapFocus to true in the next breaking change

  /**
   * Merge function to replace Object.assign with deep merging possibility
   */

  var isObject = function isObject(item) {
    return _typeof(item) === 'object' && !Array.isArray(item);
  };

  var mergeFn = function mergeFn(target, source) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (deep || !Object.assign) {
      var isDeep = function isDeep(prop) {
        return isObject(source[prop]) && target !== null && target.hasOwnProperty(prop) && isObject(target[prop]);
      };

      var replaced = Object.getOwnPropertyNames(source).map(function (prop) {
        return _defineProperty({}, prop, isDeep(prop) ? mergeFn(target[prop], source[prop], deep) : source[prop]);
      }).reduce(function (a, b) {
        return _objectSpread2({}, a, {}, b);
      }, {});
      return _objectSpread2({}, target, {}, replaced);
    } else {
      return Object.assign(target, source);
    }
  };

  var merge = mergeFn;

  var mdiIcons = {
    sizes: {
      'default': 'mdi-24px',
      'is-small': null,
      'is-medium': 'mdi-36px',
      'is-large': 'mdi-48px'
    },
    iconPrefix: 'mdi-'
  };

  var faIcons = function faIcons() {
    var faIconPrefix = config && config.defaultIconComponent ? '' : 'fa-';
    return {
      sizes: {
        'default': faIconPrefix + 'lg',
        'is-small': null,
        'is-medium': faIconPrefix + '2x',
        'is-large': faIconPrefix + '3x'
      },
      iconPrefix: faIconPrefix,
      internalIcons: {
        'information': 'info-circle',
        'alert': 'exclamation-triangle',
        'alert-circle': 'exclamation-circle',
        'chevron-right': 'angle-right',
        'chevron-left': 'angle-left',
        'chevron-down': 'angle-down',
        'eye-off': 'eye-slash',
        'menu-down': 'caret-down',
        'menu-up': 'caret-up',
        'close-circle': 'times-circle'
      }
    };
  };

  var getIcons = function getIcons() {
    var icons = {
      mdi: mdiIcons,
      fa: faIcons(),
      fas: faIcons(),
      far: faIcons(),
      fad: faIcons(),
      fab: faIcons(),
      fal: faIcons()
    };

    if (config && config.customIconPacks) {
      icons = merge(icons, config.customIconPacks, true);
    }

    return icons;
  };

  var script = {
    name: 'BIcon',
    props: {
      type: [String, Object],
      component: String,
      pack: String,
      icon: String,
      size: String,
      customSize: String,
      customClass: String,
      both: Boolean // This is used internally to show both MDI and FA icon

    },
    computed: {
      iconConfig: function iconConfig() {
        var allIcons = getIcons();
        return allIcons[this.newPack];
      },
      iconPrefix: function iconPrefix() {
        if (this.iconConfig && this.iconConfig.iconPrefix) {
          return this.iconConfig.iconPrefix;
        }

        return '';
      },

      /**
      * Internal icon name based on the pack.
      * If pack is 'fa', gets the equivalent FA icon name of the MDI,
      * internal icons are always MDI.
      */
      newIcon: function newIcon() {
        return "".concat(this.iconPrefix).concat(this.getEquivalentIconOf(this.icon));
      },
      newPack: function newPack() {
        return this.pack || config.defaultIconPack;
      },
      newType: function newType() {
        if (!this.type) return;
        var splitType = [];

        if (typeof this.type === 'string') {
          splitType = this.type.split('-');
        } else {
          for (var key in this.type) {
            if (this.type[key]) {
              splitType = key.split('-');
              break;
            }
          }
        }

        if (splitType.length <= 1) return;

        var _splitType = splitType,
            _splitType2 = _toArray(_splitType),
            type = _splitType2.slice(1);

        return "has-text-".concat(type.join('-'));
      },
      newCustomSize: function newCustomSize() {
        return this.customSize || this.customSizeByPack;
      },
      customSizeByPack: function customSizeByPack() {
        if (this.iconConfig && this.iconConfig.sizes) {
          if (this.size && this.iconConfig.sizes[this.size] !== undefined) {
            return this.iconConfig.sizes[this.size];
          } else if (this.iconConfig.sizes.default) {
            return this.iconConfig.sizes.default;
          }
        }

        return null;
      },
      useIconComponent: function useIconComponent() {
        return this.component || config.defaultIconComponent;
      }
    },
    methods: {
      /**
      * Equivalent icon name of the MDI.
      */
      getEquivalentIconOf: function getEquivalentIconOf(value) {
        // Only transform the class if the both prop is set to true
        if (!this.both) {
          return value;
        }

        if (this.iconConfig && this.iconConfig.internalIcons && this.iconConfig.internalIcons[value]) {
          return this.iconConfig.internalIcons[value];
        }

        return value;
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  const __vue_script__ = script;

  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[_vm.newType, _vm.size]},[(!_vm.useIconComponent)?_c('i',{class:[_vm.newPack, _vm.newIcon, _vm.newCustomSize, _vm.customClass]}):_c(_vm.useIconComponent,{tag:"component",class:[_vm.customClass],attrs:{"icon":[_vm.newPack, _vm.newIcon],"size":_vm.newCustomSize}})],1)};
  var __vue_staticRenderFns__ = [];

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Icon = normalizeComponent_1(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      undefined,
      undefined
    );

  var FormElementMixin = {
    props: {
      size: String,
      expanded: Boolean,
      loading: Boolean,
      rounded: Boolean,
      icon: String,
      iconPack: String,
      // Native options to use in HTML5 validation
      autocomplete: String,
      maxlength: [Number, String],
      useHtml5Validation: {
        type: Boolean,
        default: function _default() {
          return config.defaultUseHtml5Validation;
        }
      },
      validationMessage: String
    },
    data: function data() {
      return {
        isValid: true,
        isFocused: false,
        newIconPack: this.iconPack || config.defaultIconPack
      };
    },
    computed: {
      /**
       * Find parent Field, max 3 levels deep.
       */
      parentField: function parentField() {
        var parent = this.$parent;

        for (var i = 0; i < 3; i++) {
          if (parent && !parent.$data._isField) {
            parent = parent.$parent;
          }
        }

        return parent;
      },

      /**
       * Get the type prop from parent if it's a Field.
       */
      statusType: function statusType() {
        if (!this.parentField) return;
        if (!this.parentField.newType) return;

        if (typeof this.parentField.newType === 'string') {
          return this.parentField.newType;
        } else {
          for (var key in this.parentField.newType) {
            if (this.parentField.newType[key]) {
              return key;
            }
          }
        }
      },

      /**
       * Get the message prop from parent if it's a Field.
       */
      statusMessage: function statusMessage() {
        if (!this.parentField) return;
        return this.parentField.newMessage || this.parentField.$slots.message;
      },

      /**
       * Fix icon size for inputs, large was too big
       */
      iconSize: function iconSize() {
        switch (this.size) {
          case 'is-small':
            return this.size;

          case 'is-medium':
            return;

          case 'is-large':
            return this.newIconPack === 'mdi' ? 'is-medium' : '';
        }
      }
    },
    methods: {
      /**
       * Focus method that work dynamically depending on the component.
       */
      focus: function focus() {
        var _this = this;

        if (this.$data._elementRef === undefined) return;
        this.$nextTick(function () {
          var el = _this.$el.querySelector(_this.$data._elementRef);

          if (el) el.focus();
        });
      },
      onBlur: function onBlur($event) {
        this.isFocused = false;
        this.$emit('blur', $event);
        this.checkHtml5Validity();
      },
      onFocus: function onFocus($event) {
        this.isFocused = true;
        this.$emit('focus', $event);
      },
      getElement: function getElement() {
        return this.$el.querySelector(this.$data._elementRef);
      },
      setInvalid: function setInvalid() {
        var type = 'is-danger';
        var message = this.validationMessage || this.getElement().validationMessage;
        this.setValidity(type, message);
      },
      setValidity: function setValidity(type, message) {
        var _this2 = this;

        this.$nextTick(function () {
          if (_this2.parentField) {
            // Set type only if not defined
            if (!_this2.parentField.type) {
              _this2.parentField.newType = type;
            } // Set message only if not defined


            if (!_this2.parentField.message) {
              _this2.parentField.newMessage = message;
            }
          }
        });
      },

      /**
       * Check HTML5 validation, set isValid property.
       * If validation fail, send 'is-danger' type,
       * and error message to parent if it's a Field.
       */
      checkHtml5Validity: function checkHtml5Validity() {
        if (!this.useHtml5Validation) return;
        if (this.$refs[this.$data._elementRef] === undefined) return;
        if (this.getElement() === null) return;

        if (!this.getElement().checkValidity()) {
          this.setInvalid();
          this.isValid = false;
        } else {
          this.setValidity(null, null);
          this.isValid = true;
        }

        return this.isValid;
      }
    }
  };

  var script$1 = {
    name: 'BInput',
    components: _defineProperty({}, Icon.name, Icon),
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      value: [Number, String],
      type: {
        type: String,
        default: 'text'
      },
      passwordReveal: Boolean,
      iconClickable: Boolean,
      hasCounter: {
        type: Boolean,
        default: function _default() {
          return config.defaultInputHasCounter;
        }
      },
      customClass: {
        type: String,
        default: ''
      },
      iconRight: String,
      iconRightClickable: Boolean
    },
    data: function data() {
      return {
        newValue: this.value,
        newType: this.type,
        newAutocomplete: this.autocomplete || config.defaultInputAutocomplete,
        isPasswordVisible: false,
        _elementRef: this.type === 'textarea' ? 'textarea' : 'input'
      };
    },
    computed: {
      computedValue: {
        get: function get() {
          return this.newValue;
        },
        set: function set(value) {
          this.newValue = value;
          this.$emit('input', value);
          !this.isValid && this.checkHtml5Validity();
        }
      },
      rootClasses: function rootClasses() {
        return [this.iconPosition, this.size, {
          'is-expanded': this.expanded,
          'is-loading': this.loading,
          'is-clearfix': !this.hasMessage
        }];
      },
      inputClasses: function inputClasses() {
        return [this.statusType, this.size, {
          'is-rounded': this.rounded
        }];
      },
      hasIconRight: function hasIconRight() {
        return this.passwordReveal || this.loading || this.statusTypeIcon || this.iconRight;
      },
      rightIcon: function rightIcon() {
        if (this.passwordReveal) {
          return this.passwordVisibleIcon;
        } else if (this.iconRight) {
          return this.iconRight;
        }

        return this.statusTypeIcon;
      },
      rightIconType: function rightIconType() {
        if (this.passwordReveal) {
          return 'is-primary';
        } else if (this.iconRight) {
          return null;
        }

        return this.statusType;
      },

      /**
      * Position of the icon or if it's both sides.
      */
      iconPosition: function iconPosition() {
        if (this.icon && this.hasIconRight) {
          return 'has-icons-left has-icons-right';
        } else if (!this.icon && this.hasIconRight) {
          return 'has-icons-right';
        } else if (this.icon) {
          return 'has-icons-left';
        }
      },

      /**
      * Icon name (MDI) based on the type.
      */
      statusTypeIcon: function statusTypeIcon() {
        switch (this.statusType) {
          case 'is-success':
            return 'check';

          case 'is-danger':
            return 'alert-circle';

          case 'is-info':
            return 'information';

          case 'is-warning':
            return 'alert';
        }
      },

      /**
      * Check if have any message prop from parent if it's a Field.
      */
      hasMessage: function hasMessage() {
        return !!this.statusMessage;
      },

      /**
      * Current password-reveal icon name.
      */
      passwordVisibleIcon: function passwordVisibleIcon() {
        return !this.isPasswordVisible ? 'eye' : 'eye-off';
      },

      /**
      * Get value length
      */
      valueLength: function valueLength() {
        if (typeof this.computedValue === 'string') {
          return this.computedValue.length;
        } else if (typeof this.computedValue === 'number') {
          return this.computedValue.toString().length;
        }

        return 0;
      }
    },
    watch: {
      /**
      * When v-model is changed:
      *   1. Set internal value.
      */
      value: function value(_value) {
        this.newValue = _value;
      }
    },
    methods: {
      /**
      * Toggle the visibility of a password-reveal input
      * by changing the type and focus the input right away.
      */
      togglePasswordVisibility: function togglePasswordVisibility() {
        var _this = this;

        this.isPasswordVisible = !this.isPasswordVisible;
        this.newType = this.isPasswordVisible ? 'text' : 'password';
        this.$nextTick(function () {
          _this.$refs[_this.$data._elementRef].focus();
        });
      },

      /**
      * Input's 'input' event listener, 'nextTick' is used to prevent event firing
      * before ui update, helps when using masks (Cleavejs and potentially others).
      */
      onInput: function onInput(event) {
        var _this2 = this;

        this.$nextTick(function () {
          if (event.target) {
            _this2.computedValue = event.target.value;
          }
        });
      },
      iconClick: function iconClick(emit, event) {
        var _this3 = this;

        this.$emit(emit, event);
        this.$nextTick(function () {
          _this3.$refs[_this3.$data._elementRef].focus();
        });
      },
      rightIconClick: function rightIconClick(event) {
        if (this.passwordReveal) {
          this.togglePasswordVisibility();
        } else if (this.iconRightClickable) {
          this.iconClick('icon-right-click', event);
        }
      }
    }
  };

  /* script */
  const __vue_script__$1 = script$1;

  /* template */
  var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:_vm.rootClasses},[(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"input",class:[_vm.inputClasses, _vm.customClass],attrs:{"type":_vm.newType,"autocomplete":_vm.newAutocomplete,"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'input',_vm.$attrs,false)):_c('textarea',_vm._b({ref:"textarea",staticClass:"textarea",class:[_vm.inputClasses, _vm.customClass],attrs:{"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'textarea',_vm.$attrs,false)),_vm._v(" "),(_vm.icon)?_c('b-icon',{staticClass:"is-left",class:{'is-clickable': _vm.iconClickable},attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":_vm.iconSize},nativeOn:{"click":function($event){_vm.iconClick('icon-click', $event);}}}):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.hasIconRight)?_c('b-icon',{staticClass:"is-right",class:{ 'is-clickable': _vm.passwordReveal || _vm.iconRightClickable },attrs:{"icon":_vm.rightIcon,"pack":_vm.iconPack,"size":_vm.iconSize,"type":_vm.rightIconType,"both":""},nativeOn:{"click":function($event){return _vm.rightIconClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.maxlength && _vm.hasCounter && _vm.type !== 'number')?_c('small',{staticClass:"help counter",class:{ 'is-invisible': !_vm.isFocused }},[_vm._v("\r\n            "+_vm._s(_vm.valueLength)+" / "+_vm._s(_vm.maxlength)+"\r\n        ")]):_vm._e()],1)};
  var __vue_staticRenderFns__$1 = [];

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Input = normalizeComponent_1(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      undefined,
      undefined
    );

  var use = function use(plugin) {
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(plugin);
    }
  };
  var registerComponent = function registerComponent(Vue, component) {
    Vue.component(component.name, component);
  };

  var Plugin = {
    install: function install(Vue) {
      registerComponent(Vue, Input);
    }
  };
  use(Plugin);

  exports.BInput = Input;
  exports.default = Plugin;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ "62c8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("95b2");
var isRegExp = __webpack_require__("8e5d");
var anObject = __webpack_require__("157c");
var requireObjectCoercible = __webpack_require__("730c");
var speciesConstructor = __webpack_require__("433a");
var advanceStringIndex = __webpack_require__("e3f6");
var toLength = __webpack_require__("b495");
var callRegExpExec = __webpack_require__("df8c");
var regexpExec = __webpack_require__("42c5");
var fails = __webpack_require__("72df");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "64e4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "65d0":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("c91c");
var enumBugKeys = __webpack_require__("b17e");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "6a61":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "6a86":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");
var isArray = __webpack_require__("c6de");
var wellKnownSymbol = __webpack_require__("7d53");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6a89":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("3e36");
var has = __webpack_require__("f1a7");
var wrappedWellKnownSymbolModule = __webpack_require__("4e41");
var defineProperty = __webpack_require__("abdf").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "6b1d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var getOwnPropertyDescriptor = __webpack_require__("185a").f;
var createNonEnumerableProperty = __webpack_require__("5b12");
var redefine = __webpack_require__("b8ba");
var setGlobal = __webpack_require__("3e34");
var copyConstructorProperties = __webpack_require__("b634");
var isForced = __webpack_require__("ebac");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "7297":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var inspectSource = __webpack_require__("df6f");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "72df":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "730c":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "7526":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "75a4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var fails = __webpack_require__("72df");
var toIndexedObject = __webpack_require__("378c");
var nativeGetOwnPropertyDescriptor = __webpack_require__("185a").f;
var DESCRIPTORS = __webpack_require__("d4cb");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "79b4":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("37d1");

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "7c3f":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var fails = __webpack_require__("72df");
var createElement = __webpack_require__("f2bf");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "7c9b":
/***/ (function(module, exports, __webpack_require__) {

/*! Buefy v0.8.20 | MIT License | github.com/buefy/buefy */
(function (global, factory) {
   true ? factory(exports) :
  undefined;
}(this, function (exports) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  var config = {
    defaultContainerElement: null,
    defaultIconPack: 'mdi',
    defaultIconComponent: null,
    defaultIconPrev: 'chevron-left',
    defaultIconNext: 'chevron-right',
    defaultDialogConfirmText: null,
    defaultDialogCancelText: null,
    defaultSnackbarDuration: 3500,
    defaultSnackbarPosition: null,
    defaultToastDuration: 2000,
    defaultToastPosition: null,
    defaultNotificationDuration: 2000,
    defaultNotificationPosition: null,
    defaultTooltipType: 'is-primary',
    defaultTooltipAnimated: false,
    defaultTooltipDelay: 0,
    defaultInputAutocomplete: 'on',
    defaultDateFormatter: null,
    defaultDateParser: null,
    defaultDateCreator: null,
    defaultTimeCreator: null,
    defaultDayNames: null,
    defaultMonthNames: null,
    defaultFirstDayOfWeek: null,
    defaultUnselectableDaysOfWeek: null,
    defaultTimeFormatter: null,
    defaultTimeParser: null,
    defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
    defaultModalScroll: null,
    defaultDatepickerMobileNative: true,
    defaultTimepickerMobileNative: true,
    defaultNoticeQueue: true,
    defaultInputHasCounter: true,
    defaultTaginputHasCounter: true,
    defaultUseHtml5Validation: true,
    defaultDropdownMobileModal: true,
    defaultFieldLabelPosition: null,
    defaultDatepickerYearsRange: [-100, 3],
    defaultDatepickerNearbyMonthDays: true,
    defaultDatepickerNearbySelectableMonthDays: false,
    defaultDatepickerShowWeekNumber: false,
    defaultDatepickerMobileModal: true,
    defaultTrapFocus: false,
    defaultButtonRounded: false,
    defaultCarouselInterval: 3500,
    defaultTabsAnimated: true,
    defaultLinkTags: ['a', 'button', 'input', 'router-link', 'nuxt-link', 'n-link', 'RouterLink', 'NuxtLink', 'NLink'],
    customIconPacks: null
  }; // TODO defaultTrapFocus to true in the next breaking change

  /**
   * Merge function to replace Object.assign with deep merging possibility
   */

  var isObject = function isObject(item) {
    return _typeof(item) === 'object' && !Array.isArray(item);
  };

  var mergeFn = function mergeFn(target, source) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (deep || !Object.assign) {
      var isDeep = function isDeep(prop) {
        return isObject(source[prop]) && target !== null && target.hasOwnProperty(prop) && isObject(target[prop]);
      };

      var replaced = Object.getOwnPropertyNames(source).map(function (prop) {
        return _defineProperty({}, prop, isDeep(prop) ? mergeFn(target[prop], source[prop], deep) : source[prop]);
      }).reduce(function (a, b) {
        return _objectSpread2({}, a, {}, b);
      }, {});
      return _objectSpread2({}, target, {}, replaced);
    } else {
      return Object.assign(target, source);
    }
  };

  var merge = mergeFn;

  var mdiIcons = {
    sizes: {
      'default': 'mdi-24px',
      'is-small': null,
      'is-medium': 'mdi-36px',
      'is-large': 'mdi-48px'
    },
    iconPrefix: 'mdi-'
  };

  var faIcons = function faIcons() {
    var faIconPrefix = config && config.defaultIconComponent ? '' : 'fa-';
    return {
      sizes: {
        'default': faIconPrefix + 'lg',
        'is-small': null,
        'is-medium': faIconPrefix + '2x',
        'is-large': faIconPrefix + '3x'
      },
      iconPrefix: faIconPrefix,
      internalIcons: {
        'information': 'info-circle',
        'alert': 'exclamation-triangle',
        'alert-circle': 'exclamation-circle',
        'chevron-right': 'angle-right',
        'chevron-left': 'angle-left',
        'chevron-down': 'angle-down',
        'eye-off': 'eye-slash',
        'menu-down': 'caret-down',
        'menu-up': 'caret-up',
        'close-circle': 'times-circle'
      }
    };
  };

  var getIcons = function getIcons() {
    var icons = {
      mdi: mdiIcons,
      fa: faIcons(),
      fas: faIcons(),
      far: faIcons(),
      fad: faIcons(),
      fab: faIcons(),
      fal: faIcons()
    };

    if (config && config.customIconPacks) {
      icons = merge(icons, config.customIconPacks, true);
    }

    return icons;
  };

  var script = {
    name: 'BIcon',
    props: {
      type: [String, Object],
      component: String,
      pack: String,
      icon: String,
      size: String,
      customSize: String,
      customClass: String,
      both: Boolean // This is used internally to show both MDI and FA icon

    },
    computed: {
      iconConfig: function iconConfig() {
        var allIcons = getIcons();
        return allIcons[this.newPack];
      },
      iconPrefix: function iconPrefix() {
        if (this.iconConfig && this.iconConfig.iconPrefix) {
          return this.iconConfig.iconPrefix;
        }

        return '';
      },

      /**
      * Internal icon name based on the pack.
      * If pack is 'fa', gets the equivalent FA icon name of the MDI,
      * internal icons are always MDI.
      */
      newIcon: function newIcon() {
        return "".concat(this.iconPrefix).concat(this.getEquivalentIconOf(this.icon));
      },
      newPack: function newPack() {
        return this.pack || config.defaultIconPack;
      },
      newType: function newType() {
        if (!this.type) return;
        var splitType = [];

        if (typeof this.type === 'string') {
          splitType = this.type.split('-');
        } else {
          for (var key in this.type) {
            if (this.type[key]) {
              splitType = key.split('-');
              break;
            }
          }
        }

        if (splitType.length <= 1) return;

        var _splitType = splitType,
            _splitType2 = _toArray(_splitType),
            type = _splitType2.slice(1);

        return "has-text-".concat(type.join('-'));
      },
      newCustomSize: function newCustomSize() {
        return this.customSize || this.customSizeByPack;
      },
      customSizeByPack: function customSizeByPack() {
        if (this.iconConfig && this.iconConfig.sizes) {
          if (this.size && this.iconConfig.sizes[this.size] !== undefined) {
            return this.iconConfig.sizes[this.size];
          } else if (this.iconConfig.sizes.default) {
            return this.iconConfig.sizes.default;
          }
        }

        return null;
      },
      useIconComponent: function useIconComponent() {
        return this.component || config.defaultIconComponent;
      }
    },
    methods: {
      /**
      * Equivalent icon name of the MDI.
      */
      getEquivalentIconOf: function getEquivalentIconOf(value) {
        // Only transform the class if the both prop is set to true
        if (!this.both) {
          return value;
        }

        if (this.iconConfig && this.iconConfig.internalIcons && this.iconConfig.internalIcons[value]) {
          return this.iconConfig.internalIcons[value];
        }

        return value;
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  const __vue_script__ = script;

  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[_vm.newType, _vm.size]},[(!_vm.useIconComponent)?_c('i',{class:[_vm.newPack, _vm.newIcon, _vm.newCustomSize, _vm.customClass]}):_c(_vm.useIconComponent,{tag:"component",class:[_vm.customClass],attrs:{"icon":[_vm.newPack, _vm.newIcon],"size":_vm.newCustomSize}})],1)};
  var __vue_staticRenderFns__ = [];

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Icon = normalizeComponent_1(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      undefined,
      undefined
    );

  var SlotComponent = {
    name: 'BSlotComponent',
    props: {
      component: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        default: 'default'
      },
      scoped: {
        type: Boolean
      },
      props: {
        type: Object
      },
      tag: {
        type: String,
        default: 'div'
      },
      event: {
        type: String,
        default: 'hook:updated'
      }
    },
    methods: {
      refresh: function refresh() {
        this.$forceUpdate();
      },
      isVueComponent: function isVueComponent() {
        return this.component && this.component._isVue;
      }
    },
    created: function created() {
      if (this.isVueComponent()) {
        this.component.$on(this.event, this.refresh);
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.isVueComponent()) {
        this.component.$off(this.event, this.refresh);
      }
    },
    render: function render(createElement) {
      if (this.isVueComponent()) {
        return createElement(this.tag, {}, this.scoped ? this.component.$scopedSlots[this.name](this.props) : this.component.$slots[this.name]);
      }
    }
  };

  var _components;
  var script$1 = {
    name: 'BTabs',
    components: (_components = {}, _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, SlotComponent.name, SlotComponent), _components),
    props: {
      value: [Number, String],
      expanded: Boolean,
      type: String,
      size: String,
      position: String,
      animated: {
        type: Boolean,
        default: function _default() {
          return config.defaultTabsAnimated;
        }
      },
      destroyOnHide: {
        type: Boolean,
        default: false
      },
      vertical: Boolean,
      multiline: Boolean
    },
    data: function data() {
      return {
        activeTab: 0,
        defaultSlots: [],
        contentHeight: 0,
        isTransitioning: false,
        _isTabs: true // Used internally by TabItem

      };
    },
    computed: {
      mainClasses: function mainClasses() {
        return _defineProperty({
          'is-fullwidth': this.expanded,
          'is-vertical': this.vertical,
          'is-multiline': this.multiline
        }, this.position, this.position && this.vertical);
      },
      navClasses: function navClasses() {
        var _ref2;

        return [this.type, this.size, (_ref2 = {}, _defineProperty(_ref2, this.position, this.position && !this.vertical), _defineProperty(_ref2, 'is-fullwidth', this.expanded), _defineProperty(_ref2, 'is-toggle-rounded is-toggle', this.type === 'is-toggle-rounded'), _ref2)];
      },
      tabItems: function tabItems() {
        return this.defaultSlots.filter(function (vnode) {
          return vnode.componentInstance && vnode.componentInstance.$data && vnode.componentInstance.$data._isTabItem;
        }).map(function (vnode) {
          return vnode.componentInstance;
        });
      }
    },
    watch: {
      /**
      * When v-model is changed set the new active tab.
      */
      value: function value(_value) {
        var index = this.getIndexByValue(_value, _value);
        this.changeTab(index);
      },

      /**
      * When tab-items are updated, set active one.
      */
      tabItems: function tabItems() {
        var _this = this;

        if (this.activeTab < this.tabItems.length) {
          var previous = this.activeTab;
          this.tabItems.map(function (tab, idx) {
            if (tab.isActive) {
              previous = idx;

              if (previous < _this.tabItems.length) {
                _this.tabItems[previous].isActive = false;
              }
            }
          });
          this.tabItems[this.activeTab].isActive = true;
        } else if (this.activeTab > 0) {
          this.changeTab(this.activeTab - 1);
        }
      }
    },
    methods: {
      /**
      * Change the active tab and emit change event.
      */
      changeTab: function changeTab(newIndex) {
        if (this.activeTab === newIndex || this.tabItems[newIndex] === undefined) return;

        if (this.activeTab < this.tabItems.length) {
          this.tabItems[this.activeTab].deactivate(this.activeTab, newIndex);
        }

        this.tabItems[newIndex].activate(this.activeTab, newIndex);
        this.activeTab = newIndex;
        this.$emit('change', this.getValueByIndex(newIndex));
      },

      /**
      * Tab click listener, emit input event and change active tab.
      */
      tabClick: function tabClick(index) {
        if (this.activeTab === index) return;
        this.$emit('input', this.getValueByIndex(index));
        this.changeTab(index);
      },
      refreshSlots: function refreshSlots() {
        this.defaultSlots = this.$slots.default || [];
      },
      getIndexByValue: function getIndexByValue(value) {
        var index = this.tabItems.map(function (t) {
          return t.$options.propsData ? t.$options.propsData.value : undefined;
        }).indexOf(value);
        return index >= 0 ? index : value;
      },
      getValueByIndex: function getValueByIndex(index) {
        var propsData = this.tabItems[index].$options.propsData;
        return propsData && propsData.value ? propsData.value : index;
      }
    },
    mounted: function mounted() {
      this.activeTab = this.getIndexByValue(this.value || 0);

      if (this.activeTab < this.tabItems.length) {
        this.tabItems[this.activeTab].isActive = true;
      }

      this.refreshSlots();
    }
  };

  /* script */
  const __vue_script__$1 = script$1;

  /* template */
  var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-tabs",class:_vm.mainClasses},[_c('nav',{staticClass:"tabs",class:_vm.navClasses},[_c('ul',_vm._l((_vm.tabItems),function(tabItem,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(tabItem.visible),expression:"tabItem.visible"}],key:index,class:{ 'is-active': _vm.activeTab === index, 'is-disabled': tabItem.disabled }},[(tabItem.$slots.header)?_c('b-slot-component',{attrs:{"component":tabItem,"name":"header","tag":"a"},nativeOn:{"click":function($event){_vm.tabClick(index);}}}):_c('a',{on:{"click":function($event){_vm.tabClick(index);}}},[(tabItem.icon)?_c('b-icon',{attrs:{"icon":tabItem.icon,"pack":tabItem.iconPack,"size":_vm.size}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(tabItem.label))])],1)],1)}))]),_vm._v(" "),_c('section',{staticClass:"tab-content",class:{'is-transitioning': _vm.isTransitioning}},[_vm._t("default")],2)])};
  var __vue_staticRenderFns__$1 = [];

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Tabs = normalizeComponent_1(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      undefined,
      undefined
    );

  var script$2 = {
    name: 'BTabItem',
    props: {
      label: String,
      icon: String,
      iconPack: String,
      disabled: Boolean,
      visible: {
        type: Boolean,
        default: true
      },
      value: [String, Number]
    },
    data: function data() {
      return {
        isActive: false,
        transitionName: null,
        _isTabItem: true // Used internally by Tab

      };
    },
    methods: {
      /**
      * Activate tab, alter animation name based on the index.
      */
      activate: function activate(oldIndex, index) {
        this.transitionName = index < oldIndex ? this.$parent.vertical ? 'slide-down' : 'slide-next' : this.$parent.vertical ? 'slide-up' : 'slide-prev';
        this.isActive = true;
      },

      /**
      * Deactivate tab, alter animation name based on the index.
      */
      deactivate: function deactivate(oldIndex, index) {
        this.transitionName = index < oldIndex ? this.$parent.vertical ? 'slide-down' : 'slide-next' : this.$parent.vertical ? 'slide-up' : 'slide-prev';
        this.isActive = false;
      }
    },
    created: function created() {
      if (!this.$parent.$data._isTabs) {
        this.$destroy();
        throw new Error('You should wrap bTabItem on a bTabs');
      }

      this.$parent.refreshSlots();
    },
    beforeDestroy: function beforeDestroy() {
      this.$parent.refreshSlots();
    },
    render: function render(createElement) {
      var _this = this;

      // if destroy apply v-if
      if (this.$parent.destroyOnHide) {
        if (!this.isActive || !this.visible) {
          return;
        }
      }

      var vnode = createElement('div', {
        directives: [{
          name: 'show',
          value: this.isActive && this.visible
        }],
        class: 'tab-item'
      }, this.$slots.default); // check animated prop

      if (this.$parent.animated) {
        return createElement('transition', {
          props: {
            'name': this.transitionName
          },
          on: {
            'before-enter': function beforeEnter() {
              _this.$parent.isTransitioning = true;
            },
            'after-enter': function afterEnter() {
              _this.$parent.isTransitioning = false;
            }
          }
        }, [vnode]);
      }

      return vnode;
    }
  };

  /* script */
  const __vue_script__$2 = script$2;

  /* template */

    /* style */
    const __vue_inject_styles__$2 = undefined;
    /* scoped */
    const __vue_scope_id__$2 = undefined;
    /* module identifier */
    const __vue_module_identifier__$2 = undefined;
    /* functional template */
    const __vue_is_functional_template__$2 = undefined;
    /* style inject */
    
    /* style inject SSR */
    

    
    var TabItem = normalizeComponent_1(
      {},
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2,
      __vue_module_identifier__$2,
      undefined,
      undefined
    );

  var use = function use(plugin) {
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(plugin);
    }
  };
  var registerComponent = function registerComponent(Vue, component) {
    Vue.component(component.name, component);
  };

  var Plugin = {
    install: function install(Vue) {
      registerComponent(Vue, Tabs);
      registerComponent(Vue, TabItem);
    }
  };
  use(Plugin);

  exports.BTabItem = TabItem;
  exports.BTabs = Tabs;
  exports.default = Plugin;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ "7d15":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "7d53":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var shared = __webpack_require__("4cdd");
var has = __webpack_require__("f1a7");
var uid = __webpack_require__("1d8a");
var NATIVE_SYMBOL = __webpack_require__("e7a0");
var USE_SYMBOL_AS_UID = __webpack_require__("4db4");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "7f8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("72df");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "82e8":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("157c");
var defineProperties = __webpack_require__("b99b");
var enumBugKeys = __webpack_require__("b17e");
var hiddenKeys = __webpack_require__("d687");
var html = __webpack_require__("9324");
var documentCreateElement = __webpack_require__("f2bf");
var sharedKey = __webpack_require__("332c");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "83a6":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var classof = __webpack_require__("6a61");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "841a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $find = __webpack_require__("d054").find;
var addToUnscopables = __webpack_require__("ed2b");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "8697":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "8bb2":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8d0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $includes = __webpack_require__("1f5e").includes;
var addToUnscopables = __webpack_require__("ed2b");

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "8e5d":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");
var classof = __webpack_require__("6a61");
var wellKnownSymbol = __webpack_require__("7d53");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "9324":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "95b2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("2aa5");
var redefine = __webpack_require__("b8ba");
var fails = __webpack_require__("72df");
var wellKnownSymbol = __webpack_require__("7d53");
var regexpExec = __webpack_require__("42c5");
var createNonEnumerableProperty = __webpack_require__("5b12");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "9618":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "9951":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var whitespaces = __webpack_require__("fbf7");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "9a0f":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("8bb2");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "9e10":
/***/ (function(module, exports, __webpack_require__) {

/*! Buefy v0.8.20 | MIT License | github.com/buefy/buefy */
(function (global, factory) {
     true ? factory(exports) :
    undefined;
}(this, function (exports) { 'use strict';

    var CheckRadioMixin = {
      props: {
        value: [String, Number, Boolean, Function, Object, Array],
        nativeValue: [String, Number, Boolean, Function, Object, Array],
        type: String,
        disabled: Boolean,
        required: Boolean,
        name: String,
        size: String
      },
      data: function data() {
        return {
          newValue: this.value
        };
      },
      computed: {
        computedValue: {
          get: function get() {
            return this.newValue;
          },
          set: function set(value) {
            this.newValue = value;
            this.$emit('input', value);
          }
        }
      },
      watch: {
        /**
        * When v-model change, set internal value.
        */
        value: function value(_value) {
          this.newValue = _value;
        }
      },
      methods: {
        focus: function focus() {
          // MacOS FireFox and Safari do not focus when clicked
          this.$refs.input.focus();
        }
      }
    };

    //
    var script = {
      name: 'BCheckbox',
      mixins: [CheckRadioMixin],
      props: {
        indeterminate: Boolean,
        trueValue: {
          type: [String, Number, Boolean, Function, Object, Array],
          default: true
        },
        falseValue: {
          type: [String, Number, Boolean, Function, Object, Array],
          default: false
        }
      }
    };

    function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
    /* server only */
    , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
      if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
      } // Vue.extend constructor export interop.


      var options = typeof script === 'function' ? script.options : script; // render functions

      if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true; // functional template

        if (isFunctionalTemplate) {
          options.functional = true;
        }
      } // scopedId


      if (scopeId) {
        options._scopeId = scopeId;
      }

      var hook;

      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true

          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          } // inject component styles


          if (style) {
            style.call(this, createInjectorSSR(context));
          } // register component module identifier for async chunk inference


          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        }; // used by ssr in case component is cached and beforeCreate
        // never gets called


        options._ssrRegister = hook;
      } else if (style) {
        hook = shadowMode ? function () {
          style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
        } : function (context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook) {
        if (options.functional) {
          // register for functional component in vue file
          var originalRender = options.render;

          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return script;
    }

    var normalizeComponent_1 = normalizeComponent;

    /* script */
    const __vue_script__ = script;

    /* template */
    var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"label",staticClass:"b-checkbox checkbox",class:[_vm.size, { 'is-disabled': _vm.disabled }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.focus,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.$refs.label.click();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",attrs:{"type":"checkbox","disabled":_vm.disabled,"required":_vm.required,"name":_vm.name,"true-value":_vm.trueValue,"false-value":_vm.falseValue},domProps:{"indeterminate":_vm.indeterminate,"value":_vm.nativeValue,"checked":Array.isArray(_vm.computedValue)?_vm._i(_vm.computedValue,_vm.nativeValue)>-1:_vm._q(_vm.computedValue,_vm.trueValue)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){var $$a=_vm.computedValue,$$el=$event.target,$$c=$$el.checked?(_vm.trueValue):(_vm.falseValue);if(Array.isArray($$a)){var $$v=_vm.nativeValue,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedValue=$$a.concat([$$v]));}else{$$i>-1&&(_vm.computedValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.computedValue=$$c;}}}}),_vm._v(" "),_c('span',{staticClass:"check",class:_vm.type}),_vm._v(" "),_c('span',{staticClass:"control-label"},[_vm._t("default")],2)])};
    var __vue_staticRenderFns__ = [];

      /* style */
      const __vue_inject_styles__ = undefined;
      /* scoped */
      const __vue_scope_id__ = undefined;
      /* module identifier */
      const __vue_module_identifier__ = undefined;
      /* functional template */
      const __vue_is_functional_template__ = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var Checkbox = normalizeComponent_1(
        { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
        __vue_inject_styles__,
        __vue_script__,
        __vue_scope_id__,
        __vue_is_functional_template__,
        __vue_module_identifier__,
        undefined,
        undefined
      );

    //
    var script$1 = {
      name: 'BCheckboxButton',
      mixins: [CheckRadioMixin],
      props: {
        type: {
          type: String,
          default: 'is-primary'
        },
        expanded: Boolean
      },
      data: function data() {
        return {
          isFocused: false
        };
      },
      computed: {
        checked: function checked() {
          if (Array.isArray(this.newValue)) {
            return this.newValue.indexOf(this.nativeValue) >= 0;
          }

          return this.newValue === this.nativeValue;
        }
      }
    };

    /* script */
    const __vue_script__$1 = script$1;

    /* template */
    var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:{ 'is-expanded': _vm.expanded }},[_c('label',{ref:"label",staticClass:"b-checkbox checkbox button",class:[_vm.checked ? _vm.type : null, _vm.size, {
                    'is-disabled': _vm.disabled,
                    'is-focused': _vm.isFocused
                }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.focus,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.$refs.label.click();}}},[_vm._t("default"),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",attrs:{"type":"checkbox","disabled":_vm.disabled,"required":_vm.required,"name":_vm.name},domProps:{"value":_vm.nativeValue,"checked":Array.isArray(_vm.computedValue)?_vm._i(_vm.computedValue,_vm.nativeValue)>-1:(_vm.computedValue)},on:{"click":function($event){$event.stopPropagation();},"focus":function($event){_vm.isFocused = true;},"blur":function($event){_vm.isFocused = false;},"change":function($event){var $$a=_vm.computedValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.nativeValue,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedValue=$$a.concat([$$v]));}else{$$i>-1&&(_vm.computedValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.computedValue=$$c;}}}})],2)])};
    var __vue_staticRenderFns__$1 = [];

      /* style */
      const __vue_inject_styles__$1 = undefined;
      /* scoped */
      const __vue_scope_id__$1 = undefined;
      /* module identifier */
      const __vue_module_identifier__$1 = undefined;
      /* functional template */
      const __vue_is_functional_template__$1 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var CheckboxButton = normalizeComponent_1(
        { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
        __vue_inject_styles__$1,
        __vue_script__$1,
        __vue_scope_id__$1,
        __vue_is_functional_template__$1,
        __vue_module_identifier__$1,
        undefined,
        undefined
      );

    var use = function use(plugin) {
      if (typeof window !== 'undefined' && window.Vue) {
        window.Vue.use(plugin);
      }
    };
    var registerComponent = function registerComponent(Vue, component) {
      Vue.component(component.name, component);
    };

    var Plugin = {
      install: function install(Vue) {
        registerComponent(Vue, Checkbox);
        registerComponent(Vue, CheckboxButton);
      }
    };
    use(Plugin);

    exports.BCheckbox = Checkbox;
    exports.BCheckboxButton = CheckboxButton;
    exports.default = Plugin;

    Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ "9eea":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("8e5d");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "a03e":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");
var getOwnPropertyNamesModule = __webpack_require__("65d0");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var anObject = __webpack_require__("157c");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "abdf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var IE8_DOM_DEFINE = __webpack_require__("7c3f");
var anObject = __webpack_require__("157c");
var toPrimitive = __webpack_require__("083f");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "abfd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("157c");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "b17e":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "b2ff":
/***/ (function(module, exports, __webpack_require__) {

/*! Buefy v0.8.20 | MIT License | github.com/buefy/buefy */
(function (global, factory) {
   true ? factory(exports) :
  undefined;
}(this, function (exports) { 'use strict';

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var config = {
    defaultContainerElement: null,
    defaultIconPack: 'mdi',
    defaultIconComponent: null,
    defaultIconPrev: 'chevron-left',
    defaultIconNext: 'chevron-right',
    defaultDialogConfirmText: null,
    defaultDialogCancelText: null,
    defaultSnackbarDuration: 3500,
    defaultSnackbarPosition: null,
    defaultToastDuration: 2000,
    defaultToastPosition: null,
    defaultNotificationDuration: 2000,
    defaultNotificationPosition: null,
    defaultTooltipType: 'is-primary',
    defaultTooltipAnimated: false,
    defaultTooltipDelay: 0,
    defaultInputAutocomplete: 'on',
    defaultDateFormatter: null,
    defaultDateParser: null,
    defaultDateCreator: null,
    defaultTimeCreator: null,
    defaultDayNames: null,
    defaultMonthNames: null,
    defaultFirstDayOfWeek: null,
    defaultUnselectableDaysOfWeek: null,
    defaultTimeFormatter: null,
    defaultTimeParser: null,
    defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
    defaultModalScroll: null,
    defaultDatepickerMobileNative: true,
    defaultTimepickerMobileNative: true,
    defaultNoticeQueue: true,
    defaultInputHasCounter: true,
    defaultTaginputHasCounter: true,
    defaultUseHtml5Validation: true,
    defaultDropdownMobileModal: true,
    defaultFieldLabelPosition: null,
    defaultDatepickerYearsRange: [-100, 3],
    defaultDatepickerNearbyMonthDays: true,
    defaultDatepickerNearbySelectableMonthDays: false,
    defaultDatepickerShowWeekNumber: false,
    defaultDatepickerMobileModal: true,
    defaultTrapFocus: false,
    defaultButtonRounded: false,
    defaultCarouselInterval: 3500,
    defaultTabsAnimated: true,
    defaultLinkTags: ['a', 'button', 'input', 'router-link', 'nuxt-link', 'n-link', 'RouterLink', 'NuxtLink', 'NLink'],
    customIconPacks: null
  }; // TODO defaultTrapFocus to true in the next breaking change

  var script = {
    name: 'BFieldBody',
    props: {
      message: {
        type: [String, Array]
      },
      type: {
        type: [String, Object]
      }
    },
    render: function render(createElement) {
      var _this = this;

      var first = true;
      return createElement('div', {
        attrs: {
          'class': 'field-body'
        }
      }, this.$slots.default.map(function (element) {
        // skip returns and comments
        if (!element.tag) {
          return element;
        }

        var message;

        if (first) {
          message = _this.message;
          first = false;
        }

        return createElement('b-field', {
          attrs: {
            type: _this.type,
            message: message
          }
        }, [element]);
      }));
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  const __vue_script__ = script;

  /* template */

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = undefined;
    /* style inject */
    
    /* style inject SSR */
    

    
    var FieldBody = normalizeComponent_1(
      {},
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      undefined,
      undefined
    );

  var script$1 = {
    name: 'BField',
    components: _defineProperty({}, FieldBody.name, FieldBody),
    props: {
      type: [String, Object],
      label: String,
      labelFor: String,
      message: [String, Array, Object],
      grouped: Boolean,
      groupMultiline: Boolean,
      position: String,
      expanded: Boolean,
      horizontal: Boolean,
      addons: {
        type: Boolean,
        default: true
      },
      customClass: String,
      labelPosition: {
        type: String,
        default: function _default() {
          return config.defaultFieldLabelPosition;
        }
      }
    },
    data: function data() {
      return {
        newType: this.type,
        newMessage: this.message,
        fieldLabelSize: null,
        _isField: true // Used internally by Input and Select

      };
    },
    computed: {
      rootClasses: function rootClasses() {
        return [this.newPosition, {
          'is-expanded': this.expanded,
          'is-grouped-multiline': this.groupMultiline,
          'is-horizontal': this.horizontal,
          'is-floating-in-label': this.hasLabel && !this.horizontal && this.labelPosition === 'inside',
          'is-floating-label': this.hasLabel && !this.horizontal && this.labelPosition === 'on-border'
        }, this.numberInputClasses];
      },

      /**
      * Correct Bulma class for the side of the addon or group.
      *
      * This is not kept like the others (is-small, etc.),
      * because since 'has-addons' is set automatically it
      * doesn't make sense to teach users what addons are exactly.
      */
      newPosition: function newPosition() {
        if (this.position === undefined) return;
        var position = this.position.split('-');
        if (position.length < 1) return;
        var prefix = this.grouped ? 'is-grouped-' : 'has-addons-';
        if (this.position) return prefix + position[1];
      },

      /**
      * Formatted message in case it's an array
      * (each element is separated by <br> tag)
      */
      formattedMessage: function formattedMessage() {
        if (typeof this.newMessage === 'string') {
          return [this.newMessage];
        }

        var messages = [];

        if (Array.isArray(this.newMessage)) {
          this.newMessage.forEach(function (message) {
            if (typeof message === 'string') {
              messages.push(message);
            } else {
              for (var key in message) {
                if (message[key]) {
                  messages.push(key);
                }
              }
            }
          });
        } else {
          for (var key in this.newMessage) {
            if (this.newMessage[key]) {
              messages.push(key);
            }
          }
        }

        return messages.filter(function (m) {
          if (m) return m;
        });
      },
      hasLabel: function hasLabel() {
        return this.label || this.$slots.label;
      },
      hasMessage: function hasMessage() {
        return this.newMessage || this.$slots.message;
      },
      numberInputClasses: function numberInputClasses() {
        if (this.$slots.default) {
          var numberinput = this.$slots.default.filter(function (node) {
            return node.tag && node.tag.toLowerCase().indexOf('numberinput') >= 0;
          })[0];

          if (numberinput) {
            var classes = ['has-numberinput'];
            var controlsPosition = numberinput.componentOptions.propsData.controlsPosition;
            var size = numberinput.componentOptions.propsData.size;

            if (controlsPosition) {
              classes.push("has-numberinput-".concat(controlsPosition));
            }

            if (size) {
              classes.push("has-numberinput-".concat(size));
            }

            return classes;
          }
        }

        return null;
      }
    },
    watch: {
      /**
      * Set internal type when prop change.
      */
      type: function type(value) {
        this.newType = value;
      },

      /**
      * Set internal message when prop change.
      */
      message: function message(value) {
        this.newMessage = value;
      }
    },
    methods: {
      /**
      * Field has addons if there are more than one slot
      * (element / component) in the Field.
      * Or is grouped when prop is set.
      * Is a method to be called when component re-render.
      */
      fieldType: function fieldType() {
        if (this.grouped) return 'is-grouped';
        var renderedNode = 0;

        if (this.$slots.default) {
          renderedNode = this.$slots.default.reduce(function (i, node) {
            return node.tag ? i + 1 : i;
          }, 0);
        }

        if (renderedNode > 1 && this.addons && !this.horizontal) {
          return 'has-addons';
        }
      }
    },
    mounted: function mounted() {
      if (this.horizontal) {
        // Bulma docs: .is-normal for any .input or .button
        var elements = this.$el.querySelectorAll('.input, .select, .button, .textarea, .b-slider');

        if (elements.length > 0) {
          this.fieldLabelSize = 'is-normal';
        }
      }
    }
  };

  /* script */
  const __vue_script__$1 = script$1;

  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",class:[_vm.rootClasses, _vm.fieldType()]},[(_vm.horizontal)?_c('div',{staticClass:"field-label",class:[_vm.customClass, _vm.fieldLabelSize]},[(_vm.hasLabel)?_c('label',{staticClass:"label",class:_vm.customClass,attrs:{"for":_vm.labelFor}},[(_vm.$slots.label)?_vm._t("label"):[_vm._v(_vm._s(_vm.label))]],2):_vm._e()]):[(_vm.hasLabel)?_c('label',{staticClass:"label",class:_vm.customClass,attrs:{"for":_vm.labelFor}},[(_vm.$slots.label)?_vm._t("label"):[_vm._v(_vm._s(_vm.label))]],2):_vm._e()],_vm._v(" "),(_vm.horizontal)?_c('b-field-body',{attrs:{"message":_vm.newMessage ? _vm.formattedMessage : '',"type":_vm.newType}},[_vm._t("default")],2):[_vm._t("default")],_vm._v(" "),(_vm.hasMessage && !_vm.horizontal)?_c('p',{staticClass:"help",class:_vm.newType},[(_vm.$slots.message)?_vm._t("message"):[_vm._l((_vm.formattedMessage),function(mess,i){return [_vm._v("\r\n                    "+_vm._s(mess)+"\r\n                    "),((i + 1) < _vm.formattedMessage.length)?_c('br',{key:i}):_vm._e()]})]],2):_vm._e()],2)};
  var __vue_staticRenderFns__ = [];

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Field = normalizeComponent_1(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      undefined,
      undefined
    );

  var use = function use(plugin) {
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(plugin);
    }
  };
  var registerComponent = function registerComponent(Vue, component) {
    Vue.component(component.name, component);
  };

  var Plugin = {
    install: function install(Vue) {
      registerComponent(Vue, Field);
    }
  };
  use(Plugin);

  exports.BField = Field;
  exports.default = Plugin;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ "b495":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("8bb2");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "b55a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $trim = __webpack_require__("61ad").trim;
var forcedStringTrimMethod = __webpack_require__("9951");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "b634":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("f1a7");
var ownKeys = __webpack_require__("a03e");
var getOwnPropertyDescriptorModule = __webpack_require__("185a");
var definePropertyModule = __webpack_require__("abdf");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "b7fb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("8bb2");
var requireObjectCoercible = __webpack_require__("730c");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "b8ba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var createNonEnumerableProperty = __webpack_require__("5b12");
var has = __webpack_require__("f1a7");
var setGlobal = __webpack_require__("3e34");
var inspectSource = __webpack_require__("df6f");
var InternalStateModule = __webpack_require__("cdcd");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "b99b":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var definePropertyModule = __webpack_require__("abdf");
var anObject = __webpack_require__("157c");
var objectKeys = __webpack_require__("0c47");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "c607":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var setGlobal = __webpack_require__("3e34");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6de":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("6a61");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "c78b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var notARegExp = __webpack_require__("9eea");
var requireObjectCoercible = __webpack_require__("730c");
var correctIsRegExpLogic = __webpack_require__("3e32");

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "c91c":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("f1a7");
var toIndexedObject = __webpack_require__("378c");
var indexOf = __webpack_require__("1f5e").indexOf;
var hiddenKeys = __webpack_require__("d687");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cdcd":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7297");
var global = __webpack_require__("f498");
var isObject = __webpack_require__("7526");
var createNonEnumerableProperty = __webpack_require__("5b12");
var objectHas = __webpack_require__("f1a7");
var shared = __webpack_require__("c607");
var sharedKey = __webpack_require__("332c");
var hiddenKeys = __webpack_require__("d687");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "cfce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $map = __webpack_require__("d054").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d054":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("2117");
var IndexedObject = __webpack_require__("83a6");
var toObject = __webpack_require__("37d1");
var toLength = __webpack_require__("b495");
var arraySpeciesCreate = __webpack_require__("6a86");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),

/***/ "d1c3":
/***/ (function(module, exports, __webpack_require__) {

/*! Buefy v0.8.20 | MIT License | github.com/buefy/buefy */
(function (global, factory) {
   true ? factory(exports) :
  undefined;
}(this, function (exports) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  var config = {
    defaultContainerElement: null,
    defaultIconPack: 'mdi',
    defaultIconComponent: null,
    defaultIconPrev: 'chevron-left',
    defaultIconNext: 'chevron-right',
    defaultDialogConfirmText: null,
    defaultDialogCancelText: null,
    defaultSnackbarDuration: 3500,
    defaultSnackbarPosition: null,
    defaultToastDuration: 2000,
    defaultToastPosition: null,
    defaultNotificationDuration: 2000,
    defaultNotificationPosition: null,
    defaultTooltipType: 'is-primary',
    defaultTooltipAnimated: false,
    defaultTooltipDelay: 0,
    defaultInputAutocomplete: 'on',
    defaultDateFormatter: null,
    defaultDateParser: null,
    defaultDateCreator: null,
    defaultTimeCreator: null,
    defaultDayNames: null,
    defaultMonthNames: null,
    defaultFirstDayOfWeek: null,
    defaultUnselectableDaysOfWeek: null,
    defaultTimeFormatter: null,
    defaultTimeParser: null,
    defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
    defaultModalScroll: null,
    defaultDatepickerMobileNative: true,
    defaultTimepickerMobileNative: true,
    defaultNoticeQueue: true,
    defaultInputHasCounter: true,
    defaultTaginputHasCounter: true,
    defaultUseHtml5Validation: true,
    defaultDropdownMobileModal: true,
    defaultFieldLabelPosition: null,
    defaultDatepickerYearsRange: [-100, 3],
    defaultDatepickerNearbyMonthDays: true,
    defaultDatepickerNearbySelectableMonthDays: false,
    defaultDatepickerShowWeekNumber: false,
    defaultDatepickerMobileModal: true,
    defaultTrapFocus: false,
    defaultButtonRounded: false,
    defaultCarouselInterval: 3500,
    defaultTabsAnimated: true,
    defaultLinkTags: ['a', 'button', 'input', 'router-link', 'nuxt-link', 'n-link', 'RouterLink', 'NuxtLink', 'NLink'],
    customIconPacks: null
  }; // TODO defaultTrapFocus to true in the next breaking change

  var FormElementMixin = {
    props: {
      size: String,
      expanded: Boolean,
      loading: Boolean,
      rounded: Boolean,
      icon: String,
      iconPack: String,
      // Native options to use in HTML5 validation
      autocomplete: String,
      maxlength: [Number, String],
      useHtml5Validation: {
        type: Boolean,
        default: function _default() {
          return config.defaultUseHtml5Validation;
        }
      },
      validationMessage: String
    },
    data: function data() {
      return {
        isValid: true,
        isFocused: false,
        newIconPack: this.iconPack || config.defaultIconPack
      };
    },
    computed: {
      /**
       * Find parent Field, max 3 levels deep.
       */
      parentField: function parentField() {
        var parent = this.$parent;

        for (var i = 0; i < 3; i++) {
          if (parent && !parent.$data._isField) {
            parent = parent.$parent;
          }
        }

        return parent;
      },

      /**
       * Get the type prop from parent if it's a Field.
       */
      statusType: function statusType() {
        if (!this.parentField) return;
        if (!this.parentField.newType) return;

        if (typeof this.parentField.newType === 'string') {
          return this.parentField.newType;
        } else {
          for (var key in this.parentField.newType) {
            if (this.parentField.newType[key]) {
              return key;
            }
          }
        }
      },

      /**
       * Get the message prop from parent if it's a Field.
       */
      statusMessage: function statusMessage() {
        if (!this.parentField) return;
        return this.parentField.newMessage || this.parentField.$slots.message;
      },

      /**
       * Fix icon size for inputs, large was too big
       */
      iconSize: function iconSize() {
        switch (this.size) {
          case 'is-small':
            return this.size;

          case 'is-medium':
            return;

          case 'is-large':
            return this.newIconPack === 'mdi' ? 'is-medium' : '';
        }
      }
    },
    methods: {
      /**
       * Focus method that work dynamically depending on the component.
       */
      focus: function focus() {
        var _this = this;

        if (this.$data._elementRef === undefined) return;
        this.$nextTick(function () {
          var el = _this.$el.querySelector(_this.$data._elementRef);

          if (el) el.focus();
        });
      },
      onBlur: function onBlur($event) {
        this.isFocused = false;
        this.$emit('blur', $event);
        this.checkHtml5Validity();
      },
      onFocus: function onFocus($event) {
        this.isFocused = true;
        this.$emit('focus', $event);
      },
      getElement: function getElement() {
        return this.$el.querySelector(this.$data._elementRef);
      },
      setInvalid: function setInvalid() {
        var type = 'is-danger';
        var message = this.validationMessage || this.getElement().validationMessage;
        this.setValidity(type, message);
      },
      setValidity: function setValidity(type, message) {
        var _this2 = this;

        this.$nextTick(function () {
          if (_this2.parentField) {
            // Set type only if not defined
            if (!_this2.parentField.type) {
              _this2.parentField.newType = type;
            } // Set message only if not defined


            if (!_this2.parentField.message) {
              _this2.parentField.newMessage = message;
            }
          }
        });
      },

      /**
       * Check HTML5 validation, set isValid property.
       * If validation fail, send 'is-danger' type,
       * and error message to parent if it's a Field.
       */
      checkHtml5Validity: function checkHtml5Validity() {
        if (!this.useHtml5Validation) return;
        if (this.$refs[this.$data._elementRef] === undefined) return;
        if (this.getElement() === null) return;

        if (!this.getElement().checkValidity()) {
          this.setInvalid();
          this.isValid = false;
        } else {
          this.setValidity(null, null);
          this.isValid = true;
        }

        return this.isValid;
      }
    }
  };

  /**
   * Merge function to replace Object.assign with deep merging possibility
   */

  var isObject = function isObject(item) {
    return _typeof(item) === 'object' && !Array.isArray(item);
  };

  var mergeFn = function mergeFn(target, source) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (deep || !Object.assign) {
      var isDeep = function isDeep(prop) {
        return isObject(source[prop]) && target !== null && target.hasOwnProperty(prop) && isObject(target[prop]);
      };

      var replaced = Object.getOwnPropertyNames(source).map(function (prop) {
        return _defineProperty({}, prop, isDeep(prop) ? mergeFn(target[prop], source[prop], deep) : source[prop]);
      }).reduce(function (a, b) {
        return _objectSpread2({}, a, {}, b);
      }, {});
      return _objectSpread2({}, target, {}, replaced);
    } else {
      return Object.assign(target, source);
    }
  };

  var merge = mergeFn;
  /**
   * Mobile detection
   * https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
   */

  var isMobile = {
    Android: function Android() {
      return typeof window !== 'undefined' && window.navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
      return typeof window !== 'undefined' && window.navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
      return typeof window !== 'undefined' && window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function Opera() {
      return typeof window !== 'undefined' && window.navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function Windows() {
      return typeof window !== 'undefined' && window.navigator.userAgent.match(/IEMobile/i);
    },
    any: function any() {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
  };
  function removeElement(el) {
    if (typeof el.remove !== 'undefined') {
      el.remove();
    } else if (typeof el.parentNode !== 'undefined' && el.parentNode !== null) {
      el.parentNode.removeChild(el);
    }
  }
  function createAbsoluteElement(el) {
    var root = document.createElement('div');
    root.style.position = 'absolute';
    root.style.left = '0px';
    root.style.top = '0px';
    var wrapper = document.createElement('div');
    root.appendChild(wrapper);
    wrapper.appendChild(el);
    document.body.appendChild(root);
    return root;
  }

  var AM = 'AM';
  var PM = 'PM';
  var HOUR_FORMAT_24 = '24';
  var HOUR_FORMAT_12 = '12';

  var defaultTimeFormatter = function defaultTimeFormatter(date, vm) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var period = '';

    if (vm.hourFormat === HOUR_FORMAT_12) {
      period = ' ' + (hours < 12 ? AM : PM);

      if (hours > 12) {
        hours -= 12;
      } else if (hours === 0) {
        hours = 12;
      }
    }

    return vm.pad(hours) + ':' + vm.pad(minutes) + (vm.enableSeconds ? ':' + vm.pad(seconds) : '') + period;
  };

  var defaultTimeParser = function defaultTimeParser(timeString, vm) {
    if (timeString) {
      var am = false;

      if (vm.hourFormat === HOUR_FORMAT_12) {
        var dateString12 = timeString.split(' ');
        timeString = dateString12[0];
        am = dateString12[1] === AM;
      }

      var time = timeString.split(':');
      var hours = parseInt(time[0], 10);
      var minutes = parseInt(time[1], 10);
      var seconds = vm.enableSeconds ? parseInt(time[2], 10) : 0;

      if (isNaN(hours) || hours < 0 || hours > 23 || vm.hourFormat === HOUR_FORMAT_12 && (hours < 1 || hours > 12) || isNaN(minutes) || minutes < 0 || minutes > 59) {
        return null;
      }

      var d = null;

      if (vm.computedValue && !isNaN(vm.computedValue)) {
        d = new Date(vm.computedValue);
      } else {
        d = vm.timeCreator();
        d.setMilliseconds(0);
      }

      d.setSeconds(seconds);
      d.setMinutes(minutes);

      if (vm.hourFormat === HOUR_FORMAT_12) {
        if (am && hours === 12) {
          hours = 0;
        } else if (!am && hours !== 12) {
          hours += 12;
        }
      }

      d.setHours(hours);
      return new Date(d.getTime());
    }

    return null;
  };

  var TimepickerMixin = {
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      value: Date,
      inline: Boolean,
      minTime: Date,
      maxTime: Date,
      placeholder: String,
      editable: Boolean,
      disabled: Boolean,
      hourFormat: {
        type: String,
        default: HOUR_FORMAT_24,
        validator: function validator(value) {
          return value === HOUR_FORMAT_24 || value === HOUR_FORMAT_12;
        }
      },
      incrementHours: {
        type: Number,
        default: 1
      },
      incrementMinutes: {
        type: Number,
        default: 1
      },
      incrementSeconds: {
        type: Number,
        default: 1
      },
      timeFormatter: {
        type: Function,
        default: function _default(date, vm) {
          if (typeof config.defaultTimeFormatter === 'function') {
            return config.defaultTimeFormatter(date);
          } else {
            return defaultTimeFormatter(date, vm);
          }
        }
      },
      timeParser: {
        type: Function,
        default: function _default(date, vm) {
          if (typeof config.defaultTimeParser === 'function') {
            return config.defaultTimeParser(date);
          } else {
            return defaultTimeParser(date, vm);
          }
        }
      },
      mobileNative: {
        type: Boolean,
        default: function _default() {
          return config.defaultTimepickerMobileNative;
        }
      },
      timeCreator: {
        type: Function,
        default: function _default() {
          if (typeof config.defaultTimeCreator === 'function') {
            return config.defaultTimeCreator();
          } else {
            return new Date();
          }
        }
      },
      position: String,
      unselectableTimes: Array,
      openOnFocus: Boolean,
      enableSeconds: Boolean,
      defaultMinutes: Number,
      defaultSeconds: Number,
      focusable: {
        type: Boolean,
        default: true
      },
      tzOffset: {
        type: Number,
        default: 0
      },
      appendToBody: Boolean
    },
    data: function data() {
      return {
        dateSelected: this.value,
        hoursSelected: null,
        minutesSelected: null,
        secondsSelected: null,
        meridienSelected: null,
        _elementRef: 'input',
        AM: AM,
        PM: PM,
        HOUR_FORMAT_24: HOUR_FORMAT_24,
        HOUR_FORMAT_12: HOUR_FORMAT_12
      };
    },
    computed: {
      computedValue: {
        get: function get() {
          return this.dateSelected;
        },
        set: function set(value) {
          this.dateSelected = value;
          this.$emit('input', this.dateSelected);
        }
      },
      hours: function hours() {
        if (!this.incrementHours || this.incrementHours < 1) throw new Error('Hour increment cannot be null or less than 1.');
        var hours = [];
        var numberOfHours = this.isHourFormat24 ? 24 : 12;

        for (var i = 0; i < numberOfHours; i += this.incrementHours) {
          var value = i;
          var label = value;

          if (!this.isHourFormat24) {
            value = i + 1;
            label = value;

            if (this.meridienSelected === this.AM) {
              if (value === 12) {
                value = 0;
              }
            } else if (this.meridienSelected === this.PM) {
              if (value !== 12) {
                value += 12;
              }
            }
          }

          hours.push({
            label: this.formatNumber(label),
            value: value
          });
        }

        return hours;
      },
      minutes: function minutes() {
        if (!this.incrementMinutes || this.incrementMinutes < 1) throw new Error('Minute increment cannot be null or less than 1.');
        var minutes = [];

        for (var i = 0; i < 60; i += this.incrementMinutes) {
          minutes.push({
            label: this.formatNumber(i, true),
            value: i
          });
        }

        return minutes;
      },
      seconds: function seconds() {
        if (!this.incrementSeconds || this.incrementSeconds < 1) throw new Error('Second increment cannot be null or less than 1.');
        var seconds = [];

        for (var i = 0; i < 60; i += this.incrementSeconds) {
          seconds.push({
            label: this.formatNumber(i, true),
            value: i
          });
        }

        return seconds;
      },
      meridiens: function meridiens() {
        return [AM, PM];
      },
      isMobile: function isMobile$1() {
        return this.mobileNative && isMobile.any();
      },
      isHourFormat24: function isHourFormat24() {
        return this.hourFormat === HOUR_FORMAT_24;
      }
    },
    watch: {
      hourFormat: function hourFormat() {
        if (this.hoursSelected !== null) {
          this.meridienSelected = this.hoursSelected >= 12 ? PM : AM;
        }
      },

      /**
       * When v-model is changed:
       *   1. Update internal value.
       *   2. If it's invalid, validate again.
       */
      value: {
        handler: function handler(value) {
          this.updateInternalState(value);
          !this.isValid && this.$refs.input.checkHtml5Validity();
        },
        immediate: true
      }
    },
    methods: {
      onMeridienChange: function onMeridienChange(value) {
        if (this.hoursSelected !== null) {
          if (value === PM) {
            this.hoursSelected += 12;
          } else if (value === AM) {
            this.hoursSelected -= 12;
          }
        }

        this.updateDateSelected(this.hoursSelected, this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, value);
      },
      onHoursChange: function onHoursChange(value) {
        if (!this.minutesSelected && typeof this.defaultMinutes !== 'undefined') {
          this.minutesSelected = this.defaultMinutes;
        }

        if (!this.secondsSelected && typeof this.defaultSeconds !== 'undefined') {
          this.secondsSelected = this.defaultSeconds;
        }

        this.updateDateSelected(parseInt(value, 10), this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
      },
      onMinutesChange: function onMinutesChange(value) {
        if (!this.secondsSelected && this.defaultSeconds) {
          this.secondsSelected = this.defaultSeconds;
        }

        this.updateDateSelected(this.hoursSelected, parseInt(value, 10), this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
      },
      onSecondsChange: function onSecondsChange(value) {
        this.updateDateSelected(this.hoursSelected, this.minutesSelected, parseInt(value, 10), this.meridienSelected);
      },
      updateDateSelected: function updateDateSelected(hours, minutes, seconds, meridiens) {
        if (hours != null && minutes != null && (!this.isHourFormat24 && meridiens !== null || this.isHourFormat24)) {
          var time = null;

          if (this.computedValue && !isNaN(this.computedValue)) {
            time = new Date(this.computedValue);
          } else {
            time = this.timeCreator();
            time.setMilliseconds(0);
          }

          time.setHours(hours);
          time.setMinutes(minutes);
          time.setSeconds(seconds);
          this.computedValue = new Date(time.getTime());
        }
      },
      updateInternalState: function updateInternalState(value) {
        if (value) {
          this.hoursSelected = value.getHours();
          this.minutesSelected = value.getMinutes();
          this.secondsSelected = value.getSeconds();
          this.meridienSelected = value.getHours() >= 12 ? PM : AM;
        } else {
          this.hoursSelected = null;
          this.minutesSelected = null;
          this.secondsSelected = null;
          this.meridienSelected = AM;
        }

        this.dateSelected = value;
      },
      isHourDisabled: function isHourDisabled(hour) {
        var _this = this;

        var disabled = false;

        if (this.minTime) {
          var minHours = this.minTime.getHours();
          var noMinutesAvailable = this.minutes.every(function (minute) {
            return _this.isMinuteDisabledForHour(hour, minute.value);
          });
          disabled = hour < minHours || noMinutesAvailable;
        }

        if (this.maxTime) {
          if (!disabled) {
            var maxHours = this.maxTime.getHours();
            disabled = hour > maxHours;
          }
        }

        if (this.unselectableTimes) {
          if (!disabled) {
            var unselectable = this.unselectableTimes.filter(function (time) {
              if (_this.enableSeconds && _this.secondsSelected !== null) {
                return time.getHours() === hour && time.getMinutes() === _this.minutesSelected && time.getSeconds() === _this.secondsSelected;
              } else if (_this.minutesSelected !== null) {
                return time.getHours() === hour && time.getMinutes() === _this.minutesSelected;
              } else {
                return time.getHours() === hour;
              }
            });
            disabled = unselectable.length > 0;
          }
        }

        return disabled;
      },
      isMinuteDisabledForHour: function isMinuteDisabledForHour(hour, minute) {
        var disabled = false;

        if (this.minTime) {
          var minHours = this.minTime.getHours();
          var minMinutes = this.minTime.getMinutes();
          disabled = hour === minHours && minute < minMinutes;
        }

        if (this.maxTime) {
          if (!disabled) {
            var maxHours = this.maxTime.getHours();
            var maxMinutes = this.maxTime.getMinutes();
            disabled = hour === maxHours && minute > maxMinutes;
          }
        }

        return disabled;
      },
      isMinuteDisabled: function isMinuteDisabled(minute) {
        var _this2 = this;

        var disabled = false;

        if (this.hoursSelected !== null) {
          if (this.isHourDisabled(this.hoursSelected)) {
            disabled = true;
          } else {
            disabled = this.isMinuteDisabledForHour(this.hoursSelected, minute);
          }

          if (this.unselectableTimes) {
            if (!disabled) {
              var unselectable = this.unselectableTimes.filter(function (time) {
                if (_this2.enableSeconds && _this2.secondsSelected !== null) {
                  return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute && time.getSeconds() === _this2.secondsSelected;
                } else {
                  return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute;
                }
              });
              disabled = unselectable.length > 0;
            }
          }
        }

        return disabled;
      },
      isSecondDisabled: function isSecondDisabled(second) {
        var _this3 = this;

        var disabled = false;

        if (this.minutesSelected !== null) {
          if (this.isMinuteDisabled(this.minutesSelected)) {
            disabled = true;
          } else {
            if (this.minTime) {
              var minHours = this.minTime.getHours();
              var minMinutes = this.minTime.getMinutes();
              var minSeconds = this.minTime.getSeconds();
              disabled = this.hoursSelected === minHours && this.minutesSelected === minMinutes && second < minSeconds;
            }

            if (this.maxTime) {
              if (!disabled) {
                var maxHours = this.maxTime.getHours();
                var maxMinutes = this.maxTime.getMinutes();
                var maxSeconds = this.maxTime.getSeconds();
                disabled = this.hoursSelected === maxHours && this.minutesSelected === maxMinutes && second > maxSeconds;
              }
            }
          }

          if (this.unselectableTimes) {
            if (!disabled) {
              var unselectable = this.unselectableTimes.filter(function (time) {
                return time.getHours() === _this3.hoursSelected && time.getMinutes() === _this3.minutesSelected && time.getSeconds() === second;
              });
              disabled = unselectable.length > 0;
            }
          }
        }

        return disabled;
      },

      /*
      * Parse string into date
      */
      onChange: function onChange(value) {
        var date = this.timeParser(value, this);
        this.updateInternalState(date);

        if (date && !isNaN(date)) {
          this.computedValue = date;
        } else {
          // Force refresh input value when not valid date
          this.computedValue = null;
          this.$refs.input.newValue = this.computedValue;
        }
      },

      /*
      * Toggle timepicker
      */
      toggle: function toggle(active) {
        if (this.$refs.dropdown) {
          this.$refs.dropdown.isActive = typeof active === 'boolean' ? active : !this.$refs.dropdown.isActive;
        }
      },

      /*
      * Close timepicker
      */
      close: function close() {
        this.toggle(false);
      },

      /*
      * Call default onFocus method and show timepicker
      */
      handleOnFocus: function handleOnFocus() {
        this.onFocus();

        if (this.openOnFocus) {
          this.toggle(true);
        }
      },

      /*
      * Format date into string 'HH-MM-SS'
      */
      formatHHMMSS: function formatHHMMSS(value) {
        var date = new Date(value);

        if (value && !isNaN(date)) {
          var hours = date.getHours();
          var minutes = date.getMinutes();
          var seconds = date.getSeconds();
          return this.formatNumber(hours, true) + ':' + this.formatNumber(minutes, true) + ':' + this.formatNumber(seconds, true);
        }

        return '';
      },

      /*
      * Parse time from string
      */
      onChangeNativePicker: function onChangeNativePicker(event) {
        var date = event.target.value;

        if (date) {
          var time = null;

          if (this.computedValue && !isNaN(this.computedValue)) {
            time = new Date(this.computedValue);
          } else {
            time = new Date();
            time.setMilliseconds(0);
          }

          var t = date.split(':');
          time.setHours(parseInt(t[0], 10));
          time.setMinutes(parseInt(t[1], 10));
          time.setSeconds(t[2] ? parseInt(t[2], 10) : 0);
          this.computedValue = new Date(time.getTime());
        } else {
          this.computedValue = null;
        }
      },
      formatNumber: function formatNumber(value, prependZero) {
        return this.isHourFormat24 || prependZero ? this.pad(value) : value;
      },
      pad: function pad(value) {
        return (value < 10 ? '0' : '') + value;
      },

      /*
      * Format date into string
      */
      formatValue: function formatValue(date) {
        if (date && !isNaN(date)) {
          return this.timeFormatter(date, this);
        } else {
          return null;
        }
      },

      /**
       * Keypress event that is bound to the document.
       */
      keyPress: function keyPress(event) {
        // Esc key
        if (this.$refs.dropdown && this.$refs.dropdown.isActive && event.keyCode === 27) {
          this.toggle(false);
        }
      },

      /**
       * Emit 'blur' event on dropdown is not active (closed)
       */
      onActiveChange: function onActiveChange(value) {
        if (!value) {
          this.onBlur();
        }
      }
    },
    created: function created() {
      if (typeof window !== 'undefined') {
        document.addEventListener('keyup', this.keyPress);
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (typeof window !== 'undefined') {
        document.removeEventListener('keyup', this.keyPress);
      }
    }
  };

  var findFocusable = function findFocusable(element) {
    var programmatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!element) {
      return null;
    }

    if (programmatic) {
      return element.querySelectorAll("*[tabindex=\"-1\"]");
    }

    return element.querySelectorAll("a[href]:not([tabindex=\"-1\"]),\n                                     area[href],\n                                     input:not([disabled]),\n                                     select:not([disabled]),\n                                     textarea:not([disabled]),\n                                     button:not([disabled]),\n                                     iframe,\n                                     object,\n                                     embed,\n                                     *[tabindex]:not([tabindex=\"-1\"]),\n                                     *[contenteditable]");
  };

  var onKeyDown;

  var bind = function bind(el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === void 0 ? true : _ref$value;

    if (value) {
      var focusable = findFocusable(el);
      var focusableProg = findFocusable(el, true);

      if (focusable && focusable.length > 0) {
        onKeyDown = function onKeyDown(event) {
          // Need to get focusable each time since it can change between key events
          // ex. changing month in a datepicker
          focusable = findFocusable(el);
          focusableProg = findFocusable(el, true);
          var firstFocusable = focusable[0];
          var lastFocusable = focusable[focusable.length - 1];

          if (event.target === firstFocusable && event.shiftKey && event.key === 'Tab') {
            event.preventDefault();
            lastFocusable.focus();
          } else if ((event.target === lastFocusable || Array.from(focusableProg).indexOf(event.target) >= 0) && !event.shiftKey && event.key === 'Tab') {
            event.preventDefault();
            firstFocusable.focus();
          }
        };

        el.addEventListener('keydown', onKeyDown);
      }
    }
  };

  var unbind = function unbind(el) {
    el.removeEventListener('keydown', onKeyDown);
  };

  var directive = {
    bind: bind,
    unbind: unbind
  };

  var DEFAULT_CLOSE_OPTIONS = ['escape', 'outside'];
  var script = {
    name: 'BDropdown',
    directives: {
      trapFocus: directive
    },
    props: {
      value: {
        type: [String, Number, Boolean, Object, Array, Function],
        default: null
      },
      disabled: Boolean,
      hoverable: Boolean,
      inline: Boolean,
      scrollable: Boolean,
      maxHeight: {
        type: [String, Number],
        default: 200
      },
      position: {
        type: String,
        validator: function validator(value) {
          return ['is-top-right', 'is-top-left', 'is-bottom-left', 'is-bottom-right'].indexOf(value) > -1;
        }
      },
      mobileModal: {
        type: Boolean,
        default: function _default() {
          return config.defaultDropdownMobileModal;
        }
      },
      ariaRole: {
        type: String,
        validator: function validator(value) {
          return ['menu', 'list', 'dialog'].indexOf(value) > -1;
        },
        default: null
      },
      animation: {
        type: String,
        default: 'fade'
      },
      multiple: Boolean,
      trapFocus: {
        type: Boolean,
        default: function _default() {
          return config.defaultTrapFocus;
        }
      },
      closeOnClick: {
        type: Boolean,
        default: true
      },
      canClose: {
        type: [Array, Boolean],
        default: true
      },
      expanded: Boolean,
      appendToBody: Boolean,
      appendToBodyCopyParent: Boolean
    },
    data: function data() {
      return {
        selected: this.value,
        style: {},
        isActive: false,
        isHoverable: this.hoverable,
        _isDropdown: true,
        // Used internally by DropdownItem
        _bodyEl: undefined // Used to append to body

      };
    },
    computed: {
      rootClasses: function rootClasses() {
        return [this.position, {
          'is-disabled': this.disabled,
          'is-hoverable': this.hoverable,
          'is-inline': this.inline,
          'is-active': this.isActive || this.inline,
          'is-mobile-modal': this.isMobileModal,
          'is-expanded': this.expanded
        }];
      },
      isMobileModal: function isMobileModal() {
        return this.mobileModal && !this.inline && !this.hoverable;
      },
      cancelOptions: function cancelOptions() {
        return typeof this.canClose === 'boolean' ? this.canClose ? DEFAULT_CLOSE_OPTIONS : [] : this.canClose;
      },
      contentStyle: function contentStyle() {
        return {
          maxHeight: this.scrollable ? this.maxHeight === undefined ? null : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px' : null,
          overflow: this.scrollable ? 'auto' : null
        };
      }
    },
    watch: {
      /**
      * When v-model is changed set the new selected item.
      */
      value: function value(_value) {
        this.selected = _value;
      },

      /**
      * Emit event when isActive value is changed.
      */
      isActive: function isActive(value) {
        var _this = this;

        this.$emit('active-change', value);

        if (this.appendToBody) {
          this.$nextTick(function () {
            _this.updateAppendToBody();
          });
        }
      }
    },
    methods: {
      /**
      * Click listener from DropdownItem.
      *   1. Set new selected item.
      *   2. Emit input event to update the user v-model.
      *   3. Close the dropdown.
      */
      selectItem: function selectItem(value) {
        if (this.multiple) {
          if (this.selected) {
            var index = this.selected.indexOf(value);

            if (index === -1) {
              this.selected.push(value);
            } else {
              this.selected.splice(index, 1);
            }
          } else {
            this.selected = [value];
          }

          this.$emit('change', this.selected);
        } else {
          if (this.selected !== value) {
            this.selected = value;
            this.$emit('change', this.selected);
          }
        }

        this.$emit('input', this.selected);

        if (!this.multiple) {
          this.isActive = !this.closeOnClick;

          if (this.hoverable && this.closeOnClick) {
            this.isHoverable = false;
          }
        }
      },

      /**
      * White-listed items to not close when clicked.
      */
      isInWhiteList: function isInWhiteList(el) {
        if (el === this.$refs.dropdownMenu) return true;
        if (el === this.$refs.trigger) return true; // All chidren from dropdown

        if (this.$refs.dropdownMenu !== undefined) {
          var children = this.$refs.dropdownMenu.querySelectorAll('*');
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var child = _step.value;

              if (el === child) {
                return true;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } // All children from trigger


        if (this.$refs.trigger !== undefined) {
          var _children = this.$refs.trigger.querySelectorAll('*');

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = _children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _child = _step2.value;

              if (el === _child) {
                return true;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }

        return false;
      },

      /**
      * Close dropdown if clicked outside.
      */
      clickedOutside: function clickedOutside(event) {
        if (this.cancelOptions.indexOf('outside') < 0) return;
        if (this.inline) return;
        if (!this.isInWhiteList(event.target)) this.isActive = false;
      },

      /**
       * Keypress event that is bound to the document
       */
      keyPress: function keyPress(event) {
        // Esc key
        if (this.isActive && event.keyCode === 27) {
          if (this.cancelOptions.indexOf('escape') < 0) return;
          this.isActive = false;
        }
      },

      /**
      * Toggle dropdown if it's not disabled.
      */
      toggle: function toggle() {
        var _this2 = this;

        if (this.disabled) return;

        if (!this.isActive) {
          // if not active, toggle after clickOutside event
          // this fixes toggling programmatic
          this.$nextTick(function () {
            var value = !_this2.isActive;
            _this2.isActive = value; // Vue 2.6.x ???

            setTimeout(function () {
              return _this2.isActive = value;
            });
          });
        } else {
          this.isActive = !this.isActive;
        }
      },
      checkHoverable: function checkHoverable() {
        if (this.hoverable) {
          this.isHoverable = true;
        }
      },
      updateAppendToBody: function updateAppendToBody() {
        var dropdownMenu = this.$refs.dropdownMenu;
        var trigger = this.$refs.trigger;

        if (dropdownMenu && trigger) {
          // update wrapper dropdown
          var dropdown = this.$data._bodyEl.children[0];
          dropdown.classList.forEach(function (item) {
            return dropdown.classList.remove(item);
          });
          dropdown.classList.add('dropdown');
          dropdown.classList.add('dropdown-menu-animation');

          if (this.$vnode && this.$vnode.data && this.$vnode.data.staticClass) {
            dropdown.classList.add(this.$vnode.data.staticClass);
          }

          this.rootClasses.forEach(function (item) {
            // skip position prop
            if (item && _typeof(item) === 'object') {
              for (var key in item) {
                if (item[key]) {
                  dropdown.classList.add(key);
                }
              }
            }
          });

          if (this.appendToBodyCopyParent) {
            var parentNode = this.$refs.dropdown.parentNode;
            var parent = this.$data._bodyEl;
            parent.classList.forEach(function (item) {
              return parent.classList.remove(item);
            });
            parentNode.classList.forEach(function (item) {
              parent.classList.add(item);
            });
          }

          var rect = trigger.getBoundingClientRect();
          var top = rect.top + window.scrollY;
          var left = rect.left + window.scrollX;

          if (!this.position || this.position.indexOf('bottom') >= 0) {
            top += trigger.clientHeight;
          } else {
            top -= dropdownMenu.clientHeight;
          }

          if (this.position && this.position.indexOf('left') >= 0) {
            left -= dropdownMenu.clientWidth - trigger.clientWidth;
          }

          this.style = {
            position: 'absolute',
            top: "".concat(top, "px"),
            left: "".concat(left, "px"),
            zIndex: '99'
          };
        }
      }
    },
    mounted: function mounted() {
      if (this.appendToBody) {
        this.$data._bodyEl = createAbsoluteElement(this.$refs.dropdownMenu);
        this.updateAppendToBody();
      }
    },
    created: function created() {
      if (typeof window !== 'undefined') {
        document.addEventListener('click', this.clickedOutside);
        document.addEventListener('keyup', this.keyPress);
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (typeof window !== 'undefined') {
        document.removeEventListener('click', this.clickedOutside);
        document.removeEventListener('keyup', this.keyPress);
      }

      if (this.appendToBody) {
        removeElement(this.$data._bodyEl);
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  const __vue_script__ = script;

  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"dropdown dropdown-menu-animation",class:_vm.rootClasses},[(!_vm.inline)?_c('div',{ref:"trigger",staticClass:"dropdown-trigger",attrs:{"role":"button","aria-haspopup":"true"},on:{"click":_vm.toggle,"mouseenter":_vm.checkHoverable}},[_vm._t("trigger",null,{active:_vm.isActive})],2):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.animation}},[(_vm.isMobileModal)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"background",attrs:{"aria-hidden":!_vm.isActive}}):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.animation}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((!_vm.disabled && (_vm.isActive || _vm.isHoverable)) || _vm.inline),expression:"(!disabled && (isActive || isHoverable)) || inline"},{name:"trap-focus",rawName:"v-trap-focus",value:(_vm.trapFocus),expression:"trapFocus"}],ref:"dropdownMenu",staticClass:"dropdown-menu",style:(_vm.style),attrs:{"aria-hidden":!_vm.isActive}},[_c('div',{staticClass:"dropdown-content",style:(_vm.contentStyle),attrs:{"role":_vm.ariaRole}},[_vm._t("default")],2)])])],1)};
  var __vue_staticRenderFns__ = [];

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Dropdown = normalizeComponent_1(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      undefined,
      undefined
    );

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$1 = {
    name: 'BDropdownItem',
    props: {
      value: {
        type: [String, Number, Boolean, Object, Array, Function],
        default: null
      },
      separator: Boolean,
      disabled: Boolean,
      custom: Boolean,
      focusable: {
        type: Boolean,
        default: true
      },
      paddingless: Boolean,
      hasLink: Boolean,
      ariaRole: {
        type: String,
        default: ''
      }
    },
    computed: {
      anchorClasses: function anchorClasses() {
        return {
          'is-disabled': this.$parent.disabled || this.disabled,
          'is-paddingless': this.paddingless,
          'is-active': this.isActive
        };
      },
      itemClasses: function itemClasses() {
        return {
          'dropdown-item': !this.hasLink,
          'is-disabled': this.disabled,
          'is-paddingless': this.paddingless,
          'is-active': this.isActive,
          'has-link': this.hasLink
        };
      },
      ariaRoleItem: function ariaRoleItem() {
        return this.ariaRole === 'menuitem' || this.ariaRole === 'listitem' ? this.ariaRole : null;
      },
      isClickable: function isClickable() {
        return !this.$parent.disabled && !this.separator && !this.disabled && !this.custom;
      },
      isActive: function isActive() {
        if (this.$parent.selected === null) return false;
        if (this.$parent.multiple) return this.$parent.selected.indexOf(this.value) >= 0;
        return this.value === this.$parent.selected;
      },
      isFocusable: function isFocusable() {
        return this.hasLink ? false : this.focusable;
      }
    },
    methods: {
      /**
      * Click listener, select the item.
      */
      selectItem: function selectItem() {
        if (!this.isClickable) return;
        this.$parent.selectItem(this.value);
        this.$emit('click');
      }
    },
    created: function created() {
      if (!this.$parent.$data._isDropdown) {
        this.$destroy();
        throw new Error('You should wrap bDropdownItem on a bDropdown');
      }
    }
  };

  /* script */
  const __vue_script__$1 = script$1;

  /* template */
  var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.separator)?_c('hr',{staticClass:"dropdown-divider"}):(!_vm.custom && !_vm.hasLink)?_c('a',{staticClass:"dropdown-item",class:_vm.anchorClasses,attrs:{"role":_vm.ariaRoleItem,"tabindex":_vm.isFocusable ? 0 : null},on:{"click":_vm.selectItem}},[_vm._t("default")],2):_c('div',{class:_vm.itemClasses,attrs:{"role":_vm.ariaRoleItem,"tabindex":_vm.isFocusable ? 0 : null},on:{"click":_vm.selectItem}},[_vm._t("default")],2)};
  var __vue_staticRenderFns__$1 = [];

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var DropdownItem = normalizeComponent_1(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      undefined,
      undefined
    );

  var mdiIcons = {
    sizes: {
      'default': 'mdi-24px',
      'is-small': null,
      'is-medium': 'mdi-36px',
      'is-large': 'mdi-48px'
    },
    iconPrefix: 'mdi-'
  };

  var faIcons = function faIcons() {
    var faIconPrefix = config && config.defaultIconComponent ? '' : 'fa-';
    return {
      sizes: {
        'default': faIconPrefix + 'lg',
        'is-small': null,
        'is-medium': faIconPrefix + '2x',
        'is-large': faIconPrefix + '3x'
      },
      iconPrefix: faIconPrefix,
      internalIcons: {
        'information': 'info-circle',
        'alert': 'exclamation-triangle',
        'alert-circle': 'exclamation-circle',
        'chevron-right': 'angle-right',
        'chevron-left': 'angle-left',
        'chevron-down': 'angle-down',
        'eye-off': 'eye-slash',
        'menu-down': 'caret-down',
        'menu-up': 'caret-up',
        'close-circle': 'times-circle'
      }
    };
  };

  var getIcons = function getIcons() {
    var icons = {
      mdi: mdiIcons,
      fa: faIcons(),
      fas: faIcons(),
      far: faIcons(),
      fad: faIcons(),
      fab: faIcons(),
      fal: faIcons()
    };

    if (config && config.customIconPacks) {
      icons = merge(icons, config.customIconPacks, true);
    }

    return icons;
  };

  var script$2 = {
    name: 'BIcon',
    props: {
      type: [String, Object],
      component: String,
      pack: String,
      icon: String,
      size: String,
      customSize: String,
      customClass: String,
      both: Boolean // This is used internally to show both MDI and FA icon

    },
    computed: {
      iconConfig: function iconConfig() {
        var allIcons = getIcons();
        return allIcons[this.newPack];
      },
      iconPrefix: function iconPrefix() {
        if (this.iconConfig && this.iconConfig.iconPrefix) {
          return this.iconConfig.iconPrefix;
        }

        return '';
      },

      /**
      * Internal icon name based on the pack.
      * If pack is 'fa', gets the equivalent FA icon name of the MDI,
      * internal icons are always MDI.
      */
      newIcon: function newIcon() {
        return "".concat(this.iconPrefix).concat(this.getEquivalentIconOf(this.icon));
      },
      newPack: function newPack() {
        return this.pack || config.defaultIconPack;
      },
      newType: function newType() {
        if (!this.type) return;
        var splitType = [];

        if (typeof this.type === 'string') {
          splitType = this.type.split('-');
        } else {
          for (var key in this.type) {
            if (this.type[key]) {
              splitType = key.split('-');
              break;
            }
          }
        }

        if (splitType.length <= 1) return;

        var _splitType = splitType,
            _splitType2 = _toArray(_splitType),
            type = _splitType2.slice(1);

        return "has-text-".concat(type.join('-'));
      },
      newCustomSize: function newCustomSize() {
        return this.customSize || this.customSizeByPack;
      },
      customSizeByPack: function customSizeByPack() {
        if (this.iconConfig && this.iconConfig.sizes) {
          if (this.size && this.iconConfig.sizes[this.size] !== undefined) {
            return this.iconConfig.sizes[this.size];
          } else if (this.iconConfig.sizes.default) {
            return this.iconConfig.sizes.default;
          }
        }

        return null;
      },
      useIconComponent: function useIconComponent() {
        return this.component || config.defaultIconComponent;
      }
    },
    methods: {
      /**
      * Equivalent icon name of the MDI.
      */
      getEquivalentIconOf: function getEquivalentIconOf(value) {
        // Only transform the class if the both prop is set to true
        if (!this.both) {
          return value;
        }

        if (this.iconConfig && this.iconConfig.internalIcons && this.iconConfig.internalIcons[value]) {
          return this.iconConfig.internalIcons[value];
        }

        return value;
      }
    }
  };

  /* script */
  const __vue_script__$2 = script$2;

  /* template */
  var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[_vm.newType, _vm.size]},[(!_vm.useIconComponent)?_c('i',{class:[_vm.newPack, _vm.newIcon, _vm.newCustomSize, _vm.customClass]}):_c(_vm.useIconComponent,{tag:"component",class:[_vm.customClass],attrs:{"icon":[_vm.newPack, _vm.newIcon],"size":_vm.newCustomSize}})],1)};
  var __vue_staticRenderFns__$2 = [];

    /* style */
    const __vue_inject_styles__$2 = undefined;
    /* scoped */
    const __vue_scope_id__$2 = undefined;
    /* module identifier */
    const __vue_module_identifier__$2 = undefined;
    /* functional template */
    const __vue_is_functional_template__$2 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Icon = normalizeComponent_1(
      { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2,
      __vue_module_identifier__$2,
      undefined,
      undefined
    );

  var script$3 = {
    name: 'BInput',
    components: _defineProperty({}, Icon.name, Icon),
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      value: [Number, String],
      type: {
        type: String,
        default: 'text'
      },
      passwordReveal: Boolean,
      iconClickable: Boolean,
      hasCounter: {
        type: Boolean,
        default: function _default() {
          return config.defaultInputHasCounter;
        }
      },
      customClass: {
        type: String,
        default: ''
      },
      iconRight: String,
      iconRightClickable: Boolean
    },
    data: function data() {
      return {
        newValue: this.value,
        newType: this.type,
        newAutocomplete: this.autocomplete || config.defaultInputAutocomplete,
        isPasswordVisible: false,
        _elementRef: this.type === 'textarea' ? 'textarea' : 'input'
      };
    },
    computed: {
      computedValue: {
        get: function get() {
          return this.newValue;
        },
        set: function set(value) {
          this.newValue = value;
          this.$emit('input', value);
          !this.isValid && this.checkHtml5Validity();
        }
      },
      rootClasses: function rootClasses() {
        return [this.iconPosition, this.size, {
          'is-expanded': this.expanded,
          'is-loading': this.loading,
          'is-clearfix': !this.hasMessage
        }];
      },
      inputClasses: function inputClasses() {
        return [this.statusType, this.size, {
          'is-rounded': this.rounded
        }];
      },
      hasIconRight: function hasIconRight() {
        return this.passwordReveal || this.loading || this.statusTypeIcon || this.iconRight;
      },
      rightIcon: function rightIcon() {
        if (this.passwordReveal) {
          return this.passwordVisibleIcon;
        } else if (this.iconRight) {
          return this.iconRight;
        }

        return this.statusTypeIcon;
      },
      rightIconType: function rightIconType() {
        if (this.passwordReveal) {
          return 'is-primary';
        } else if (this.iconRight) {
          return null;
        }

        return this.statusType;
      },

      /**
      * Position of the icon or if it's both sides.
      */
      iconPosition: function iconPosition() {
        if (this.icon && this.hasIconRight) {
          return 'has-icons-left has-icons-right';
        } else if (!this.icon && this.hasIconRight) {
          return 'has-icons-right';
        } else if (this.icon) {
          return 'has-icons-left';
        }
      },

      /**
      * Icon name (MDI) based on the type.
      */
      statusTypeIcon: function statusTypeIcon() {
        switch (this.statusType) {
          case 'is-success':
            return 'check';

          case 'is-danger':
            return 'alert-circle';

          case 'is-info':
            return 'information';

          case 'is-warning':
            return 'alert';
        }
      },

      /**
      * Check if have any message prop from parent if it's a Field.
      */
      hasMessage: function hasMessage() {
        return !!this.statusMessage;
      },

      /**
      * Current password-reveal icon name.
      */
      passwordVisibleIcon: function passwordVisibleIcon() {
        return !this.isPasswordVisible ? 'eye' : 'eye-off';
      },

      /**
      * Get value length
      */
      valueLength: function valueLength() {
        if (typeof this.computedValue === 'string') {
          return this.computedValue.length;
        } else if (typeof this.computedValue === 'number') {
          return this.computedValue.toString().length;
        }

        return 0;
      }
    },
    watch: {
      /**
      * When v-model is changed:
      *   1. Set internal value.
      */
      value: function value(_value) {
        this.newValue = _value;
      }
    },
    methods: {
      /**
      * Toggle the visibility of a password-reveal input
      * by changing the type and focus the input right away.
      */
      togglePasswordVisibility: function togglePasswordVisibility() {
        var _this = this;

        this.isPasswordVisible = !this.isPasswordVisible;
        this.newType = this.isPasswordVisible ? 'text' : 'password';
        this.$nextTick(function () {
          _this.$refs[_this.$data._elementRef].focus();
        });
      },

      /**
      * Input's 'input' event listener, 'nextTick' is used to prevent event firing
      * before ui update, helps when using masks (Cleavejs and potentially others).
      */
      onInput: function onInput(event) {
        var _this2 = this;

        this.$nextTick(function () {
          if (event.target) {
            _this2.computedValue = event.target.value;
          }
        });
      },
      iconClick: function iconClick(emit, event) {
        var _this3 = this;

        this.$emit(emit, event);
        this.$nextTick(function () {
          _this3.$refs[_this3.$data._elementRef].focus();
        });
      },
      rightIconClick: function rightIconClick(event) {
        if (this.passwordReveal) {
          this.togglePasswordVisibility();
        } else if (this.iconRightClickable) {
          this.iconClick('icon-right-click', event);
        }
      }
    }
  };

  /* script */
  const __vue_script__$3 = script$3;

  /* template */
  var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:_vm.rootClasses},[(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"input",class:[_vm.inputClasses, _vm.customClass],attrs:{"type":_vm.newType,"autocomplete":_vm.newAutocomplete,"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'input',_vm.$attrs,false)):_c('textarea',_vm._b({ref:"textarea",staticClass:"textarea",class:[_vm.inputClasses, _vm.customClass],attrs:{"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'textarea',_vm.$attrs,false)),_vm._v(" "),(_vm.icon)?_c('b-icon',{staticClass:"is-left",class:{'is-clickable': _vm.iconClickable},attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":_vm.iconSize},nativeOn:{"click":function($event){_vm.iconClick('icon-click', $event);}}}):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.hasIconRight)?_c('b-icon',{staticClass:"is-right",class:{ 'is-clickable': _vm.passwordReveal || _vm.iconRightClickable },attrs:{"icon":_vm.rightIcon,"pack":_vm.iconPack,"size":_vm.iconSize,"type":_vm.rightIconType,"both":""},nativeOn:{"click":function($event){return _vm.rightIconClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.maxlength && _vm.hasCounter && _vm.type !== 'number')?_c('small',{staticClass:"help counter",class:{ 'is-invisible': !_vm.isFocused }},[_vm._v("\r\n            "+_vm._s(_vm.valueLength)+" / "+_vm._s(_vm.maxlength)+"\r\n        ")]):_vm._e()],1)};
  var __vue_staticRenderFns__$3 = [];

    /* style */
    const __vue_inject_styles__$3 = undefined;
    /* scoped */
    const __vue_scope_id__$3 = undefined;
    /* module identifier */
    const __vue_module_identifier__$3 = undefined;
    /* functional template */
    const __vue_is_functional_template__$3 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Input = normalizeComponent_1(
      { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
      __vue_inject_styles__$3,
      __vue_script__$3,
      __vue_scope_id__$3,
      __vue_is_functional_template__$3,
      __vue_module_identifier__$3,
      undefined,
      undefined
    );

  var script$4 = {
    name: 'BFieldBody',
    props: {
      message: {
        type: [String, Array]
      },
      type: {
        type: [String, Object]
      }
    },
    render: function render(createElement) {
      var _this = this;

      var first = true;
      return createElement('div', {
        attrs: {
          'class': 'field-body'
        }
      }, this.$slots.default.map(function (element) {
        // skip returns and comments
        if (!element.tag) {
          return element;
        }

        var message;

        if (first) {
          message = _this.message;
          first = false;
        }

        return createElement('b-field', {
          attrs: {
            type: _this.type,
            message: message
          }
        }, [element]);
      }));
    }
  };

  /* script */
  const __vue_script__$4 = script$4;

  /* template */

    /* style */
    const __vue_inject_styles__$4 = undefined;
    /* scoped */
    const __vue_scope_id__$4 = undefined;
    /* module identifier */
    const __vue_module_identifier__$4 = undefined;
    /* functional template */
    const __vue_is_functional_template__$4 = undefined;
    /* style inject */
    
    /* style inject SSR */
    

    
    var FieldBody = normalizeComponent_1(
      {},
      __vue_inject_styles__$4,
      __vue_script__$4,
      __vue_scope_id__$4,
      __vue_is_functional_template__$4,
      __vue_module_identifier__$4,
      undefined,
      undefined
    );

  var script$5 = {
    name: 'BField',
    components: _defineProperty({}, FieldBody.name, FieldBody),
    props: {
      type: [String, Object],
      label: String,
      labelFor: String,
      message: [String, Array, Object],
      grouped: Boolean,
      groupMultiline: Boolean,
      position: String,
      expanded: Boolean,
      horizontal: Boolean,
      addons: {
        type: Boolean,
        default: true
      },
      customClass: String,
      labelPosition: {
        type: String,
        default: function _default() {
          return config.defaultFieldLabelPosition;
        }
      }
    },
    data: function data() {
      return {
        newType: this.type,
        newMessage: this.message,
        fieldLabelSize: null,
        _isField: true // Used internally by Input and Select

      };
    },
    computed: {
      rootClasses: function rootClasses() {
        return [this.newPosition, {
          'is-expanded': this.expanded,
          'is-grouped-multiline': this.groupMultiline,
          'is-horizontal': this.horizontal,
          'is-floating-in-label': this.hasLabel && !this.horizontal && this.labelPosition === 'inside',
          'is-floating-label': this.hasLabel && !this.horizontal && this.labelPosition === 'on-border'
        }, this.numberInputClasses];
      },

      /**
      * Correct Bulma class for the side of the addon or group.
      *
      * This is not kept like the others (is-small, etc.),
      * because since 'has-addons' is set automatically it
      * doesn't make sense to teach users what addons are exactly.
      */
      newPosition: function newPosition() {
        if (this.position === undefined) return;
        var position = this.position.split('-');
        if (position.length < 1) return;
        var prefix = this.grouped ? 'is-grouped-' : 'has-addons-';
        if (this.position) return prefix + position[1];
      },

      /**
      * Formatted message in case it's an array
      * (each element is separated by <br> tag)
      */
      formattedMessage: function formattedMessage() {
        if (typeof this.newMessage === 'string') {
          return [this.newMessage];
        }

        var messages = [];

        if (Array.isArray(this.newMessage)) {
          this.newMessage.forEach(function (message) {
            if (typeof message === 'string') {
              messages.push(message);
            } else {
              for (var key in message) {
                if (message[key]) {
                  messages.push(key);
                }
              }
            }
          });
        } else {
          for (var key in this.newMessage) {
            if (this.newMessage[key]) {
              messages.push(key);
            }
          }
        }

        return messages.filter(function (m) {
          if (m) return m;
        });
      },
      hasLabel: function hasLabel() {
        return this.label || this.$slots.label;
      },
      hasMessage: function hasMessage() {
        return this.newMessage || this.$slots.message;
      },
      numberInputClasses: function numberInputClasses() {
        if (this.$slots.default) {
          var numberinput = this.$slots.default.filter(function (node) {
            return node.tag && node.tag.toLowerCase().indexOf('numberinput') >= 0;
          })[0];

          if (numberinput) {
            var classes = ['has-numberinput'];
            var controlsPosition = numberinput.componentOptions.propsData.controlsPosition;
            var size = numberinput.componentOptions.propsData.size;

            if (controlsPosition) {
              classes.push("has-numberinput-".concat(controlsPosition));
            }

            if (size) {
              classes.push("has-numberinput-".concat(size));
            }

            return classes;
          }
        }

        return null;
      }
    },
    watch: {
      /**
      * Set internal type when prop change.
      */
      type: function type(value) {
        this.newType = value;
      },

      /**
      * Set internal message when prop change.
      */
      message: function message(value) {
        this.newMessage = value;
      }
    },
    methods: {
      /**
      * Field has addons if there are more than one slot
      * (element / component) in the Field.
      * Or is grouped when prop is set.
      * Is a method to be called when component re-render.
      */
      fieldType: function fieldType() {
        if (this.grouped) return 'is-grouped';
        var renderedNode = 0;

        if (this.$slots.default) {
          renderedNode = this.$slots.default.reduce(function (i, node) {
            return node.tag ? i + 1 : i;
          }, 0);
        }

        if (renderedNode > 1 && this.addons && !this.horizontal) {
          return 'has-addons';
        }
      }
    },
    mounted: function mounted() {
      if (this.horizontal) {
        // Bulma docs: .is-normal for any .input or .button
        var elements = this.$el.querySelectorAll('.input, .select, .button, .textarea, .b-slider');

        if (elements.length > 0) {
          this.fieldLabelSize = 'is-normal';
        }
      }
    }
  };

  /* script */
  const __vue_script__$5 = script$5;

  /* template */
  var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",class:[_vm.rootClasses, _vm.fieldType()]},[(_vm.horizontal)?_c('div',{staticClass:"field-label",class:[_vm.customClass, _vm.fieldLabelSize]},[(_vm.hasLabel)?_c('label',{staticClass:"label",class:_vm.customClass,attrs:{"for":_vm.labelFor}},[(_vm.$slots.label)?_vm._t("label"):[_vm._v(_vm._s(_vm.label))]],2):_vm._e()]):[(_vm.hasLabel)?_c('label',{staticClass:"label",class:_vm.customClass,attrs:{"for":_vm.labelFor}},[(_vm.$slots.label)?_vm._t("label"):[_vm._v(_vm._s(_vm.label))]],2):_vm._e()],_vm._v(" "),(_vm.horizontal)?_c('b-field-body',{attrs:{"message":_vm.newMessage ? _vm.formattedMessage : '',"type":_vm.newType}},[_vm._t("default")],2):[_vm._t("default")],_vm._v(" "),(_vm.hasMessage && !_vm.horizontal)?_c('p',{staticClass:"help",class:_vm.newType},[(_vm.$slots.message)?_vm._t("message"):[_vm._l((_vm.formattedMessage),function(mess,i){return [_vm._v("\r\n                    "+_vm._s(mess)+"\r\n                    "),((i + 1) < _vm.formattedMessage.length)?_c('br',{key:i}):_vm._e()]})]],2):_vm._e()],2)};
  var __vue_staticRenderFns__$4 = [];

    /* style */
    const __vue_inject_styles__$5 = undefined;
    /* scoped */
    const __vue_scope_id__$5 = undefined;
    /* module identifier */
    const __vue_module_identifier__$5 = undefined;
    /* functional template */
    const __vue_is_functional_template__$5 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Field = normalizeComponent_1(
      { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
      __vue_inject_styles__$5,
      __vue_script__$5,
      __vue_scope_id__$5,
      __vue_is_functional_template__$5,
      __vue_module_identifier__$5,
      undefined,
      undefined
    );

  var script$6 = {
    name: 'BSelect',
    components: _defineProperty({}, Icon.name, Icon),
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      value: {
        type: [String, Number, Boolean, Object, Array, Function],
        default: null
      },
      placeholder: String,
      multiple: Boolean,
      nativeSize: [String, Number]
    },
    data: function data() {
      return {
        selected: this.value,
        _elementRef: 'select'
      };
    },
    computed: {
      computedValue: {
        get: function get() {
          return this.selected;
        },
        set: function set(value) {
          this.selected = value;
          this.$emit('input', value);
          !this.isValid && this.checkHtml5Validity();
        }
      },
      spanClasses: function spanClasses() {
        return [this.size, this.statusType, {
          'is-fullwidth': this.expanded,
          'is-loading': this.loading,
          'is-multiple': this.multiple,
          'is-rounded': this.rounded,
          'is-empty': this.selected === null
        }];
      }
    },
    watch: {
      /**
      * When v-model is changed:
      *   1. Set the selected option.
      *   2. If it's invalid, validate again.
      */
      value: function value(_value) {
        this.selected = _value;
        !this.isValid && this.checkHtml5Validity();
      }
    }
  };

  /* script */
  const __vue_script__$6 = script$6;

  /* template */
  var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:{ 'is-expanded': _vm.expanded, 'has-icons-left': _vm.icon }},[_c('span',{staticClass:"select",class:_vm.spanClasses},[_c('select',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"select",attrs:{"multiple":_vm.multiple,"size":_vm.nativeSize},on:{"blur":function($event){_vm.$emit('blur', $event) && _vm.checkHtml5Validity();},"focus":function($event){_vm.$emit('focus', $event);},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.computedValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0];}}},'select',_vm.$attrs,false),[(_vm.placeholder)?[(_vm.computedValue == null)?_c('option',{attrs:{"disabled":"","hidden":""},domProps:{"value":null}},[_vm._v("\r\n                        "+_vm._s(_vm.placeholder)+"\r\n                    ")]):_vm._e()]:_vm._e(),_vm._v(" "),_vm._t("default")],2)]),_vm._v(" "),(_vm.icon)?_c('b-icon',{staticClass:"is-left",attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":_vm.iconSize}}):_vm._e()],1)};
  var __vue_staticRenderFns__$5 = [];

    /* style */
    const __vue_inject_styles__$6 = undefined;
    /* scoped */
    const __vue_scope_id__$6 = undefined;
    /* module identifier */
    const __vue_module_identifier__$6 = undefined;
    /* functional template */
    const __vue_is_functional_template__$6 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Select = normalizeComponent_1(
      { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
      __vue_inject_styles__$6,
      __vue_script__$6,
      __vue_scope_id__$6,
      __vue_is_functional_template__$6,
      __vue_module_identifier__$6,
      undefined,
      undefined
    );

  var _components;
  var script$7 = {
    name: 'BTimepicker',
    components: (_components = {}, _defineProperty(_components, Input.name, Input), _defineProperty(_components, Field.name, Field), _defineProperty(_components, Select.name, Select), _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, Dropdown.name, Dropdown), _defineProperty(_components, DropdownItem.name, DropdownItem), _components),
    mixins: [TimepickerMixin],
    inheritAttrs: false,
    data: function data() {
      return {
        _isTimepicker: true
      };
    },
    computed: {
      nativeStep: function nativeStep() {
        if (this.enableSeconds) return '1';
      }
    }
  };

  /* script */
  const __vue_script__$7 = script$7;

  /* template */
  var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timepicker control",class:[_vm.size, {'is-expanded': _vm.expanded}]},[(!_vm.isMobile || _vm.inline)?_c('b-dropdown',{ref:"dropdown",attrs:{"position":_vm.position,"disabled":_vm.disabled,"inline":_vm.inline,"append-to-body":_vm.appendToBody,"append-to-body-copy-parent":""},on:{"active-change":_vm.onActiveChange}},[(!_vm.inline)?_c('b-input',_vm._b({ref:"input",attrs:{"slot":"trigger","autocomplete":"off","value":_vm.formatValue(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"loading":_vm.loading,"disabled":_vm.disabled,"readonly":!_vm.editable,"rounded":_vm.rounded,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":_vm.handleOnFocus},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.toggle(true);},"change":function($event){_vm.onChange($event.target.value);}},slot:"trigger"},'b-input',_vm.$attrs,false)):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":_vm.disabled,"focusable":_vm.focusable,"custom":""}},[_c('b-field',{attrs:{"grouped":"","position":"is-centered"}},[_c('b-select',{attrs:{"disabled":_vm.disabled,"placeholder":"00"},nativeOn:{"change":function($event){_vm.onHoursChange($event.target.value);}},model:{value:(_vm.hoursSelected),callback:function ($$v) {_vm.hoursSelected=$$v;},expression:"hoursSelected"}},_vm._l((_vm.hours),function(hour){return _c('option',{key:hour.value,attrs:{"disabled":_vm.isHourDisabled(hour.value)},domProps:{"value":hour.value}},[_vm._v("\r\n                            "+_vm._s(hour.label)+"\r\n                        ")])})),_vm._v(" "),_c('span',{staticClass:"control is-colon"},[_vm._v(":")]),_vm._v(" "),_c('b-select',{attrs:{"disabled":_vm.disabled,"placeholder":"00"},nativeOn:{"change":function($event){_vm.onMinutesChange($event.target.value);}},model:{value:(_vm.minutesSelected),callback:function ($$v) {_vm.minutesSelected=$$v;},expression:"minutesSelected"}},_vm._l((_vm.minutes),function(minute){return _c('option',{key:minute.value,attrs:{"disabled":_vm.isMinuteDisabled(minute.value)},domProps:{"value":minute.value}},[_vm._v("\r\n                            "+_vm._s(minute.label)+"\r\n                        ")])})),_vm._v(" "),(_vm.enableSeconds)?[_c('span',{staticClass:"control is-colon"},[_vm._v(":")]),_vm._v(" "),_c('b-select',{attrs:{"disabled":_vm.disabled,"placeholder":"00"},nativeOn:{"change":function($event){_vm.onSecondsChange($event.target.value);}},model:{value:(_vm.secondsSelected),callback:function ($$v) {_vm.secondsSelected=$$v;},expression:"secondsSelected"}},_vm._l((_vm.seconds),function(second){return _c('option',{key:second.value,attrs:{"disabled":_vm.isSecondDisabled(second.value)},domProps:{"value":second.value}},[_vm._v("\r\n                                "+_vm._s(second.label)+"\r\n                            ")])}))]:_vm._e(),_vm._v(" "),(!_vm.isHourFormat24)?_c('b-select',{attrs:{"disabled":_vm.disabled},nativeOn:{"change":function($event){_vm.onMeridienChange($event.target.value);}},model:{value:(_vm.meridienSelected),callback:function ($$v) {_vm.meridienSelected=$$v;},expression:"meridienSelected"}},_vm._l((_vm.meridiens),function(meridien){return _c('option',{key:meridien,domProps:{"value":meridien}},[_vm._v("\r\n                            "+_vm._s(meridien)+"\r\n                        ")])})):_vm._e()],2),_vm._v(" "),(_vm.$slots.default !== undefined && _vm.$slots.default.length)?_c('footer',{staticClass:"timepicker-footer"},[_vm._t("default")],2):_vm._e()],1)],1):_c('b-input',_vm._b({ref:"input",attrs:{"type":"time","step":_vm.nativeStep,"autocomplete":"off","value":_vm.formatHHMMSS(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"rounded":_vm.rounded,"loading":_vm.loading,"max":_vm.formatHHMMSS(_vm.maxTime),"min":_vm.formatHHMMSS(_vm.minTime),"disabled":_vm.disabled,"readonly":false,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":_vm.handleOnFocus,"blur":function($event){_vm.onBlur() && _vm.checkHtml5Validity();}},nativeOn:{"change":function($event){_vm.onChange($event.target.value);}}},'b-input',_vm.$attrs,false))],1)};
  var __vue_staticRenderFns__$6 = [];

    /* style */
    const __vue_inject_styles__$7 = undefined;
    /* scoped */
    const __vue_scope_id__$7 = undefined;
    /* module identifier */
    const __vue_module_identifier__$7 = undefined;
    /* functional template */
    const __vue_is_functional_template__$7 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Timepicker = normalizeComponent_1(
      { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
      __vue_inject_styles__$7,
      __vue_script__$7,
      __vue_scope_id__$7,
      __vue_is_functional_template__$7,
      __vue_module_identifier__$7,
      undefined,
      undefined
    );

  var use = function use(plugin) {
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(plugin);
    }
  };
  var registerComponent = function registerComponent(Vue, component) {
    Vue.component(component.name, component);
  };

  var Plugin = {
    install: function install(Vue) {
      registerComponent(Vue, Timepicker);
    }
  };
  use(Plugin);

  exports.BTimepicker = Timepicker;
  exports.default = Plugin;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ "d4cb":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "d687":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d6de":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var global = __webpack_require__("f498");
var getBuiltIn = __webpack_require__("5428");
var IS_PURE = __webpack_require__("0e93");
var DESCRIPTORS = __webpack_require__("d4cb");
var NATIVE_SYMBOL = __webpack_require__("e7a0");
var USE_SYMBOL_AS_UID = __webpack_require__("4db4");
var fails = __webpack_require__("72df");
var has = __webpack_require__("f1a7");
var isArray = __webpack_require__("c6de");
var isObject = __webpack_require__("7526");
var anObject = __webpack_require__("157c");
var toObject = __webpack_require__("37d1");
var toIndexedObject = __webpack_require__("378c");
var toPrimitive = __webpack_require__("083f");
var createPropertyDescriptor = __webpack_require__("9618");
var nativeObjectCreate = __webpack_require__("82e8");
var objectKeys = __webpack_require__("0c47");
var getOwnPropertyNamesModule = __webpack_require__("65d0");
var getOwnPropertyNamesExternal = __webpack_require__("ee58");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var getOwnPropertyDescriptorModule = __webpack_require__("185a");
var definePropertyModule = __webpack_require__("abdf");
var propertyIsEnumerableModule = __webpack_require__("e129");
var createNonEnumerableProperty = __webpack_require__("5b12");
var redefine = __webpack_require__("b8ba");
var shared = __webpack_require__("4cdd");
var sharedKey = __webpack_require__("332c");
var hiddenKeys = __webpack_require__("d687");
var uid = __webpack_require__("1d8a");
var wellKnownSymbol = __webpack_require__("7d53");
var wrappedWellKnownSymbolModule = __webpack_require__("4e41");
var defineWellKnownSymbol = __webpack_require__("6a89");
var setToStringTag = __webpack_require__("fa46");
var InternalStateModule = __webpack_require__("cdcd");
var $forEach = __webpack_require__("d054").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "d74b":
/***/ (function(module, exports, __webpack_require__) {

/*! Buefy v0.8.20 | MIT License | github.com/buefy/buefy */
(function (global, factory) {
   true ? factory(exports) :
  undefined;
}(this, function (exports) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  var config = {
    defaultContainerElement: null,
    defaultIconPack: 'mdi',
    defaultIconComponent: null,
    defaultIconPrev: 'chevron-left',
    defaultIconNext: 'chevron-right',
    defaultDialogConfirmText: null,
    defaultDialogCancelText: null,
    defaultSnackbarDuration: 3500,
    defaultSnackbarPosition: null,
    defaultToastDuration: 2000,
    defaultToastPosition: null,
    defaultNotificationDuration: 2000,
    defaultNotificationPosition: null,
    defaultTooltipType: 'is-primary',
    defaultTooltipAnimated: false,
    defaultTooltipDelay: 0,
    defaultInputAutocomplete: 'on',
    defaultDateFormatter: null,
    defaultDateParser: null,
    defaultDateCreator: null,
    defaultTimeCreator: null,
    defaultDayNames: null,
    defaultMonthNames: null,
    defaultFirstDayOfWeek: null,
    defaultUnselectableDaysOfWeek: null,
    defaultTimeFormatter: null,
    defaultTimeParser: null,
    defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
    defaultModalScroll: null,
    defaultDatepickerMobileNative: true,
    defaultTimepickerMobileNative: true,
    defaultNoticeQueue: true,
    defaultInputHasCounter: true,
    defaultTaginputHasCounter: true,
    defaultUseHtml5Validation: true,
    defaultDropdownMobileModal: true,
    defaultFieldLabelPosition: null,
    defaultDatepickerYearsRange: [-100, 3],
    defaultDatepickerNearbyMonthDays: true,
    defaultDatepickerNearbySelectableMonthDays: false,
    defaultDatepickerShowWeekNumber: false,
    defaultDatepickerMobileModal: true,
    defaultTrapFocus: false,
    defaultButtonRounded: false,
    defaultCarouselInterval: 3500,
    defaultTabsAnimated: true,
    defaultLinkTags: ['a', 'button', 'input', 'router-link', 'nuxt-link', 'n-link', 'RouterLink', 'NuxtLink', 'NLink'],
    customIconPacks: null
  }; // TODO defaultTrapFocus to true in the next breaking change

  /**
   * Merge function to replace Object.assign with deep merging possibility
   */

  var isObject = function isObject(item) {
    return _typeof(item) === 'object' && !Array.isArray(item);
  };

  var mergeFn = function mergeFn(target, source) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (deep || !Object.assign) {
      var isDeep = function isDeep(prop) {
        return isObject(source[prop]) && target !== null && target.hasOwnProperty(prop) && isObject(target[prop]);
      };

      var replaced = Object.getOwnPropertyNames(source).map(function (prop) {
        return _defineProperty({}, prop, isDeep(prop) ? mergeFn(target[prop], source[prop], deep) : source[prop]);
      }).reduce(function (a, b) {
        return _objectSpread2({}, a, {}, b);
      }, {});
      return _objectSpread2({}, target, {}, replaced);
    } else {
      return Object.assign(target, source);
    }
  };

  var merge = mergeFn;

  var mdiIcons = {
    sizes: {
      'default': 'mdi-24px',
      'is-small': null,
      'is-medium': 'mdi-36px',
      'is-large': 'mdi-48px'
    },
    iconPrefix: 'mdi-'
  };

  var faIcons = function faIcons() {
    var faIconPrefix = config && config.defaultIconComponent ? '' : 'fa-';
    return {
      sizes: {
        'default': faIconPrefix + 'lg',
        'is-small': null,
        'is-medium': faIconPrefix + '2x',
        'is-large': faIconPrefix + '3x'
      },
      iconPrefix: faIconPrefix,
      internalIcons: {
        'information': 'info-circle',
        'alert': 'exclamation-triangle',
        'alert-circle': 'exclamation-circle',
        'chevron-right': 'angle-right',
        'chevron-left': 'angle-left',
        'chevron-down': 'angle-down',
        'eye-off': 'eye-slash',
        'menu-down': 'caret-down',
        'menu-up': 'caret-up',
        'close-circle': 'times-circle'
      }
    };
  };

  var getIcons = function getIcons() {
    var icons = {
      mdi: mdiIcons,
      fa: faIcons(),
      fas: faIcons(),
      far: faIcons(),
      fad: faIcons(),
      fab: faIcons(),
      fal: faIcons()
    };

    if (config && config.customIconPacks) {
      icons = merge(icons, config.customIconPacks, true);
    }

    return icons;
  };

  var script = {
    name: 'BIcon',
    props: {
      type: [String, Object],
      component: String,
      pack: String,
      icon: String,
      size: String,
      customSize: String,
      customClass: String,
      both: Boolean // This is used internally to show both MDI and FA icon

    },
    computed: {
      iconConfig: function iconConfig() {
        var allIcons = getIcons();
        return allIcons[this.newPack];
      },
      iconPrefix: function iconPrefix() {
        if (this.iconConfig && this.iconConfig.iconPrefix) {
          return this.iconConfig.iconPrefix;
        }

        return '';
      },

      /**
      * Internal icon name based on the pack.
      * If pack is 'fa', gets the equivalent FA icon name of the MDI,
      * internal icons are always MDI.
      */
      newIcon: function newIcon() {
        return "".concat(this.iconPrefix).concat(this.getEquivalentIconOf(this.icon));
      },
      newPack: function newPack() {
        return this.pack || config.defaultIconPack;
      },
      newType: function newType() {
        if (!this.type) return;
        var splitType = [];

        if (typeof this.type === 'string') {
          splitType = this.type.split('-');
        } else {
          for (var key in this.type) {
            if (this.type[key]) {
              splitType = key.split('-');
              break;
            }
          }
        }

        if (splitType.length <= 1) return;

        var _splitType = splitType,
            _splitType2 = _toArray(_splitType),
            type = _splitType2.slice(1);

        return "has-text-".concat(type.join('-'));
      },
      newCustomSize: function newCustomSize() {
        return this.customSize || this.customSizeByPack;
      },
      customSizeByPack: function customSizeByPack() {
        if (this.iconConfig && this.iconConfig.sizes) {
          if (this.size && this.iconConfig.sizes[this.size] !== undefined) {
            return this.iconConfig.sizes[this.size];
          } else if (this.iconConfig.sizes.default) {
            return this.iconConfig.sizes.default;
          }
        }

        return null;
      },
      useIconComponent: function useIconComponent() {
        return this.component || config.defaultIconComponent;
      }
    },
    methods: {
      /**
      * Equivalent icon name of the MDI.
      */
      getEquivalentIconOf: function getEquivalentIconOf(value) {
        // Only transform the class if the both prop is set to true
        if (!this.both) {
          return value;
        }

        if (this.iconConfig && this.iconConfig.internalIcons && this.iconConfig.internalIcons[value]) {
          return this.iconConfig.internalIcons[value];
        }

        return value;
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  const __vue_script__ = script;

  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[_vm.newType, _vm.size]},[(!_vm.useIconComponent)?_c('i',{class:[_vm.newPack, _vm.newIcon, _vm.newCustomSize, _vm.customClass]}):_c(_vm.useIconComponent,{tag:"component",class:[_vm.customClass],attrs:{"icon":[_vm.newPack, _vm.newIcon],"size":_vm.newCustomSize}})],1)};
  var __vue_staticRenderFns__ = [];

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Icon = normalizeComponent_1(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      undefined,
      undefined
    );

  var FormElementMixin = {
    props: {
      size: String,
      expanded: Boolean,
      loading: Boolean,
      rounded: Boolean,
      icon: String,
      iconPack: String,
      // Native options to use in HTML5 validation
      autocomplete: String,
      maxlength: [Number, String],
      useHtml5Validation: {
        type: Boolean,
        default: function _default() {
          return config.defaultUseHtml5Validation;
        }
      },
      validationMessage: String
    },
    data: function data() {
      return {
        isValid: true,
        isFocused: false,
        newIconPack: this.iconPack || config.defaultIconPack
      };
    },
    computed: {
      /**
       * Find parent Field, max 3 levels deep.
       */
      parentField: function parentField() {
        var parent = this.$parent;

        for (var i = 0; i < 3; i++) {
          if (parent && !parent.$data._isField) {
            parent = parent.$parent;
          }
        }

        return parent;
      },

      /**
       * Get the type prop from parent if it's a Field.
       */
      statusType: function statusType() {
        if (!this.parentField) return;
        if (!this.parentField.newType) return;

        if (typeof this.parentField.newType === 'string') {
          return this.parentField.newType;
        } else {
          for (var key in this.parentField.newType) {
            if (this.parentField.newType[key]) {
              return key;
            }
          }
        }
      },

      /**
       * Get the message prop from parent if it's a Field.
       */
      statusMessage: function statusMessage() {
        if (!this.parentField) return;
        return this.parentField.newMessage || this.parentField.$slots.message;
      },

      /**
       * Fix icon size for inputs, large was too big
       */
      iconSize: function iconSize() {
        switch (this.size) {
          case 'is-small':
            return this.size;

          case 'is-medium':
            return;

          case 'is-large':
            return this.newIconPack === 'mdi' ? 'is-medium' : '';
        }
      }
    },
    methods: {
      /**
       * Focus method that work dynamically depending on the component.
       */
      focus: function focus() {
        var _this = this;

        if (this.$data._elementRef === undefined) return;
        this.$nextTick(function () {
          var el = _this.$el.querySelector(_this.$data._elementRef);

          if (el) el.focus();
        });
      },
      onBlur: function onBlur($event) {
        this.isFocused = false;
        this.$emit('blur', $event);
        this.checkHtml5Validity();
      },
      onFocus: function onFocus($event) {
        this.isFocused = true;
        this.$emit('focus', $event);
      },
      getElement: function getElement() {
        return this.$el.querySelector(this.$data._elementRef);
      },
      setInvalid: function setInvalid() {
        var type = 'is-danger';
        var message = this.validationMessage || this.getElement().validationMessage;
        this.setValidity(type, message);
      },
      setValidity: function setValidity(type, message) {
        var _this2 = this;

        this.$nextTick(function () {
          if (_this2.parentField) {
            // Set type only if not defined
            if (!_this2.parentField.type) {
              _this2.parentField.newType = type;
            } // Set message only if not defined


            if (!_this2.parentField.message) {
              _this2.parentField.newMessage = message;
            }
          }
        });
      },

      /**
       * Check HTML5 validation, set isValid property.
       * If validation fail, send 'is-danger' type,
       * and error message to parent if it's a Field.
       */
      checkHtml5Validity: function checkHtml5Validity() {
        if (!this.useHtml5Validation) return;
        if (this.$refs[this.$data._elementRef] === undefined) return;
        if (this.getElement() === null) return;

        if (!this.getElement().checkValidity()) {
          this.setInvalid();
          this.isValid = false;
        } else {
          this.setValidity(null, null);
          this.isValid = true;
        }

        return this.isValid;
      }
    }
  };

  var script$1 = {
    name: 'BInput',
    components: _defineProperty({}, Icon.name, Icon),
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      value: [Number, String],
      type: {
        type: String,
        default: 'text'
      },
      passwordReveal: Boolean,
      iconClickable: Boolean,
      hasCounter: {
        type: Boolean,
        default: function _default() {
          return config.defaultInputHasCounter;
        }
      },
      customClass: {
        type: String,
        default: ''
      },
      iconRight: String,
      iconRightClickable: Boolean
    },
    data: function data() {
      return {
        newValue: this.value,
        newType: this.type,
        newAutocomplete: this.autocomplete || config.defaultInputAutocomplete,
        isPasswordVisible: false,
        _elementRef: this.type === 'textarea' ? 'textarea' : 'input'
      };
    },
    computed: {
      computedValue: {
        get: function get() {
          return this.newValue;
        },
        set: function set(value) {
          this.newValue = value;
          this.$emit('input', value);
          !this.isValid && this.checkHtml5Validity();
        }
      },
      rootClasses: function rootClasses() {
        return [this.iconPosition, this.size, {
          'is-expanded': this.expanded,
          'is-loading': this.loading,
          'is-clearfix': !this.hasMessage
        }];
      },
      inputClasses: function inputClasses() {
        return [this.statusType, this.size, {
          'is-rounded': this.rounded
        }];
      },
      hasIconRight: function hasIconRight() {
        return this.passwordReveal || this.loading || this.statusTypeIcon || this.iconRight;
      },
      rightIcon: function rightIcon() {
        if (this.passwordReveal) {
          return this.passwordVisibleIcon;
        } else if (this.iconRight) {
          return this.iconRight;
        }

        return this.statusTypeIcon;
      },
      rightIconType: function rightIconType() {
        if (this.passwordReveal) {
          return 'is-primary';
        } else if (this.iconRight) {
          return null;
        }

        return this.statusType;
      },

      /**
      * Position of the icon or if it's both sides.
      */
      iconPosition: function iconPosition() {
        if (this.icon && this.hasIconRight) {
          return 'has-icons-left has-icons-right';
        } else if (!this.icon && this.hasIconRight) {
          return 'has-icons-right';
        } else if (this.icon) {
          return 'has-icons-left';
        }
      },

      /**
      * Icon name (MDI) based on the type.
      */
      statusTypeIcon: function statusTypeIcon() {
        switch (this.statusType) {
          case 'is-success':
            return 'check';

          case 'is-danger':
            return 'alert-circle';

          case 'is-info':
            return 'information';

          case 'is-warning':
            return 'alert';
        }
      },

      /**
      * Check if have any message prop from parent if it's a Field.
      */
      hasMessage: function hasMessage() {
        return !!this.statusMessage;
      },

      /**
      * Current password-reveal icon name.
      */
      passwordVisibleIcon: function passwordVisibleIcon() {
        return !this.isPasswordVisible ? 'eye' : 'eye-off';
      },

      /**
      * Get value length
      */
      valueLength: function valueLength() {
        if (typeof this.computedValue === 'string') {
          return this.computedValue.length;
        } else if (typeof this.computedValue === 'number') {
          return this.computedValue.toString().length;
        }

        return 0;
      }
    },
    watch: {
      /**
      * When v-model is changed:
      *   1. Set internal value.
      */
      value: function value(_value) {
        this.newValue = _value;
      }
    },
    methods: {
      /**
      * Toggle the visibility of a password-reveal input
      * by changing the type and focus the input right away.
      */
      togglePasswordVisibility: function togglePasswordVisibility() {
        var _this = this;

        this.isPasswordVisible = !this.isPasswordVisible;
        this.newType = this.isPasswordVisible ? 'text' : 'password';
        this.$nextTick(function () {
          _this.$refs[_this.$data._elementRef].focus();
        });
      },

      /**
      * Input's 'input' event listener, 'nextTick' is used to prevent event firing
      * before ui update, helps when using masks (Cleavejs and potentially others).
      */
      onInput: function onInput(event) {
        var _this2 = this;

        this.$nextTick(function () {
          if (event.target) {
            _this2.computedValue = event.target.value;
          }
        });
      },
      iconClick: function iconClick(emit, event) {
        var _this3 = this;

        this.$emit(emit, event);
        this.$nextTick(function () {
          _this3.$refs[_this3.$data._elementRef].focus();
        });
      },
      rightIconClick: function rightIconClick(event) {
        if (this.passwordReveal) {
          this.togglePasswordVisibility();
        } else if (this.iconRightClickable) {
          this.iconClick('icon-right-click', event);
        }
      }
    }
  };

  /* script */
  const __vue_script__$1 = script$1;

  /* template */
  var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:_vm.rootClasses},[(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"input",class:[_vm.inputClasses, _vm.customClass],attrs:{"type":_vm.newType,"autocomplete":_vm.newAutocomplete,"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'input',_vm.$attrs,false)):_c('textarea',_vm._b({ref:"textarea",staticClass:"textarea",class:[_vm.inputClasses, _vm.customClass],attrs:{"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'textarea',_vm.$attrs,false)),_vm._v(" "),(_vm.icon)?_c('b-icon',{staticClass:"is-left",class:{'is-clickable': _vm.iconClickable},attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":_vm.iconSize},nativeOn:{"click":function($event){_vm.iconClick('icon-click', $event);}}}):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.hasIconRight)?_c('b-icon',{staticClass:"is-right",class:{ 'is-clickable': _vm.passwordReveal || _vm.iconRightClickable },attrs:{"icon":_vm.rightIcon,"pack":_vm.iconPack,"size":_vm.iconSize,"type":_vm.rightIconType,"both":""},nativeOn:{"click":function($event){return _vm.rightIconClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.maxlength && _vm.hasCounter && _vm.type !== 'number')?_c('small',{staticClass:"help counter",class:{ 'is-invisible': !_vm.isFocused }},[_vm._v("\r\n            "+_vm._s(_vm.valueLength)+" / "+_vm._s(_vm.maxlength)+"\r\n        ")]):_vm._e()],1)};
  var __vue_staticRenderFns__$1 = [];

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Input = normalizeComponent_1(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      undefined,
      undefined
    );

  var _components;
  var script$2 = {
    name: 'BNumberinput',
    components: (_components = {}, _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, Input.name, Input), _components),
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      value: Number,
      min: [Number, String],
      max: [Number, String],
      step: [Number, String],
      disabled: Boolean,
      type: {
        type: String,
        default: 'is-primary'
      },
      editable: {
        type: Boolean,
        default: true
      },
      controls: {
        type: Boolean,
        default: true
      },
      controlsRounded: {
        type: Boolean,
        default: false
      },
      controlsPosition: String
    },
    data: function data() {
      return {
        newValue: !isNaN(this.value) ? this.value : parseFloat(this.min) || 0,
        newStep: this.step || 1,
        _elementRef: 'input'
      };
    },
    computed: {
      computedValue: {
        get: function get() {
          return this.newValue;
        },
        set: function set(value) {
          var newValue = value;

          if (value === '') {
            newValue = parseFloat(this.min) || null;
          }

          this.newValue = newValue;
          this.$emit('input', newValue);
          !this.isValid && this.$refs.input.checkHtml5Validity();
        }
      },
      fieldClasses: function fieldClasses() {
        return [{
          'has-addons': this.controlsPosition === 'compact'
        }, {
          'is-grouped': this.controlsPosition !== 'compact'
        }, {
          'is-expanded': this.expanded
        }];
      },
      buttonClasses: function buttonClasses() {
        return [this.type, this.size, {
          'is-rounded': this.controlsRounded
        }];
      },
      minNumber: function minNumber() {
        return typeof this.min === 'string' ? parseFloat(this.min) : this.min;
      },
      maxNumber: function maxNumber() {
        return typeof this.max === 'string' ? parseFloat(this.max) : this.max;
      },
      stepNumber: function stepNumber() {
        return typeof this.newStep === 'string' ? parseFloat(this.newStep) : this.newStep;
      },
      disabledMin: function disabledMin() {
        return this.computedValue - this.stepNumber < this.minNumber;
      },
      disabledMax: function disabledMax() {
        return this.computedValue + this.stepNumber > this.maxNumber;
      },
      stepDecimals: function stepDecimals() {
        var step = this.stepNumber.toString();
        var index = step.indexOf('.');

        if (index >= 0) {
          return step.substring(index + 1).length;
        }

        return 0;
      }
    },
    watch: {
      /**
      * When v-model is changed:
      *   1. Set internal value.
      */
      value: function value(_value) {
        this.newValue = _value;
      }
    },
    methods: {
      decrement: function decrement() {
        if (typeof this.minNumber === 'undefined' || this.computedValue - this.stepNumber >= this.minNumber) {
          var value = this.computedValue - this.stepNumber;
          this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
        }
      },
      increment: function increment() {
        if (typeof this.maxNumber === 'undefined' || this.computedValue + this.stepNumber <= this.maxNumber) {
          var value = this.computedValue + this.stepNumber;
          this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
        }
      },
      onControlClick: function onControlClick(event, inc) {
        // IE 11 -> filter click event
        if (event.detail !== 0 || event.type === 'click') return;
        if (inc) this.increment();else this.decrement();
      },
      onStartLongPress: function onStartLongPress(event, inc) {
        var _this = this;

        if (event.button !== 0 && event.type !== 'touchstart') return;
        this._$intervalTime = new Date();
        clearInterval(this._$intervalRef);
        this._$intervalRef = setInterval(function () {
          if (inc) _this.increment();else _this.decrement();
        }, 250);
      },
      onStopLongPress: function onStopLongPress(inc) {
        if (!this._$intervalRef) return;
        var d = new Date();

        if (d - this._$intervalTime < 250) {
          if (inc) this.increment();else this.decrement();
        }

        clearInterval(this._$intervalRef);
        this._$intervalRef = null;
      }
    }
  };

  /* script */
  const __vue_script__$2 = script$2;

  /* template */
  var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-numberinput field",class:_vm.fieldClasses},[(_vm.controls)?_c('p',{staticClass:"control",on:{"mouseup":function($event){_vm.onStopLongPress(false);},"mouseleave":function($event){_vm.onStopLongPress(false);},"touchend":function($event){_vm.onStopLongPress(false);},"touchcancel":function($event){_vm.onStopLongPress(false);}}},[_c('button',{staticClass:"button",class:_vm.buttonClasses,attrs:{"type":"button","disabled":_vm.disabled || _vm.disabledMin},on:{"mousedown":function($event){_vm.onStartLongPress($event, false);},"touchstart":function($event){$event.preventDefault();_vm.onStartLongPress($event, false);},"click":function($event){_vm.onControlClick($event, false);}}},[_c('b-icon',{attrs:{"icon":"minus","both":"","pack":_vm.iconPack,"size":_vm.iconSize}})],1)]):_vm._e(),_vm._v(" "),_c('b-input',_vm._b({ref:"input",attrs:{"type":"number","step":_vm.newStep,"max":_vm.max,"min":_vm.min,"size":_vm.size,"disabled":_vm.disabled,"readonly":!_vm.editable,"loading":_vm.loading,"rounded":_vm.rounded,"icon":_vm.icon,"icon-pack":_vm.iconPack,"autocomplete":_vm.autocomplete,"expanded":_vm.expanded,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":function($event){_vm.$emit('focus', $event);},"blur":function($event){_vm.$emit('blur', $event);}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=_vm._n($$v);},expression:"computedValue"}},'b-input',_vm.$attrs,false)),_vm._v(" "),(_vm.controls)?_c('p',{staticClass:"control",on:{"mouseup":function($event){_vm.onStopLongPress(true);},"mouseleave":function($event){_vm.onStopLongPress(true);},"touchend":function($event){_vm.onStopLongPress(true);},"touchcancel":function($event){_vm.onStopLongPress(true);}}},[_c('button',{staticClass:"button",class:_vm.buttonClasses,attrs:{"type":"button","disabled":_vm.disabled || _vm.disabledMax},on:{"mousedown":function($event){_vm.onStartLongPress($event, true);},"touchstart":function($event){$event.preventDefault();_vm.onStartLongPress($event, true);},"click":function($event){_vm.onControlClick($event, true);}}},[_c('b-icon',{attrs:{"icon":"plus","both":"","pack":_vm.iconPack,"size":_vm.iconSize}})],1)]):_vm._e()],1)};
  var __vue_staticRenderFns__$2 = [];

    /* style */
    const __vue_inject_styles__$2 = undefined;
    /* scoped */
    const __vue_scope_id__$2 = undefined;
    /* module identifier */
    const __vue_module_identifier__$2 = undefined;
    /* functional template */
    const __vue_is_functional_template__$2 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var Numberinput = normalizeComponent_1(
      { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2,
      __vue_module_identifier__$2,
      undefined,
      undefined
    );

  var use = function use(plugin) {
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(plugin);
    }
  };
  var registerComponent = function registerComponent(Vue, component) {
    Vue.component(component.name, component);
  };

  var Plugin = {
    install: function install(Vue) {
      registerComponent(Vue, Numberinput);
    }
  };
  use(Plugin);

  exports.BNumberinput = Numberinput;
  exports.default = Plugin;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ "d86f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var fails = __webpack_require__("72df");
var isArray = __webpack_require__("c6de");
var isObject = __webpack_require__("7526");
var toObject = __webpack_require__("37d1");
var toLength = __webpack_require__("b495");
var createProperty = __webpack_require__("dac6");
var arraySpeciesCreate = __webpack_require__("6a86");
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");
var wellKnownSymbol = __webpack_require__("7d53");
var V8_VERSION = __webpack_require__("4fed");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "da06":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("3cec");
var classofRaw = __webpack_require__("6a61");
var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "dac6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("083f");
var definePropertyModule = __webpack_require__("abdf");
var createPropertyDescriptor = __webpack_require__("9618");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "df6f":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c607");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "df8c":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("6a61");
var regexpExec = __webpack_require__("42c5");

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "e129":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "e345":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VueCronEditorBuefy_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4a27");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VueCronEditorBuefy_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VueCronEditorBuefy_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e3f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("b7fb").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "e7a0":
/***/ (function(module, exports, __webpack_require__) {

var IS_NODE = __webpack_require__("f117");
var V8_VERSION = __webpack_require__("4fed");
var fails = __webpack_require__("72df");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  /* global Symbol -- required for testing */
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (IS_NODE ? V8_VERSION === 38 : V8_VERSION > 37 && V8_VERSION < 41);
});


/***/ }),

/***/ "e8e5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("d054").forEach;
var arrayMethodIsStrict = __webpack_require__("7f8a");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "ebac":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "ed2b":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");
var create = __webpack_require__("82e8");
var definePropertyModule = __webpack_require__("abdf");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "ee58":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("378c");
var nativeGetOwnPropertyNames = __webpack_require__("65d0").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "ef14":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var IndexedObject = __webpack_require__("83a6");
var toIndexedObject = __webpack_require__("378c");
var arrayMethodIsStrict = __webpack_require__("7f8a");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "ef1f":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("3cec");
var redefine = __webpack_require__("b8ba");
var toString = __webpack_require__("5268");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "f117":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("6a61");
var global = __webpack_require__("f498");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "f1a7":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "f2bf":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var isObject = __webpack_require__("7526");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "f498":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  /* global globalThis -- safe */
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("7d15")))

/***/ }),

/***/ "f8a5":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var toObject = __webpack_require__("37d1");
var nativeKeys = __webpack_require__("0c47");
var fails = __webpack_require__("72df");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "fa46":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("abdf").f;
var has = __webpack_require__("f1a7");
var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "fa8c":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var DOMIterables = __webpack_require__("130d");
var forEach = __webpack_require__("e8e5");
var createNonEnumerableProperty = __webpack_require__("5b12");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "fbf7":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vue-cron-editor-buefy.umd.js.map
